/* eslint-disable prettier */
/* eslint-disable max-len */
/**
 * HE resource file
 */

import {
    ArcTimeLineValidationTypes,
    ArcTimelineGroups,
    Entity,
    GAComponentDocumentStatus,
    GALinkStatus,
    GARoleTypeId,
    TaskListTypes,
    actionTypes,
    activityType,
    assignmentTypes,
    bulkAssignment,
    bulkAssignmentConstants,
    clientRequestNoteTab,
    confidentialityTypes,
    filters,
    financialStatementType,
    gaRecommendationType,
    gaScopes,
    groupSummaryTabs,
    independenceActionIds,
    instructionStatus,
    instructionType,
    ipFilterType,
    ipInputType,
    linkType,
    milestoneBuildTaskIds,
    notesFilter,
    reviewNoteRoutes,
    rnhFilterTypeQuery,
    rnhQuickFilter,
    snapshotComparisonIds,
    syncStatus,
    todoListTimeframeOptions,
    trialBalanceType,
    uiViews,
    receiveInstructionSwitcherIds
} from "../util/uiconstants";

export const labels = {

    //Review notes tile 2

    reviewNoteTileGraphHeader: "פתח הערות סקירה (review notes ) עד תאריך יעד",
    reviewNoteTileGraphHeaderAssignedToMe: "פתח הערות סקירה (review notes) שהוקצו לי, לפי תאריך יעד",
    reviewNoteTileGraphHeaderAuthoredByMe: 'Authored open notes, by due date',
    reviewNoteYAxisLabel: "סקירת הערות",
    overDueCatFirst: "איחור מעל 90",
    overDueCatSecond: "איחור 31-90",
    overDueCatThird: "איחור 10-30",
    overDueCatFourth: "איחור <10",
    catFifth: '<10',
    catSixth: '10-30',
    catSeventh: '31-90',
    catEighth: '>90',
    noNotesAvailable: "אין הערות זמינות",


    //ReviewNoteTiles
    totalOpen: "סך הכל פתוח",
    totalCleared: "סך הכל נוקה (cleared)",
    changeDueDate: "שינוי תאריך יעד",
    reviewNoteHashValue: '#',

    //Rejected PSPs
    rejectedPSPsTitle: 'Rejected PSPs',
    noRejectedPSPs: 'No rejected PSPs',
    updateRejectedPSPs: 'Update rejected PSPs',


    //CRA Build Step 2 Labels
    inherentRiskTypeId: "הערכת הסיכון שבמהות (IR)",
    controlRiskTypeId: "הערכת הסיכון המשולב (CRA)",
    viewUnRelatedWCGWs: "הצג WCGWs לא קשורים",
    unrelatedWCGWsInstruction: "ה-WCGWs המפורטים להלן אינם קשורים למצגי הנהלה כלשהם. הם צריכים להיות קשורים לפחות למצג הנהלה אחד או להימחק. כדי למצוא בקלות את ה-WCGWs הללו במודל 'קשר WCGWs למצגי ההנהלה', בחר \'Unrelated WCGWs'\ מהתפריט הנפתח של ה- SCOTs. אם ה-WCGW אינו רלוונטי עוד או שיש צורך לערוך אותו, לחץ על הקישור \'זהה WCGWs ובקרות'\ בעמוד להלן בכדי לבצע שינויים אלה.",
    relatedWCGWsInstruction: "קשר WCGWs למצג ההנהלה שנבחר. בחר SCOT כדי לקשר WCGWs מתת תהליך מהותי (SCOT) ספציפי, או בחר אפשרות מתוך All SCOTs. לרשימה של WCGWs שצריכים להיות קשורים למצג ההנהלה, בחר \'WCGWs לא קשורים'\.",
    allScots: " כל תתי התהליכים המהותיים (SCOTs)",
    allWCGWs: "כל ה-WCGW",
    unRelatedWCGWs: " WCGWs  לא קשורים",
    //CRA Build Step 4 Header Label
    craValue: "CRA",
    incompleteCraValue: "CRA לא מלא",
    // Panel Headers
    taskCategories: "נווט למשימה",
    taskCategoryExecution: "ביצוע הביקורת",
    taskList: "רשימת משימות",
    taskDetails: "פרטי המשימה",
    fullScreen: "מסך מלא",
    exitFullScreen: "יציאה ממסך מלא",
    defaultDropdown: "תפריט נפתח",
    status: "סטטוס",
    language: "שפה",
    channel: "ערוץ",
    header: "כותרת עליונה",
    headerName: "שם כותרת עליונה",
    sectionCustomLabelLabel: "התאם כותרת",
    sectionNamePlaceHolder: "הזן כותרת לפיסקה",
    showRelatedObjectLabel: "הצג אובייקטים קשורים",
    errorBanner: "{0} שגיאה/ות",
    customize: "התאמה אישית",
    customized: "מותאם אישית",
    custom: "מותאם אישית",
    description: "תיאור",
    seeDescription: "ראה תיאור",
    section: "מקטע",
    entities: "ישויות",
    edit: "ערוך",
    delete: "מחק",
    collapse: "צמצם",
    collapseAll: "צמצם הכל",
    expand: "הרחב",
    expandAll: "הרחב הכל",
    incompleteResponse: "תגובה שאינה מלאה",
    unresolvedComments: "הערות (comments) לא פתורות",
    saving: "שומר ...",
    tasks: "משימות",
    requests: "בקשות",

    //BodyType Placeholder
    numericValuePlaceholder: "הזן סכום",

    //Modal
    addButton: "לחצן ' הוסף '",
    evidence: "ראיות",
    temporary: "זמני",
    temporaryFiles: "קבצים זמניים",
    priorPeriod: "תקופה קודמת",
    externaldocuments: "מסמכים חיצוניים",
    eydocuments: "מסמכי EY",
    clientRequestClientAnalytics: "שם ניתוח",
    groupdocuments: "מסמכים של הקבוצה",
    name: "שם",
    reason: "סיבה",
    browse: "חפש",
    uploadFile: "העלאת קבצים",
    uploadDocument: "העלה מסמך",
    duplicateDocumentHeader: "מסמך אחד או יותר עם שם זהה כבר קיים בתיק ביקורת זה (כקבצי ראיות (Evidence) או קבצים זמניים(Temporary)).",
    duplicateDocumentInstruction: "בחר 'החלף' (Overwrite) כדי להעלות את המסמך ולהחליף את הקובץ הקיים או 'מחק' (Discard) לביטול. אם קובץ קיים זה נמצא ב 'ראיות' (Evidence) המסמך יעלה ל- 'ראיות' (Evidence). אם הקובץ הקיים נמצא בקבצים 'זמניים' (Temporary) המסמך יעלה לקבצים 'זמניים' (Temporary).",
    overwriteLabel: "החלף",
    discardLabel: "לבטל את",
    discardChangesLabel: "התעלם משינויים",
    note: "הערה",
    notes: "הערות",
    signOffs: "Sign-offs",
    related: "קשורים",
    attributes: "מאפיינים",
    approveChanges: "אשר שינויים",
    nodocumentsAdded: "אין מסמכים זמינים",
    noEntitiesAvailable: "אין ישויות זמינות",
    noDocumentsUpload: "אין מסמכים שנטענים כעת.",
    noSections: "אין סעיפים זמינים",
    noRequestMessage: "אין בקשות או משימות חיצוניות בהתקשרות זו",
    noResultFound: "לא נמצאו תוצאות.",
    noRequestsFound: "לא נמצאו בקשות",
    noTimePhasesFound: "אין שלבי זמן זמינים",
    noEntitiesFound: "אין תוצאות",
    relatedEntities: "ישויות קשורות",
    noClickableRelatedEntities: "לא ניתן לערוך ישויות קשורות עבור משימה זו",
    taskByEntityLabel: "משימות לפי ישות",
    relEntityLabel: "ישות",
    singleEntity: "ישות {0}",
    multipleEntity: "{0} ישויות",
    engagementDeliveryLabel: "משימות לפי תיק ביקורת",
    onlyShowRelEntities: "הצג רק ישויות קשורות",
    engDeliveryDescription: "משימה זו משויכת לכל הישויות בהתקשרות.",
    relEntitiesDescription: "הצג ישויות הקשורות למשימה. ניתן לערוך ישויות קשורות רק עבור משימות OSP ו-OST.",
    relEntitiesPSTorPSPDesc: "הצג ישויות הקשורות למשימה. לא ניתן לערוך ישויות קשורות עבור משימות PST ו-PSP.",
    warningRelMsg: "המשימה חייבת להיות קשורה לישות אחת או יותר. כדי להפוך את ההתקשרות למשימה רחבה, שנה את הלחצן משימה לפי ישות.",
    reldetailDescription: "כברירת מחדל, משימות OSP ו-OST הן כלל רוחביות וקשורות לכל הישויות. משימות יכולות להיות קשורות לישות אחת או יותר על ידי הפעלת משימות לפי ישות.",
    results: "תוצאות",
    searchPlaceholder: "חיפוש",
    searchDocPlaceholder: "חפש במסמך",
    searchCanvasForms: "חפש טפסי Canvas",
    searchControlForms: "חפש תת תהליך מהותי SCOTs",
    canvasFormListDescription: "בחר טופס קנבס מהרשימה למטה כדי להציג דוחות הקשורים לטופס קנבס.",
    controlFormListDescription: "בחר תת תהליך מהותי SCOT בכדי לראות את טפסי הבקרה (control forms) הקשורים אליו.",
    object: "אובייקט",
    relateCollaboration: "קשר שיתופי פעולה",
    reviewNote: "סקירת הערות",
    reviewNoteSingle: "הערת סקירה",
    documentReviewNotes: "הערות במסמך",
    noEvidenceFilesAssociated: "אין קבצי ראיות המשויכים למשימה זו",
    taskReviewNoteWithParenthesess: "הערה(ות) למשימה",
    taskNotes: "הערות משימה",
    documentsNotes: "הערות במסמך",
    addNewDocumentNote: "הוסף הערת מסמך",
    selectDocument: "בחירת מסמך",
    taskReviewNotes: "הערה המשויכת למשימה",
    showCleared: "הצג נוקה",
    Replied: "השיב:",
    showClosed: "הצג נסגר",
    allNotes: "כל ההערות",
    myNotes: "ההערות שלי",
    noTasksAvailable: "אין משימות זמינות",
    noWCGWAvailableForTask: "ROMM לא זמין",
    noSubstantiveTasksAvailable: "אין משימות מבססות קשורות",
    noNotesAssociatedWithDocument: "אין הערות המשויכות למסמך זה",
    noNotesAssociatedWithTak: "אין הערות המשויכות למשימה זו",
    otherEngagementNotes: "הערות אחרות בהתקשרות",
    to: "ל",
    deleteReviewNote: "מחק",
    missingToUserError: "נדרש",
    missingReviewNoteTextError: "נדרש לסקור את טקסט ההערה",
    invalidReviewNoteTextError: "הטקסט שהוזן חורג מהמגבלה",
    dueDateRequiredTextError: "נדרש תאריך יעד",
    saveNoteTextError: "שמור או בטל בכדי להמשיך",
    engagementName: "שם ההתקשרות:",
    assignmentsCountLabel: "משימות לביצוע",
    AssignmentsDays: "‬ימים",
    closedOnTime: "נסגר בזמן",
    daysToPrepare: "ימים להכנה",
    daysToReview: "ימים לסקירה",
    totalAssignments: 'סה"כ <br> הקצאות ',
    currentlyAssigned: "<br> מוקצים כרגע",
    UpcomingAssignments: "בקרוב",
    authoredByMe: "נכתב על ידי",
    commentsLabel: "סקירת הערות",
    clearedOnTime: "נוקה בזמן",
    daysToClear: "ימים לנקות",
    daysToClose: "ימים לסגירה",
    totalLabel: 'סה"כ הערות',

    criticalAndHighRn: "קריטי והערות בדירוג גבוה ",
    criticalAndHighComments: "קריטי והערות בדירוג גבוה ",
    lowAndMediumComments: "הערות בדירוג בינוני ונמוך",
    metricsInstructionalText: "הצג את מדדי הביצועים עבור ההקצאות וההערות שלך למטה. <br>בחר חבר צוות כדי לראות את המדדים שלו או בחר <b>תצוגת תיק הביקורת</b> כדי לראות סיכום כולל.",
    metricsNewInstructionalText: "בחר חבר צוות כדי לראות את הערות הסקירה וההקצאות שלו או בחר <b>תצוגת תיק הביקורת</b> בכדי לראות סיכום כולל.",
    switchToViewPlaceholder: "אין נתונים להצגה.<br>בחר חבר צוות אחר או עבור אל <b>תצוגת תיק הביקורת.</b>",
    tasksClosedOnTime: "המשימות נסגרו בזמן",
    daysDetailReview: "ימים לסקירה מפורטת (detail review)",
    daysGeneralReview: "ימים לסקירה כללית (general review)",
    totalDaysReview: 'סה"כ ימים לסקירה ',
    metricsInstructionalTextconfiguration: "ראה למטה סיכום כולל של מדדי ביצועים עבור הקצאות והערות.",

    //document download
    docSizeMB: "MB",
    docSizeKB: "KB",
    labelForExpiredPackage: "פג תוקף החבילה.",
    headerForDocumentDownload: "לחץ על שם הקובץ להורדה",
    labelForNoFiles: "לא היו קבצים בקטגוריות שנבחרו.",
    labelForProcessing: "קבצים נמצאים בעיבוד.",

    //create dropdown texts
    create: "צור",
    addRequestText: "בקשה",
    addExternalTaskText: "משימה חיצונית",
    addFindingText: "ממצא",
    show: "הצג:",
    riskTypeHeader: "סוג הסיכון",
    wcgwHeader: "WCGW",
    hasNotes: "הערות פתוחות",
    hasNote: "הערה פתוחה",
    noNotes: "(0 הערות פתוחות)",
    addTemporaryFiles: "הוסף קבצים זמניים",
    addPriorPeriodEvidence: "הוסף תקופה קודמת",
    addExternalDocuments: "הוסף מסמכים חיצוניים",
    //Nav
    navHeaderTasks: "משימות",
    quickFilterAllCompletedTasks: "כל המשימות שהושלמו",
    quickFilterMyCompletedAssignmnets: "המשימות שהוקצו לי שהושלמו",
    quickFilterMyUpcomingAssignments: "המשימות הקרובות שהוקצו לי",
    navHeaderTaskCategory: "משימות לפי קטגוריות ",
    navFilterBy: "אפשרויות סינון",
    navHeaderDocuments: "מסמכים",
    navHeaderCollaboration: "שיתוף פעולה",
    navHeaderAssignments: "משימות לביצוע",
    navHeaderAutomation: "אוטומציה",
    navHeaderMore: "עוד",
    navDashboard: "Dashboard",
    navReviewnotes: "סקירת הערות",
    navHeaderManageteam: "ניהול צוות",
    navHeaderMangeteamNew: "ניהול צוות - חדש",
    mangeteam: "ניהול צוות",
    postArchive: "אחרי הארכיב",
    addmember: "הוסף חבר צוות",
    addnewmember: "הוסף חבר צוות",
    addPriorPeriodMembers: "הוסף חברי צוות לא פעילים",
    addPriorPeriodUsers: "הוסף חברי צוות לא פעילים",
    createPackage: "צור חבילה",
    engagementrole: "תפקיד בתיק הביקורת",
    noPendingPriorPeriodUsers: "אין חברים לא פעילים להזמין",
    sendPriorPeriodUserInvitesWithCount: "שלח ({0}) זימונים",
    sendPriorPeriodUserInvitesWithoutCount: "שלח זימונים",
    priorPeriodMembersModalHeaderMessage: "בחר את החברים הלא פעילים שברצונך להוסיף להתקשרות שלך. החברים יקבלו הרשאות שהיו להם בעבר במסגרת ההתקשרות עם ההפעלה מחדש.",
    priorPeriodIndependenceModalHeaderMessage: "בחר את חברי הצוות הלא פעילים שתרצה להוסיף להתקשרות שלך לצרכי אי תלות בלבד.",
    disabledPriorPeriodMembersButtonToolTip: "אין לך הרשאה להוסיף חברי צוות קודמים. פנה אל חבר צוות ביקורת אחר עם הרשאות מתאימות לבצע פעולה זו.",
    disabledNewMembersButtonToolTip: "אין הרשאה להוסיף חברי צוות חדשים. פנה אל חבר צוות ביקורת אחר עם הרשאות מתאימות לבצע פעולה זו.",
    disabledNewMembersButtonToolTipThirdpartyuser: "אין לך הרשאה נוספת להוספת משתמשים חדשים חיצוניים לתיק הביקורת. דבר עם חבר צוות לתיק הביקורת שיש לו הרשאות מתאימות לביצוע פעולה זו. ",
    rbacNoRightsForContentUpdateToolTip: "אין הרשאות גישה מספיקות לביצוע עדכון תוכן. פנה למנהל תיק הביקורת שלך ובקש הרשאה ליזום עדכון תוכן.",
    deactivateInternalUsersWithCount: "נבחרו {0} חברים",
    canvasFormSelectionMessageSingular: "{0} טפסי קאנבס נבחרו",
    canvasFormSelectionMessagePlural: "נבחרו {0} טפסי Canvas",
    pspAccountSelectionMessageSingular: "נבחר סעיף {0}",
    pspAccountSelectionMessagePlural: "{0} סעיפים נבחרו",
    manageTeamGroupLabel: "קבוצה",
    manageTeamGroupsLabel: " קבוצה",
    allAccessGroups: " קבוצות",
    reactivate: "הפעל מחדש",
    deactivate: "בטל",
    unselect: "בטל את כל הסינונים",
    deactivateInternalModalTitle: "הפוך חברי צוות פנימיים ללא פעילים",
    deactivateInternalModalMessage: "האם אתה בטוח שברצונך להפוך את חברי הצוות הבאים ללא פעילים?",
    deactivateInternalUsersSuccessMessage: "{0} חברי צוות נהפכו ללא פעילים בהצלחה.",
    deactivateExternalModalTitle: "הפוך חברי צוות חיצוניים ללא פעילים",
    deactivateExternalModalMessage: "האם אתה בטוח שברצונך להפוך את חברי הצוות הבאים ללא פעילים מ{0}? פריטים שהוקצו להם בעבר יוקצו מחדש לקבוצות הגישה המתאימות.",
    deactivateExternalSuccessMessage: "חברי הצוות הפכו ללא פעילים בהצלחה",
    internalMember: "חברי צוות פנימיים",
    addinternalmember: "הוסף חבר צוות פנימי",
    addThirdPartymember: "הוסף משתמש חיצוני",
    missingResponsiblePerson: "חסר גורם אחראי",
    sentRequests: "נשלח",
    receivedRequests: "התקבל",
    syncProfileNotAllowed: "סנכרון פרופיל אינו מותר",
    allSyncProfileNotAllowedMessage: "סנכרון פרופיל אינו מותר. הטופס אינו זמין עבור פרופיל זה.",
    allCanvasFormsContentUpdateMessage: "לא ניתן להעביר תוכן עבור פעילויות הפעלה של EY Canvas FIT משותפות. אנא בטל את הקישור לפעילויות אלו כדי להמשיך לעדכוני תוכן.",
    someFormContentUpdateMessage: "לא ניתן לסנכרן חלק מהטפסים לפרופיל תיק הביקורת מכיוון שאין תוכן",
    linkedFormContentUpdateMessage: "לא ניתן להעביר עבור פעילויות הפעלה של EY Canvas FIT משותפות. בכדי לעדכן תוכן עבורם, אנא בטל את הקישור לפעילויות אלו.",
    leaveUsFeedback: "השאר לנו משוב",

    notApplicableLabel: "לא רלוונטי",
    addThirdPartyMemberDescription: "יש להשתמש בפונקציונליות זו רק כדי להעניק למבקרי צד ג' גישה לתיק הביקורת ב EY Canvas. יש להשיג אישורים והרשאות מתאימים מהמחלקה המקצועית.",
    hasOverallResponsibilityDescription: "חבר בצוות הביקורת הלוקח אחריות כוללת על ההכוונה, הפיקוח וביצוע הביקורת או ההתקשרות ועל כך שהדוח ו/או המסקנה בחבילת הדיווח הבין משרדית מתאימים בנסיבות העניין.",
    partnerInChargeHeader: "Executive in charge/שותף אחראי על הביקורת (PIC)",
    picFlag: "PIC",
    CannotUpdatePicInArchivedEngagement: "לא ניתן לעבד עריכות בשדות מוגבלים. רענן ונסה שוב.",

    noGroupFound: "לא נוצרו קבוצות למתן הרשאות גישה בתיק ביקורת זה. בחר \ 'הוסף קבוצה למתן הרשאות גישה \' כדי ליצור קבוצה למתן הרשאות גישה חדשה חיצונית לחברי צוות.",
    addGroup: "הוסף קבוצה",
    deleteGroup: "מחק את קבוצת הגישה",
    deleteGroupMessage: "האם אתה בטוח שברצונך למחוק את קבוצת הגישה ה{0}?",
    addAccessGroup: "הוסף קבוצה למתן הרשאות גישה",
    accessGroupCreated: "קבוצת גישה חדשה {0} נוצרה בהצלחה",
    accessGroupUpdated: "שינויים בקבוצת למתן הרשאות גישה {0} נשמרו בהצלחה.",
    editAccessGroup: "ערוך את קבוצת הגישה",
    sharedGroupwarning: "זוהי קבוצת גישה משותפת ושינויים בה יבואו לידי ביטוי בכל תיקי הביקורת הקשורים אליה.",
    groups: "קבוצות",
    addExternalMembers: "כל חברי הצוות החיצוניים",
    members: "חברי צוות",
    externalMember: "חברי צוות חיצוניים",
    member: "חבר צוות",
    role: "תפקיד (Role)",
    actions: "פעולות",
    internalUserEdit: "ערוך",
    internalUserDeactivate: "להפוך ללא פעיל (Deactivate)",
    usersFilter: "מסנן",
    externalUserEdit: "ערוך",
    externalUserDeactivate: "להפוך ללא פעיל (Deactivate)",
    externalUserGroupLabel: "קבוצות",
    externalNoUserInGroup: "לא נוספו חברי צוות לקבוצה למתן הרשאות גישה זו.",
    externalNoUserInAllGroup: "לא נוספו חברי צוות להתקשרות זו.",
    alias: "כינוי",
    independence: "אי תלות",
    navManagegroup: "ניהול ביקורת קבוצה",
    navCRAsummary: "סיכום הערכת הסיכון המשולב (CRA)",
    navAuditplan: "תוכנית ביקורת",
    navWorkplan: "תוכנית עבודה",
    navSEM: "Substantive Evaluation Matrix",
    nav440GL: "שינויים לאחר תאריך הדוח",
    navFindings: "ממצאים",
    navCanvasformupdates: "עדכוני טפסים ב- Canvas",
    navPSPContentUpdates: "עדכוני תוכן PSP",
    navCopyhubNew: "Copy hub - חדש",
    navCopyhub: "Copy hub",
    navArchiveChecklist: "שאלון לביצוע ארכיב",
    navExporthub: "ייצוא כונן HUB",
    navReporting: "דוחות",
    navAccountSummary: "סיכום הסעיפים",
    navScotSummary: "סיכום תתי התהליכים המהותיים (SCOTs)",
    navItSummary: "סיכום IT",
    navGroupInstructionSummary: "הנחיות קבוצתיות",
    navGroupInvolvement: "מעורבות קבוצתית",
    navHelixProjects: "חיבורי EY Helix",
    navContentUpdates: "עדכון תוכן",
    contentUpdateErrorMsg: "אין לך הרשאות לשמור שינויים. פנה לחברי צוות אחרים עם הרשאות מתאימות בכדי לבצע שינויים.",
    contentUpdateTitleTip: "אין הרשאות גישה מספיקות לביצוע עדכון תוכן. פנה למנהל תיק הביקורת שלך ובקש הרשאה ליזום עדכון תוכן.",
    noPreviousUpdates: "אין עידכונים קודמים",
    noContentUpdateResults: "לא נמצאו תוצאות",
    noPSPAccountsToUpdate: "אין סעיפים לעדכון",
    rbcaUnavailableMsg: "EY Canvas לא יכול לשמור שינויים כעת. אנא נסה שנית. אם הבעיה נמשכת צור קשר עם התמיכה הטכנית",
    showErrInProgressMsg: "29007 - לא ניתן להפעיל עדכוני תוכן בזמן שעדכונים אחרים מתבצעים. המתן עד שיסתיים עדכון התוכן הנוכחי או רענן את הדף ונסה שוב.",
    navHelp: "עזרה כללית",
    validationNavHelp: "עזרה באימות",
    searchUserText: "חפש משתמש",
    superModelTitle: "אובייקטים בהתקשרות (Engagement objects)",
    superModelText: "Super modal",
    independenceOnlyMembers: "חברי צוות לצרכי אי תלות בלבד",
    noIndependenceOnlyPriorPeriodUsers: "אין חברי צוות לא פעילים שניתן להזמין לצרכי אי תלות בלבד",

    //Copyright
    copyRight: "זכויות יוצרים © <year> כל הזכויות שמורות",

    //Copyhub List labels
    moreRecipient: "עוד",
    copyHubPackageName: "שם חבילה",
    copyHubSentBy: "נשלח על-ידי",
    copyHubSentTo: "נשלח אל",
    copyHubReceivedBy: "התקבל על ידי",
    copyHubDate: "תאריך",
    copyHubRemainingTime: "זמן שנותר",
    copyHubAvailableFor: "פנוי ל",
    copyHubStatus: "סטטוס",
    noCopyHubSentPackages: "עדין לא נותרו חבילות העתקה. בחר צור חבילה כדי ליצור חבילת נתונים חדשה.",
    noCopyHubReceivedPackages: "אין חבילות העתקה (copy packages) זמינות לתיק ביקורת זה",
    remainingTimeTooltip: "פריטים יוסרו לצמיתות בזמן הארכיב, או 10 ימים לאחר היצירה",
    copyHubDeleteText: "מחק",
    appendDays: "ימים",
    generalInformation: "מידע כללי",
    copyDocuments: "מסמכים",
    copyFiles: "קבצים",
    scots: "SCOTs",
    accounts: "סעיפים",
    copyHubImport: "ייבוא",
    copyHubPackageType: "סוג חבילה: ",
    copyHubCreatedModal: "נוצר: ",
    copyHubRemainingTimeModal: "זמן שנותר: ",
    copyHubAvailableForModal: "פנוי ל:",
    copyHubInstructionModal: "הנחיות: ",
    copyHubCategories: "קטגוריות",
    copyHubPendingDeletion: "ממתין למחיקה",
    copyHubVersionMismatchCat: "אין אפשרות להציג קטגוריות עקב אי-התאמה של גירסת החבילה",
    copyHubVersionMismatchPersonInfo: "אין אפשרות להציג פרטי שולח ומקבל עקב אי-התאמה בגירסת החבילה",
    copyHubViewLegacyPacakgeDetails: "זוהי חבילת העתקה מקורית (legacy) שאין מידע מפורט עבורה",
    associateTasks: "משימות קשורות",
    backToForms: "בחזרה לטפסים",
    noTaskSelected: "יש לבחור לפחות משימה אחת",
    taskLabel: "משימה:",
    taskMessage: "עליך לשייך את המשימה לטפסי ייבוא אלה.",
    importSuccessMessage: "בקשת הייבוא הועברה בהצלחה להמתנה ",
    taskSelectedText: "משימות שנבחרו",
    insufficientPermissionsToImport: "אין מספיק הרשאות לייבוא העתק מחבילת הדיווח. צור קשר עם מנהל תיק הביקורת שלך ובקש אישור לייבא  את חבילת הדיווח.",
    cannotImportExpiredPackage: "לא ניתן לייבא חבילת דיווח שפג תוקפה.",
    cannotImportWhileInProgress: "לא ניתן לייבא חבילת דיווח שכבר בתהליך.",
    deletePackageHeader: "מחק חבילת דיווח",
    copyPackageDeleted: "חבילת הדיווח נמחקה",
    copyPackageDeleteConfirmation: "האם אתה בטוח שברצונך למחוק חבילת דיווח זו?",
    insufficientPermissionsToDelete: "אין הרשאות מספיקות למחיקת חבילות העתקה. פנה למנהל תיק הביקורת שלך ובקש הרשאה למחוק את חבילות ההעתקה.",
    insufficientPermissions: "הרשאות לא מספיקות",
    GuidedWorkflowsPackageDisplayText: "בחירה בייבוא תוביל לעדכון תהליכי עבודה מודרכים (Guided Workflows) תואמים מהעותק להתקשרות זו. תהליכי עבודה מודרכים (guided workflow) ללא התאמה לא ייובאו.",
    copyRequestStatusInQueue: "בתור",
    GuidedWorkflowImportError: "ייבוא תהליכי עבודה מודרכים (Guided Workflows) אינו זמין עבור התקשרות מרובות ישויות",

    //TopHeaderLayout.js
    topHeaderLayoutMilestoneText: "סיכום שלב - תיאום או התאמה של המידע הכספי לרשומות החשבונאיות שבוקרו. השג ראיה לכך שהמידע הכספי ביניים שבוקר תואם ליתרות החשבונאיות של הסעיפים שבוקרו. ",
    //TaskLayoutHeader
    taskLayoutHeaderSearchPlaceholder: "חפש משימות",
    taskLayoutHeaderAssignments: "משימות לביצוע",
    taskLayoutHeaderAddTask: "משימה חדשה",
    wcgwSearchPlaceholder: "חפש WCGW",
    //TaskListHeader
    taskTypeHeader: "סוג",
    taskNameHeader: "שם",
    taskDueDateHeader: "תאריך יעד",
    reviewNoteChangeDueDate: "שינוי תאריך יעד",
    taskListHeaderSortByDueDate: "תאריך יעד",
    taskListHeaderSortByTaskName: "שם משימה",
    sortBy: "מיין לפי:",
    ascending: "בסדר עולה",
    descending: "בסדר יורד",
    taskListHeaderSortByKnowledge: "תוכנית ביקורת",
    taskListHeaderDeleteWarning: "האם אתה בטוח שברצונך למחוק משימות שנבחרו.",
    taskListHeaderSortText: "מיין",
    taskListHeaderSortOrderText: "סדר מיון",
    taskListHeaderTimePhaseText: "הגדר שלב זמן",
    taskListHeaderBookMarkText: "Bookmark",
    taskListHeaderFavoriteText: "מועדף",
    taskListHeaderEditText: "עריכת כותרת משימה",
    moreMenu: "עוד",
    taskListHeaderMoveTaskText: "שנה קבוצת משימות",
    taskGroupIconHoverText: "שנה קבוצת משימות",
    taskGroupLabel: "שנה קבוצה",
    task: "משימה",
    toc: "TOC",
    tenNotes: "10 הערות",
    source: "מקור",
    nature: "אופי",
    assertion: "יעדי ביקורת",
    relatedAccounts: "סעיפים קשורים",
    testOfDetail: "בדיקת פריטים (Test of details)",
    testOfControl: "טסט לבקרה (TOC)",
    substantiveAnalyticalProcedure: "נוהל אנליטי מבסס",
    tod: "TOD",
    sap: "SAP",
    int: "INT",
    ext: "שלוחה",
    notSel: "לא נבחר",
    internal: "פנימי",
    external: "חיצוני",
    notSelected: "לא נבחר",
    documentCannotOpen: "לא ניתן לפתוח מסמך זה מפרטי המשימות (Task Details). נווט אל רשימת המסמכים (Documents List) כדי לפתוח מסמך זה.",
    //TaskPanelLayout
    emptyTaskDetailsMessage: "בחר משימה לצפייה בפרטים",
    multiTaskSelectedMessage: "כדי לאפשר בקרות בבת אחת השתמש במקש בקרהת מפתח ובחר משימות מרובות.  \n אם ברצונך לעבוד על משימה בודדת בחר משימה זו מרשימת המשימות.",
    emptyAndMultiSelectedMessage: "בכדי לאפשר בקרות בכמות גדולה השתמש בתיבת הסימון כדי לבחור משימה אחת או יותר. השתמש במקש shift בכדי לבחור מספר משימות בו זמנית. אם ברצונך לעבוד על משימה בודדת בחר משימה זו מהרשימה.",
    //Evidence
    evidenceDragAndDrop: "גרירה ושחרר או",
    //Timephases
    noResultTimePhase: "לא נמצאו תוצאות",
    //handoff
    handoff: "מסירת המסמך (Hand-Off)",
    handoffConfirmButtonText: "העבר",
    handoffModalTitle: "העבר משימה",
    handoffTitle: "העברה לחבר הצוות הבא",
    handoffTextLine2: "כדי לחתום על קובץ הראיות, בחר מבין האפשרויות שלהלן.",
    return: "החזר",
    returnDisabledMessage: "לא ניתן לאחזר משימה זאת הואיל : (1) אתה המכין שהוקצה למשימה (2) סטטוס המשימה אינו 'בסקירה' או 'הושלם' או (3) לא הוקצה מכין.",
    handOffTitleTip: "מסירת המסמך לעיון (Hand-off for Review)",
    //Mark Complete
    markCompleteTitleTip: "סמן כהושלם",
    markCompleteTitle: "לסמן משימה כהושלמה",
    markCompleteText: "ה- sign-off שלך מתייחס לכל הראיות שמשויכות למשימה זו כפי שמצוין להלן. משימה זו תסומן כמשימה שהושלמה. ",
    markCompleteTextLine1: "העביר (hand-off) את המשימה הזו לחבר הצוות הבא.",
    markCompleteTextLine2: "כדי לחתום על קובץ ראיות, בחר מבין האפשרויות שלהלן. אם הוקצת למשימה זו והשלמת אותה, בחר <b>כן</b> כדי לסגור אותה. אם משימה זו דורשת אישור שותף אחראי על הביקורת PIC או שותף מלווה EQR, בחר מבין האפשרויות שלהלן.",
    markCompleteConfirm: "סמן כהושלם",
    signOffAs: "חתום על הכל כגון:",
    additionalSignOff: "sign-offs נוספים נדרשים",
    additionalTaskStatus: "סגור את המשימה שלי",
    markCompleteModalHeaderTextPart1: "משימה זו תסומן כמשימה שהושלמה.",
    markCompleteModalHeaderTextPart2: "כדי לחתום על קובץ ראיות, בחר מבין האפשרויות שלהלן. אם הוקצת למשימה זו והשלמת אותה, בחר <b>כן</b> כדי לסגור אותה. אם משימה זו דורשת אישור שותף אחראי על הביקורת PIC או שותף מלווה EQR, בחר מבין האפשרויות שלהלן.",
    ep: "PIC",
    eqr: "EQR",
    closeMyAssignment: "סגור את המשימה שלי",
    tempMarkCompleteMessage: "לא ניתן לסמן שהמשימה הושלמה. רענן את הדף ונסה שוב. אם הבעיה נמשכת פנה ללתמיכה הטכנית.",
    tempMarkCompleteEnable: "סמן כהושלם - Enable",
    tempMarkCompleteDisable: "סמן כהושלם - Disable",
    //TaskDetails
    seeTask: "ראה משימות",
    NoTasksFound: "לא נמצאו משימות",
    taskDetailsAddRelate: "הוסף/קשר",
    taskDetailsDocument: "מסמך",
    taskDetailsAutomationRequest: "בקשה אוטומטית",
    taskDetailsExternalTask: "משימה חיצונית",
    taskDetailsFinding: "ממצא",
    taskDetailsRequest: "בקשה",
    taskDetailsNotes: "הערות",
    taskDetailsRelatedTask: "משימה קשורה",
    epeqr: "PIC/EQR",
    epeqrsignoffheader: "נדרשת חתימה",
    addTaskGroupLabel: "הוסף קבוצת משימות",
    itgcTaskDescription: "בצע את הבדיקות המתוכננות שלנו על הבקרות הכלליות במערכות המידע (ITGCs) בכדי לקבל ראיות ביקורת נאותות מספיקות בקשר לאפקטיביות התפעולית של הבקרות כאמור לאורך כל תקופת ההסתמכות.",
    //create assignment
    createassignmentheaderLine1: "לחבר הצוות שנבחר אין הקצאה למשימה זו.",
    createassignmentheaderLine2: "צור הקצאה כאן. אם לחבר צוות אחר כבר יש הקצאה שלא הושלמה מאותו סוג",
    createassignmentheaderLine3: "בחר ",
    createassignmentheaderLine4: " כדי להחליף אותו במשימה זו.",
    overwriteIncompleAssignments: "החלף הקצאות לא שלמות",
    //Create Assignment
    createassignmentheader1: "לחבר הצוות שנבחר אין הקצאה למשימה זו.",
    createassignmentheader2: "צור הקצאה כאן.",
    //Guidance
    atlasLink: "קישור לאטלס",
    automationLink: "קישור אוטומציה חכם (Smart Automation)",
    otherLink: "קישור אחר",
    helixLink: "קישור Helix",
    relatedAutomations: "אוטומציות קשורות",
    noSuggestedAutomationLabel: "אין אוטומציות מוצעות למשימה זו.",
    noSuggestedItemLabel: "אין פריטים מוצעים למשימה זו.",
    noAutomationRequestLabel: "משימה זו אינה קשורה לשום אוטומציה. כדי להתחיל צור אוטומציה חדשה או קשר אוטומציה קיימת.",
    relateAutomation: "מקושר",
    relateAutomationModelHeader: "קשר אוטומציות חכמות (Smart Automations)",
    automationSolution: "פתרון",
    automationName: "שם אוטומציה",
    relateAutomationTextLine1: "קשר אוטומציה חכמה (Smart Automation) למשימה זו.",
    relateAutomationTextLine2: "לאחר הקישור, באפשרותך לצפות באוטומציה דרך פרטי המשימה ולפתוח אותה באמצעות לחיצה.",
    noSamrtAutomationForEngagement: "לא נוצרו אוטומציות חכמות (Smart Automations) עבור תיק הביקורת שלך.",
    searchAutomationLabel: "חפש אוטומציות  (Search automations)",

    //RelatedItemHeader
    relatedItemsHeader: "פריטים קשורים",
    relateButtonText: "מקושר",
    createButtonText: "צור",
    relatedItemREQ: "בקשה",
    relatedItemET: "משימה חיצונית",
    relatedItemATM: "אוטומציה",
    relatedItemRelatedTask: "משימה קשורה ",
    relateObjectsToTaskTitle: "קשר פריטים למשימה זו",
    relateObjectsToTaskSubTitle: "קשר פריט אחד או יותר למשימה זו. פריטים אלה יופיעו במקטע פריטים קשורים בפרטי המשימה.",
    relateObjectOptionsHeaderPSPOSP: "סעיפים מצגי הנהלה (assertions) וסעיפים בסיכון מוגבל (limited risk accounts)",
    relateObjectOptionsHeaderITWalkthrough: "תהליכי IT",
    relateObjectOptionsHeaderITControl: "בקרות IT (ITGCs ו- ITSPs)",
    // SDM Nextwave services
    scheduledServicesText: "שירותים קשורים",
    suggestedServicesText: "שירותים מוצעים",
    suggestedServicesDefaultMessage: "קיימים שירותי NextWave המוצעים עבור משימה זו. לחץ על",
    suggestedServicesDefaultMessage1: '+',
    suggestedServicesDefaultMessage2: " בכדי להתחיל.",
    suggestedServicesPlaceholderMessage: "אין שירותים מוצעים עבור משימה זו.",
    nextWaveServiceOfferingLabel: "שירות",
    nextWaveServiceStatusLabel: "סטטוס",
    nextWaveServiceStartDateLabel: "להתחיל",
    nextWaveServiceDueDateLabel: "היעד בעוד",
    nextWaveServiceRequestCreate: "צור בקשה",
    nextWaveServiceRequests: "בקשות שירות מרוכזות (Centralized service requests)",
    nextWaveServiceGatewayRequests: "בקשות לקבלת שירות (Service Gateway)",
    onlyShowSelectedTask: "הצג רק את המשימה שנבחרה",
    sdmRestrictAddTaskLabel: "לחץ על המשך כדי לעבור לשלב הבא. בחירת המשימות תתבצע לאחר שתתקבל החלטה לבצע/או לא לבצע חלק מהנהלים על ידי  GDS באמצעות מנהלי תיק ההתקשרות. ",
    //Links
    linksText: "קישורים",
    //Forms
    formsText: "טפסים",
    /*Accounts*/
    associatedTasks: "משימות המשויכות לפריט- WCGW",
    noAssertionsChecked: "בחר יעד ביקורת (assertion) בכדי לצפות ב WCGW קשורים",
    noAccountsCreated: "לא נוצרו סעיפים",
    noDesignationSelected: "לא נבחרה הקצאה",
    noRelatedAccounts: "אין חשבונות קשורים",
    manageAccount: "ניהול סעיפים וגילויים",
    /*Risks*/
    risk: "סיכון ",
    risks: "סיכונים",
    wcgw: "WCGW",
    riskWcgw: "שיוך של סיכון:WCGW",
    wcgwTasks: "WCGW: משימה",
    riskWcgwLabel: "קשר סיכונים ל-WCGWs",
    wcgwTasksLabel: "קישור ה- WCGW למשימה",
    noRiskTypes: "לא נמצאו סוגי סיכונים",
    saveRisk: "שמור",
    noRisksFound: "לא נמצאו סיכונים",
    haveBeenIdentified: "זוהה",
    noAssertionFound: "אין מצגי הנהלה קשורים החלים על התקשרות זו",
    noAssertionApplicable: "לא שויכו מצגי הנהלה החלים על התקשרות זו",
    noWCGWFound: "אין WCGW שקשורים לסיכון זה. לחץ על ערוך קשרים לאחד או יותר מה- WCGWs הרלוונטים.",
    noRelatedWCGWs: "אין WCGWs קשורים",
    noRelatedControls: "אין בקרות קשורות",
    noRelatedRisks: "אין סיכוני IT קשורים",
    noRelatedITGCs: "אין ITGCs קשורים",
    iTriskVal: "סיכון IT",
    iTrisksVal: "סיכוני IT",
    iTGCVal: "בקרות כלליות במערכות המידע (ITGC)",
    iTGCsVal: "ITGCs",
    iTSPVal: "נוהל מבסס ל- IT  (IT-substantive testing procedures (ITSP)) ",
    iTSPsVal: "ITSPs",
    iTGCname: "שם ITGC",
    iTSPname: "שם ITSP",
    noWCGWAvailable: "אין ROMM זמין עבור מצג(י) ההנהלה (Assertion(s שנבחרו",
    relevantWcgwCountHint: "יש לקרוא את המספר המוצג לצד שם הסעיף כמספר ה- WCGW הקשורים לסיכון בקרה שהוחלט לא להסתמך על הבקרה או יעדי הנהלה הקשורים להערכת סיכון גבוהה יותר אשר קשורים לנוהל מבסס בהשוואה למספר הכולל של ה- WCGWs.",
    noAccountsFound: "לא נמצאו רשומות",
    selectAssertionToRelateWCGW: "בחר מצג הנהלה כדי לקשר סיכון ל WCGW",
    significantAccounts: "סעיפים מהותיים",
    riskName: "סיכון: ",
    accountName: "סעיף: ",
    noScotsFound: "אין תתי תהליכים מהותיים (SCOTs) קשורים",
    relatedwcgw: "WCGWs מקושרים",
    relatedRisks: "סיכונים קשורים",
    noRelatedAssertionsLabel: "לא נבחרו מצגי הנהלה לחשבון",
    boltIconTitle: "סיכונים קשורים",
    instructions: "הוראות",
    expandRisk: "1. הרחב את הסיכון",
    selectAssertion: "2. בחר מצג הנהלה (assertion)",
    identifyRelatedWCGW: "3. זהה WCGWs הקשורים לסיכון",
    clickAccount: "1. לחץ על סעיף",
    selectWCGW: "2. בחר WCGW",
    identifyRelatedTask: "3. זהה את המשימות כמענה ל- WCGW",
    information: "מידע",
    requiredAssertions: "מצגי הנהלה נדרשים",
    wcgwWithoutTasks: "WCGW ללא משימות",
    found: "מצא",
    editAssociations: "ערוך קישורים",
    riskWCGW: "שיוך של סיכון:WCGW",
    wcgwTask: "קישורים של משימה:WCGW",
    requireTaskToBeRelated: "נדרש כי המשימה תהיה קשורה ל",
    expandCollapse: "לחץ כאן כדי להרחיב/לצמצם",
    requiredAssertionsInfo: "הצג רק יעדי הנהלה עם הערכת סיכון בקרה שלא מסתמכים על הבקרות והסתמכות ויעדי הנהלה הקשורים להערכות סיכון גבוהות יותר.",
    wCGWwithoutTasksInfo: "הצג רק WCGWs הקשורים לקביעה של הערכת סיכון בקרה של אי הסתמכות וקביעות הקשורות להערכות סיכון גבוהות יותר שלא קשורות למשימות מהותיות שנותנות מענה.",
    noBuildStepsAvailable: "אין שלבים זמינים להצגה.",
    accountRiskAssessmentSummary: "סעיפים וגילויים",
    manageRisk: "ניהול סיכונים",
    addResponsivePSPOSP: "הוסף מענה באמצעות PSP/OSP",
    assertionlbl: "יעד הנהלה",
    addResponsiveControl: "הוסף מענה באמצעות בקרה",
    addResponsiveTOC: "הוסף מענה באמצעות בדיקת בקרה TOC ",
    showOnlyRelatedItems: "הצג רק כאלו שקשורים",
    relatedControlCounter: "בקרה {0}",
    relatedControlsCounter: "{0} בקרות",
    noControlsAvailableForRelateItem: "אין בקרות זמינות",
    relateControlName: "בקרות",
    relateContolsAPIErrorMessage: "בקרה לא יכולה להיות קשורה למצג ההנהלה. רענן את הדף ונסה שוב. אם הבעיה נמשכת פנה לדלפק העזרה.",
    relateTasksAPIErrorMessage: "המשימה לא יכולה להיות מקושרת למצג הנהלה. רענן את הדף ונסה שוב. אם הבעיה נמשכת פנה לתמיכה הטכנית.",
    toggleFilterWarningMessage: "הצג רק סעיפים וגילויים ללא כל נהלים מבססים",
    toggleFilterWarningMessageForRisk: "הצג רק סיכונים ללא כל נהלים מבססים או בקרות/TOCs אשר תוכננו למתן תגובה (responsive).",
    warningIconHoverText: "סיכון ללא כל נהלים מבססים או בקרות/TOCs אשר תוכננו למתן תגובה (responsive).",
    filterYes: "כן",
    filterNo: "לא",

    /*OrphanedControls*/
    orphanedControls: 'View unrelated controls',
    unRelatedOrphanControls: 'Unrelated controls',
    noOrphanedControlsDataLabel: "No unrelated controls available",
    noOrphanedControlsResultLabel: "No unrelated controls available",
    noControlSelected: 'At least one control must be selected for deletion.',
    controlsDeleteConformation: 'Are you sure that you want to delete the selected controls?',
    controlDeleteConformation: 'Are you sure that you want to delete the selected control?',
    deleteControlModalHeader: 'Confirm deletion of selected control',
    deleteControlsModalHeader: 'Confirm deletion of selected controls',

    /*SEM*/
    select: "בחר",
    selectAnAccountFromTheDropDown: "1. בחר סעיף מהרשימה להלן",
    applyAsertionsFilters: "2. בחר מסננים למצגי ההנהלה (assertions)",
    reviewTheTasksThatRespondToTheRisks: "3. סקור את המשימה(ות) כמענה לסיכון(נים)",
    riskOfMaterialMisstatement: "סיכונים להצגה מוטעית מהותית (ROMM)",
    expandScot: "1. הרחב את תת התהליך המהותי (ה- SCOT)",
    selectWCGWToDisplayTheResponsiveTask: "2. בחר את הסיכון להצגה מוטעית מהותית בכדי להציג את משימות המענה לסיכון בהתאם",
    tasksWithNoRelatedWCGW: "משימות ללא סיכונים קשורים להצגה מוטעית מהותית ROMM",
    selected: "המשתמש שנבחר",
    clearSelections: "בטל את כל הסינונים",
    romm: "ROMM",
    selectAccount: "סעיף",
    selectHeader: "בחר כותרת",
    riskOfMaterialMisstatementsWithoutRelatedTask: "סיכונים של הצגה מוטעית מהותית ROMM ללא משימות קשורות",
    selectOneOrMoreTasksToSeeTheRelatedROMM: "בחר משימה אחת או יותר שברצונך לראות ב ROMM הרלוונטי",
    invalidRelatedEntity: "לא ניתן למצוא חשבון קשור. רענן את הדף ונסה שוב. צור קשר עם דלפק העזרה (Help Desk) אם הבעיה נמשכת.",
    scrollUp: "לגלול למעלה",
    scrollDown: "לגלול למעלה",
    duplicate: "העתק",
    showIndex: "הצג אינדקס (מפתח ערכים)",
    noContentAvailable: "אין תוכן זמין",
    navigateTo: "נווט אל",
    /*validations */
    semValidation: "תיקוף SEM",
    riskWCGWValidation: "תיקוף Risk WCGW",
    showValidation: "תיקוף",
    wcgwWithNoRelatedTask: "WCGW ללא משימה מבססת קשורה",
    riskWithNoRelatedWCGW: "סיכון שלא משויך אליו WCGW",
    noValidationIdentified: "לא זוהו ולידציות",
    onlyShowScotWithNoControlNoWCGW: "הצג רק תתי תהליכים מהותיים SCOTs ללא קישור של WCGW או בקרה",
    /*CRA Badge*/
    ir: "IR",
    cr: "CR",
    cra: "CRA",
    selectToEdit: "בחר כדי לערוך",
    both: "שני",
    prefix: "קידומת",
    suffix: "סיומת",
    optional: "(אופציונלי)",
    title: "כותרת",
    charLimitExceeded: "חריגה ממגבלת התווים",
    requiredField: "שדה חובה",
    Lastmodifiedby: "שונה לאחרונה על ידי",
    fileSize: " | {1} KB",
    fileSizeInKB: "{1} KB",
    fileSizeHeader: "גודל הקובץ",
    daysAgo: "ימים לפני",
    weekAgo: "לפני שבוע",
    weeksAgo: "לפני שבועות",
    monthAgo: "לפני חודש",
    monthsAgo: "לפני חודשים",
    yearAgo: "לפני שנה",
    yearsAgo: "לפני שנים",
    currentlyBeingModifiedBy: "שונה כעת על ידי",
    beingEditedInCoeditModeError: 'Being edited in multi-user edit',
    beingEditedInCoeditMode: 'Being edited in multi-user edit. Edit started by {0} ',
    beingEditedInCoeditModeOn: 'on {0}.',
    coEditModeAutomaticallyEnds: 'Multi-user editing. {0} days until multi-user editing automatically ends.',
    coEditModeIsEnding: "עריכה מרובת משתמשים מסתיימת",
    coEditMode: "עריכה מרובת משתמשים",
    checkInInProgressMessage: "הצ'ק-אין מתבצע. ייתכן שיחלפו עד 20 דקות עד שהמסמך ייעשה צ'ק-אין. אנא רענן לקבלת עדכונים",
    checkOutInProgressMessage: "הצ'ק-אאוט מתבצע. יתכן שיחלפו עד 20 דקות עד שהמסמך יעשה צ'ק-אאוט. אנא רענן לקבלת עדכונים",
    daasErrorMessage: "לא ניתן להשלים את הפעולה כעת. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית (Help Desk)",
    coEditModeIsStarting: "עריכה מרובת משתמשים מתחילה",
    daasOpenDocumentWarning: 'Multi-user editing may have been ended by another user. Refresh the page and try again.',
    daasStartCollaborationModeWarning: 'Collaboration mode may have been started by another user. Refresh the page and try again.',
    documentCurrentlyBeingModifiedTitle: 'Document currently being modified',
    documentCurrentlyBeingModifiedHeader: 'This document is currently being modified by {0}. This user opened the document',
    documentCurrentlyBeingModifiedBody: 'Starting multi-user edit mode could cause conflicts, so we recommend discussing with {0} before proceeding. Select {1} to start the multi-user edit mode or {2} to return without starting multi-user edit mode.',
    documentEndMultiUserEditingTitle: 'Confirm you want to end multi-user editing',
    documentEndMultiUserEditingHeader: 'Warning: Other users may be actively editing this document.  This can be checked by opening the document and seeing if other users are currently in the file. Please confirm that all changes are complete before ending multi-user mode. File changes in multi-user mode may take up to 1 minute to be processed. Therefore, please wait at least 1 minute after exiting the file before ending multi-user mode.',
    documentEndMultiUserEditingBody: 'Select {0} to end the multi-user edit mode or {1} to return without ending multi-user edit mode.',
    startMultiuserEditing: 'Start',
    continue: "המשך",
    openReadOnly: "פתוח לקריאה בלבד",
    takeControlFromTeam: "קבל שליטה מחבר צוות הנוכחי",
    itapplication: "אפליקציית IT",
    aggregateITevaluation: "הערכת IT כוללת:",
    control: "בקרה",
    itgcitsp: "ITGC/ITGC",
    limitedRisk: "סעיף בסיכון מוגבל (limited risk account)",
    so: "SO",
    itApp: "אפליקציית IT",
    itAppType: "אפליקציית IT",
    deleteTaskModalHeader: "אשר מחיקה של המשימה שנבחרה",
    deleteTasksModalHeader: "אשר מחיקה של המשימות שנבחרו",
    deleteTaskModalMessage: "האם אתה בטוח שברצונך למחוק משימה זו? ",
    deleteTaskModalMessage1: "ראיות רלוונטיות שאינן קשורות למשימות אחרות בהתקשרות יועברו לקבצים זמניים. ממצאים ומענה למשימות שאינם קשורים לאף ראיית ביקורת אחרת ימחקו. ",
    deleteTasksModalMessage: "האם אתה בטוח שברצונך למחוק את המשימות הנ'ל? ",
    someTasksCannotBeDeleted: "לא ניתן למחוק חלק מהמשימות",
    onlySomeTasksCanBeDeleted: "ניתן למחוק רק חלק מהמשימות שבחרת.",
    tasksThatCanBeDeleted: "אם תבחר להמשיך <b>המשימות המפורטות למטה יוסרו</b> מתיק הביקורת שלך. ראיות שאינן קשורות למשימות אחרות בתיק הביקורת שלך יועברו לקבצים זמניים. ממצאים ומשימות מענה לסיכון שזוהה שאינם קשורים לראיות אחרות יימחקו גם הם. ",
    tasksThatCannnotBeDeleted: "<b>לא ניתן להסיר את המשימות המפורטות להלן</b> מתיק הביקורת שלך, אך עשויות להידחות מתוכנית הביקורת במידת הצורך.",
    accountHeader: "סעיפים",
    noAccountsIdentified: "לא זוהו סעיפים.",
    noRisksIdentified: "לא זוהו סיכונים",
    noAssertionsIdentified: "מצגי ההנהלה לא זוהו",
    noWcgwsIdentified: "לא זוהו WCGW",
    // Tasks/TaskDetails/Evidence
    addEvidence: "הוסף ראיות",
    relateEvidence: "קשר ראיות",
    relateTemporary: "קשר קבצים זמניים",
    relatePriorPeriod: "קשר ראיית ביקורת מהתקופה הקודמת",
    relateExtDoc: "קישור למסמכים חיצוניים",
    relateFile: "קשר קבצים",
    relateAnalytics: "קשר ניתוחים",
    quickAddButton: "הוסף קיצור",
    createPaperProfile: "יצירת paper profile",
    paperProfileInformationMessage: "אנו מכינים את כל התיעוד באופן אלקטרוני לרבות חתימות (sign-offs) של המכין והסוקר. רק תיעוד המסופק לנו על ידי ההנהלה או צד שלישי כעותק קשיח ושעבורו לא זמין עותק אלקטרוני (כגון עותק של חוזה חתום בין הישות לבין צד שלישי) מותרים כתיעוד כעותק קשיח בניירות העבודה שלנו. ",
    paperProfileName: "שם ה- Paper profile",
    paperProfileAdd: "הוסף",
    paperProfileError: "אנא הזן שם תקף ל paper profile",
    otherEngagementsInWorkspace: "התקשרויות אחרות בסביבת העבודה",
    relateDescription: "קשר מסמך מהתקשרות זו או מהתקשרות אחרת בסביבת העבודה.",
    onlyShowRelatedDocuments: "הצג רק מסמכים קשורים",
    relateDescriptionTemp: "קשר מסמך מהתקשרות זו.",
    added: "נוסף",
    documentLocation: "מיקום המסמך",
    documentIneligibleForSharingMessage: "לא ניתן לשתף מסמכים סודיים.",
    confidentialityNotAppropiateForSharing: "אין לך הרשאה עקב מגבלת סודיות לשליחת מסמך זה.",
    documentIsCheckedOut: "המסמך נמצא במצב עריכה משותפת ולא ניתן לשתף אותו. סיים מצב עריכה משותפת בכדי לשתף את המסמך.",
    addCanvasFormNew: "הוסף טופס Canvas חדש",
    documentCount: "מסמך {0}",
    documentsCount: "{0} מסמכים",
    fitDocumentCannotbeSelected: "לא ניתן לשתף מסמכי FIT בין התקשרויות.",
    // Task/TaskDetail/Description
    noDescriptionAvailable: "אין תיאור זמין.",
    knowledge: "ידע",
    knowledgeDescription: "תיאור הידע",
    descriptionInstructions: "התיאור המופיע בהנחיות",
    fromInstructions: "מההנחיות",
    customizeDescription: "תיאור מותאם אישית",
    custimizeTaskDescription: "התאמה אישית של תיאור משימה",
    editTaskDescription: "עריכת תיאור משימה",
    saveLabel: "שמור",
    okLabel: "אישור",
    cancelLabel: "בטל",
    leaveCommentLabel: "השאר הערה",
    addLabel: "הוסף",
    closeLabel: "סגור",
    editText: "ערוך",
    enterReply: "הזן מענה",
    reply: "תגובה",
    deleteTagDesc: "לא ניתן לבטל את מחיקת התג. האם אתה בטוח שברצונך להמשיך?",
    requiredText: "טקסט נדרש",
    descriptionEmptyError: "תיאור נדרש",
    descriptionMaxLengthError: "אורך התיאור חרג מהאורך המירבי המותר",
    assignmentDueDate: "תאריך היעד להקצאה",
    navigateToGuidedWorkflow: "נווט אל הפעלת EY Canvas FIT",
    openInTasksPage: "פתח במשימות",
    copyTaskLink: "העתק קישור למשימה",
    copyReviewNoteLink: "העתק קישור להערת סקירה",
    urlCopiedLabel: "הקישור הועתק בהצלחה",
    //Related Tasks
    showOnlyRelatedTask: "הצג רק כאלו שקשורים",
    noTaskAvailable: "אין משימות זמינות",

    // Client Request / Client Request Detail /  Client Request Drawer
    openInCollaborationPage: "פתוח בשיתוף פעולה (Collaboration)",
    copyRequestLink: "העתק את קישור הבקשה",
    requestType2MessageTitleDrawer: "לבקשה זו יש פונקציונליות נוספת.",
    requestType2MessageSubtitleDrawer1: "אנא",
    requestType2MessageSubtitleDrawer2: "לחץ כאן",
    requestType2MessageSubtitleDrawer3: "כדי לנווט אליו.",

    // SeeMore component
    showMore: "הצג עוד",
    showLess: "הצג פחות",
    showMoreEllipsis: "הצג עוד ...",
    showLessEllipsis: "הצג פחות ...",

    // Request Description
    saveAndCloseButtonLabel: "שמור וסגור",
    saveButtonLabel: "שמור",
    cancelButtonLabel: "סגור",

    // Request Description Modal labels
    discardChangesModalText: "התעלם משינויים",
    inlineSaveUnsavedChanges: "ישנם שינויים שלא נשמרו, האם ברצונך להמשיך?",

    // RelateWCGWModal labels
    wcgwName: "שם WCGW",
    wcgwByScot: "WCGWs לפי תתי תהליכים מהותיים SCOT",
    unrelatedSCOTsHeader: "SCOTs לא מקושרים",
    unrelatedSCOTPlaceholder: "אין תתי תהליכים מהותיים SCOTs לא קשורים",
    noWcgwPlaceholder: "לא נוצרו WCGWs",
    showOnlyUnrelatedWCGW: "הצג רק כאלו שלא קשורים",

    // CharCount component.
    of: "של",
    characters: "תווים",
    fromUserLabel: "מ",
    toUserLabel: "ל",
    handoffto: "מסירה (Hand-off) ל",
    priorityLabel: "עדיפות",
    addNoteLabel: "הוסף",
    replyNoteLabel: "ענה",
    characterCountLabel: "  של 4000 תווים",
    taskNotePlacehodler: "הזן הערה למשימה",
    documentNotePlacehodler: "הזן הערה למסמך",
    taskNoteStatusBy: "על ידי:",
    addNewReviewNoteButtonText: "הערה חדשה",
    fromKnowledge: "מתוך מאגר הידע",
    /*day labels*/
    mon: "שני",
    tues: "שלישי",
    wed: "רביעי",
    thurs: "חמישי",
    fri: "שישי",
    sat: "שבת",
    sun: "ראשון",
    /*month labels*/
    jan: "ינואר",
    feb: "פברואר",
    march: "מרץ",
    april: "אפריל",
    may: "מאי",
    june: "יוני",
    july: "יולי",
    august: "אוגוסט",
    sept: "ספטמבר",
    oct: "אוקטובר",
    nov: "נובמבר",
    dec: "דצמבר",
    /*Rename*/
    documentDropdown: "רשימה נפתחת של מסמך",
    fileNameRequired: "נדרש שם קובץ",
    invalidCharacters: 'אין אפשרות לכלול בשם הקובץ: */:< > \\? |\"',
    existingFileName: "שם הקובץ אינו ייחודי. רענן את הדף או שנה את שם הקובץ בכדי להסיר הודעה זו.",
    unknowError: "אירעה שגיאה בלתי צפויה. רענן את הדף כדי להסיר הודעה זו.",
    maxLengthExceeded: "שם המסמך לא יכול לכלול מעבר ל- 115 תווים.",
    documentNameSyncErrorMessage: "לא ניתן היה לסנכרן את שם המסמך עם ה-  Portal Client Canvas. רענן את הדף ונסה שוב.",
    /*Delete*/
    deleteFileTitle: "מחיקת המסמך",
    deleteFileCloseBtnTitle: "בטל",
    deleteFileConfirmBtnTitle: "מחק",
    deleteFileCloseTitle: "Close",
    deleteFileModalMessage: "האם אתה בטוח שברצונך למחוק את המסמך?",
    none: "אף אחד",
    /*Unlink*/
    unlinkFileTitle: "נתק את הקישור של הראיה ששותפה",
    unlinkSource: "מקור",
    unlinkTarget: "יעד",
    unlinkFileCloseBtnTitle: "בטל ",
    unlinkFileConfirmBtnTitle: "אשר",
    unlinkFileCloseTitle: "סגירה",
    unlinkFileModalMessage: "האם אתה בטוח שברצונך לבטל את הקישור לתקייה המשותפת של ראיות הביקורת?",
    /*Relate Tasks*/
    relateTasksTitle: "קשר משימות",
    relateTaskSearchPlaceholder: "לחץ Enter כדי לחפש",
    relateTaskInstructionalText: "הוסף או הסר משימות שהמסמך צריך להיות קשור אליהן. אם המסמך הוא ראיית ביקורת הסרתו מהמשימה האחרונה תעביר אותו לקבצים זמניים.",
    relatedTaskInstructionalText: "המסמך קשור למשימות הבאות בתיק ביקורת זה. לחץ על שם משימה כדי לנווט אליה.",
    relateTaskName: "שם משימה",
    relateTaskType: "סוג",
    relatedTaskCounter: "{0} משימה",
    relatedTasksCounter: "{0} משימות",
    /*Relate Entities*/
    relateEntitiesTitle: "קשר ישויות",
    relateEntitiesSearchPlaceholder: "הזן כדי לחפש לפי שם",
    relateEntitiesName: "שם הישות",
    relateEntitiesIndex: "אינדקס סטנדרטי של ישות",
    relatedEntitiesCounter: "{0} ישויות",
    relatedEntityCounter: "{0} ישויות",
    onlyShowRelatedEntities: "הצג רק ישויות קשורות",
    unableToRemoveSystemAssociatedRelatedEntity: "אין אפשרות להסיר את הקשרים של המערכת בין מסמכים וישויות",
    /* Finalize document */
    document: "Document",
    finalize: "לסכם",
    finalizeDocument: "סיים את המסמך",
    finalizeDocumentTitle: "האם אתה בטוח שברצונך להודיע ​​לצוות הראשי שהמסמך הזה הושלם?",
    finalizeDocumentSubtitle: "סיום מסמך מודיע לצוות הראשי שאינך מצפה לשלוח גרסאות נוספות של המסמך ומשנה את סטטוס המסמך ל<b>גרסה סופית נשלחה</b>. במקרה שאתה מבצע שינויים במסמך סופי, אתה עדיין יכול לשלוח גרסה חדשה לצוות הראשי.",
    /* Remove From Task */
    removeEvidenceModalTitle: "הסר מהמשימה",
    remove: "הסר",
    removeFromTaskModalContent: "האם אתה בטוח שברצונך להסיר את המסמך שסימנת ממשימה זו? מסמך זה אינו משויך לאף משימה אחרת בתיק ביקורת זה ולכן יועבר לקבצים זמניים.",
    sharedEvidenceRemoveFromTaskModalContent: "האם הינך בטוח שברצונך להסיר את המסמך שנבחר ממשימה זו? מסמך זה משותף ואינו משויך למשימה אחרת בתיק ביקורת זה. המסמך כבר לא יהיה זמין בתיק הביקורת שלך אם הוא יוסר.",
    /*AddDocumentToTasksModal*/
    modalCheckboxHeading: "הוספה לראיות עבור משימה אחת או יותר",
    modalRadioHeading: "שייך מסמך למשימה אחת או יותר",
    confirm: "אשר",
    proceed: "המשך",
    modalCheckboxMessage: "בחר לאילו משימות רלוונטיות יתווסף מסמך זה.",
    selectedDocument: "מסמך שנבחר",
    modalRadioMessage: "מסמך זה נוסף בעבר לראיית ביקורת או לקבצים זמניים.",
    modalRadioMessage1: "הוספת מסמך זה שוב תיצור עותק כפול. בחר האם לשייך עותק קיים של מסמך זה או ליצור עותק חדש.",
    option: "אפשרות",
    option1Message: "שייך מסמך קיים למשימה זו",
    option2Message: "צור עותק חדש של מסמך זה",
    addToEvidenceSelectAll: "בחר הכל",
    currentTask: "המשימה הנוכחית:",
    createNewCopy: "צור עותק חדש",
    fileNameMaxLenError: (maxFileLen) => ` שם הקובץ מוגבל ל- $ {maxFileLen} תווים. `,
    /* Confidentiality */
    confidentiality: "סודיות",
    confidentialityType: "סודי (אופציונלי)",
    confidentialityTitle: "מסמך סודיות",
    confidentialityPlaceholder: "בחר סודיות",
    confidentialityText: "הגדר את רמת הגישה הנדרשת לפתיחת מסמך זה. רמות הגישה נקבעות על ידי מנהלי ההתקשרות בדף ניהול צוות (manage team). אם מסמך זה הוגדר כבר כסודי הרי שרק מי שיכול לפתוח את המסמך לערוך בו שינויים.",
    confidentialityNotOpenable: "לא ניתן לפתוח את המסמך מכיוון שההרשאות שלך בתיק הביקורת אינן מספקות. רמות הגישה נקבעות על ידי מנהלי ההתקשרות בדף ניהול צוות (manage team).",
    confidentialityTargetNotOpenable: "ניתן לפתוח מסמכים חסויים רק ממקור תיק הביקורת (source engagement).",
    /*Sign-off requirements*/
    signOffRequirements: "דרישות חתימה",
    signoffRequirementsModalTitle: "דרישות חתימה",
    signoffRequirementsModalDescription1: "התאם את דרישות החתימה של בכיר בצוות על מסמך זה למטה.",
    signoffRequirementsModalDescription2: "לא ניתן להתאים חלק מדרישות החתימה מכיוון שהן נדרשות על ידי EY Canvas.",
    signoffRequirementsModalSaveLabel: "שמור",
    signoffRequirementsModalCancelLabel: "בטל",
    signoffRequirementsModalCloseLabel: "Close",
    signoffRequirementsModalPICLabel: "PIC",
    signoffRequirementsModalEQRLabel: "EQR",
    /*SEM summary*/
    nextAccount: '>',
    prevAccount: "<",
    reviewedBy: "נסקר על ידי",
    displaytoc: "הצג TOC",
    viewBy: "נראה על ידי",
    substantiveEvaluation: "Substantive Evaluation Matrix",
    reviewed: "נסקר",
    estimate: "אומדן",
    /*440GL*/
    FourFortyTitle: "ראיות שונו לאחר תאריך הדיווח ({0})",
    LeftContainerTitle440GL: "סיבות לשינוי",
    approvals: "אישורים",
    approveChangesColumnTitle: "אשר שינויים",
    approveChangesButton: "אשר שינויים",
    deleteApproval: "הסר אישור",
    unauthorizedAction: "הפעולה יכולה להתבצע רק על ידי מנהלי תיק הביקורת",
    reasonColumnTitle: "סיבה",
    approvedBy: "אושר על ידי:",
    approvedByPeople: "אנשים",
    noChangeReasonCommentAvailable: "לחץ על ערוך סיבה מתוך אפשרויות גלגל השיניים של המסמך כדי להזין את הסיבה לשינוי.",
    changeReasonModalTitle: "ערוך סיבה לשינוי",
    changeReasonModalText: "בחר את הסיבה(ות) לשינויים שבוצעו במסמך לאחר תאריך הדוח. אם בוצעו שינויים אדמיניסטרטיביים מרובים בחר את השינוי המשמעותי ביותר מהתפריט הנפתח שלהלן. אם בוצעו שינויים אדמיניסטרטיביים וגם שינויים שאינם אדמיניסטרטיביים בחר שאינו אנמיניסטרטיבי להלן.",
    changeReasonUploadModalTitle: "סיבה להעלאת המסמך",
    changeReasonUploadModalText: "בחר את הסיבה(ות) לשינויים שבוצעו במסמך לאחר תאריך הדוח. אם בוצעו שינויים אדמיניסטרטיביים מרובים בחר את השינוי המשמעותי ביותר מהתפריט הנפתח שלהלן. אם בוצעו שינויים אדמיניסטרטיביים וגם שינויים שאינם אדמיניסטרטיביים בחר שאינו אנמיניסטרטיבי להלן.",
    changeReasonModalComboPlaceholder: "בחר",
    changeReasonModalAnnotationText: "תעד את הנסיבות בהן נתקלת ואת הסיבות להוספת המידע; נהלי ביקורת חדשים או נוספים שבוצעו ראיות ביקורת שהושגו והמסקנות שהוסקו וההשפעה על דוח המבקר שלנו.",
    changeReasonUploadModalAnnotationText: "תעד את הנסיבות בהן נתקלת ואת הסיבות להוספת המידע; נהלי ביקורת חדשים או נוספים שבוצעו ראיות ביקורת שהושגו והמסקנות שהוסקו וההשפעה על דוח המבקר שלנו.",
    changeReasonModalAnnotationPlaceHolder: "הזן סיבה לשינוי",
    changeReasonModalChangeReasonRequired: "שנה את הסיבה לשמירה.",
    noDocumentsModifiedAfterReportDate: "לא השתנו מסמכים לאחר תאריך הדוח",
    noReasonSelected: "לא נבחרה סיבה לשינוי",
    fileSizeColumn: "גודל הקובץ",
    changePercent: "% שינוי",
    toolTipChangePercent: "השינוי בגודל הקובץ מחושב באמצעות גודל הקובץ נכון לתאריך הדוח וגודל הקובץ הנוכחי",
    /*Account Conclusion*/
    AccountConclusion: "סיכום של הסעיף",
    AccountDetails: "פרטים",
    Conclusions: "מסקנות",
    accountDetailsTab: "פרטים",
    conclusionsTab: "מסקנות",
    accountConclusionNoContentText: "לא נמסר תוכן עבור טופס זה. עבור אל Canvas Form Updates מהתפריט Global Navigation More ועדכן את התוכן באופן ידני.",
    validations: "תיקוף",
    /*RelatedFindings*/
    deficiency: "{0} ליקויים קשורים",
    misstatement: "{0} הצגות מוטעות קשורות",
    relatedDeficiency: "{0} ליקוי קשור",
    relatedMisstatement: "{0} הצגה מוטעית קשורה",
    deficiencies: "ליקויים",
    misstatements: "הצהרות מוטעות",
    pagingShowtext: "הצג",
    documentOpenModelLabel: "המסמך שונה כעת",
    openedLabelText: "נפתח ",
    modelDocumentOpenedText: "מסמך זה משתנה כעת על-ידי ",
    modelUserOpenedTheDocumentText: "משתמש זה פתח את המסמך ",
    modelOpenedDocumentConflictText: "פתיחת המסמך עלול לגרום לקונפליקטים ולכן אנו ממליצים לפתוח לקריאה-בלבד. אם ברצונך להיות עורך מסמך זה הרי ש",
    clickHereEnabledText: "לחץ כאן.",
    reviewNotesTemporeryFilesTitle: "הערות סקירה לקבצים זמניים",
    addNewReviewNoteTitle: "הערות משימה",
    /*Assignments*/
    assignedTo: "הוקצה ל",
    createAssignment: "צור הקצאה",
    createAssignments: "צור הקצאות",
    editAssignments: "ערוך הקצאות",
    deleteAssignments: "מחק הקצאות",
    removeAssignments: "הסר הקצאות",
    noTimephaseSelected: "לא נבחר",
    unassigned: "Unassigned",
    unassignedCapitalized: "Unassigned",
    dueDateBlank: "היעד בעוד",
    reviewerAssignment: "הקצאות לסוקר",
    manageAssignments: "ניהול הקצאת משימות",
    manageTaskAssignments: "צור משימות לביצוע",
    selectedTasks: "משימות שנבחרו",
    someTasksCannotBeMoved: "חלק מהמשימות לא ניתנות להעברה",
    onlySomeTaskCanMoveToOtherGroup: "ניתן להעביר רק חלק מהמשימות שבחרת לקבוצת משימות אחרת.",
    taskThatCanBeMovedToOtherGroup: "אם תבחר להמשיך <b>המשימות המפורטות להלן יועברו</b> לקבוצת המשימות שבחרת.",
    tasksThatCannotBeMovedToOtherGroup: "<b>לא ניתן להעביר את המשימות המפורטות להלן</b> לקבוצת משימות אחרת.",
    taskGroupSectionNotFound: "לא נמצאו תוצאות",
    placeholderForSearch: "חפש",
    taskFilter: "סנן",
    noResultsAvavilable: "לא נמצאו תוצאות",
    noTasksAvavilable: "אין משימות זמינות",
    clearAll: "נקה הכל",
    engagementPhase: "שלב בביקורת",
    noOptionAvailable: "אין אפשרויות זמינות",
    noTimePhase: "לא הוקצה לוח זמנים",
    roles: "תפקידים",
    users: "חברי הצוות",
    rommAssociatedWNotRelyAssertion: "ה- ROMM מקושר למצג הנהלה (assertion) עם סיכון בקרה (CR) ברמת Not Rely או למצג הנהלה (assertion) עם סיכון שבמהות (IR) גבוה כאשר מדובר בסעיף הכרוך באומדנים",
    hasRiskAssociated: "סיכון קשור",
    canvas: "Canvas",
    workingoffline: "עבודה במצב לא מקוון",
    syncinprogress: "מתבצע סנכרון",
    prepareoffline: "מכין נתונים למצב לא מקוון",
    connectionavilable: "חיבור זמין",
    createAnAssignment: "צור הקצאה",
    createAssignmentEnd: "כדי להתחיל במשימה זו.",
    // Manage Assignments
    step01: "שלב 01",
    step02: "שלב 02",
    step03: "שלב 03",
    step04: "שלב 04",
    step05: "שלב 05",
    manageAssigmentsStep1: "בחר פעולה.",
    manageAssigmentsStep2: "ערוך משימה שהוקצתה",
    editAssignment: "ערוך הקצאת משימה",
    deleteAssignment: "מחק הקצאת משימה",
    manageAssigmentsStep3: "השלם הקצאה",
    taskAssigmentStatusHeader: "סטטוס הקצאה",
    taskAssigmentStatusTileHeader: "סטטוס משימה והקצאה",
    taskAssignmentName: "הקצאה",
    dueDateAssigment: "היעד בעוד",
    editDueDate: "אופציונלי: ערוך ימים לפני תאריך היעד",
    teamMemberAssigmentLabel: "חבר צוות",
    currentAssigmentLabel: "נוכחי",
    handOffToAssigmentLabel: "העבר ל:",
    priorToEndDateLabel: "לפני תאריך הסיום",
    noTimePhaseAssigmentLabel: "לא הוקצה לוח זמנים",
    closedByAssigmentLabel: "נסגר על-ידי",
    onAssingmentLabel: "על",
    preparerAssigmentOpenTitleTip: "העבר משימה זו לסגירת המשימה שהוקצתה לך",
    reviewerAssigmentOpenTitleTip: "סמן את המשימה שהוקצתה כסגורה",
    reviewerAssigmentClosedTitleTip: "סמן את המשימה שהוקצתה כפתוחה",
    AssigmentLabel: "העבר משימה זו לסגירת המשימה שהוקצתה לך",
    noEvidenceReviewerAssigmentTitleTip: "הוסף ראייה לסימון המשימה שהוקצתה כסגורה",
    noTaskEvidencesHandoffModal: "אין קבצי ראיות המשויכים למשימה זו.",
    back: "חזור",
    savecontinue: "שמור והמשך",
    finish: "סיים",
    save: "שמור",
    emptyManageAssignmentStep: "...",
    selectAssignmentActionToContinue: "בחר פעולה כדי להמשיך.",
    createNewTaskAssingment: "צור הקצאת משימה חדשה",
    deleteTaskAssingment: "מחק הקצאת משימה",
    createTaskAssingment: "צור הקצאת משימה",
    editExistingTaskAssingment: "ערוך הקצאת משימה קיימת",
    editTaskAssingment: "ערוך משימה שהוקצתה",
    removeExistingTaskAssingment: "הסר הקצאת משימה קיימת",
    warningPopUpPreparerAssignmentTitle: "החלף את הקצאת המכין הקיימת",
    warningPopUpPreparerAssignmentText: "כבר הוקצה מכין למשימה זו. האם אתה בטוח כי ברצונך לשנות את ההקצאה?",
    warningPopUpPreparerAssignmentConfirm: "אשר",
    warningPopUpPreparerAssignmentCancel: "בטל",
    selectTaskAssingment: "בחר הקצאת משימה",
    viewHistoryAndConflicts: "הצג היסטוריה",
    noHistoryAvailable: "אין היסטוריה זמינה",
    teamMember: "חבר צוות",
    dateEdited: "השתנה לאחרונה",
    viewHistoryHeader: "היסטוריית הגירסאות למסמכים אלה מוצגת להלן.",
    viewHistorySubHeader: "לחץ על שם חברי צוות כדי לפתוח גרסה קודמת של מסמך זה במצב לקריאה בלבד. כל שינוי שבוצע בגרסה קודמת זו לא יישמר ב- EY Canvas.",
    docConflictedMessage: "קיימים קונפליקטים המשוייכים למסמך זה. בכדי לפתור אותם נווט ללשונית הקונפליקטים ברשימת המסמכים.",
    removeTaskAssingment: "הסר הקצאת משימה",
    addAssignmentInstructionalText: "הזן כאן את שם חבר הצוות שהוקצה למשימה (לדוגמה סוקר לסקירה מפורטת סוקר לסקירה כללית)",
    addNewAssingmentName: "הוסף משימה חדשה בשם",
    addTaskAssignmentName: "הוסף שם למשימה שהוקצתה ",
    assignmentName: "שם חבר הצוות שהוקצה",
    selectedTask: "משימה שנבחרה",
    createTaskAssignmentHeading: "צור כאן הקצאת משימה חדשה.",
    createTaskAssignmentHeading1: "הזן את פרטי ההקצאה להלן ובחר <b>שמור וסגור</b> כדי לסיים. כדי ליצור הקצאה נוספת, בחר <b>שמור והוסף עוד הקצאה</b>.",
    saveDelete: "שמור ומחק",
    createTaskAssignmentFinishLabel: "שמור וסגור",
    createTaskAssignment: "שמור והוסף",
    editTaskAssignment: "שמור ונהל אחר",
    createTaskAssignmentSaveAndContinueLabel: "שמור ונהל אחר",
    daysPriorToEndDate: "ימים לפני תאריך היעד",
    daysdue: "מספר הימים (Days due)",
    daysPriorToEndDateOptional: "ימים לפני תאריך היעד (אופציונלי)",
    timephase: "Time Phase",
    timephasesLabel: "שלבי זמן",
    manageTimePhase: "ניהול שלבי זמן (time phases)",
    removeTaskAssingmentSingleTaskHeading: "בחר את ההקצאה שברצונך למחוק.",
    removeTaskAssingmentSingleTaskHeading2: "לחץ על 'שמור וסגור' אם סיימת או לחץ על 'שמור ונהל אחר' אם ברצונך לנהל מטלת משימה נוספת.",
    removeTaskAssingmentMultipleTaskHeading: "אם שילוב ההקצאה וחבר הצוות קיים עבור משימה נבחרת, ההקצאה תימחק. בצע את הבחירות שלך וסמן <b>שמור וסגור</b> לסיום. כדי למחוק הקצאה אחרת, בחר <b>שמור ומחק</b>.",
    editTaskAssingnmentStep2Heading: "בחר את הקצאת המשימות שברצונך לערוך.",
    selectedAssignment: "הקצאה שנבחרה:",
    editTaskAssingmentBulkHeading: "בחר את הקצאת המשימה שתרצה לערוך.",
    editTaskAssingmentBulkSubHeading1: "אם קיים השילוב של המטלה וחבר הצוות המוקצה לה עבור מטלה שנבחרה, היא תוקצה מחדש. קיימת האפשרות לערוך את <b>הימים שלפני תאריך הסיום</b>. במידה ותערוך ערך זה, הוא יעודכן עבור כל המשימות שהוקצו מחדש. ערוך ולאחר מכן בחר <b>שמור וסגור</b> כדי לסיים. על מנת לערוך מטלה נוספת, בחר <b>שמור וערוך מטלה נוספת</b>.",
    noResultInCategory: "לא נמצאו תוצאות בקטגורית המשימות הזו.",
    searchTaskList: "חיפוש רשימת משימות",
    searchCanvasFormList: "חפש",
    clearHoverText: "Clear",
    filtersWarningMessage: "חריגה ממגבלת המסנן. ניתן להחיל 25 מסננים בלבד באותו הזמן.",
    reviewNotesWarningMessage: "אירעה שגיאה בעת איחזור הנתונים. נסה שנית. אם הבעיה נמשכת צור קשר עם התמיכה הטכנית.",
    editTaskAssingmentSept3Header: "ערוך את ההקצאה שנבחרה.",
    editTaskAssingmentSept3Header2: "לחץ על 'שמור וסגור' אם סיימת או לחץ על 'שמור ונהל אחר' אם ברצונך לנהל מטלת משימה נוספת.",
    editTaskAssignmentHeaderPart1: "ערוך את פרטי המשימה מטה ובחר <b>שמור שינויים</b>.",
    calculatedDate: "תאריך מחושב",
    saveAndAddbtn: "שמור והוסף עוד אחד",

    //Calendar Toggle Labels
    daysPriorToEndDateRequired: "ימים לפני תאריך הסיום (חובה)",
    dueDateRequired: "תאריך יעד (חובה)",
    selectDate: "בחר תאריך",
    calculateDate: "חשב תאריך",

    /* Bulk TimePhase*/
    taskText: "משימה",
    timephasesetsuccess: "שלב הזמן {0} הוגדר בהצלחה.",
    timephasessetsuccess: "{0} שלבי הזמן הוגדרו בהצלחה.",
    addTimephaseLabel: "הוסף שלב זמן (time phase)",
    infoSetTimePhase: "<h3>הגדר שלבי זמן</h3><p>גרור ושחרר משלב זמן כדי להגדיר את שלב הזמן עבור הפריטים שנבחרו</p>",
    infoEditTimePhase: "<h3>ערוך את שלב הזמן</h3><p>לחץ על תפריט כללי (שלוש נקודות) ובחר 'ערוך' בכדי לערוך את מאפייני שלב הזמן.</p>",
    infoAddTimePhase: "<h3>הוסף שלב זמן</h3><p>לחץ על הוסף שלב זמן כדי ליצור שלב זמן חדש.</p>",
    infoDeleteTimePhase: "<h3>מחק את שלב הזמן</h3><p>לחץ על תפריט הכללי (שלוש נקודות) ובחר 'מחק' בכדי למחוק את שלב הזמן.</p>",
    deletedTimePhaseFilterWarningMessage: "שלב הזמן (Time phase) נמחק על ידי משתמש אחר.",

    //Set assignment dates modal labels
    setAssignmentTitle: "הגדר תאריך יעד להקצאה(ות)",
    setAssignmentDesc: "לא הגדרת את תאריכי היעד של ההקצאה(ות). בחר את תאריכ(י) היעד של ההקצאה(ות) מטה כדי להמשיך.",
    setAssignmentDesc2: "למשימה אחת או יותר יש תאריך שלב זמן מוקדם מתאריך היעד שבחרת {0}. התאם את תאריכי היעד של המשימות או את תאריך היעד של שלב הזמן כדי להמשיך.",
    timePhaseNameLabel: "Time Phase",
    timephaseEndDate: "תאריך סיום שלב הזמן",
    tasksLabel: "מספר משימות",
    assignmentDateLabel: "הקצאה",
    noAssignedTimePhase: "לא הוקצה לוח זמנים",
    endDate: "סוף תקופה",
    calendarDateError: "תאריך היעד צריך להיות פחות מתאריך סיום שלב הזמן",

    /* Events*/
    addEventLabel: "הוסף אירוע",
    sharedWithClient: "שיתוף",
    noEventsMessage: "לא זוהו אירועים.",
    naLabel: "לא רלוונטי",
    deleteEventModalTitle: "מחק את האירוע",
    deleteEventDescription: " האם אתה בטוח שברצונך למחוק את האירוע הזה?",
    showEventeName: "אירוע",
    eventDateLabel: "תאריך",
    eventDatesLabel: "תאריכים",
    showEventStartDate: "תחילת תקופה",
    showEventEndDate: "סוף תקופה",
    deleteEventSuccessMessage: "האירוע נמחק בהצלחה.",
    eventTypeLabel: "סוג אירוע",
    singleDayEventLabel: "יום אחד",
    multiDayEventLabel: "מספר ימים",
    dateRangeEventLabel: "טווח תאריכים",
    eventSharedWithClientLabel: "משותף עם הלקוח",
    editEventLabel: "ערוך אירוע",
    eventUpdateSuccessMessage: "האירוע עודכן בהצלחה.",
    noTimephasesMessage: "לא זוהו שלבי זמן (time phases).",

    /* Review Notes */
    showAll: "הכול",
    reviewNotesLabel: "סקירת הערות",
    athoredByMeLabel: "נכתב על ידי",
    assignedToMe: "מוקצות לי",
    assignedToOpen: "הוקצה ל (פתוח)",
    authoredByCleared: "נכתב על ידי (נוקה, cleared)",
    totalOpenReviewLabel: "סך כל הערות סקירה פתוחות",
    totalClearedReviewLabel: 'סה"כ הערות סקירה שנוקו ',
    agingLabel: "גיול",
    openLabel: "פתח",
    clearedLabel: "Cleared",
    noUsersFoundLabel: "לא נמצאו תוצאות",
    chartDataLabel: "אין נתונים זמינים.",
    noClientDataAvailable: "אין נתונים זמינים",
    DaysLessThan10: "<10 ימים",
    Days11To30: "<30 ימים",
    Days31To60: "<60 יום",
    Days61To90: "<90 ימים",
    DaysMoreThan90: "> 90 יום",
    noReviewNotesFound: "לא נמצאו הערות סקירה (review notes)",

    formMaxLength: "הטקסט אינו יכול לחרוג מ-{number} תווים.",
    voiceNote: "הודעה קולית",
    microphoneBlockedMessage: "אפשר לדפדפן לגשת למיקרופון שלך כדי להשתמש בהערות קוליות. אם כבר איפשרת, אנא רענן ונסה שוב.",
    microphoneBlockedOnVideoMessage: "אפשר לדפדפן לגשת למיקרופון שלך כדי להשתמש בקול בהקלטת מסך. אם כבר איפשרת זאת, אנא רענן ונסה שוב.",
    notInMainWindowVoice: "הקלטות קול אינן מותרות בתוך סל האפשרויות, נא לפתוח את המסמך בלשונית חדשה בכדי לבצע את הפעולה.",
    notInMainWindowScreen: "הקלטות מסך אסורות בתוך סל האפשרויות, נא לפתוח את המסמך בלשונית חדשה בכדי לבצע את הפעולה.",
    screenRecord: "הקלטת מסך",
    playbackReview: "סקירת שמע",
    recording: "הקלטה",

    /* Sign Offs */
    preparerHoverText: "חתום כמכין",
    reviewerHoverText: "חתום כסוקר",
    preparerTitle: "חתימות מכין",
    reviewerTitle: "חתימות הסוקר",
    preparerLetter: "P",
    reviewerLetter: "R",
    deleteHoverText: "הסר חתימה",
    signoffsrequired: "נדרשת חתימה",
    signoffsOptional: "השותף האחראי על הביקורת (PIC) / השותף המלווה (EQR) - אופציונלי",
    eqrLabel: "EQR",
    partnerInChargeLabel: "PIC",

    landingPage: "דף הפתיחה",
    dashboardPage: "Dashboard",
    tasksPage: "משימות",
    documentsPage: "מסמכים",
    collaborationPage: "שיתוף פעולה",
    automationPage: "אוטומציה",
    newContentUpdate: "עדכון תוכן",
    contentUpdatesHistory: "היסטוריה",
    history: "היסטוריה",
    contentUpdateType: "סוג עדכון תוכן",
    iniciatedBy: "התחיל על ידי (Initiated by)",
    date: "תאריך",
    clickForOptions: "לחץ לקבלת אפשרויות נוספות",
    offline: "לא מחובר",
    eyServiceGateway: 'EY Service Gateway',
    eyAutomation: 'EY Automation',
    eyserviceGatewayAutomation: 'EY Service Gateway & Automation',

    // ContentUpdates
    contentUpdate: "עדכוני תוכן",
    canvasFormUpdates: "עדכוני טפסים ב- Canvas",
    syncFormProfile: "סנכרון פרופיל טופס",
    documentName: "שם המסמך",
    analyticName: "שם ניתוח",
    formType: "סוג הטופס",
    dateOfContent: "תאריך התוכן",
    formStatus: "סטטוס",
    formsWarningMessage: "יש לבחור טופס EY Canvas אחד או יותר לעדכון",
    formsUpdateSuccessMessage: "עדכון טופס EY Canvas נשלח",
    filterTypeOfFormLabel: "סוג הטופס",
    filterSourceOfFormLabel: "מקור הטופס",
    documentSelectionRequired: "בחר מסמך להחלפה",
    overwriteForm: "החלף טופס",
    overwriteFormInstructionalText: "בחר טופס כדי להחליף את התגובות עם הנתונים מהטופס הנוכחי של ה- Canvas. שימו לב שטופס הקנבס הנוכחי יועבר לקבצים זמניים.",
    confirmOverwrite: "אשר החלפה",
    confirmOverwriteAreYouSure: "האם אתה בטוח שברצונך להעתיק את תוכן הטופס \ '{0} \' לטופס \ '{1} \'?",
    confirmOverwriteDesc: "התגובות יוחלפו בצורה \ '{1} \', אך ראיות ביקורת ואובייקטים קשורים לא. יש לשייך מחדש את הראיות והאובייקטים הרלוונטיים לטופס \ '{1} \' לאחר השלמת ההחלפה. טופס \ '{0} \' ישמור על שכבות הפרופיל/GAM הקיימות שלו. לכן, אם פרופיל זה שונה מטופס \ '{1} \', בדוק ונקה את התוכן שהועתק.",
    confirmOverwriteDoNotClose: "אין לסגור את הדפדפן או לנווט משם בזמן שתהליך ההחלפה מתבצע. לאחר סיום תהליך ההחלפה, טופס \ '{0} \' יועבר לקבצים זמניים. לא ניתן לבטל פעולה זו.",
    sourceDocument: "מקור המסמך",
    targetDocument: "מסמך מטרה",
    profileLayers: "שכבות GAM (GAM layers)",
    pspAccountWarningMessage: "יש לבחור סעיף אחד או יותר לעדכון",
    pspAccountUpdateSuccessMessage: "הבקשה לעדכון תוכן PSP הוגשה",
    pspAccountconfirmUpdateMessage: "לעדכון סעיפים אלו עשויה להיות השפעה משמעותית על התוכן. כאשר מתחיל העדכון, לא ניתן יהיה לבצע עדכוני תוכן נוספים עד להשלמת העדכון.",
    est: "כולל אומדן",
    bookmarkTaskModalHeader: "לא ניתן להוריד (download) את המשימות שנבחרו",
    bookmarkTaskModalMessage: "לא ניתן להוריד את המשימות שנבחרו למצב עבודה לא מקוון (offline).",
    noGuidanceAvailable: "אין הדרכה זמינה",
    next: "הבא",
    previous: "הקודם",
    guidanceLink: "קישור",
    addToEvidenceLabel: "הוסף לראיות",
    otherEngagements: "התקשרויות אחרות",
    navigationView: "תצוגת ניווט",
    listView: "תצוגת רשימה",
    detailsView: "תצוגה מפורטת",
    closeguidance: "סגור הדרכה",
    reviewNotesModalClose: "Close",
    gamGuidanceLinkLabel: "הנחיות המתודולוגיה GAM",
    inProgess: "מתבצע",
    upcomingReview: "לסקירה קרובה",
    teamSummaryEmptyTaskDetailsMesage1: "השתמש בסיכום צוות (Team Summary) כדי להציג מטלות של מכינים וסוקרים עבור כל אחד מחברי הצוות לפי סטטוס. כדי לנהל את כל המטלות לתיק הביקורת שלך בחר",
    teamSummaryEmptyTaskDetailsMesage2: "נהל מטלות.",
    teamSummaryEmptyTaskDetailsMesage3: "בכדי לאפשר בקרות בכמות גדולה השתמש בתיבת הסימון כדי לבחור משימה אחת או יותר. השתמש במקש shift בכדי לבחור מספר משימות בו זמנית. אם ברצונך לעבוד על משימה בודדת בחר משימה זו מהרשימה.",
    taskSummaryPoint1: "בחר 'להכנה' (To prepare) כדי להציג רשימה של מטלות מכין (preparer) לכל חבר צוות.",
    taskSummaryPoint2: "בחר 'לסקירה' (To review) כדי להציג רשימה של מטלות סוקר (reviewer) עבור כל אחד מחברי הצוות.",
    taskSummaryPoint3: "המשימות שהוקצו ממוינות לפי סטטוס משימה  (טרם החל בתהליך עבודה ובוצע).",
    noLinksfound: "אין קישורים זמינים למשימה זו.",
    noFormsfound: "אין טפסים זמינים למשימה זו.",
    workofflinemsg: "פעולה זו תוריד את הגרסאות העדכניות ביותר של המשימות שבחרת ותאפשר לך להמשיך לערוך באופן לא מקוון. עלייך לסנכרן את השינויים מאוחר יותר על ידי חיבור מחדש.",
    workonlinemsg: "חזרה למצג מקוון (online) תסנכרן באופן אוטומטי את השינויים שביצעת. וודא כי חיבור האינטרנט זמין לפני החיבור מחדש. ",
    workoffline: "עבודה במצב לא מקוון (offline)",
    workonline: "עבודה במצב מקוון (online)",
    duplicateFileNames: "כפילות בשמות הקובץ",
    training: "תרגול",
    duplicateFileNameValidationMessage: "לקובץ שאתה מנסה להוסיף לתיק ביקורת זה יש שם זהה לקובץ הקיים בתיק ביקורת זה. שנה שם לאחד הקבצים כדי להמשיך.",
    documentHelperConnectionIssue: 'זוהתה בעיה ב-EY Canvas Document Helper. לחץ <a style="color: #467cbe" href="https://eyt.service-now.com/kb_view.do?sysparm_article=KB0486774" target="_blank">כאן</a> להנחיות כיצד לפתור בעיה זו.',
    incompleteCra: "הערכת הסיכון המשולב (CRA) לא הושלמה",
    noteItemCreated: "נוצר:",
    NetworkErrorMessage: "הרשת המבוקשת חווה קשיים.רענן את הדף ונסה שוב מאוחר יותר. צור קשר עם דלפק העזרה (Help Desk) אם השגיאה נמשכת.",
    saveClose: "שמור וסגור",
    contentupdatePSPs: "עדכון תוכן - PSPs",
    /* PAANS */
    paansIsNotReachable: "ה- EY Policy Authoring Approvals and Notification Service אינו זמין כעת. איננו יכולים לאשר אם כל נהלי המדיניות הרלוונטיים שהושלמו. אם לא סקרת את נהלי המדיניות הרלוונטיים רענן את הדף ונסה שנית. אם הבעיה נמשכת פנה לתמיכה הטכנית (Help Desk).",

    /* Add New Task */
    standardtask: "משימה רגילה (Standard task) - OST",
    substantivetask: "משימה מבססת (Substantive task) - OSP",
    walkthroughtask: "משימת Walkthrough - WT",
    controltask: "משימת בקרה - TOC",
    addnewTask: "הוסף משימה חדשה",
    taskType: "סוג משימה",
    taskTypeError: "נא בחר סוג משימה",
    selectTaskTypeHeader: "בחר סוג משימה כדי להמשיך.",
    selectTaskType: "בחר סוג משימה",
    enterTaskDetails: "הזן פרטי משימה",
    assignTask: "הקצה משימה",
    taskGroup: "קבוצת משימות",
    finishLabel: "שמור וסגור",
    addTaskContinueLabel: "שמור והקצה",
    AssignTaskStepSaveandContinueLabel: "שמור & הוסף אחר",
    addTaskDetailsHeader: "הזן פרטי משימה כדי להמשיך.",
    addTaskAssignmentHeader: "אופציונלי: צור הקצאה למשימה זו.",
    addTaskDetailsSubHeader: "לחץ על <b>שמור והקצה</b> אם ברצונך להקצות משימה זו כעת או לחץ על <b>שמור וסגור</b> אם תרצה להקצות משימה זו מאוחר יותר.",
    addTaskAssignmentSubHeader: "הזן את פרטי ההקצאה למטה ובחר שמור וסגור כדי לסיים. ליצירת מטלה נוספת בחר שמור והוסף.",
    addTaskAssignmentSubHeader1: "הזן את פרטי ההקצאה שלהלן ובחר <b>שמור וסגור</b> לסיום. כדי ליצור הקצאה אחרת, בחר <b>שמור והוסף.</b>",
    addTaskGroup: "הוסף קבוצת משימות חדשה כאן. לאחר ההוספה, תוכל לבחור קבוצת משימות זו בעת יצירת משימות חדשות וכן להעביר משימות OST קיימות לקבוצת משימות זו.",
    relateObjectHeaderAccount: "בחר מצג הנהלה אחד או יותר עבור סעיף או גילוי משמעותי, או בחר סעיף בסיכון מוגבל ( limited risk account).",
    relateObjectSubHeaderAccount: "משימות יכולות להיות קשורות רק לסעיף או לגילוי אחד.",
    relateObjectHeader: "קשר פריט אחד או יותר כדי להמשיך",
    limitedRiskAccount: "סעיף בסיכון מוגבל (limited risk account)",
    onlyShowAddedObject: "הצג רק אובייקטים שנוספו",
    relateObjectRequiredError: "בכדי להמשיך יש לבחור אובייקט אחד או יותר.",
    invalidSelectionWarning: "משימות יכולות להיות קשורות רק לסעיף או לגילוי אחד. הסר את מצגי ההנהלה או את הסעיף בסיכון מוגבל בכדי לקשר את המשימה למצגי ההנהלה עבור סעיף או גילוי אחר או סעיף אחר בסיכון מוגבל ( limited risk account).",
    invalidSelctionCRA: "בחר סוג אובייקט אחד",
    relateObjectOptionsHeaderAccountTask: "מצגי הנהלה וסעיפים בסיכון מוגבל (limited risk accounts)",
    relateObjectOptionsHeaderITWalkthroughTask: "תהליכי IT/SO",
    relateObjectOptionsHeaderITControlTask: "בקרות IT כלליות",
    relateObjectOptionsHeaderITSubstantiveTask: "נהלי IT מבססים ",
    relateObjectOptionsHeaderSCOTControlTask: "בקרות",
    relateObjectOptionsHeaderSCOTWalkthroughTask: "SCOTs",
    StrategyTypeControls: "בקרות",
    StrategyTypeSubstantive: "ביקורת מבססת",

    //Manage quick filters labels
    manageQuickFilterHeader: "בחר מסנן שמור או מוצע כברירת מחדל.",
    manageQuickFilterText: "אם תבחר ברירת מחדל, מסנן זה יוחל כאשר תנווט לרשימת המשימות.",
    noDefaultFilter: "אין מסנן ברירת מחדל",
    suggestedFiltersHeading: "מסננים מוצעים",
    savedFiltersHeading: "מסננים שמורים",
    manageQuickFilters: "נהל מסננים מהירים",
    manageLabel: "נהל",


    /* RNH Labels */
    emptyNoteDetailsMessage: "בחר הערה כדי לצפות בפרטים. כדי לבחור מספר בקרות, השתמש במקשים control או shift ובחר מספר הערות ביקורת. אם ברצונך לעבוד על הערה בודדת, בחר הערה זו מהרשימה.",
    emptyRepliesMessage: "אין תגובות עדיין",
    emptyRepliesMessageAlt: "אין תשובות",
    reviewNotes: "הערות סקירה",
    reviewNotesStatus: "סקור את סטטוס ההערה",
    reviewNotesStatusAssignedToMe: "סטטוס הערות סקירה שהוקצו לי",
    reviewNotesStatusAuthoredByMe: "סטטוס הערות סקירה שכתבתי",
    comments: "סקירת הערות",
    showHideNotes: "הצג/הסתר הערות",
    fileType: "סוג קובץ",
    noteType: "סוג",
    statusId: "סטטוס",
    rnhPriority: "עדיפות",
    rnhDueDate: "יעד:",
    rnhModifiedDate: "מותאם",
    textAreaPlaceholder: "הזן הערה",
    requiredFieldErrorMessage: "שדה זה הינו חובה.",
    meLabel: "אני",
    editIconHoverText: "ערוך",
    deleteIconHoverText: "מחק",
    deleteIconModalTitle: "מחק הערה",
    deleteIconCommentModalTitle: "מחק הערה",
    deleteReplyIconModalTitle: "מחק תגובה",
    deleteIconModalConfirmMessage: "האם אתה בטוח שברצונך למחוק את תגובתך להערה זו?",
    deleteIconModalConfirmMessageParent: "האם הינך בטוח שברצונך למחוק את ההערה שנבחרה?",
    deleteIconModalCommentConfirmMessage: "האם אתה בטוח שברצונך למחוק תשובה זו?",
    deleteIconModalCommentConfirmMessageParent: "האם אתה בטוח שברצונך למחוק הערה זו? גם כל התשובות להערה זו יימחקו.",
    deleteIconModalAcceptText: "מחק",
    replyInputPlaceholder: "השב להערה זו",
    changeStatus: "שנה סטטוס",
    emptyReplyErrorMsg: "הוסף טקסט או הערה קולית כדי להמשיך",
    lengthReplyErrorMsg: "התגובה לא יכולה לעלות על 4000 תווים",
    closeTitle: "Close",
    closedBy: "נסגר על ידי",
    ClearedBy: "נסגר על ידי",
    ReopenedBy: "נפתח מחדש על ידי",
    commentTitle: "הערה",
    noteDueDateLabel: "היעד בעוד",
    reopen: "פתח שוב",
    noNotesAssociatedWithDocumentLabel: "השאר הערה באמצעות הקלטים למטה. הקצה את ההערה למשתמש וציין את העדיפות ואת תאריך היעד.",
    noNotesFound: "לא נמצאו הערות",

    /* Add new review note RNH */
    addNewNoteButtonTitle: "הערה חדשה",
    addNewNoteModalTitle: "הוסף הערה חדשה",
    addNewNoteModalClose: "סגור",
    backButtonLabel: "חזור",
    cancelButtonLabel: "בטל",
    addNewNoteStep1Title: "בחר סוג הערה",
    addNewNoteStep2Title: "בחר מסמך או משימה",
    addNewNoteStep3Title: "הזן פרטי הערה",
    editNoteModalTitle: "ערוך הערה",
    editReplyModelTitle: "ערוך תגובה",
    voiceNoteButtonLabel: "הודעה קולית",
    stopRecordingButtonLabel: "הפסק",
    enterText: "הזן טקסט",

    /* RNH Review note hub Step 1 */
    step1Title: "בחר סוג הערה כדי להמשיך.",
    step1Subtitle: "אתה יכול להוסיף רק מסמך והערת משימה כאן. יש להוסיף הערות לטופס קנבס בתוך טופס הקנבס המתאים.",
    step1NoTypeSelectedError: "בחר סוג הערה כדי להמשיך.",

    /* RNH Review note hub Step 2 */
    step2DocumentTitle: "בחר את המסמך שאליו תרצה להוסיף הערה.",
    step2TaskTitle: "בחר את המשימה שאליה תרצה להוסיף הערה.",
    step2SearchTitle: "חפש",
    step2SearchClearTitleTip: "נקה",
    step2ErrorMessageTop: "בחר פריט כדי להמשיך.",
    step2ErrorMessageBottom: "מלא את השדות הדרושים שזוהו לעיל כדי להמשיך.",
    step2EmptySearch: "לא נמצאו תוצאות",

    /* RNH Review note hub Step 3 */
    step3InstructionalText: "הזן את פרטי ההערה עבור המסמך או המשימה שנבחרו.",
    step3InstructionalSubTitle: "לחץ על <b>שמור וסגור</b> כשתסיים או לחץ על <b>שמור והוסף נוסף</b> אם ברצונך להוסיף הערה נוספת למסמך או למשימה שנבחרו.",
    step3SelectedDocument: "מסמך שנבחר:",
    step3SelectedTask: "משימה שנבחרה:",
    step3SaveAndContinue: "שמור והוסף עוד",
    step3SaveAndClose: "שמור וסגור",

    /* RNH List Layout Labels*/
    searchReviewNotes: "חפש הערות",
    searchReviewNotesResultsNotFound: "לא נמצאו תוצאות בקטגוריית הערות זו",
    searchReviewNotesNotAvailable: "אין הערות זמינות",
    notesRepliesNotFound: "לא נמצאו תגובות עבור ההערות שנבחרו.",

    selectValueToContinue: "נא בחר ערך כדי להמשיך",
    required: "נדרש",
    invalidEngagementId: "מספר תיק ביקורת אינו תקף. רענן את הדף ונסה שוב. צור קשר עם דלפק העזרה (Help Desk) אם הבעיה נמשכת.",
    accessDenied: "הגישה נדחתה",
    annotationDeletedError: "ההערה שנבחרה נמחקה. רענן את הדף ונסה שוב.",

    /* RNH Filters */
    rnhClearAll: "נקה הכל",
    rnhShowMore: "עוד",
    rnhFilter: "מסנן",
    hideFiltersLabel: "הסתר",
    noDocumentChangeTypes: "לא נמצאו תוצאות",
    selectatasktype: "בחר סוג משימה",
    importfromknowledge: "ייבא מהידע (Knowledge)",
    assigntaskoptional: "הקצאת משימה (אופציונלי)",
    relateanobject: "שייך אובייקט (object)",
    account: "סעיף",
    userOrRole: "משתמש או תפקיד",
    userSummary: "סיכום משתמש",
    other: "אחרים",
    userNotFound: "המשתמש לא נמצא",
    dueOnOrBefore: "עד לתאריך או לפני",
    dueOnOrAfter: "מהתאריך או אחרי",

    /*Dashboard - Milestone tile*/
    milestonesLabel: "שלבים (Milestones)",
    scopeAndStrategy: "היקף ואסטרטגיה",
    scopeAndStrategyTabLabel: "היקף ואסטרטגיה",
    executionTabLabel: "ביצוע (Execution)",
    conclusionTabLabel: "מסקנה",
    viewAllTabLabel: "הצג הכל",
    noTaskAssociatedToMilestoneMsg: "אין משימות הקשורות לאבני הדרך (milestones) בשלב ביקורת זה.",
    overdueLabel: "תאריך היעד חלף",
    upcomingLabel: "תאריך יעד קרוב",
    quickLinkText: "קישורים מהירים",
    inreviewLabel: "בסקירה",
    CompleteLabel: "המשימות למענה  בביקורת הושלמו",
    completeLabel: "המשימות למענה  בביקורת הושלמו",
    startLabel: "התחלה",
    endLabel: "סוף",
    auditPhaseSummary: "סיכום שלב בביקורת",
    milestoneView: "תצוגת אבן דרך (milestone)",
    timePhaseView: "תצוגת לוח זמנים",
    localLandingPageHeader: "דף זה מציג רק EY Canvas Engagements הזמינים במרכז הנתונים הזה.",
    localLandingPage: "עמוד נחיתה מקומי",
    noEngagementsAvailable: "אין התקשרויות זמינות במרכז הנתונים הזה",
    engagements: "תיקי הביקורת",
    /* Document List */
    docListRelatedTasks: "משימות קשורות",
    temporaryFilesTab: "קבצים זמניים",
    priorPeriodEvidenceTab: "ראיית ביקורת מתקופה קודמת",
    conflictsTab: "קונפליקטים / סתירות (Conflicts)",
    recentlyDeletedTab: "נמחק לאחרונה",
    docListSelectedDocument: "נבחר מסמך {0}",
    docListSelectedDocuments: "נבחרו {0} מסמכים",
    shared: "שיתוף",
    shareStatusOwned: "בבעלות תיק ביקורת זה",
    shareStatusShared: "שותף לתוך תיק ביקורת זה",
    unlinkInprogress: "ביטול קישור בתהליך עבודה",
    unlinkError: "שגיאה בביטול קישור",
    documentList: "מסמכים",
    restoreModalTitle: "שחזור לקבצים זמניים",
    restoreModalText: "שחזר כדי להחזיר מסמך זה לקבצים זמניים.",
    permanentlyDeleteModalTitle: "מחיקה לצמיתות",
    permanentlyDeleteModalText: "מחיקה לצמיתות של המסמך תסיר אותו מ- EY Canvas ולא ניתן לבטל אותה. לחץ על מחק לצמיתות כדי להמשיך.",
    misstatementsInstructionalText: "המסמך קשור להצגות המוטעות הבאות בתיק ביקורת זה. לחץ על הצגה מוטעית כדי לנווט אליה.",
    deficienciesInstructionalText: "המסמך קשור לליקויים הבאים בתיק ביקורת זה. לחץ על ליקוי כדי לנווט אליו.",
    referenceId: "ID",
    findingDescription: "תיאור",
    deficienciesModalTitle: "ליקויים קשורים",
    misstatementsModalTitle: "הצגות מוטעות קשורות",
    startsWith: "מתחיל עם",
    contains: "מכיל",
    documentsWherePICEQRSignOffIsRequired: "מסמכים בהם נדרשת חתימה של השותף האחראי על הביקורת / השותף המלווה (PIC/EQR)",
    otherDocuments: "מסמכים אחרים",
    documentsWherePICSignOffIsRequired: "מסמכים שבהם נדרשת חתימת השותף האחראי על הביקורת PIC",
    documentSignoffRequiredLabel: "נדרשות החתימות של:",
    timePhaseFilterLabel: "שלב בלוח הזמנים",
    drillDownTimePhaseFilterLabel: "הצג לפי שלב זמן",
    auditPhasesLabel: "שלב בביקורת",
    openedLabel: "נפתח",

    clientApprovals: "חתימה על ידי חיצוניים",
    noTeamsAvailable: "עדיין לא נוצרו צוותים. צור צוות ושלח בקשת קישור כדי להתחיל.",
    noDocumentRecieved: "טרם התקבלו מסמכים.",
    team: "צוות",
    pendingEvidence: "ראיות בהמתנה",
    noTimePhasePlaceHolder: "אין שלבי זמן (timephases)",

    regionComponentEvidence: "ראיות מצוות הביקורת של הישות המוחזקת והחברה המחזיקה",
    preparersignoffs: "חתימות מכין",
    reviewersignoffs: "חתימות הסוקר",
    receivedon: "התקבל ב:",
    nosignoffsyet: "אין חתימות עד כה.",
    noRegionComponentEvidence: "טרם התקבלו מסמכים. כדי לראות רשימה של אזורים ורכיבים שעדיין לא שלחו מסמכים, בחר <b>תיעוד בהמתנה</b>.",
    noComponentEvidence: "טרם התקבלו מסמכים.",
    assignToRegionOrComponent: "הקצה לישות מחזיקה או לישות מוחזקת",
    assignRegionComponentModalText: "בחר את הישות המחזיקה או הישות המוחזקת שאליה תרצה להקצות מסמך זה.",
    documentAssignedToPGT: "מסמך זה כבר הוקצה לאזור או ליחידה מדווחת אחרים. לכן, הוא אינו זמין להקצאה.",
    assignedToRegionComponent: "אזור או יחידה מדווחת שהוקצו:",
    noRegionComponentsAvailable: "אין ישויות מחזיקות או ישויות מוחזקות זמינות",
    documentUnassignedFromComponent: "{0}הוקצה מתוך {1}.",
    documentUnassigned: "בוטלה ההקצאה של {0}.",
    documentReturnedToComponent: "{0} הוחזר ל- {1}.",
    documentReturned: "{0} הוחזר.",
    regionComponentName: "שם אזור (region) או ישות מוחזקת (component)",
    relatedReviewNoteCount: "הערה פתוחה אחת מתיקי ביקורת אחרים",
    relatedReviewNotesCount: "{0} הערות פתוחות מתיקי ביקורת אחרים",

    deleteVersion: "מחק גרסה",
    deleteVersionMessage: "בחר גרסה כדי להמשיך.",
    deleteVersionDisabledMessage: "ניתן למחוק גרסאות היסטוריה רק ​​מהמקור של מעורבות המסמך על ידי מנהלי ההתקשרות.",
    deleteVersionTitle: "מחק את גרסת המסמך",
    deleteVersionPlaceholder: "האם אתה בטוח שברצונך למחוק את גרסת ההיסטוריה הזו? לא ניתן לבטל פעולה זו",

    childDocumentsCountLabel: "עותקים קיימים",
    childDocumentsModalTitle: "עותקים קיימים",
    childDocumentsModalDescription: "המסמכים להלן נוצרו מהמסמך המקורי.",
    childDocumentsModalColumnDocumentName: "שם המסמך",
    childDocumentsModalColumnDocumentType: "סוג מסמך",
    childDocumentsModalColumnRelatedTasks: "משימות קשורות",
    childDocumentsModalColumnSignoffs: "Sign-offs",

    bulkAddToEvidenceDescription1: "צור עותק חדש של המסמכים המוצגים כראיה, או בחר עותק קיים אם זמין.",
    bulkAddToEvidenceDescription2: 'כברירת מחדל, מסמכים חדשים שנוצרו יתווספו לכל המשימות וטפסי ה- Canvas שהמסמך הישן היה קשור אליהם. השתמש ב"אפשרויות מתקדמות" כדי לבחור ידנית את המשימות ואת טפסי ה- Canvas שאליהם יש לשייך את המסמך החדש. השתמש באפשרות "מצא והחלף" בכדי להחליף חלקים מסוימים במסמך / בשם המסמך החדש (למשל, השנה); ניתן להשתמש באפשרות זו מספר פעמים.',
    bulkAddToEvidenceDescription3: "כאשר מסמך קיים נבחר, הוא יתווסף רק למשימה הנוכחית. אם זמין רק מסמך קיים אחד, הוא יבחר מראש; אחרת בחר עותק קיים להוספה.",
    bulkAddToEvidenceAdvancedOn: "אפשרויות מתקדמות",
    bulkAddToEvidenceAdvancedOff: "כבוי",
    bulkAddToEvidenceFindText: "מצא טקסט",
    bulkAddToEvidenceFindTextRequired: "אנא הזן טקסט חיפוש חוקי.",
    bulkAddToEvidenceReplaceWith: "להחליף ב",
    bulkAddToEvidenceReplaceSuccess: "הוחלף {0} ב-{1}.",
    bulkAddToEvidenceUseExisting: "השתמש בקיים",
    bulkAddToEvidenceCreateNew: "צור חדש",
    bulkAddToEvidenceDocumentName: "שם המסמך",
    bulkAddToEvidenceExistingDocument: "מסמך קיים",
    bulkAddToEvidenceSelectANewOrExistingCopy: "בחר עותק חדש או קיים",
    bulkAddToEvidenceAssociateToTasks: "שייך למשימות",
    bulkAddToEvidenceAssociateToCanvasForms: "שיוך ל-Canvas Forms",
    bulkAddToEvidenceOtherRelatedTasks: "משימות קשורות אחרות",
    bulkAddToEvidenceAssociateToTasksPlaceholder: "ניתן לשייך רק מסמכים שנוצרו לאחרונה למשימות. מסמכים קיימים ישויכו אוטומטית למשימה הנוכחית.",
    bulkAddToEvidenceSelectedTask: "{0} משימה קשורה",
    bulkAddToEvidenceSelectedTasks: "{0} משימות קשורות",
    bulkAddToEvidenceSelectedTasksPlaceholder: "אין משימה קשורה זמינה",
    bulkAddToEvidenceAssociateToCanvasFormsPlaceholder: "ניתן לשייך רק מסמכים חדשים שנוצרו ל-Canvas Forms.",
    bulkAddToEvidenceRelatedCanvasForms: "טפסי Canvas קשורים",
    bulkAddToEvidenceSelectedForm: "{0} טופס Canvas קשור",
    bulkAddToEvidenceSelectedForms: "{0} טפסי Canvas קשורים",
    bulkAddToEvidenceSelectedFormsPlaceholder: "אין טפסי Canvas קשורים",
    picRequiredValidation: "מסמך, עבורו נדרשת חתימת השותף האחראי על הביקורת PIC, אינו קשור למשימת PIC",
    eqrRequiredValidation: "מסמך, עבורו נדרשת חתימת השותף המלווה EQR, אינו קשור למשימת EQR",
    picEqrRequiredValidation: "מסמך, עבורו נדרשת חתימת השותף האחראי על הביקורת PIC או חתימת השותף המלווה EQR, אינו קשור למשימת PIC/EQR",

    viewSwitcherDefault: "תצוגת ברירת מחדל",
    viewSwitcherEntity: "תצוגת ישויות",
    viewSwitcherAllEntities: "כל הישויות",
    viewByEntities: "תצוגה לפי ישויות",

    /* bulk delete modal */
    bulkDeleteFilesModalMessage: "האם אתה בטוח שברצונך למחוק את המסמכים שנבחרו?",
    bulkDeleteFIlesModalMessageSub: "מסמכים שלא ניתן למחוק מצוינים להלן ולא יימחקו.",
    bulkDeleteModalLabel: "מחק מסמכים",
    bulkDeleteSuccessMessage: "המסמכים נמחקו בהצלחה",
    bulkDeleteValidDocumentsHeader: "המסמכים הבאים יימחקו",
    bulkDeleteInvalidDocumentsHeader: "לא ניתן למחוק את המסמכים המפורטים להלן",

    /* Bulk sign-off requirements modal */
    bulkSignOffRequirementsModalMessage: "התאם את דרישות החתימות של הבכירים על המסמכים שנבחרו למטה. לא ניתן להתאים חלק מדרישות החתימה מכיוון שהן נדרשות על ידי EY Canvas.",
    bulkSignOffRequirementsResultMessage: "{0} דרישות לחתימות מסמכים עודכנו בהצלחה",


    bulkOpenCountWarning: "מספר המסמכים שנבחר חורג מהמקסימום המותר. רק ה-{0} הראשון ייפתח",

    /* Pending evidence modal */
    pendingEvidenceInstructionalText: "הצוותים המפורטים להלן לא שלחו עדיין מסמכים קבוצתיים.",
    pendingEvidenceDueDate: "תאריך יעד",
    searchRegionComponentLabel: "חפש אזורים וישויות מוחזקות (components)",

    /* Review Notes Count */
    noReviewNotesAssignedOrAuthored: "אין הערות עבור חבר הצוות שנבחר.",
    noUserSelected: "בחר משתמש כדי לראות פרטים. אינך יכול להקצות הערות לתפקידים ב- EY Canvas.",
    reviewNotesText: "סקירת הערות",
    assigned: "הוקצה",
    authored: "מחבר",
    overdue: "תאריך היעד חלף",
    comingDue: "לקראת תאריך היעד",
    cleared: "נוקה (Cleared)",
    open: "פתח",
    closed: "סגור",
    noTaskAssignedToUser: "אין משימות המוקצות לחבר הצוות או לבעל התפקיד שנבחר.",
    preparer: "P",
    reviewer: "R",
    assignments: "משימות לביצוע",
    notStarted: "טרם החל",
    inProgress: "מתבצע",
    done: "בוצע",
    forUpcomingReview: "הבא",
    noTaskOrNotesAssigned: "אין משימות או הערות עבור חבר הצוות או בעל התפקיד שנבחר.",
    fromTo: "מאת / ל",

    /* Collaboration grid */
    overdueCollaboration: "תאריך היעד חלף",
    comingDueCollaboration: "לקראת תאריך היעד",

    /*Document Conflict*/
    documentConflict: "קונפליקט בסנכרון מסמכים",
    documentConflictModalConfirm: "שמור גרסה זו",
    documentConflictModalClose: "בטל",
    documentConflictInstruction: "כדי לפתור את הקונפליקט בחר את גרסת המסמך אותה יש לשמור.",
    documentConflictMessage: "לחץ על שם חבר הצוות כדי לפתוח גרסה קודמת של מסמך זה במצב קריאה בלבד. כל שינוי שיעשה בגירסה קודמת זו לא יישמר ב- EY Canvas.",
    lastmodifiedDate: "תאריך שינוי אחרון",
    modifiedBy: "שונה על ידי",
    documentConflictErrorMessage: "בחר גירסה כדי להמשיך",
    currentVersion: "גירסה נוכחית",
    documentConflictError: "הודעת שגיאת קונפליקט בין מסמכים",
    documentConflictHeader: "למסמך זה יש קונפליקט",
    viewHistory: "הצג היסטוריה",
    confirmButtonToolTip: "דרושה לך הרשאה לפתרון התנגשויות עבור מסמכי הקבוצה. פנה למנהל תיק הביקורת ובקש הרשאה לבצע פעולה זו.",
    documentHistoryHeader: "היסטוריית הגרסאות של המסמך מוצגת להלן",
    documentHistoryMessage: "לחץ על שם חבר/י הצוות כדי לפתוח גרסה קודמת של מסמך זה במצב לקריאה בלבד. כל השינויים שבוצעו בגירסה הקודמת לא יישמרו ב- EY Canvas.",

    documentHistoryInstruction: 'אם הגרסה הקודמת צריכה להיות הגרסה הנוכחית, בחר בגרסה זו ולחץ על עדכן גרסה ',
    documentHistoryAdminInstruction: 'אם אין צורך בגרסה, בחר את הגרסה ולחץ על "מחק גרסה".',

    documentHistoryModalConfirm: "עדכון גירסא",
    documentHistoryModalClose: "Close",
    documentHistoryErrorMessage: "יש קונפליקט במסמך אנא פתור אותו לפני שממשיכים.",

    /* Dashboard  - Collaboration Tile*/
    clientCollboration: "שיתוף פעולה עם לקוחות",
    nextwaveServices: "שירותים מרכזיים (Centralized Services)",
    receivedStatusLabel: "התקבל",
    acceptedStatusLabel: "התקבל",
    outstandingStatusLabel: "מעבר ל- / יוצא מן הכלל (Outstanding)",
    collaborationNonUsageMessage1: "השתמש בשיתוף פעולה כדי לשלוח בקשות ומשימות חיצוניות לחברי צוות חיצוניים ישירות ב- EY Canvas. כדי להפעיל את שיתוף הפעולה תחילה רשום את הלקוח בפרוטל הלקוחות של EY Canvas (EY Canvas Client Portal). לאחר מכן הגדר קבוצות  למתן הרשאות גישה. אחר כך צור בקשות ו/או הקצה משימות חיצוניות. לחץ",
    collaborationNonUsageMessage2: "להסבר כיצד להתחיל.",
    collaborationNonUsageMessageHyperlinkText: "כאן",
    collaborationNonSentMessage1: "נווט אל",
    collaborationNonSentMessage2: "ושלח טיוטות כדי להתחיל.",
    collaborationNonSentMessageHyperlinkText: "שיתוף פעולה",
    noBodies: "אין תוכן זמין",
    editResponse: "ערוך תגובה",
    unsentDrafts: "טיוטות שלא נשלחו",
    unsentDraft: "טיוטה שלא נשלחה",
    noUnsentDrafts: "לא נמצאו טיוטות שלא נשלחו",
    requestsSent: "הבקשות נשלחו",
    nextWavetotalTasks: "סה'כ משימות",
    comingDueTimeframe: "מסגרת הזמן (Time frame)",
    otherTimeframeDataAvailableMessage: "בחירת מסגרת זמן אחרת להצגת הנתונים",

    /* Dashboard Engagement Metrics */
    engagementMetricsTileHeader: "מדדי תיק הביקורת",
    overdueColumnHeader: "תאריך היעד חלף",
    comingDueColumnHeader: "לקראת תאריך היעד",
    whatsNewColumnHeader: "מה חדש",
    placeholderMessageNoContentInSpecifiedTimeframe: "בחר מסגרת זמן אחרת להצגת נתונים",
    placeholderMessageNoEngagementMetrics: "אין ערכים (metrics) זמינים לתיק הביקורת שלך.",
    performanceMetrics: "מדדי ביצועים",
    reviewNotesAndAssignments: "עיין בהערות ובמשימות",
    /*Dashboard Engagement overview*/
    engagementOverview: "סקירת התקשרות ",
    engagementOverviewInstructionalText: "סקור את התקדמות ההתקשרויות שלך לפי שלב הביקורת למטה.",

    /*Dashboard Milestone tile*/
    milestoneprogressTileHeader: "סיכום CRA",
    milestoneprogressSubHeader: "בחר שלב ביקורת למטה כדי לראות את השלמת המשימה לפי אבן דרך. כדי להציג את השלמת המשימה לפי שלב זמן, בחר <b>הצג לפי שלב זמן</b>. כדי לראות התקדמות מפורטת עבור כל אבן דרך או שלב זמן, בחר <b>הצג פרטים.</b>",
    tasksStatus: "סטטוס משימות",
    preparerAssignments: "הקצאות מכין",
    reviewerAssignments: "הקצאות לסוקר",
    openComments: "הערות פתוחות",
    /* Dashboard Profile Page */
    groupAudit: "ביקורת קבוצה (Group Audit)",
    groupStatus: "סטטוס ביקורת קבוצה",
    viewInstructions: "הצג הוראות",
    instructionsInstructionalText: "הוראות שהתקבלו מהצוות הראשי מוצגות למטה. בחר קישור לצפייה בהוראות.",
    noInstructionsAccepted: "עדיין לא התקבלו הנחיות.",

    /* Dashboard SDM Summary */
    nextWaveservices: "שירותים מרכזיים (Centralized Services)",
    totalTasksLabel: "סה'כ משימות",
    tasksUsingNextWaveservices: " משימות באמצעות שירותים מרכזיים",
    tasksSuggestedForNextwaveUse: " משימות שהוצעו עבור שירותים מרכזיים",
    outOf: "מתוך",
    tasksUsing: "משימות באמצעות",
    suggestedFor: "הוצע עבור",
    nextwaveUse: "שירותים מרכזיים (Centralized Services)",
    draftRequests: "טיוטת בקשות",
    draftRequest: "טיוטת בקשה",
    createRequests: "צור בקשות",
    noRequestCreated: "עדיין לא נוצרו בקשות. צור ושלח בקשה כדי להתחיל.",

    /* RNH Bulk Controls */
    rnhBulkAssignPriorityTitle: "שינוי סדר העדיפויות",
    rnhBulkAssignPriorityTooltip: "עדיפות",
    rnhBulkDueDateTooltip: "תאריך יעד",
    rnhBulkAssignPriorityModalHeader: "לא ניתן לערוך את ההערות שנבחרו",
    rnhBulkAssignPriorityModalContent: "אתה יכול לשנות את העדיפות רק של הערות בסטטוס פתוח. פתח מחדש הערות עם סטטוס cleared או סגור כדי לשנות את העדיפות.",
    rnhBulkAssignDueDateModalContent: "אתה יכול לשנות את תאריך היעד רק של הערות עם סטטוס פתוח. פתח מחדש פתקים עם סטטוס cleared או סגור כדי לשנות את תאריך היעד.",
    rnhBulkAssignUserTooltip: "להקצות מחדש",
    rnhBulkAssignUserSearch: "חפש",
    rnhBulkAssignUserTitle: "לא ניתן לערוך את הערות הסקירה שנבחרו",
    rnhBulkAssignUserText: "אתה יכול להקצות מחדש רק הערות סקירה בסטטוס פתוח. פתח מחדש הערות סקירה עם סטטוס cleared או סגור כדי להקצות מחדש.",
    rnhBulkAssignStatusTooltip: "סטטוס",
    rnhBulkAssignUserNoFound: "לא נמצאו תוצאות",
    rnhBulkDueDatePlaceholder: "בחר תאריך",
    rnhBulkDeleteTextCorrect: "האם אתה בטוח שברצונך למחוק את ההערות שנבחרו? לאחר מחיקת הערת סקירה לא תוכל יותר לגשת אליה.",
    rnhBulkDeleteTextIncorrect: "ניתן למחוק רק הערות שנמצאות בסטטוס סגורות (Closed). סגור הערות בסטטוס 'Open' או 'Cleared' בכדי שתוכל לבצע את פעולת המחיקה. ",
    rhnBulkDeleteTitleCorrect: "מחק את  ההערות שנבחרו",
    rhnBulkDeleteTitleIncorrect: "לא ניתן למחוק את ההערות שנבחרו",
    rnhBulkDeleteTextIncorrectComment: "אתה יכול למחוק הערות סקירה רק כשהן בסטטוס סגור. סגור הערות סקירה עם סטטוס 'פתוח' או cleared כדי למחוק.",
    rhnBulkDeleteDescriptionAuthorComment: "אתה יכול למחוק רק הערות שאתה כתבת.",
    rnhBulkDeleteEngagementComment: "האם אתה בטוח שברצונך למחוק את הערות הסקירה שנבחרו? לאחר מחיקת הערת סקירה לא תוכל יותר לגשת אליה.",
    rhnBulkDeleteTitleCorrectEngagementComment: "מחק את  ההערות שנבחרו",
    rhnBulkDeleteTitleCommentCloseStatus: "לא ניתן למחוק את ההערות שנבחרו",


    fourFortyFilters: "מסננים",
    fourFortySearch: "חפש",

    /* Add External Member Start*/
    addExternalModalTitle: "הוסף חבר חיצוני",
    accessGroupSelection: "גישה לקבוצה שנבחרה",
    noRecordinGroups: "לא נמצאו תוצאות",
    permission: "הרשאות",
    permissionProjectManagement: "ניהול פרויקטים",
    permissionProjectManagementDesc: "אפשרות להציג את סטטוס בקשות הלקוח ומשימות חיצוניות בפורטל הלקוחות ב- EY Canvas (EY Canvas Client Portal). חבר חיצוני זה לא יוכל לגשת לפרטי בקשות הלקוח ומשימות חיצוניות.",
    permissionInfoTooltip: "רשימת כל ההרשאות",
    groupInfoTooltip: "רשימת קבוצות",
    groupRequired: "אנא בחר קבוצה/ות",
    firstnameRequired: "נדרש להזין שם פרטי",
    lastnameRequired: "נדרש להזין שם משפחה",
    initialsRequired: "נדרש להזין ראשי תיבות של השם",
    roleRequired: "נדרש להזין את התפקיד בצוות ההתקשרות",
    confidentialityRequired: "נדרשת סודיות",
    groupLabel: "קבוצות גישה",
    firstnameLabel: "שם פרטי",
    lastnameLabel: "שם משפחה",
    initialsLabel: "ראשי תיבות",
    userinfo: "User Info",
    userinfoDescription: "הזן את השם הפרטי שם המשפחה או כתובת הדוא'ל של חבר הצוות שאתה רוצה להזמין ולחץ על Enter.",
    inviteAndClose: "הזמן וסגור",
    inviteAndAddOther: "הזמן והוסף עוד",
    addAndClose: "הזמן וסגור",
    addAndAddOther: "הזמן והוסף נוסף",
    externalUserCreatedSuccessMessage: "נוספת בהצלחה",
    accessGroupSelectionMessage: "קבוצות גישה מאפשרות לצוותים לנהל מי מחברי הצוות החיצוניים יכול לראות בקשות שנשלחות לפורטל הלקוחות - EY Canvas Client Portal. הגע להסכמה עם הלקוח שלך לגבי רשימת קבוצות הגישה והמשתמשים שתהיה להם גישה לפורטל הלקוחות - EY Canvas Client Portal. כאשר בקשה מוקצית למשתמש חיצוני שהוא חלק מהקבוצה, היא תהיה גלויה *לכל* חבר באותה קבוצה.",
    accessGroupSectionMessage1: "חברי צוות חיצוניים חייבים להירשם באמצעות My EY Admin Portal לפני הוספתם ל-EY Canvas. לחץ על",
    accessGroupSectionMessage2: "כדי לגשת ל-  My EY Admin Portal ולהתחיל.",
    accessGroupMessageHyperlinkText: "כאן",
    accessGroupUserMessage1: "למידע נוסף על צירוף משתמשים לחצו",
    accessGroupUserMessage2: "כדי לגשת ל-EY Atlas.",
    noRecordForExternalMember1: "כתובת אימייל לא נמצאה.",
    noRecordForExternalMember2: "ודא שחבר הצוות החיצוני רשום ב-My EY.",

    /* Add External Member End*/

    /* Edit External Member Start*/

    editExternalModalTitle: "ערוך חבר צוות חיצוני",
    editExternalaccessGroupSelection: "בחירת קבוצת גישה",
    editExternalGroupInfoTooltip: "רשימת קבוצות",
    editExternalGroupLabel: "גישה לקבוצות",
    editExternalGroupRequired: "אנא בחר קבוצה/ות",
    editExternalNoRecordinGroups: "לא נמצאו תוצאות",
    editExternalUserinfo: "מידע על המשתמש",
    editExternalUserinfoDescription: "ערוך את השם הפרטי את שם המשפחה או את ראשי התיבות.",
    editExternalEmailLabel: "דואל",
    editExternalFirstnameLabel: "שם פרטי",
    editExternalLastnameLabel: "שם משפחה",
    editExternalInitialsLabel: "ראשי תיבות",
    editExternalSaveLabel: "שמור",
    editExternalUsersSuccessMessage: "שינויים ב- {0} {1} נשמרו בהצלחה.",
    editExternalUsersCloseLabel: "Close",

    /* Edit External Member End*/



    /*access group*/
    groupName: "שם הקבוצה",
    groupNameHelp: "נדרש שם כדי ליצור קבוצה למתן הרשאות גישה",
    groupNameHelpOnEdit: "נדרש שם",
    groupNameReq: "נדרש שם קבוצה",
    groupNameInvalidCharacter: "תווים לא חוקיים",
    grpDomainManage: "נהל דומיינים (domains)",
    grpDomainHelp: "דומיינים (domains) מגבילים את המשתמשים שיכולים להתווסף לקבוצה למתן הרשאות גישה. לפחות דומיין (domain) אחד נדרש על מנת לצור קבוצה למתן הרשאות גישה. דומיין (domain) הוא התווים אחרי סמל @. השתמש ב- * עבור תווים כלליים (למשל *.ey.com)",
    btnAddNewDomain: "הוסף דומיין (domain) חדש",
    btnAddExistingDomain: "הוסף דומיין (domain) קיים ",
    domainValidation01: "נדרש לפחות דומיין (domain) חוקי אחד",
    domainValidation02: "בחר דומיין (domain)",
    domainValidation03: "להעתיק פקודת יומן",
    domainValidation04: "שם דומיין (domain) לא חוקי",
    domainValidation05: "נדרש שם דומיין (domain)",
    domainName: "שם הדומיין (domain)",
    emailDomain: "דוא'ל דומיין (domain)",
    groupDeletionErrorPendingReqMsg: "אירעה שגיאה בעת מחיקת קבוצת הגישה. ודא כי אין בקשות / משימות חיצוניות שהוקצו לקבוצה זו או לחברי הקבוצה ונסה שוב",
    groupDeletionSuccessMsg: "{0} נמחק בהצלחה. כל החברים הפעילים נהפכו ללא פעילים כעת.",

    /* uncommon values for internal mem */
    editInternalMember: "ערוך פרטי חבר צוות פנימי",
    editThirdPartyMember: "עריכת משתמש  צד שלישי",
    listOfAllPerm: "רשימת כל ההרשאות",
    internalPermiInviteExt: "הזמן חברי צוות פנימיים",
    internalPermiInviteInt: "הזמן חברי צוות חיצוניים",
    internalPermiAssignPer: "הקצה הרשאות",
    internalPermiDeleteEng: "מחק התקשרות",
    internalPermiArchEng: "העברת תיעוד ההתקשרות לארכיון",
    internalPermiUpdateContet: "עדכן תוכן",

    internalPermiInviteExtToolTp: "באפשרותך להזמין חברי צוות פנימיים לתיק הביקורת",
    internalPermiInviteIntToolTp: "באפשרותך להזמין חברי צוות חיצוניים לתיק הביקורת",
    internalPermiAssignPerToolTp: "באפשרותך להקצות הרשאות אלו לחברי צוות פנימיים וחיצוניים בתיק הביקורת",
    internalPermiDeleteEngToolTp: "באפשרותך למחוק את תיק הביקורת",
    internalPermiArchEngToolTp: "באפשרותך לארכב את תיק הביקורת",
    internalPermiUpdateContetToolTp: "אפשרות לערוך את הפרופיל ולקבל עדכון תוכן",
    internalMemberInviteSuccessMessage: "שלחת בהצלחה הזמנה ל {0} {1}",
    internalMemberPostArchivalAdditionSuccessMessage: "הוספת בהצלחה את {0} {1}",
    invitePriorPeriodUsersSuccessMessage: "זימנת בהצלחה משתמשים לא פעילים",
    editInternalUsersSuccessMessage: "השינויים שביצעת ב{0} {1} נשמרו בהצלחה",
    rbacErrorEditUser: "לא ניתן לשמור שינויים כעת. נסה שוב ואם הבעיה נמשכת צור קשר עם התמיכה הטכנית (Help Desk).",
    universalQueueErrorEditUser: "דף הנחיתה של ה- EY Canvas אינו נגיש כרגע והוא נדרש לעריכה. נסה שוב ואם הבעיה נמשכת צור קשר עם התמיכה הטכנית",
    removeExternalUsersSuccessMessage: "{0} {1} הוסרו בהצלחה.",
    reActivateExternalUsersSuccessMessage: "{0} {1} הופעל מחדש בקבוצה(ות) למתן הרשאות הגישה הבאות: {2}",

    /*user search component*/
    seachInputRequired: "חפש קלט (input) נדרש",
    nameOrEmail: "שם או דוא'ל",
    emailForExternal: "דואל",
    noRecord: "לא נמצאו תוצאות",
    userSearchPlaceholder: "הזן שם או דוא'ל ולחץ על Enter כדי לראות תוצאות.",
    userSearchPlaceholderForExternal: "הזן דוא'ל ולחץ על Enter כדי לראות את התוצאות",
    clearAllValues: "נקה את כל הערכים",
    inValidEmail: "אנא הזן דוא'ל חוקי",

    maxLengthForEditResponse: "מקסימום התווים המרבי כולל תגיות לעיצוב טקסט עשיר הם 30000. הסר עיצוב מיותר ונסה שוב.",
    clickEditResponseToContinue: "לחץ על ערוך תגובה כדי להמשיך",
    bodyDescriptionFromKnowledge: "תוכן ממאגר הידע (knowledge)",
    execution: "ביצוע הביקורת",
    cannotpasteimages: "אין אפשרות להדביק תמונות",
    pastingImagesNotAllowed: "אין להדביק תמונות. אם יש צורך בתמונות העלה אותן כראיות ביקורת והפנה אליהן.",
    saveResponse: "יש שינויים שלא נשמרו האם ברצונך להמשיך",
    conclusion: "מסקנה",
    referenceDocsPlaceHolder: "פתח במהירות קבצים שנמצאים בשימוש תכוף על ידי הוספתם כאן.",
    referenceDocsTeamPlaceHolder: "לא נוספו הפניות/קישורים לתיק ביקורת זה. לחץ 'הוסף מסמך' כדי להתחיל.",
    referenceDocsMyPlaceHolder: "לא הוספת מסמכי הפניות. לחץ על 'הוסף מסמך' כדי להתחיל.",
    teamDocuments: "הצמדת צוות (Team pinned)",
    myDocuments: "ההצמדה שלי",
    teamDocumentsModalTitle: "מסמכי הצוות",
    myDocumentsModalTitle: "המסמכים שלי",
    referenceDocuments: "צוות מוצמד (Team pinned)",

    /* PinnedDocument  */
    PinnedDocument: "מסמכים מוצמדים (Pinned documents)",
    PinnedDocumentSubTite: "צור רשימה של מסמכים שהגישה אליהם מתבצעת באופן תדיר על ידי הצמדת פריטים לרשימה שלך או לרשימת הצוותים שלך למטה. כדי לשנות את הרשימה, בחר <b>הוסף מסמך</b>.",
    PinnedDocPaceholder: "לא הצמדת שום מסמך. <br> בחר <b>הוסף מסמך</b> כדי להצמיד מסמכים לכאן.",
    PinnedTeamDocPlaceholder: "הצוות שלך לא הצמיד מסמכים. <br> בחר <b>הוסף מסמך</b> כדי להצמיד מסמכים לכאן.",
    PinnedDocAddDocHeaderText: "בחר ראיות וקבצים זמניים בכדי להתאים אישית את רשימת המסמכים המוצמדים (pinned documents).",
    onlyShowPinnedDocuments: "הצג רק מסמכים מוצמדים (pinned documents)",
    pinned: "מוצמד (Pinned)",
    /* Arc Timeline */
    arcTitle: "שאלון לביצוע ארכיב",
    arcCompleted: "הושלם",
    arcSubmit: "שלח לארכיב",
    arcDescription: "השלם את כל הפריטים ברשימה כדי לארכב תיק ביקורת זה",
    invalidEngagementCode: "קוד תיק הביקורת לא חוקי",
    invalidClientCode: "קוד לקוח לא חוקי",
    arcCheckBox: "שינוי הארכיב (Archive override)",
    arcUnlinkEvidenceButtonText: "בטל את הקישור לכולם",
    arcUnlinkEvidenceModalTitle: "בטל את הקישור בין כל הראיות המשותפות",
    arcUnlinkEvidenceModalText: "האם אתה בטוח שברצונך לבטל את הקישור בין כל הראיות המשותפות בתיק ביקורת זה לבין תיקי ביקורת אחרים בסביבת העבודה? לאחר השלמת פעולה זו לא ניתן יהיה לבטל אותה.",
    arcUnlinkEvidenceModalConfirmButton: "בטל את הקישור לכולם",
    arcUnlinkEvidenceModalCancelButton: "בטל",
    arcUnlinkEvidenceButtonUnlinkInProgress: "ביטול קישור בתהליך עבודה",
    arcUnlinkEvidenceButtonUnlinkError: "שגיאה בביטול קישור",
    arcUnlinkGroupEngagementButtonText: "בטל קישור לקבוצה",
    arcUnlinkGroupEngagementModalTitle: "בטל קישור של תיק הביקורת מהקבוצה",
    arcUnlinkGroupEngagementModalText: "האם אתה בטוח שברצונך לבטל את הקישור של תיק הביקורת לתיק ביקורת אחר בסביבת העבודה הזו? לאחר שתשלים פעולה זו לא ניתן יהיה לבטל אותה.",
    arcUnlinkGroupEngagementModalConfirmButton: "בטל קישור",
    arcUnlinkGroupEngagementModalCancelButton: "בטל",
    arcUnlinkGroupEngagementButtonUnlinkInProcess: "ביטול הקישור בתהליך",
    arcModalTitle: "רשומת ARC קיימת",
    arcProceedWithArchive: "המשך בארכיב",
    arcModalBodyText: "הינך מנסה לארכב קובץ תיק ביקורת משוחזר. קובץ זה כבר קיים במרכז הרשומות בארכיון (Archive Records Center (ARC)). האם הינך בטוח שברצונך להמשיך?",
    noDataAvailabel: "אין נתונים זמינים כרגע. רענן את הדף ונסה שוב. אם הבעיה נמשכת פנה אל התמיכה הטכנית.",
    reportDateBeforeCurrentDate: "תאריך הדיווח של תיק הביקורת חייב להיות התאריך הנוכחי או לפניו. עדכן את תאריך הדיווח כדי להמשיך. כדי לעדכן את תאריך הדיווח, לחץ על הקישור 'אשר את הדיוק של התאריכים הקריטיים בתיק הביקורת'.",

    /*Helix Projects*/
    linkedProjects: "פרוייקטים מקושרים",
    suggestedAnalyzers: "ניתוחים מוצעים",
    linkSelected: "הקישור שנבחר",
    noLinkedProjectsAvailable: "אין פרוייקטים מקושרים",
    helixProjectTitle: "פרוייקט  EY Helix Projects",
    findProjects: "מצא פרוייקטים",
    findProjectsModalTitle: "מצא פרויקטים של EY Helix",
    selectProjectsToLink: "בחר פרויקט אחד או יותר של EY Helix למטה כדי ליצור קישור לסביבת העבודה שלך ב-Canvas. אתה יכול לחפש באופן ידני לפי קוד לקוח כדי למצוא פרויקטים אחרים של EY Helix.",
    newSearch: "חיפוש חדש",
    noResultsFound: "לא נמצאו תוצאות",
    enterClientCode: "הזן קוד לקוח כדי לחפש שוב",
    enterClientCodeToDisplayAnalizers: "הזן קוד לקוח כדי להציג רשימה של כלי ניתוח (analyzers) זמינים.",
    defaultClientCodeIsInvalid: "{0} קוד הלקוח המוגדר כברירת מחדל עבור התקשרות זו אינו חוקי. הזן קוד לקוח חוקי כדי להציג רשימה של כלי ניתוח (analyzers) זמינים.",
    mirrorCodesNotAccepted: "שים לב כי קודים מקבילים (mirror codes) אינם אפשריים",
    helixProjectSearch: "חפש",
    helixProjectsSearchPlaceholderText: "הזן קוד לקוח כדי לחפש",
    helixWizardProjectsSearchPlaceholderText: "חפש כלי ניתוח (analyzer) לפי קוד לקוח",
    selectOneOrMoreProjects: "בחר פרוייקט Helix אחד או יותר מהרשימה לקישור",
    noPermissionLabel: "עליך להיות בעל הרשאות לארכיב בכדי לארכב את תיק הביקורת. ",
    linkProject: "קשר פרויקט",
    oneAnalyzerMustBeSelected: "יש לבחור כלי ניתוח (analyzer) אחד.",
    selectAnAnalyzer: "בחר כלי ניתוח (Analyzer)",
    selectOneAnalyzer: "בחר כלי ניתוח EY Helix Analyzers להלן בכדי ליצור קישור להתקשרות שלך ב- EY Canvas. באפשרותך לחפש ידנית לפי קוד לקוח כדי למצוא פרויקטים של EY Helix ואת כלי הניתוח (analyzers) הקשורים.",
    selectAnalyzerModalTitle: "בחר Analyzer עבור",
    selectAnalyzerModalBodyText: "בחר EY Helix analyzer בכדי לקשר עם ההתקשרות שלך ב-EY Canvas",
    selectAnalyzerModalSubmitButtonLabel: "קשר פרויקט",
    projectCanNotBeLikedTootip: "פרויקט EY Helix זה אינו זמין מכיוון שהמיקום שלו אינו תואם את המיקום של ההתקשרות ב- EY Canvas .",
    unlinkProjectConfirmationModalTitle: "אזהרה - בטל קישור לפרויקט",
    unlinkProjectConfirmationModalBodyText: "לכלי הניתוח EY Helix analyzer, שהוסר ממנו הקישור, יש סימניות של לקוח המשויכות להתקשרות זו. ביטול הקישור של כלי ניתוח זה יגרום לכך שהסימניות הללו לא יהיו זמינות עוד. לא ניתן לבטל פעולה זו. האם אתה רוצה להמשיך?",
    defineConnectionSettings: "הגדר הגדרות חיבור",

    helixConnectionPageTitle: "חיבורי EY Helix",
    helixConnectionPageSubtitle: "כלי ניתוח EY Helix Analyzer מחוברים, הנתונים המיובאים שלהם ואחוז חשבונות GL שמופו לחשבונות EY. לחץ על האחוז ממופה כדי להתאים את המיפוי. האחוז הממופה יכול להיות שונה בין החיבור לנתונים המיובאים. לדוגמה, אם המיפוי התרחש לאחר תאריך הייבוא. ייבא מחדש את הנתונים בכדי לקבל את המיפוי העדכני ביותר.",
    helixIntegrationPageNoConnectedAnalyzerLabel: "אין כלי ניתוח (analyzers)  מקושרים",
    helixIntegrationPageTitle: "אינטגרציה של EY Helix",
    helixIntegrationPageSubtitle: "קשר כלי ניתוח EY Helix Analyzers אחד או יותר להתקשרות ב-EY Canvas.",
    helixIntegrationPageNoHelixProjectLinkedLabel1: "אין כלי ניתוח (analyzers) קשורים. כדי לקשר לכלי ניתוח (analyzer) חדש,",
    helixIntegrationPageNoHelixProjectLinkedLabel2: " לחץ כאן.",
    helixIntegrationPageColumnConnectionName: "שם החיבור",
    helixIntegrationPageColumnConnectionType: "סוג חיבור",
    helixIntegrationPageColumnAnalysisPeriod: "תאריך Analysis",
    helixIntegrationPageColumnAnalyzerName: "שם כלי הניתוח EY Helix Analyzer",
    helixIntegrationPageColumnLastConnectedBy: "התחבר לאחרונה על ידי",
    connectAnalyzer: "קשר כלי ניתוח (analyzer)",
    dataImportModalTitle: "אישור ייבוא",
    dataImportModalBodyLabel: "ייבוא 'היקף ואסטרטגיה' כבר קיים בהתקשרות זו. רק ייבוא אחד של 'היקף ואסטרטגיה' מותר לכל התקשרות. ייבוא נתונים אלה יחליף את הייבוא הקיים של 'היקף ואסטרטגיה'. אתה רוצה להמשיך? לא ניתן לבטל פעולה זו.",
    dataImportModalBodyLabelMest: "כבר קיים ייבוא ​​של 'היקף ואסטרטגיה' עבור ישות זו. רק ייבוא ​​יחיד של 'היקף ואסטרטגיה' מותר לכל ישות. ייבוא ​​נתונים אלה יחליף את הייבוא ​​'היקף ואסטרטגיה' הקיים. האם אתה רוצה להמשיך? לא ניתן לבטל פעולה זו.",
    dataImportModalCancelButtonLabel: "בטל",
    dataImportModalCloseButtonLabel: "סגור",
    dataImportModalConfirmButtonLabel: "ייבוא",
    dataImportModalImportError: "אירעה שגיאה הקשורה לכלי הניתוח EY Helix Analyzer המחובר. לא ניתן לייבא נתונים. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",

    //Entites to Business Mapping Modal
    entityMappingModalTitle: 'Entity mapping',
    entityMappingModalCancelLabel: 'Cancel',
    entityMappingModalSaveLabel: 'Save',
    entityMappingModalDescription: 'Manage the mapping between entities and business units for this connection. Each business unit can be mapped to a single entity only.',
    entityMappingModalBusinessUnitsPlaceholder: 'Business unit(s)',
    entityMappingModalAllBusinessUnitsLabel: 'All business units',
    entityMappingModalBusinessUnitSelectedCount: '{0} business unit',
    entityMappingModalBusinessUnitsSelectedCount: '{0} business units',
    entityMappingModalNoResultsFound: 'No results found',
    entityMappingModalNoEntitiesLabel1: 'No entities exists in the engagement.',
    entityMappingModalNoEntitiesLabel2: 'Create an entity to get started.',
    entityMappingModalBusinessUnitAlreadyMapped: 'A business unit can be related to only one entity. Unrelate from other entities to enable.',
    /*Entites to Business Table*/
    entityMappingTableEntityColumnLabel: 'Entity',
    entityMappingTableBusinessUnitsColumnLabel: 'Business unit(s)',

    helixProjectPageTitle: "פרויקטים של EY Helix",
    helixProjectPageSubtitle: "קשר את הפרויקט/ים של EY Helix הרלוונטיים להתקשרות זו של EY Canvas. כאשר מקושרים יותר מפרויקט אחד של EY Helix, בחר אחד כפרויקט הראשי כדי לאפשר שילוב נתונים ב-EY Canvas. ניתן לשלב רק את הפרויקט הראשי ב-EY Canvas, ולכן עליו להכיל את כל פעילות רישום פקודות היומן עבור התאריך הרלוונטי להתקשרות.",
    helixProjectPageNoHelixProjectLinkedLabel1: "לא קיימים פרויקטים נוספים של EY Helix המקושרים להתקשרות.",
    helixProjectPageNoHelixProjectLinkedLabel2: "הוסף פרויקט חדש של EY Helix",
    helixProjectPageNoHelixProjectLinkedLabel3: " בכדי להתחיל.",
    helixProjectPageNoHelixProjectLinkedLabel4: "לחץ",
    linkToHelixProject: "פתוח ב-EY Helix",
    addNewEYHelixProject: "הוסף פרויקט חדש של EY Helix",
    eyHelixSetup: "שלב נתוני EY Helix",
    existingConnectionDetectedModalTitle: "זוהו חיבורים קיימים",
    existingConnectionDetectedDescription: "כלי הניתוח (ה- Analyzer) שנבחר היה מחובר בעבר להתקשרות זו של EY Canvas. אתה יכול ליצור חיבור חדש או לבחור חיבור קיים למטה.",
    selectExistingConnection: "בחר חיבור קיים",
    selectCreateNewConnection: "צור חיבור חדש",
    connectionNoRecords: "לא נמצאו חיבורים",
    selectOneOfTheOptionsToProceed: "בחר אחת מהאפשרויות כדי להמשיך.",
    saveHelixProjectErrorMessage: "לא ניתן לשמור את כלי הניתוח (analyzer) שנבחר. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    noResultFoundForAnalyzerSelection: "ודא שכלי הניתוח (analyzer) שאתה מחפש נמצא במצב חוקי ושקיבלת גישה לכלי הניתוח (analyzer). פנה למנהל מערכת של EY Helix לקבלת פרטים נוספים. הזן קוד לקוח כדי לחפש שוב.",

    /*Helix Analyzer Details Drawer*/
    connectButtonLabel: "התחבר",
    reConnectButtonLabel: "התחבר מחדש",
    demoteFromFinancialStatementsOptionLabel: "המר מהדוחות הכספיים",
    promoteToFinancialStatementsOptionLabel: "קדם לדוחות כספיים",
    deleteOptionLabel: "מחק",
    projectAndAnalyzerDetailsSectionTitle: "פרטי הפרויקט וכלי הניתוח (Analyzer)",
    projectNameLabel: "שם הפרוייקט",
    clientCodeLabel: "קוד לקוח",
    analyzerNameLabel: "שם Analyzer",
    periodEndDateLabel: "תאריך סיום",
    analysisDateLabel: "תאריך Analysis",
    lastConnectedByLabel: "התחבר לאחרונה על ידי",
    connectionSettingsSectionTitle: "הגדרות חיבור",
    connectionTypesLabel: "סוגי חיבור",
    currencyTypeLabel: "סוג המטבע",
    currencyLabel: "מַטְבֵּעַ",
    currencyCodeLabel: "קוד מטבע",
    businessUnitsLabel: "יחידות עסקיות",
    entitiesLabel: "ישויות",
    analysisPeriodLabel: "תאריך Analysis",
    comparativePeriod1Label: "תאריך השוואה 1",
    comparativePeriod2Label: "תאריך השוואה 2",
    manageAccountMappingSectionTitle: "ניהול מיפוי הסעיפים (Account mapping)",
    manageAccountMappingButtonLabel: "ניהול מיפוי הסעיפים (Account mapping)",
    mappedGLAccountsLabel: "% חשבונות GL ממופים:",
    updateSettingsButtonLabel: "עדכן הגדרות",
    deleteConnection: "מחק חיבור",
    deleteConnectionQuestion: "האם אתה בטוח שברצונך למחוק את החיבור שנבחר? כל הנתונים ששולבו בעבר הקשורים לחיבור זה יימחקו. לא ניתן לבטל פעולה זו.",
    deleteConnectionWithAnalyticsQuestion: "האם אתה בטוח שברצונך למחוק את החיבור שנבחר? כל הנתונים ששולבו בעבר הקשורים לחיבור זה יימחקו. בנוסף, החיבור שנבחר כולל סימניות לקוח המשויכות להתקשרות זו. מחיקת החיבור תגרום לכך שסימניות אלה לא יהיו זמינות עוד. לא ניתן לבטל פעולה זו.",

    /*Helix Projects Table*/
    tableShowing: "מציג תוצאות עבור:",
    tableClientCode: " -קוד לקוח: ",
    tableEngagementCode: "קוד התקשרות",
    tableEngagementCodeName: "שם ההתקשרות",
    tableProjectID: "מספר זיהוי פרוייקט",
    tableProjectName: "שם פרוייקט",
    tableAnalyzerName: "שם Analyzer",
    tablePeriodEndDate: 'Period end date',
    tableEYHelixPeriodEndDate: "סוף תקופה",
    tableAnalysisDate: "תאריך ניתוח",
    tableEYHelixAnalysisDate: "תאריך Analysis",
    tableAssignedPartner: "שותף שהוקצה",
    tableProjectLinked: "פרויקט מקושר",
    tableTooltipAnalizerIsDeleted: "כלי הניתוח (Analyzer) נמחק בתוך EY Helix. כדי למחוק את החיבור לצמיתות, לחץ כדי לפתוח את  האפשרויות המפורטות. אנא שקול אם יש לחבר כלי הניתוח (Analyzer) אחר.",
    tableTooltipAnalizerIsUnavailable: "כלי הניתוח (Analyzer) אינו זמין בתוך EY Helix. פנה למנהל מערכת של EY Helix לקבלת פרטים נוספים. כדי למחוק את החיבור לצמיתות, לחץ כדי לפתוח את האפשרויות המפורטות. אנא שקול אם יש לחבר כלי הניתוח (Analyzer) אחר.",
    tableTooltipNotValidUser: "אינך חבר צוות מורשה של כלי הניתוח (analyzer) שנבחר. פנה למנהל הפרויקט של EY Helix כדי לקבל גישה ולנסות שוב.",

    /*Helix Project Cards*/
    cardAnalyzerConnectionLabel: "חיבורים",
    cardAnalyzerHelixLabel: "כלי הניתוח EY Helix Analyzer",
    cardAnalyzerMappedGLAccountsLabel: "חשבונות GL ממופים",
    cardAnalyzerEntityMappingLabel: 'Entity mapping',
    cardAnalyzerManageGLAccountsLink: "ניהול מיפוי הסעיפים (Account mapping)",
    cardAnalyzerSectionScopeAndStrategy: "היקף ואסטרטגיה",
    cardAnalyzerSectionFinancialStatements: "דוחות כספיים",
    cardAnalyzerSectionButtonLink: "כאן",
    cardAnalyzerSectionButtonDisconnect: "נתק כלי ניתוח Analyzer",
	cardAnalyzerSectionScopeAndStrategyNoBalance: "נתוני היקף ואסטרטגיה משמשים להצגת יתרות בפעילויות היקף ואסטרטגיה כגון מהותיות. לחץ על {0} כדי לייבא נתוני היקף ואסטרטגיה.",
    cardAnalyzerSectionFinancialStatementsNoBalance: "ניתן לייבא דוחות כספיים ל-EY Canvas כדי לספק פירוט מהדוחות הכספיים למקום שבו בוצעה העבודה בהתקשרות EY Canvas. לחץ על {0} בכדי לייבא דוחות כספיים.",
    cardAnalyzerSectionAnotherAnalyzerType: " כלי ניתוח Analyzer זה חובר כדי להקל על האינטגרציה בין EY Canvas, EY Helix ו/או EY Smart Sampling. לחץ על {0} כדי לנתק את כלי ניתוח זה.",
    cardAnalyzerSectionButtonLinkDisableTooltip: "אינך חבר צוות מורשה של  כלי הניתוח Analyzer  המקושר. צור קשר עם מנהל הפרויקט של ה- EY Helix בכדי לקבל גישה.",
    cardAnalyzerSectionButtonLinkDisableTooltipPermission: 'אין לך את ההרשאות הדרושות לייבא נתונים אלה. ודא שיש לך את ההרשאה "ייבוא ​​נתוני EY Helix" במסגרת התקשרות Canvas זו ונסה שוב.',
    cardAnalyzerTrialBalanceAnalisysPeriod: "תאריך Analysis",
    cardAnalyzerTrialBalanceComparativePeriod: "תאריך השוואתי",
    cardAnalyzerTrialBalanceSecondComparativePeriod: "תאריך השוואה שני",
    cardAnalyzerTrialBalanceLastImportDate: "תאריך הייבוא ​​האחרון",
    cardAnalyzerTrialBalanceCurrency: "מַטְבֵּעַ",
    cardAnalyzerTrialBalanceBusinessUnits: "יחידות עסקיות",
    cardAnalyzerTrialBalanceMapedGLAccounts: "חשבונות GL ממופים",
    cardAnalyzerTrialBalanceImportStatus: "סטטוס ייבוא",
    cardAnalyzerTrialBalanceCurrencyTypeFunctional: "פוּנקצִיוֹנָלִי",
    cardAnalyzerTrialBalanceCurrencyTypeReporting: "דוחות",
    cardAnalyzerTrialBalanceImportData: "ייבוא נתונים",
    cardAnalyzerTrialBalanceAdjustmentModule: "מודול התאמה",
    cardAnalyzerTrialBalanceReImport: "יבוא מחדש",
    cardAnalyzerTrialBalanceRemove: "הסר",
    cardAnalyzerTrialBalanceImportStatusInProgress: "בתהליך",
    cardAnalyzerTrialBalanceImportStatusImported: "מיובאים",
    cardAnalyzerTrialBalanceImportStatusError: "שגיאה",
    cardAnalyzerTrialBalanceImportStatusDisconnected: "מנותק",
    cardAnalyzerTrialBalanceImportModalTitle: "ייבוא נתונים",
    cardAnalyzerTrialBalanceImportModalDescription: "בחר את המאפיינים של הייבוא ​​ולחץ על 'ייבוא' כדי לייבא",
    cardAnalyzerTrialBalanceImportModalButton: "ייבוא",
    cardAnalyzerTrialBalanceReImportModalTitle: "ייבא נתונים מחדש",
    cardAnalyzerTrialBalanceReImportModalDescription: "בחר את המאפיינים של הייבוא ​​ולחץ על 'יבוא מחדש' כדי לייבא מחדש.",
    cardAnalyzerTrialBalanceReImportModalButton: "יבוא מחדש",
    cardAnalyzerTrialBalanceImportInProgressTooltip: "הייבוא מתבצע. פעולה זו עשויה להימשך מספר דקות.",
    cardAnalyzerTrialBalanceImportEntityTooltip: "לא ניתן לשנות ישות במהלך יבוא מחדש. צור ייבוא ​​חדש כדי לבחור ישות אחרת.",
    cardAnalyzerTrialBalanceImportMestEntity: "בחירה זו נעשתה בשלב הקודם. כדי לערוך, עליך לחזור לשם.",
    cardAnalyzerTrialBalanceMestBusinessUnit: "בחירה זו מבוססת על הישות לעיל. כדי לערוך את הקשרים בין הישות ליחידות העסקיות, גש ל'מיפוי ישויות' בדף הסיכום להלן.",
    cardAnalyzerTrialBalanceFirstSelectCurrencyTypeTooltip: "תחילה בחר 'סוג מטבע' כדי להפעיל שדה זה.",
    cardAnalyzerTrialBalanceFirstSelectCurrencyTooltip: "תחילה בחר 'מטבע' כדי להפעיל שדה זה.",

    /*Helis Linked Projects Cards*/
    analysisDate: "תאריך ניתוח:",
    unlinkProject: "בטל את קישור הפרויקט",
    editAnalyzer: "ערוך מנתח (analyzer)",
    deleteProject: "מחק פרויקט",
    projectDeleted: "הפרויקט נמחק.",
    loadingProjectDataLinked: "טוען נתונים מ-EY Helix",
    projectMarkPrimaryConfirmationHeader: "שנה את פרויקט EY Helix הראשי",
    projectMarkPrimaryConfirmationMsg: "האם אתה בטוח שברצונך לשנות את פרויקט ה- EY Helix הראשי?",
    projectPrimaryEYHexliProject: "פרויקט ה- EY Helix הראשי",
    helixProjectUnlink: "בטל קישור",
    helixProjectDelete: "מחק",
    analyzersLabel: "כלי הניתוח (Analyzers) :",


    /*Helix Import List*/
    importHelixList: "רשימת ייבוא EY Helix",
    importDocumentName: "שם המסמך",
    importDocumentID: "מזהה מסמך",
    importFileSize: "גודל קובץ (ב-KB)",
    importDownload: "הורד",
    importNoRecords: "לא נמצאו מסמכים",
    importInvalidDocumentID: "מזהה מסמך דורש התאמה מלאה לחיפוש. אנא ודא שצירפת את מזהה המסמך המלא",

    /*Helix Connect analyzer modal*/
    connectAnalyzerClientLabel: "לקוח:",
    addConnectionNameLabel: "הוספת שם חיבור",
    connectionNamePlaceholder: "שם החיבור",
    connectionNameRequired: "נדרש",
    connectAnalyzerModalTitle: "קשר כלי ניתוח (analyzer)",
    connectAnalyzerDescription: "בחר  כלי ניתוח Analyzer להלן בכדי ליצור קישור להתקשרות זו של ה- EY Canvas. חפש לפי קוד לקוח כדי למצוא פרויקטים של EY Helix וכלי הניתוח הקשורים.",
    analyzerLocationIncompatibleErrorMessage: "לא ניתן לחבר את  כלי הניתוח Analyzer  מכיוון שהנתונים שלו מאוחסנים במיקום שאינו תואם את המיקום של ההתקשרות של ה- EY Canvas.",
    analyzerMaxConnectionReachedErrorMessage: "הגעתם למספר מרבי של חיבורים מותרים עבור  כלי הניתוח Analyzer שנבחר. אנא בחר  כלי ניתוח אחר בכדי להמשיך.",
    helixAnalyzerErrorMessage: "אירעה שגיאה בחיבור  לכלי הניתוח EY Helix Analyzer. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    helixAnalyzerGLAConnectionErrorMessage: "יש שגיאה אחת או יותר המתחברות לכלי הניתוח (Analyzer) EY Helix כדי לקבל כמות חשבונות ממופים. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    helixReImportErrorMessage: "אירעה שגיאה בייבוא נתונים מה- EY Helix. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",

    /*Helix Select Entity Modal*/
    selectEntityModalTitle: "בחר ישות",
    noEntitiesMappedToBusiness: "אין ישויות שמופו ליחידות עסקיות.",
    noEntitiesMappedToBusinessFirst: "לחץ",
    noEntitiesMappedToBusinessLink: "כאן",
    noEntitiesMappedToBusinessLinkText: " בכדי להתחיל.",
    searchEntityPlaceholder: "חפש ישות",
    entityListHeader: "ישות",
    selectEntityErrorMessage: "בחר ישות כדי להמשיך.",
    entityAlreadyConnectedToScopeAndStrategy: "כבר קיים ייבוא ​​של 'היקף ואסטרטגיה' עבור ישות זו. רק ייבוא ​​יחיד של 'היקף ואסטרטגיה' מותר לכל ישות. הסר את הייבוא ​​הקיים כדי לאפשר בחירה זו.",
    selectEntityNoEntitiesFound: "לא נמצאו תוצאות",
    selectEntityModalDescription: "בחר ישות שעבורה ברצונך לייבא נתונים.",

    /*Manage Account Mapping*/
    manageAccountMapping: "ניהול מיפוי הסעיפים (Account mapping)",
    manageAccountMappingErrorMessage: "לא ניתן היה להתחבר ל- EY Helix. רענן את הדף ונסה שוב. אם הבעיה ממשיכה, אנא פנה לתמיכה הטכנית.",
    helixViewerLoader: "טוען תצוגת Helix Viewer...",

    /*Helix Remove Import Modal*/
    removeImportModalTitle: "הסר ייבוא",
    removeImportRemoveButtonLabel: "הסר",
    removeImportDescription: "האם אתה בטוח שברצונך להסיר את הייבוא ​​הבא?",
    removeImportActionUndoneDescription1: "האם אתה בטוח שברצונך להסיר את הייבוא ​​הבא?",
    removeImportActionUndoneDescription2: "לא ניתן לבטל פעולה זו.",
    removeImportErrorMessage: "הנתונים המיובאים השתנו מאז שפתחת מסך זה. כדי להמשיך בהסרה, רענן את הדף ונסה שוב.",

    /*Disconnect analyzer modal*/
    disconnectAnalyzerModalTitle: "נתק כלי ניתוח (analyzer)",
    disconnectAnalyzerDisconnectButtonLabel: "לְנַתֵק",
    disconnectAnalyzerDescription: "האם אתה בטוח שברצונך לנתק את כלי הניתוח (Analyzer) שנבחר?",
    disconnectAnalyzerImportsExistErrorMessage: "לחיבור זה נוסף ייבוא מאז שפתחת מסך זה. ניתן לנתק חיבור רק אם כל פעולות הייבוא המשויכות הוסרו תחילה. רענן את הדף ונסה שוב.",

    /*Content Update */
    quote: '"',
    performContentUpdate: "בצע עדכון תוכן",
    contentupdate: "עדכוני תוכן",
    btnContentUpdate: "עידכון",
    btnContentUpdateSelected: "עידכון",
    updateSuccessMessage: "עדכון התוכן נשלח",
    msgContentUpdate: "בחר קטגוריה אחת או יותר למטה כדי לעדכן את התוכן. אם כבר הושלמו כמויות משמעותיות של עבודה שוחח עם מנהלי ההתקשרות האם עדכון התוכן מתאים. לא ניתן לבטל עדכוני תוכן.",
    msgIndependance: "עדכון אי תלות עלול לגרום לכך שיידרש להשלים שוב את הצהרות אי התלות. ",
    msgProfile: "לעדכון פרופיל ההתקשרות עשויה להיות השפעה משמעותית על תוכן תיק הביקורת. משתמשים עשויים לאבד את הגישה לתיק הביקורת עד לשליחת פרופיל חדש. לא ניתן לבטל פעולה זו. ",
    msgHistoryContentUpdate: "עדכוני תוכן שבוצעו בעבר והסטטוס שלהם.",
    msgWarningTitle: "אזהרה",
    btnProceedContentUpdate: "המשך",
    btnCancelContentUpdate: "בטל",
    confirmationMessageP1: "אתה עומד להשלים את עדכון התוכן עבור קטגוריות התוכן שנבחרו. בחר",
    confirmationMessageP2: "כדי להמשיך או לבחור",
    confirmationMessageP3: "אם אינך מעוניין להשלים את עדכון התוכן בשלב זה.",
    warningMessage: "סוג תוכן אחד או יותר צריכים להיבחר לעידכון",
    groupReportingFormsSent: "דיווח קבוצתי <b>טפסים שנשלחו</b>",
    groupReportingFromStatus: "טופס סטטוס דיווח  של חברות הקבוצה",
    primaryTeamReviewStatus: "סטטוס סקירת צוות הבקורת הראשי",
    reportingStatus: "סטטוס דיווח",
    taskStatusLabel: "סטטוס המשימה",
    primaryTeam: "צוות הביקורת הראשי",
    componentTeam: "צוות הביקורת של ישות מוחזקת (Component team)",
    groupTasksReceived: "ביקורת קבוצה <b>משימות שהתקבלו</b>",
    group: "קבוצה",
    regionalTeam: "צוות איזורי",
    unlinkedLabel: "הקישור בוטל",
    linkedLabel: "מקושר",
    unlinkedTasks: "<b>משימות ללא קישור</b>",
    unlinkedTask: "<b>משימות לא מקושרות</b>",
    primaryTeamGroupTaskPlaceholder: "צור ישויות מוחזקות (components) ושלח הנחיות לקבוצה כדי לעקוב אחר תהליך העבודה כאן.",
    componentTeamGroupTaskPlaceholder: "קבל את המשימות הקבוצתיות של הישויות המוחזקות (Components) מהצוות הראשי בכדי לראות כאן את סיכום התהליך.",
    confirmUpdateMessage1: "לעדכון הטפסים הללו עשויה להיות השפעה משמעותית על התוכן. לאחר ההפעלה, לא ניתן לבצע עדכון תוכן נוסף עד להשלמתם.",
    confirmUpdateMessage2: "בחר 'המשך' כדי להמשיך או בחר 'ביטול' אם אינך מעוניין להשלים את עדכון התוכן בשלב זה.",
    updateSelectedTitle: "עדכון נבחר",
    statusCodeForbidden: 403,
    pspAccountHeader: "סעיף",
    pspAccountDateHeader: "תאריך התוכן",
    pspAccountStatus: "סטטוס",
    pspAccountSelected: "המשתמש שנבחר",

    /*Preapre for Arc*/
    YearEndDate: "תאריך סיום השנה:",
    PeriodEndDate: "תאריך סיום התקופה המבוקרת:",
    ReportDate: "תאריך דיווח:",
    ArcDeadlineDate: "תאריך יעד ארכיב:",
    ClientCode: "קוד לקוח:",
    PrimaryEngCode: "קוד תיק ביקורת הראשי",
    SecondaryEngCode: "קוד התקשרות ביקורת משני:",
    ReportType: "האם הדוחות מסויגים בדרך כלשהי ו/או  האם כוללים פסקת הדגש עניין (emphasis of matter)?:",
    ProtectedDocuments: "הערה: אין לשמור מסמכים מוגנים בתיקי ביקורת, אלא אם יש צורך בכך",
    noObjectsAvailable: "אין פריטים זמינים",
    CurrentlyUnavailable: "לא זמין כרגע",
    showMoreToggle: "הצג עוד",
    showLessToggle: "הצג פחות",

    //#region Document upload status

	docListUploadTemporaryPlaceholder: '<center>אין מסמכים זמינים<br />—<br />תוכל לגרור ולשחרר מסמך אחד או יותר או ללחוץ על <button class="motif-button motif-text-alt-button motif-button-small">הוסף קבצים זמניים</button></center>',
    uploadEvidencePlaceholder: "גרור ושחרר מסמך אחד או יותר או לחץ על <a>הוסף ראיה</a>",
    uploadTemporaryPlaceholder: "גרור ושחרר מסמך אחד או יותר או לחץ על <a>הוסף קבצים זמניים</a>",

    processing: "Processing",
    uploading: "טוען",
    uploadComplete: "Processing",
    downloading: "Downloading",
    downloadComplete: "ההורדה הושלמה",
    loading: "טעינה",

    //#region Filter

    filter: "סנן",
    noFiltersAvailable: "אין מסננים (filters) זמינים",
    pickADate: "בחר תאריך",
    filterYes: "כן",
    filterNo: "לא",

    //#region Document list filters
    filterGroupDocumentsLabel: "מסמכים",
    filterDocumentContentLabel: "תוכן המסמך",
    filterSharedEvidenceLabel: "ראיה ששותפה",
    filterFileExtensionLabel: "סיומת קובץ",
    filterDocumentConflictLabel: "קונפליקטים בסינכרון",
    filterDuplicateFileNameLabel: "להעתיק שם קובץ",
    filterCanvasFormsLabel: "טפסי Canvas",

    filterGroupModificationsLabel: "שינויים",
    filterLastModifyUserLabel: "שונה לאחרונה על ידי",
    filterModifyAfterReviwerSignoffLabel: "השתנה מאז חתימת הסוקר",
    filterModifiedAfterLabel: "שונה לאחרונה על ידי",

    filterGroupReviewNotesLabel: "סקירת הערות",
    filterReviewNoteStatusLabel: "סטטוס",
    filterReviewNoteAssignedToLabel: "הוקצה ל",
    filterReviewNoteAuthoredByLabel: "נכתב על ידי",
    filterReviewNoteOtherEngagementLabel: "מתיקי ביקורת אחרים",

    filterGroupSignOffsLabel: "Sign-offs",
    filterSignOffMissingLabel: "חתימות חסרות",
    filterSignedOffByUserLabel: "נחתם על ידי",
    filterNotSignedOffByUserLabel: "לא נחתם על ידי",
    filterSignOffRequirementsLabel: "דרישות חתימה",

    filterGroupOtherLabel: "אחרים",
    documentLink: "קישור למסמך",
    filterByCopyLinkDocument: "מסונן לפי העתקת מסמך קישור",
    filterGroupAuditComponentLabel: "צוות אזור/ישות מדווחת",
    noGroupAuditComponents: "לא נוצרו ישויות מוחזקות",
    filterFindingsLabel: "ממצאים",
    filterGroupInstruction: "הנחיות קבוצה",
    noGroupInstruction: "לא נוצרו הנחיות",

    documentSearchPlaceholderLabel: "חיפוש מסמכים",
    analyticSearchPlaceholderLabel: "חפש ניתוחים",
    //#endregion

    //#endregion

    pendingResponseLabel: "תגובה ממתינה",
    receivedLabel: "התקבל",
    dueToPrimaryTeam: "בשל צוות הביקורת הראשי PT",
    sentToPrimaryTeam: "נשלח לצוות הביקורת הראשי",
    documentationPending: "תיעוד בהמתנה",
    documentationComplete: "התיעוד הושלם",
    viewBytimephaseTextLabel: "צפה ב-  time phase",
    showDetails: "הצג פרטים",
    referenceDocAddDocHeaderText: "קשר בין ראיות או קבצים זמניים מתיק ביקורת זה בכדי לגשת אליהם מה- dashboard.",
    addDocsToTeam: "הוספת מסמכים למסמכי צוות",
    addDocsToMy: "הוספת מסמכים למסמכים שלי",
    addDocument: "הוסף מסמך",
    externalUserRemove: "הסר",

    // Internal user roles abbr
    adminRole: "Admin",
    readOnlyRoleForThirdPartyUser: "לקריאה בלבד",
    legacy: "ללא הגבלה",
    permissionLabel: "הרשאה",
    displayPermissionErrorText: "לא ניתן להציג הרשאות כעת. אנא נסה שנית. אם הבעיה נמשכת פנה אל התמיכה הטכנית.",
    onlyShowRelatedTasks: "הצג רק משימות קשורות",

    softwareUpdate: "עדכוני תוכנה",
    updateNow: "עדכן כעת",
    updateMsg: "עדכוני תוכנה זמינים עבור EY Canvas. בחר באפשרות עדכן כעת כדי להוריד ולהתקין את העדכונים. הדף יתרענן לאחד מכן.",

    processingError: "שגיאת עיבוד",

    //Create tag modal labels
    createtags: "צור תגים",
    reportDate: "תאריך דיווח:",
    managetags: "נהל תגים",
    savechanges: "שמור שינויים",
    manageTagGroupCreate: "צור",
    manageTagGroupDiscard: "Discard",
    manageTagGroupCreateTooltip: "קבוצת תגים",
    deletetag: "מחק תג",
    deletetaggroup: "מחק את קבוצת התגים",
    createTagGroup: "צור קבוצת תגים",
    manageTagGroupName: "קבוצת תגים",
    countOftasksAssigned: "כמות המשימות שהוקצו",
    createTagGroupMessage: "צור קבוצות תגים ותגים כדי להתחיל. לחץ על {0} כדי ליצור קבוצת תגים.",
    tagsContnetSearchPlaceholder: "תגי חיפוש",
    deleteTagHoverText: "לאחר השמירה לא ניתן יהיה לשחזר את התגים או קבוצות התגים שנמחקו.",
    deleteTagGroupHoverText: "תג זה יוסר מכל המשימות בתיק הביקורת שלך.",
    tagSaveChangesInfoText: "כל התגים בקבוצה זו יימחקו ויוסרו מכל המשימות בתיק הביקורת שלך.",
    tagConfirmModalTitleText: "השינויים יוחלו לאחר שמירתם.",
    tagConfirmModalPrimaryMessage: "האם אתה בטוח שברצונך לשמור את השינויים האלה?",
    tagConfirmModalSecondaryMessage: "האם אתה בטוח שברצונך לשמור את השינויים האלה?",
    tagDeleteModalSecondaryMessage: "לאחר השמירה, לא ניתן יהיה לשחזר את כל התגים שנמחקו.",
    createNewTag: "צור תג חדש",
    tagWillBeRemovedFromRequests: "תג זה יוסר מכל הבקשות שלך בתיק הביקורת. ",
    eyTags: "תגי EY",
    clientTags: "תגי לקוח",
    allTags: "כל התגים",
    // Add canvas form
    addCanvasForm: "הוסף טופס Canvas",
    addCanvasFormName: "שם המסמך",
    addCanvasFormNameBlankMessage: "שם המסמך הוא שדה חובה",
	addCanvasFormNameInvalidCharacterMessage: 'שם לא יכול להכיל אף אחת מהתווים הבאים: */: <br> \\? | "',
    addCanvasFormDigital: "דיגיטלי",
    addCanvasFormCore: "ליבה",
    addCanvasFormNonComplex: "לא מורכב",
    addCanvasFormComplex: "מורכב",
    addCanvasFormListed: "ברשימה",
    addCanvasFormGroupAudit: "ביקורת קבוצתית",
    addCanvasFormPCAOBFS: "PCAOB-FS",
    addCanvasFormPCAOBIA: "PCAOB-IA",
    addCanvasFormStandards: "תקנים",
    addCanvasFormStandardsNotSelectedMessage: "נדרשים לעמוד בתקנים",
    addCanvasFormLanguage: "אנגלית (ארהב)",
    addCanvasFormLanguageNotSelectedMessage: "נדרש לציין את השפה",
    addCanvasFormNoResultFound: "לא נמצאו תוצאות",
    addCanvasFormManageTasks: "נהל משימות",
    addCanvasFormAvailableTasks: "שם משימה",
    addCanvasFormAvailableTaskType: "סוג",
    addCanvasFormTypeOfForm: "סוג הטופס",
    addCanvasFormSubServiceLine: "תת מחלקה",
    addCanvasFormTypeOfFormNotSelectedMessage: "סוג הטופס נדרש",
    addCanvasFormSelectedTasks: "משימות שנבחרו",
	addCanvasFormNoTaskDataAvailable: "לא נבחרו משימות. בחר לפחות משימה אחת כדי ליצור טופס.",
    addCanvasFormCreateForm: "צור טופס",
    addCanvasFormCancel: "בטל",
    addCanvasFormSuccessMessage: "{0} נוצר בהצלחה. ייתכן שהפעולה תימשך עד עשר דקות עד שהתוכן יועבר במלואו.",
    // Add Canvas form manage Objects
    addCanvasFormManageObjects: "נהל את {0}",
    addCanvasFormAvailableObjects: "{0} שם //",
    addCanvasFormSelectedObjects: "נבחר {0}",
    addCanvasFormClickHereToOpenManageTab: "לחץ כאן כדי לפתוח את הכרטיסייה ניהול {0}",
    addCanvasFormNoObjectsDataAvailableRequired: "לא נבחר {0}. בחר לפחות אחד כדי ליצור טופס",
    addCanvasFormNoObjectsDataAvailableOptional: 'No {0} selected.',
    addCanvasFormObjectNotDefinedMessage: "הפריטים אינם זמינים לטופס זה",
    addCanvasFormOptional: "(אופציונלי)",
    addCanvasFormObjects: "פריטים",
    addCanvasFormObject: "אובייקט",
    addCanvasFormSCOT: "תת התהליך המהותי (SCOT)",
    addCanvasFormSCOTs: "SCOTs",
    addCanvasFormITProcess: "תהליך IT",
    addCanvasFormITProcesses: "תהליכי IT",
    addCanvasFormControl: "בקרה",
    addCanvasFormControls: "בקרות",
    addCanvasFormITControl: "בקרת IT",
    addCanvasFormITControls: "בקרות IT",
    addCanvasFormITApplication: "יישום IT",
    addCanvasFormITApplications: "יישומי IT",
    addCanvasFormSignoffRequirements: "נדרשות חתימות:",
    addCanvasFormPICCheckBox: "PIC",
    addCanvasFormEQRCheckBox: "EQR",
    itProcessRelatedITGCITSP: "תהליך IT ו-ITGCs/ITSPs קשורים",
    taskTitle: "הבן ותעד את תהליך ה-IT: {0}",
    taskDescription: "תעד את ההבנה שלנו לגבי תהליך ה-IT. צרף את הטופס הרלוונטי כראיה כדי לתמוך בהבנתנו את תהליך ה-IT.<br>כאשר ITGCs מופיעים בקטע תכונות משימות, בצע הליכי הדרכה כדי לאשר את הבנתנו את ה-ITGCs ולהעריך את התכנון והיישום שלהם. צרף ראיות על הנהלים שלנו.",
    addCanvasFormAccounts: "סעיפים",
    addCanvasFormAccount: "סעיף",
    addCanvasFormErrorMessage: "טופס זה יכול להיות קשור רק לחשבון אחד",
    addCanvasFormValidationMessage: "נדרשת בחירה",
    addCanvasFormEstimates: "אומדנים",
    addCanvasFormEstimate: "אומדן",
    addEstimateCanvasFormErrorMessage: "טופס זה יכול להיות קשור רק לאומדן אחד בלבד",
    addControlCanvasFormErrorMessage: "טופס זה יכול להיות קשור רק לבקרה אחת",
    addScotCanvasFormErrorMessage: "טופס זה יכול להיות קשור רק לתת תהליך מהותי (SCOT) אחד",

    //Independence Confirmation
    sortOrderIndependence: "סדר מיון",
    confirmationStatus: "סטטוס אישור",
    confirmationDate: "תאריך אישור",
    independenceConfirmationSearch: "חפש חברי צוות",
    editTemplate: "ערוך תבנית",
    viewTemplate: "הצג תבנית",
    confirmedBy: "אושר על ידי",
    overriddenBy: "נעקף על ידי",
    grantedBy: "הוענקה גישה על ידי",
    deniedBy: "נדחתה גישה על ידי",
    list: "רשימה",
    paginationShow: "הצג",
    options: "אפשרויות",
    removeTeamMemberModalText: "האם אתה בטוח שברצונך להסיר את חבר הצוות הזה מתיק הביקורת שלך?",
    removeTeamMemberModalTitle: "הסר את חבר הצוות",
    overrideRemovedBy: "ביטול הוסר על ידי",

    // Custom instructions
    addCustomInstruction: "הוסף הנחיות מותאמות אישית",
    editCustomInstruction: "ערוך הנחיות מותאמות אישית",
    customInstructionInstructionalText: "הוסף או ערוך הנחיות מותאמות אישית כאן. הנחיות אלו יופיעו בהצהרות אי התלות האישיות של כל אחד מחברי הצוות כדי לתת הדרכה כיצד להגיב על שאלות ספציפיות ללקוח.",
    customInstructionPermissionTooltip: "עליך להיות בעל הרשאת <b> ניהול תיק הביקורת</b> בכדי לבצע פעולה זו. שוחח עם <b> מנהל תיק הביקורת </b> בכדי לבקש הרשאה.",
    customInstructionMaxLengthExceeded: "הטקסט חרג מהאורך המרבי המותר",

    //Independence Confirmation Details
    details: "פרטים",
    question: "שְׁאֵלָה",
    answer: "תשובה",
    countTeamMembers: "ספירת חברי הצוות",
    executiveApproval: "אישור מנהלים",
    yes: "כן",
    no: "לא",
    independenceModalText: "כאן תוכלו לראות את חברי הצוות שבחרו בתשובה זו בהצהרת אי התלות האישית שלהם.",
    notApplicable: "לא ישים",
    readMore: "קרא יותר",
    readLess: "קרא פחות",
    teamMembsersTitle: "פרטי חבר הצוות",

    tasksSelected: "משימות שנבחרו",
    taskSelected: "משימה שנבחרה",
    unselectAll: "בטל את הבחירה בכולם",
    addForm: "הוסף טופס",
    addFormName: "שם",
    addFormDigital: "דיגיטלי",
    addFormCore: "ליבה",
    addFormNonComplex: "לא מורכב",
    addFormComplex: "מורכב",
    addFormListed: "ברשימה",
    addFormGroupAudit: "ביקורת קבוצתית",
    addFormPCAOBFS: "PCAOB-FS",
    addFormPCAOBIA: "PCAOB-IA",
    addFormStandards: "תקנים",
    addFormLanguage: "אנגלית (ארהב)",
    addFormManageTasks: "נהל משימות",
    addFormManageObjects: "נהל פריטים",
    addFormAvailableTasks: "משימות זמינות",
    addFormAvailableObjects: "פריטים זמינים",
    addFormTypeOfForm: "סוג הטופס",
    addFormSelectedTasks: "משימות שנבחרו",
    addFormSelectedObjects: "פריטים נבחרים",
    addFormCreateForm: "צור טופס",
    addFormCancel: "בטל",
    createtag: "צור תג",
    tagsLabel: "תגים",

    //Group instruction summary
    sInstruction: "היקף",
    iInstruction: "אישי",

    //CGT and CGT Unlinked related labels
    cgtSend: "לשלוח",
    cgtDueDate: "תאריך יעד",
    cgtFrom: "מ",

    notesSelected: "הערות שנבחרו",
    noteSelected: "הערה שנבחרה",
    cgtUnlinkedLabel: "לא מקושר",
    cgtUnlinkedInformationMessage: "משימה זו אינה מקושרת עוד לתיק ביקורת קבוצה אחרת וניתן למחוק אותה אם היא כבר לא נדרשת.",
    sendtoPrimaryTeam: "שלח לצוות הראשי",
    sendtoPrimaryTeamdisableBtn: "משימה זו חייבת להכיל לפחות ראיה אחת עם לפחות חתימת מכין וחתימת בודק בכדי שיהיה אפשר לשלוח אותה לצוות הראשי",
	cgtSendModalHeader: 'בחר מסמך אחד או יותר לשליחה לצוות הראשי. <span class="modal-instruction-text">טפסי קנבס יישלחו בפורמט PDF. תיעוד של טפסי PDF Canvas שנשלחו לצוות הראשי זמין בקבצים זמניים.</span>',
    cgtNotifyCheck: "הודע לצוות הראשי כי לא צפויים להישלח מסמכים נוספים.",
    cgtCanvasFormValidation: "ישנם אימותים (validations) שלא נפתרו בטופס Canvas זה. שקול אם יש לפתור את האימותים לפני שליחתם לצוות הביקורת הראשי (Primary Team).",
    finalVersionLabel: "גרסה סופית",
    draftVersionLabel: "טיוטה",
    otherEvidence: "ראיה אחרת",
    selectAtLeastOneDocument: "בחר מסמך אחד לפחות כדי להמשיך.",
	cgtsendmodelinstructionheader: 'בחר מסמך אחד או יותר לשליחה לצוות הראשי. <span class="modal-instruction-text">סימון מסמך כ<b>גרסת טיוטה</b> מודיע לצוות הראשי שאתה עדיין עובד על המסמך ועלול לשלוח גרסאות נוספות. סימון מסמך כ<b>גרסה סופית</b> מודיע לצוות הראשי שהעבודה שלך הושלמה ושאינך מצפה לשלוח גרסאות נוספות של המסמך.</span>',
    //Independence confirmation
    undefined: "לא מוגדר",
    incomplete: "לא הושלם",
    nomattersidentified: "לא זוהו סוגיות",
    matteridentifiedpendingaction: "זוהתה סוגייה - פעולה בהמתנה",
    matterresolveddeniedaccess: "נפתרה הסוגייה - נחסמה גישה",
    matterresolvedgrantedaccess: "נפתרה הסוגייה - הוענקה גישה",
    notapplicable: "לא ישים",
    restored: "שוחזר",
    overriden: "נעקף על ידי",
    override: "לעקוף",
    priornomattersidentified: "לפני - לא זוהו סוגיות",
    priormatteridentifiedpendingaction: "לפני - זוהתה סוגיה - פעולה בהמתנה",
    priormatterresolvedgrantedaccess: "לפני - הסוגיה נפתרה - הוענקה גישה",
    priormatterresolveddeniedaccess: "לפני - הסוגיה נפתרה - הגישה נחסמה",
    addTagsLabelForTaskList: "הוסף תגים",
    addTagLabelForTaskDetails: " + הוסף תג",
    manageTagsColorInputLabel: "צבע",
    manageTagsTagNameInputLabel: "שם תג",
    addTagRequiredMessage: "נדרש",
    addNewTagLinkText: "הוסף תג חדש",
    manageTagsLabel: "נהל תגים",
    manageTagGroupHeader: "צור כאן תגים וקבוצות חדשות. תוכל גם לערוך ולמחוק תגים וקבוצות קיימות. משימות תיוג יכולות לשפר את הארגון והניהול של תיק הביקורת שלך.",
    //add tag color dropdown
    addTagRedColorText: "אָדוֹם",
    addTagOrangeColorText: "כתום",
    addTagTealColorText: "ירוק כחלחל",
    addTagBlueColorText: "כחול",
    addTagPurpleColorText: "סגול",
    addTagGreenColorText: "ירוק",
    deleteAssignmentConfirmationMessage: "האם אתה בטוח שברצונך למחוק הקצאת משימה זו?",

    // Return label for Returned document
    recieved: "התקבל",

    selectServiceOffering: "בחר מבצע שירות",
    selectTasks: "בחר משימות",
    reviewSuggestedTasks: "סקירת משימות מוצעות",
    reviewAvailableTasks: "סקירת משימות זמינות",
    setDueDate: "הגדר תאריך יעד",
    schedulerCreateRequestStep4TabText: "פרוטוקולים של הפעלה ותקשור (Operating and communication protocols)",
    createWorkRequestHeadingpart1: "תן שם לבקשת השירות שלך ובחר את מציע השירות בכדי להתחיל.",
    createWorkRequestHeadingpart2: "הצעות השירות המפורטות להלן מבוססות על פרופיל ההתקשרות שלך ועל השירותים הזמינים באזורך. העלויות משתנות בהתאם לדרגת המשאבים המוקצים והמורכבות. ",
    createWorkRequestHeadingpart3: "אם ההתקשרות שלך גולגלה קדימה, כל הצעות השירות ששימשו את תיק הביקורת שלך בתקופה הקודמת מסומנות ב ",
    createWorkRequestHeadingpart4: "תקופה קודמת ",
    createWorkRequestHeadingpart5: "badge",
    createWorkRequestStep2Headingpart1: "סקירת משימות זמינות עבור",
    createWorkRequestStep2Headingpart2: " הצעת שירות.",
    createWorkRequestStep2Headingpart3: "<u> להשתתפות הצוות בפיילוט השני של הריכוזיות (Wave 2 centralization) </u>, בחר את המשימות הרלוונטיות על סמך הקריטריונים הבאים, שחברי הצוות הריכוזי (centralized team members) עשויים לבצע: (1) נהלי ביקורת אובייקטיביים (כלומר נהלים שאינם דורשים שיקול דעת או שדורשים מעט שיקול דעת), (2) נהלים סובייקטיביים (כלומר נהלים הדורשים שיקול דעת) רק לאומדנים ברמת סיכון נמוכה (lower risk estimates) או כאשר הסיכון שבמהות (IR) עבור מצג ההנהלה הרלוונטי הוא נמוך (lower). משימות שכבר נכללות בבקשת שירות ריכוזית (centralized service request) אחרת מסומנות כ",
    createWorkRequestStep2Headingpart4: ". אם השתמשת בשירות זה בעבר, משימות שנכללו בבקשת התקופה הקודמת שלך מסומנות כ",
    createWorkRequestStep2Headingpart5: "תקופה קודמת.",
    requestName: "שם בקשה",
    submittedBy: "נשלח על ידי",

    // Next wave labels
    totalTasks: "משימות",
    noServiceRequest: "עדיין לא נוצרו בקשות שירות. צור ושלח בקשות שירות בכדי להתחיל.",
    eyContact: "איש קשר של EY",
    requestStatusText: "מצב בקשה",
    requestsByStatusText: "בקשות לפי סטטוס",
    serviceRequest: "בקשות שירות (Service Requests)",
    serviceGateway: "שער שירות (Service Gateway)",
    centralizedServices: "בקש שירותים",
    serviceRequestDueDate: "היעד בעוד",
    NA: "לא רלוונטי",
    more: "עוד",
    eycontacts: "אנשי קשר ב- EY",
    addEYContact: "הוסף איש קשר של EY",
    editEYContacts: "ערוך את אנשי הקשר של EY",
    addEYContactInstructions: "הוסף או הסר אנשי קשר של EY עבור בקשה זו. אנשי הקשר המעודכנים של EY יישלחו למנהלי המשאבים ולמשאבים שיוקצו.",
    editEYContactDisabledInstructions: "אתה חייב לקבל את הרשאת <b>בקש שירותים</b> כדי לבצע פעולה זו. דבר עם מנהל התקשרות כדי לקבל גישה.",
    emptyEYContactsPlaceholder: "הוסף לפחות איש קשר אחד מ-EY כדי להמשיך.",
    estimatedHours: "זמן להשלים (שעות)",
    resourceManagers: "מנהלי התקשרות 'Resource managers",
    nextWaveServices: "שירותים מרכזיים (Centralized Services)",
    centralizedservices: "שירותים מרכזיים (Centralized Services)",
    onlyShowAccepetedRequests: "הצג רק בקשות שהתקבלו",
    showSelectedOnly: "הצג רק את הפריטים שנבחרו",
    emptyEngCodeMessage: "אין קודים תקפים לתיק הביקורת שלך.",
    primary: "צוות ראשי",
    estimatedCosts: "עלויות משוערות",
    assignedResources: "משאבים שהוקצו",
    generalAuditTasks: "משימות ביקורת כלליות",
    generalInfo: "מידע כללי",
    requestID: "ה- ID של הבקשה",
    createdDate: "נוצר",
    startDate: "הַתחָלָה",
    serviceRequestDue: "היעד בעוד",
    comingDueIn: "תאריך היעד מתקרב - נקבע ל",
    comingDueTodayLabel: "תאריך היעד חל היום",
    daysLabel: "‬ימים",
    dayLabel: "יום",
    createByLabel: "נוצר על ידי",
    notProvidedLabel: "לא סופק",
    editLabel: "ערוך",
    serviceRequestNoHistoryLabel: "אין היסטוריה לבקשה זו.",
    serviceRequestHistoryLabel: "יומן (LOG) היסטורי",
    serviceRequestTasks: "משימות בקשת שירות",
    suggestedRequestTasks: "משימות בקשה מוצעות",
    estimatedCost: "עלות משוערת",
    addinstructionsAndRelatedFiles: "הוסף פרוטוקולים של הפעלה ותקשור (operating and communication protocols) אחרים עבור בקשה זו",
    instructionText: "ראיות הקשורות לבקשה זו יועברו לארכיון ויכללו בבקשה זו אם תבצע רול-פורוורד לתיק הביקורת שלך לשנה הבאה. קבצים זמניים לא יועברו לארכיב ולא ייכללו בבקשה זו אם תבצע רול-פורוורד לתיק הביקורת שלך.",
    instructionPlaceHolder: "פרוטוקלים של הפעלה ותקשור (operating and communication protocols) אחרים",
    warningText: "ראיות יועברו לארכיב עם הבקשה אך קבצים זמניים לא.",
    availableDocuments: "מסמכים זמינים",
    noDocumentsAvailable: "אין מסמכים זמינים.",
    selectAll: "בחר הכל",
    deselectAll: "בטל את כל הסינונים",
    documentsSelected: "נבחרו מסמכים",
    selectedDocuments: "מסמכים נבחרים",
    noDocumentSelected: "עדיין לא נבחרו מסמכים. בחר מסמך להתחלה (אופציונלי).",
    TaskName: "שם משימה",
    AssignmentsLabel: "משימות לביצוע",
    noTaskAssociatedToServiceRequest: "אין משימות המשויכות לבקשה זו.",
    requestServices: "בקש שירותים",

    serviceNotEditable1: "כדי לשנות את המשימות הכלולות בבקשה זו, בחר ",
    serviceNotEditable2: "ערוך",
    serviceNotEditable3: "ב",
    serviceNotEditable4: "משימות",
    serviceNotEditable5: "בכרטיסיה. כדי לבצע שינויים נוספים או לבטל בקשת שירות זו, יש ",
    serviceNotEditable6: "צור קשר עם אחד ממנהלי ההתקשרות 'Resource managers",
    serviceNotEditable7: "(אם הוקצה).",

    serviceReqMarkComplete: "סימון בקשת שירות מרכזית ככזו שהושלמה תודיע לספק השירות כי אין צורך בעבודה נוספת וכי סיימת את הביקורת. לאחר שבקשת השירות מסומנת שהושלמה, לא ניתן לבטל אותה.",
    serviceReqMarkCompleted: "הושלם",
    editServiceRequestTasks1: "סקור משימות שנבחרו עבור בקשת שירות זו.",
    editServiceRequestTasks2: "כל המשימות המוצעות עבור ",
    editServiceRequestTasks3: "הצעת שירות מוצגת כאן. כדי להוסיף משימה, בחר אותה מהרשימה שלהלן. בכדי להסיר משימה, בטל את בחירתה.",

    submitServiceRequestConfirmation1: "האם אתה בטוח שברצונך להגיש בקשת שירות זו?",
    submitServiceRequestConfirmation2: "בחרת בהצעת שירות שכבר נשלחה לתיק הביקורת שלך. ",
    alreadyScheduledHeader: "הצעת השירות כבר נקבעה",

    createServiceRequestPermission1: "דרושות לך הרשאות יצירת בקשת שירות כדי להמשיך.",
    createServiceRequestPermission: "עליך להיות בעל הרשאת <b>ניהול בקשות שירות</b> כדי לבצע פעולה זו. שוחח עם מנהל Engagement כדי לקבל גישה.",
    schedulerRequestSubmissionError: "אירעה שגיאה שמנעה הגשת בקשה זו למי שתזמן אותה. בחר <b> שלח מחדש </ b> כדי לנסות שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    resubmit: "הגש מחדש",
    noServiceManager: "טרם הוקצה מנהל התקשרות (resource manager) לבקשה זו.",
    noAssignedResource: "טרם הוקצו משאבים לבקשה זו.",
    noMileStoneSetForService: "תאריכי ההתחלה ותאריכי היעד (due-dates) של אבן הדרך  (milestone)עדיין לא הוגדרו עבור בקשה זו.",
    isEngagementNominnatedForCentralizeService: "האם ההתקשרות שלך נבחרה או אושרה על ידי האזור שלך להשתתף בפיילוט GDS Centralization?",
	needApprovalForSericeRequestCreation: 'אנא צור קשר עם שותף מנהל הביקורת האיזורי שלך (Regional Assurance Managing Partner) כדי להשיג את האישור המתאים להמשיך עם בקשת השירות הנ"ל.',

    //TaskList Filters
    filterMissingRelatedTaskLabel: "מסמך שותף אחראי על הביקורת (PIC)/שותף מלווה (EQR) אינו קשור למשימה",
    filterRelatedToRisksLabel: "קשור לסיכונים",
    filterGroupTasksLabel: "משימות",
    filterGroupAssignmentsLabel: "משימות לביצוע",
    filterGroupDocumentsignoffsLabel: "חתימה על מסמכים",
    filterGroupProjectManagementLabel: "ניהול פרויקטים",
    filterAssignmentTypeLabel: "סוג הקצאה",
    filterTaskStatusLabel: "סטטוס המשימה",
    filterTaskTypeLabel: "סוג משימה",
    filterAssignedToLabel: "הוקצה ל",
    filterAssignmentStatusLabel: "סטטוס הקצאה",
    filterTaskReviewNoteStatusLabel: "סטטוס הערה",
    filterTaskCommentStatusLabel: "סטטוס הערות",
    filterTaskReviewNoteAssignedToLabel: "הוקצה ל",
    filterTaskReviewNoteAuthoredByLabel: "נוצר על ידי",
    filterPICDocumentsAssociated: "מסמכי השותף האחראי על הביקורת PIC  משויכים",
    filterEQRDocumentsAssociated: "מסמכי השותף המלווה EQR משויכים",
    missingSignOffs: "חתימות חסרות",
    signedOffBy: "חתום על ידי",
    notSignedOffBy: "לא חתום על ידי",
    filterTimePhaseLabel: "Time Phase",
    filterMilestoneLabel: "אבן דרך",
    filterAuditPhaseLabel: "שלב בביקורת",
    filterEngagementPhaseLabel: "שלב בתיק הביקורת",
    filterDocumentConflictsLabel: "קונפליקטים במסמך",
    filterEntitiesLabel: "ישות",
    missingEntityDocuments: "מסמכי ישות חסרים",
    filterDownloadedForOfflineLabel: "הורד לעבודה במצב לא מקוון",
    filterNextwaveServicesLabel: "שירותים מרכזיים (Centralized Services)",
    filterServiceGateway: "שער שירות (Service Gateway)",
    filterScheduledServicesLabel: "שירותים קשורים",
    filterSuggestedServicesLabel: "שירותים מוצעים",
    NoDocumentSignedOffLabel: "אין מסמכים חתומים על ידי",
    SomeDocumentSignedOffLabel: "כמה מסמכים חתומים על ידי",
    AllDocumentSignedOffLabel: "כל המסמכים חתומים על ידי",
    usersLabel: "חברי הצוות",
    serviceRequests: "שירותים מרכזיים (Centralized Services)",
    backToMainPage: "חזרה לדף הראשי",
    suggestedNextwaveRequests: "בקשות מרכזיות מוצעות (Suggested centralized requests)",
    /* Component Send Status */
    deliveredDate: "נמסר: {0}",
    sentDate: "נשלח: {0}",
    sentFailure: "אירעה כשל במסירה נסה שוב ואם הבעיה נמשכת פנה אל התמיכה הטכנית.",
    chooseTaskInstructionLabel: "בחר משימות שייכללו בבקשה זו.",
    createSRstep2InstructionalTextPart1: "משימות שכבר כלולות בבקשה אחרת מתויגות כ-",
    createSRstep2InstructionalTextPart2: ". אם השתמשת בהצעת שירות זו בעבר, משימות שנכללו בבקשה שלך מתקופה קודמת מסומנות כ ",
    createSRstep2InstructionalTextPart3: "השתמש במתג למטה כדי להציג רק משימות שהוצעו.",
    availableTasksLabel: "משימות זמינות",
    guidance: "הנחיית אטלס",
    helixAnalyzers: "Helix analyzers",
    eyHelix: "EY Helix",
    smartAutomationLinks: "Smart Automation",
    createAutomation: "צור אוטומציה",
    noProjectTitle: "קשר פרויקט Helix",
    multipleProjectsTitle: "בחר פרויקט Helix מקושר",
    noProjectMessage: "קשר פרוייקט Helix לתיק ביקורת זה בכדי להתחיל בשימוש ב- Helix Analyzer.",
    multipleProjectsMessage: "תיק ביקורת זה קשור למספר פרויקטים של Helix. בחר פרויקט Helix מהרשימה שלהלן כדי להמשיך.",

    automationGuidanceHeader: "אוטומציות מוצעות",
    helixAnalyzersHeader: "ניתוחים מוצעים",
    linkToHelixLabel: "קישור ל- Helix",
    noSelectedTasksText: "עדיין לא נבחרו משימות. בחר משימה כדי להתחיל.",
    selectedTasksLabel: "משימות נבחרות",
    serviceOffering: "הצעת שירות",
    submitRequest: "שלח בקשה",
    scheduleYourRequest: "תזמן את בקשתך.",
    serviceRequestStep3HeaderText: "בחר את תאריך ההתחלה שתרצה שהמשאבים שהוקצו יתחילו לעבוד על משימות אלה. לאחר מכן בחר בתאריך בו משימות אלה אמורות להסתיים.",
    serviceRequestMilestoneDueDateHeaderText1: "בחר את",
    startanddue: "תאריך התחלה ותאריך יעד",
    eachmilestone: "לכל אבן דרך (milestone)",
    serviceRequestMilestoneDueDateHeaderText2: "הצוות שלך אחראי על כל העבודות המועברות. לכן, תאריך היעד שנבחר אמור לאפשר מספיק זמן לצוות שלך לסקור את העובדה שנמסרה.",
    serviceRequestMilestoneDueDateHeaderText3: "זמן משוער להשלמה צריך לכלול רק את הזמן שאתה מצפה שידרש לספק השירות להשלים",
    schedulerBudgetMainQuestion: "האם צוות תיק הביקורת שלך:",
    schedulerBudgetFirstQuestion: "האם כללת את כל העבודה לבקשה זו בתהליכים הכספיים, התימחור והתכנון שלך?",
    schedulerBudgetSecondQuestion: "האם הודעת למנהל מנוסה על הבקשה הזו?",
    schedulerBudgetThirdQuestion: "האם התאמת את השעות לחברי הצוות באופן הולם?",
    timetocompleteinfo1: "הזמן המשוער להשלמה צריך לכלול רק את ",
    timetocompleteinfo2: "הזמן שאתה מצפה שספק השירות יצטרך.",
    serviceRequestStartDate: "להתחיל",
    saveDraft: "שמור טיוטה",
    step3ValidationError: "תאריך היעד חייב להיות לאחר תאריך ההתחלה",
    scheduledLabel: "מתוזמן",
    suggestedLabel: "מוּצָע",
    searchTasksLabel: "חפש משימות",
    submit: "שלח",
    selectTaskRequiredErrorMessage: "עליך לבחור לפחות משימה אחת כדי להמשיך.",
    moveToCompleted: "עבור לסיום",
    requestResubmitMessagePart1: "משלוח מחדש של בקשה זו יאפס את המצב ל ",
    requestResubmitMessagePart2: "בהמתנה.",
    requestResubmitMessagePart3: "כל השינויים שיבוצעו ייבחנו על-ידי מי שתזמן אותם.",
    showSuggestedTaskToggle: "הצג רק משימות מוצעות",

    // Assignments
    addAssignmentName: "הוסף שם הקצאה",
    editAssignmentName: "ערוך את שם ההקצאה",
    deleteAssignmentName: "מחק את שם ההקצאה",
    deleteAssignmentNameInstructionalTextHeader: "האם אתה בטוח שברצונך למחוק את שם ההקצאה?",
    deleteAssignmentNameInstructionalText: " הזמן שאתה מצפה שספק השירות ייגרם לו.",
    assignmentType: "סוג הקצאה",
    assignmentTypeInstructionalText: "בחר סוג הקצאה והזן שם להלן. בסיום לחץ <b>הוסף</b>.",
    assignmentEditInstructionalText: "ערוך את סוג ושם ההקצאה להלן. בסיום לחץ על <b> שמור שינויים </ b>.",
    noSuggestedTaskLabel: "אין משימות מוצעות בקטגוריה זו.",
    manageAssignmentsLabel: "ניהול הקצאות",
    myAssignmentsLabel: "ההקצאות שלי",
    myAssignedTasks: "המשימות שהוקצו לי",
    currentlyAssignedTasks: "מוקצה כרגע",
    assignmentModalInstructionalText1: "כדי להקצות מחדש או להסיר פעילויות שהוקצו לחבר צוות או לתפקיד, בחר את שמם להלן. באפשרותך גם להשתמש באייקון <b>מחק </b> כדי למחוק את כל ההקצאות עבור חבר צוות או תפקיד. כדי לערוך או למחוק שם משימה, בחר בתפריט <b>עוד</b>.",
    unassignedTasks: "משימות שלא הוקצו",
    assignedTasks: "משימות שהוקצו",
    type: "סוג",
    priorperiodservicerequests: "בקשות שירות לתקופה קודמת",
    unmarkcomplete: "בטל סימון הושלם",
    taskAttributes: "מאפייני משימה",
    engagementTeam: "צוות הביקורת",
    assignTo: "הוקצה ל",
    reAssignTo: "הוקצה מחדש ל",
    assign: "Assign",
    reAssign: "הוקצה מחדש",
    reAssignWarningLabel: "בחר משימה אחת או יותר בכדי להקצות אותה/ן מחדש",
    assignWarningLabel: "בחר משימה אחת או יותר להקצאה",
    searchByTaskName: "חפש לפי שם משימה",
    searchByTimePhaseName: "חפש לפי שם השלב בלוח הזמנים",
    assignment: "הקצאה",
    noMembersWithThisAssignment: "אין חברי צוות או בעלי תפקידים עם הקצאה זו.",
    deleteTaskAssingmentByMemberAndAssignmentIntructionalText: "המטלה תוסר מכל המשימות בתיק הביקורת שלך.",
    noTaskAttributes: "אין מאפיינים עבור משימה זו. בחר צור או קשר (Create or Relate) בכדי להתחיל בעבודה.",
	assignmentWithoutAssignedUser: 'שם ההקצאה הנ"ל אינו בשימוש כרגע.',

    // v2 profile navigation Zeus to Hercules to Kronos message
    v2ProfileDocumentIdAvailableMessage: "אוסף פרטי פרופיל אנא המתן",
    v2ProfileDocumentIdDeletedMessage: "לא נמצא מידע על פרופיל התיק. רענן את הדף ונסה שנית. אם השגיאה נמשכת פנה לתמיכה הטכנית. ",
    accountAndRelatedAssertions: "סעיף ומצגי ההנהלה המקושרים",
    risks: "סיכונים",
    scotName: "שם תת התהליך המהותי SCOT",
    strategy: "אסטרטגיית תת התהליך המהותי (SCOT)",
    transactionType: "סוג טרנזקציה",
    notSelectedText: "לא נבחר",
    relatedBy: "מקושר על ידי",
    collaboration: "שיתוף פעולה",
    controlsLabel: "בקרות",
    scotAndRelatedControls: "תת תהליך מהותי SCOT ובקרות רלוונטיות",
    scotAndRelatedRisks: "תת תהליך מהותי SCOT וסיכונים קשורים להצגה מוטעית מהותית",
    frequencyLabel: "תדירות",
    operatingEffectively: "פועל באפקטיביות",
    designedEffectively: "עוצב באפקטיביות",
    timeToCompleteHours: "זמן להשלים (שעות)",
    completeRequiredFieldValidationError: "אנא השלם את כל השדרות הנדרשים בכדי להמשיך.",
    itgcsAndItsps: "ITGCs ו- ITSPs. ",
    itprocessItgcsAndItsps: "תהליכי IT ו- ITGC/ITSPs",
    approachLabel: "גישה",
    typeLabel: "סוג",
    itProcessName: "שם תהליך ה- IT",
    processEvaluation: "הערכת התהליך",
    unrelatedControls: "בקרות לא מקושרות",
    disableNextwavePlaceholder: "שירותים מרכזיים אינם זמינים כעת עבור המדינה שלך. רענן את הדף ונסה שוב. אם השגיאה נמשכת, פנה לתמיכה הטכנית.",
    disableNextwavePlaceholderDataCenter: "שירותים מרכזיים אינם זמינים כעת עבור מרכז הנתונים המקומי שלך. אנא רענן את הדף ונסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk) .",
    dataPrivacyInviteMessage: "לפני שליחת הזימון האם שקלת כראוי את מגבלות הגישה לניירות העבודה שעשויים לחול עקב הוראות פרטיות הנתונים (data privacy)?",
    //Session Timeout
    sessionTimerMsg: "בגלל חוסר פעילות משך זמן העבודה הנוכחי שלך עומד להסתיים. למען שמירה על אבטחת המידע משך זמן העבודה ב- EY Canvas Client Portal מסתיים אוטומטית לאחר 30 דקות של חוסר פעילות. משך זמן העבודה הנוכחי שלך יפוג בעוד {0} דקות. אם ברצונך להישאר מחובר לחץ על המשך.",
    logout: "התנתק",
    sessionPopupTitle: "התנתקות אוטומטית להגנת המידע",
    allSuggestedTasks: "משימות",
    viewByAccount: "הצג לפי סעיף",
    viewBySCOT: "הצג לפי תת-תהליך מהותי SCOT",
    noServiceOfferingsAvailable: "אין הצעות שירות זמינות לתיק הביקורת שלך בשלב זה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",

    //Collaboration
    myRequests: "הבקשות שלי",
    allRequests: "כל הבקשות",
    calendar: "לוּחַ שָׁנָה",
    calendarTodayButton: "היום",
    requestsListButton: "רשימת בקשות",
    eventsButton: "אירועים",
    analyticsButton: "ניתוח",
    showAssignedToMe: "הצג את הבקשות שלי",
    selectRequestsTitle: "בחר בקשות להצגת פריטים",
    selectRequestsSub1: "כדי להפעיל את מרבית הבקרות, השתמש בתיבות הסימון או לחץ לחיצה ארוכה על",
    selectRequestsSub2: "המקשים shift או control בעת בחירת בקשות מרובות.",
    noTagMessage: "עדיין לא נוצרו תגים. לחץ <b>כאן<b> בכדי להתחיל.",
    tagAs: "תייג כ:",
    addTag: "הוסף תג",
    searchTag: "חפש תגים",
    documentsAttached: "מסמכים מצורפים",
    editDraftRequest: "ערוך את טיוטת הבקשה",
    deleteRequest: "מחק בקשה",
    deleteLabel: "מחק",
    deleteLabelDisabled: "אין לך הרשאות מספיקות למחיקה פריטים רבים. צור קשר עם מנהל תיק הביקורת שלך ובקש הרשאה למחוק כמות פריטים גדולה.",
    DeleteRequestConfirmMsg1: "האם אתה בטוח שברצונך למחוק בקשה זו?",
    DeleteRequestConfirmMsg2: "לא ניתן לבטל פעולה זו.",
    deleteRequestSuccess: "הבקשה נמחקה",
    DeleteRequestsConfirmMsg1: "האם אתה בטוח שברצונך למחוק את {0} הבקשות האלה?",
    dueDateCollabLabel: "תאריך יעד",
    requestLabel: "בַּקָשָׁה",
    statusLabel: "סטטוס",
    inValidRequestTitleLabel: "לא ניתן למחוק את הבקשות הבאות במצב הנוכחי",
    bulkSendButton: "שלח",
    bulkDeleteButton: "מחק",
    commentSyncFailedRetry: "לא ניתן היה לשלוח תגובה לפורטל הלקוחות של EY Canvas.",
    commentSyncFailedRetrySendAgain: "שלח שוב.",
    commentDeleted: "הודעה זו נמחקה.",
    CommmentDeletionSyncFailed: "לא ניתן היה למחוק את התגובה מפורטל הלקוחות של ה- EY Canvas",
    clickLabel: "לחץ",
    toRetry: "לנסות שוב.",
    replySyncFailedRetry: "לא ניתן היה לשלוח את התשובה לפורטל הלקוחות של EY Canvas.",
    quickFilterPriority: "עדיפות",
    quickFilterErrorCounterTooltip: "בבקשה אחת או יותר יש שגיאה ודורשת טיפול.",

    eyContactNoResultsFound: "המשתמש לא נמצא",
    eyContactClear: "Clear",
    eyContactSearch: "חפש",
    eyContactCollaboration: "איש קשר של EY",
    eyParticipantsCollaboration: "משתתפי EY",
    externalParticipantsCollaboration: "משתתפים חיצוניים",
    syncInProgressEYContact: "הסנכרון מתבצע",
    syncErrorEyContact: "שגיאת סנכרון. בבקשה נסה שוב.",
    noAssignedContact: "אין איש קשר מוקצה",
    noAssignedParticipant: "לא נוספו משתתפים",

    commentsTooltipLabel: "הערות",
    recordingVirusScanInProgress1: "סריקת וירוסים מתבצעת. הודעה קולית תהיה זמינה לאחר השלמתו.",
    screenrecordVirusScanInProgress1: "סריקת וירוסים מתבצעת. תיעוד המסך יהיה זמין לאחר השלמתו.",
    recordingVirusScanInProgress2: "רענן את הדף ונסה שוב.",
    confidentialDocumentsModalTitle: "מסמכים סודיים",
    confidentialDocumentsModalMsg1: "לבקשה נוספו המסמכים הסודיים הבאים.",
    confidentialDocumentsModalMsg2: "על ידי לחיצה על המשך, אתה מאשר שיש לך רמת סודיות מתאימה לשליחת המסמך לפורטל הלקוחות של - Canvas ושבדקת את הקצאת הבקשה.",
    confidentialDocumentsModalMsg3: "אין לך את רמת הסודיות המתאימה לשלוח אחד או יותר מהמסמכים האלה לפורטל הלקוחות של ה- Canvas. אנא הסר את כל המסמכים הסודיים שאין לך גישה אליהם בכדי להמשיך.",
    confidentialityLevel: "רמת סודיות",
    voiceNoteUploadError: "שגיאה בקבלת פרטי המסמך. רענן את הדף ונסה שוב. אם הבעיה נמשכת, צור קשר עם התמיכה הטכנית.",
    requestEventTitle: "אירוע",
    noTaskDescription: "אין תיאור משימה",

    newRequestLabel: "בקשה חדשה",
    newEventLabel: "אירוע חדש",

    //Analytics Tab
    analyticsCreateDateLabel: "צור תאריך:",
    createdByLabel: "נוצר על ידי:",
    expirationDateLabel: "תאריך תפוגה:",
    sharedWithLabel1: "משותף עם",
    sharedWithLabel2: "בקשות",
    sharedWithLabel3: "בקשה",
    analyticsTabTitle: "ניתוח",
    analyticsTabSubtitle: "שתף ניתוח נתונים עם לקוחות מפרויקטים מחוברים של EY Helix. כדי להתחיל, צור שאילתת לקוח מחלונית הסימניות (bookmarks pane) ב",
    analyticsTabSubtitle2: "EY Helix",
    analyticsTabSubtitle3: '.',
    noActiveAnalyticsLabel: "לא נבחרו ניתוחים",
    noActiveAnalyticsSubtitleLabel1: "לא נוצרו ניתוחים. לחץ",
    noActiveAnalyticsSubtitleLabel2: "כאן",
    noActiveAnalyticsSubtitleLabel3: " בכדי להתחיל.",
    noActiveAnalyticsSubtitleLabel4: "לאחר קישור פרויקט ושמירת סימניות ב-EY Helix, חזור לדף זה כדי להציג ניתוח תצוגה מקדימה שניתן לשתף עם פורטל הלקוחות של EY Canvas.",
    selectAnalyticsLabel: "בחר ניתוח",
    analyticsNoPrimaryHelixProjectsMessage: "התקשרות זו אינה מקושרת לפרויקט Primary EY Helix",
    selectAnalyticsModal: {
        closeTitleTip: "סגור",
        modalTitle: "בחר ניתוח",
        modalHeader: "בחר ניתוח לשיתוף עם חברי צוות חיצוניים",
        selectAnalyticPlaceholder: "בחר ניתוח",
        selectAnalyticError: "הניתוח נדרש",
        analyticNamePlaceholder: "הזן שם ניתוח (חובה)",
        analyticNameError: "נדרש שם ניתוח",
        cancel: "בטל",
        viewPreview: "הצג ניתוח",
        noPreviewAvailable: "אין תצוגה מקדימה זמינה",
        noPreviewDescription: "בחר מנתח בכדי לאפשר תצוגה מקדימה",
        clickPreviewAnalytic: "לחץ כדי להציג תצוגה מקדימה של הניתוח שנבחר",
        documentObservation: {
            label: "תיעוד כל תצפית או שאילתה לגבי האנליטיקה שנבחרה",
            placeHolderLabel: "הזן תצפית או שאילתה (אופציונלי)"
        }
    },
    viewAnalyticsModal: {
        closeTitleTip: "סגור",
        observationFieldPlaceholder: "תצפיות או שאילתות לגבי הניתוח שנבחר",
        noObservationField: "אין תצפיות או שאילתות עבור ניתוח זה.",
        appliedFiltersLabel: "החל מסננים",
        appliedFilters: [{
                id: '1',
                label: "מטבע ניתוח"
            },
            {
                id: '2',
                label: "קוד מטבע"
            },
            {
                id: '3',
                label: "עיגול תצוגה"
            },
            {
                id: '4',
                label: "קבוצת יחידות עסקיות BU"
            },
            {
                id: '5',
                label: "יחידה עסקית"
            },
            {
                id: '6',
                label: "סוג חשבון ראשי"
            },
            {
                id: '7',
                label: "תת-סוג חשבון ראשי"
            },
            {
                id: '8',
                label: "שיעור חשבון ראשי"
            },
            {
                id: '9',
                label: "תת-סוג חשבון ראשי"
            },
            {
                id: '10',
                label: "שם חשבון ראשי"
            },
            {
                id: '11',
                label: "ייעוד חשבון EY ראשי"
            },
            {
                id: '12',
                label: "חשבון EY ראשי"
            },
            {
                id: '13',
                label: "יחידה עסקית"
            },
            {
                id: '14',
                label: "תאריך Analysis"
            },
            {
                id: '15',
                label: "תאריך השוואתי"
            },
            {
                id: '16',
                label: "קבוצת מגזר 01"
            },
            {
                id: '17',
                label: "קבוצת מגזר 02 "
            },
            {
                id: '18',
                label: "קבוצת מגזר 03"
            },
            {
                id: '19',
                label: "קבוצת מגזר 04 "
            },
            {
                id: '20',
                label: "קבוצת מגזר 05"
            }
        ],
        save: "שמור",
        cancel: "בטל",
        disabledEdit: "לא ניתן לערוך תצפית מכיוון שהבקשה כבר נשלחה לפורטל הלקוחות של EY Canvas. אנא משוך את הבקשה כדי לאפשר פעולה זו.",
        errors: {
            unautorizedUser: "אינך חבר צוות מורשה של פרויקט EY Helix הקשור. פנה למנהל הפרויקט של EY Helix כדי לקבל גישה ונסה שוב.",
            bookmarkNotFound: "הניתוח שנבחר נמחק. עבור אל EY Helix כדי לנהל ניתוחים שנמחקו או כדי ליצור ניתוח חדש.",
            unautorizedAccessToBookmark: "אין לך גישה לסימניה המבוקשת של EY Helix. פנה למנהל הפרויקט של EY Helix כדי לקבל גישה ולנסות שוב.",
            authenticationError: "שגיאת אימות. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
            genericError: "רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
            defaultError: "{0} רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת."
        }
    },
    deleteAnalyticModal: {
        modalTitle: "מחק את הניתוח",
        modalHeader: "האם אתה בטוח שברצונך למחוק את הניתוח הזה? הניתוח לא יהיה זמין יותר בתוך EY Canvas."
    },
    // activity feed
    search: "חפש",
    searchTeams: "חפש צוותים",
    clear: "Clear",
    groupActivityLabel: "פעילות קבוצה",
    documents: "מסמכים",
    documentLabel: "Document",
    linkRequests: "בקשות קישור",
    received: "התקבל",
    returned: "הוחזר",
    rejected: "נדחה",
    accepted: "התקבל",
    sent: "נשלח",
    unlinked: "לא מקושר",
    finalized: "סופיים",
    groupActivityFeed: "הזנת פעילות קבוצה",
    component: "ישות מוחזקת (component)",
    noExternalApprovalsMessage: "אין אישורים חיצוניים",
    noFileSelectedMessage: "בחר מסמך להצגת פרטים",
    noInstructionSelectedMessage: "בחר פריט לצפייה בפרטים.",
    noLinkRequestSelectedMessage: "בחר פריט לצפייה בפרטים.",
    noItemSelectedMessage: "בחר פריט להצגת פרטים",
    viewGroupActivity: "הצג פעילות קבוצה",
    pointOfContact: "נקודת מגע",
    currentStatus: "מצב נוכחי",
    resolved: "התהליך הסתיים",
    viewVersion: "הצג גירסה",

    // activity feed right pane headings
    scope: "היקף",
    groupRole: "תפקיד בקבוצה",
    linkRequestStatus: "סטטוס בקשת קישור",
    instructionStatus: "סטטוס ההנחייה",
    linkStatus: "סטטוס קישור",
    today: "היום",
    yesterday: "אתמול",
    thisWeek: "השבוע",
    lastWeek: "בשבוע שעבר",
    twoWeeksAgo: "לפני שבועיים",
    threeWeeksAgo: "לפני שלושה שבועות",
    lastMonth: "חודש שעבר",
    older: "ישן יותר",
    actionsDateNote: "כל התאריכים והשעות מדווחים לפי שעון GMT.",
    noActionsMessage: "אין נתונים להצגה",
    noManageRequestPermissionMessagePart1: "דרושות לך הרשאות <b> ניהול בקשת שירות </ b> כדי לבצע פעולה זו.",
    guidedWorkflow: "הפעלת EY Canvas FIT",
    navExecution: "ביצוע הביקורת",
    navCanvasEconomics: "EY Canvas Economics",
    navOversight: "פיקוח על EY Canvas",
    navConclusion: "מסקנה",
    navTeamMemberIndependence: "אי תלות של חבר צוות",
    navGroupAudit: "בקרות ללא יישומי IT קשורים",
    navGroupActivityFeed: "הזנת פעילות קבוצה",
    navPrimaryStatus: "סטטוס ראשוני",
    navComponentStatus: "סטטוס הרכיב",
    navGroupStatus: "סטטוס ביקורת קבוצה",
    navEngagementManagement: "ניהול ההתקשרות",
    navProfile: "פרופיל",
    navGroupStructureSummary: "מבנה הקבוצה",
    OpenGuidedWorkflowDocument: "פתח את המסמך הזה באמצעות הפעלת EY Canvas FIT",
    navNotApplicable: "לא ישים",
    canvasForms: "טפסי Canvas",
    eYCanvasEconomics: "כלכלת EY Canvas (EY Canvas Economics)",
    overDueAssignments: "משימות שתאריך היעד שלהן חלף ",
    comingDueAssignments: "משימות שתאריך היעד שלהן בעוד ",
    overDueReviewNotes: "הערות סקירה שתאריך היעד שלהן חלף ",
    comingDueReviewNotes: "הערות סקירה שתאריך היעד שלהן בעוד ",

    //Group Audit/Status  for DashboardV2

    Reportingformsbystatus: "חבילות הדיווח לפי סטטוס",
    ReportingStatusSubTitle: "צפה במשימות קבוצתיות שהוקצו לצוותי המרכיבים למטה וכן סיכום של מסמכי קבוצה שהתקבלו לפי סטטוס. <br/> אתה יכול לבחור לסקור התקדמות מפורטת לפי צוות או לפי משימה קבוצתית.",

    Total: "סך הכול",
    Returned: "הוחזר",
    Overdue: "באיחור",
    PendingResponse: "ממתין למענה",
    Received: "התקבל",
    ReadyForReview: "מוכן לסקירה",
    messageNoDocument: "טרם התקבלו מסמכים.",
    byTeam: "לפי צוות",
    byGroupTask: "לפי משימת קבוצה",
    groupStructureLabel: "מבנה הקבוצה",
    instructionPending: "ההנחיות ממתינות לקבלתן",
    linkRequestPending: "בקשת קישור בהמתנה",
    notusingeycanvas: "לא משתמש ב-EY Canvas",
    pendingLabel: "ממתין",
    teams: "צוותים",
    NoDocumentReceiced: "טרם התקבלו מסמכים.",
    selectTeamToSeeData: "אין נתונים זמינים. בחר צוות כדי לראות נתונים כאן.",
    noDataAvailable: "אין נתונים זמינים.",
    prepared: "מוּכָן",
    tasksAssigned: "המשימות הוקצו",
    taskAssigned: "המשימה הוקצתה",
    instructionNotSent: "ההנחיות לא נשלחו",
    assignedTeamNotProvidedDocForTasks: "צוותי \{0}\ לא שלחו מסמכים עבור משימות אלה | \{1}\ צפויים מסמכים",
    documentRecievedOutOfAssignedTasks: "מסמכים שהתקבלו <br><b>\{0}\</b> מתוך \{1}\ משימות שהוקצו",
    documentRecievedOutOfAssignedTeams: "מסמכים שהתקבלו <br><b>\{0}\</b> מתוך \{1}\ צוותים שהוקצו",

    groupStatusSubTitle: "הצג למטה משימות קבוצתיות שהוקצו על ידי הצוות הראשי וכן סיכום של מסמכי הקבוצה לפי סטטוס. <br/> אתה יכול לבחור לסנן את המשימות הקבוצתיות לפי משימה או סטטוס מסמך.",
    notSent: "לא נשלח",
    draftsent: "הטיוטה נשלחה",
    finalsent: "הגרסה הסופית נשלחה",
    noTaskForComponent: "אין נתונים זמינים. <p> משימות קבוצתיות שנשלחו מהצוות הראשי יוצגו כאן לאחר שהן יתקבלו.</p>",
    noTaskForComponentWithStatus: "אין נתונים זמינים. <p> בחר אפשרות סטטוס אחת או יותר כדי לראות נתונים כאן.</p>",

    //Dashboard V2 - activity feed
    activityFeedSubHeadingText: "בחר סוג פעילות כדי לסקור את פעילות המעורבות הרלוונטית ב-10 הימים האחרונים. <br/> לחץ על סמל <b>פעילות</b> של פריט ספציפי כדי להציג את כל הפעילות עבור אותו פריט. <br/> אתה יכול גם להשתמש במתג כדי לחדד את התצוגה שלך.",
    activityFeedSubHeadingGroupAudit: "בחר סוג פעילות כדי לסקור את פעילות המעורבות הרלוונטית ב-10 הימים האחרונים. <br/> לחץ על סמל <b>פעילות</b> של פריט ספציפי כדי להציג את כל הפעילות עבור אותו פריט. <br/> אתה יכול גם להשתמש במתג כדי לחדד את התצוגה שלך.",
    teamHistoryInstructionalText: "סקור את הפעילות של הצוות הזה ב-10 הימים האחרונים.",
    teamHistory: "היסטוריית הקבוצה",
    onlySeeMyActivity: "ראה רק את הפעילות שלי",

    taskAddedBy: "משימה נוספה על ידי",
    taskMarkedCompleteBy: "משימה שסומנה הושלמה על ידי",
    taskUnmarkedCompleteBy: "משימה שלא סומנה הושלמה על ידי",
    taskHandedOffBy: "המשימה הועברה על ידי",
    assignmentAddedBy: "המשימה הוספה על ידי",
    assignmentEditedBy: "המשימה נערכה על ידי",
    assignmentClosedBy: "המשימה נסגרה על ידי",
    assignmentReOpenedBy: "המשימה נפתחה מחדש על ידי",
    assignmentDeletedBy: "המשימה נמחקה על ידי",
    noteAddedBy: "הערה נוספה על ידי",
    noteClearedBy: "הערה נוקתה (cleared) על ידי",
    noteClosedBy: "הערה נסגרה על ידי",
    noteReopenedBy: "הערה נפתחה מחדש על ידי",

    linkRequestSent: "בקשת קישור נשלחה על ידי",
    instructionSentBy: "הנחיות נשלחו על ידי",
    linkRequestAcceptedBy: "בקשת קישור התקבלה על ידי",
    engagementUnlinkedBy: "בוטל הקישור של סביבת העבודה על ידי",
    instructionAcceptedBy: "הנחיות התקבלו על ידי",
    instructionReturnedBy: "ההנחיות הוחזרו על ידי",
    labelTo: "אל",
    instructionReceivedFrom: "הנחיות שהתקבלו מ",
    filtersLabel: "מסננים",
    advanceOptions: "פעולות בכמות גדולה",
    advanceOptionsLabel: "פעולות בכמות גדולה",
    relatedScots: "תתי תהליכים מהותיים (SCOT) קשורים",
    noRelatedScots: "אין תתי תהליכים מהותיים (SCOTs) קשורים",
    materialityLabel: "מהותיות",
    currentPeriod: "תאריך נוכחי",
    previousPeriod: "תאריך קודם",
    showCurrentPeriod: "הצג את התאריך הנוכחי",
    showPriorPeriod: "הצג תאריך קודם",
    planningMateriality: "סף המהותיות PM",
    tolerableError: "הטעות הנסבלת TE",
    sadNominalAmount: "סכום נומינלי של SAD",
    pmLabel: "PM",
    teLabel: "TE",
    sadLabel: "SAD",
    accountBalance: "יתרת סעיף",
    mapAccountBalances: "מפה את יתרות החשבון",
    connectToHelixProject: "התחבר לפרויקט Helix",
    connectToImportBalances: "  לייבא יתרות",
    helixMultiple: "Multiple",
    selectMESTentity: "בחר ישות כדי להציג פרטים",
    relatedWCGWAndControls: "סיכונים (WCGW) ובקרות קשורים",
    relateAtLeastOneWCGW: "לכל מצג הנהלה עם סיכון בקרה של Rely (CR=Rely), חייב להיות מקושר לפחות WCGW אחד.",
    notRelyRelateWCGW: 'Assertions with a control risk of Not Rely do not have a requirement to identify a WCGW.',
    relatedITProcesses: "תהליכי IT קשורים",
    noRelatedITProcesses: "אין תהליכי IT קשורים",
    relatedITRiskITGCs: "סיכוני IT קשורים, ITGCs ו-ITSPs",
    relatedITRisks: "סיכוני IT הקשורים",
    ALRAHigherRiskCode: "H",
    materialityMestSelectEntity: "בחר ישות כדי להציג פרטים",
    OARCurrentPeriod: "תאריך Analysis",
    OARComparative1Period: "תאריך השוואה 1",
    xTELabel: "xTE",
    priorPeriodDesignation: "ייעוד תקופה קודמת:",
    priorPeriodEstimate: "אומדן תקופה קודמת:",
    notApplicableAbbreviation: "לא רלוונטי",
    accountDetails: "פרטי חשבון",
    launchGuidedWorkflow: "הפעל תהליך עבודה מודרך (guided workflow)",
    guidedWorkflowTitle: 'Guided workflow',
    viewAccountBalace: "הצג את יתרות החשבון",
    viewAccountBalaceForEntity: "בחר ישות כדי להציג את יתרות החשבון",
    mainActivities: "פעילויות עיקריות",
    oversightProjectTile: {
        typeOversight: "השמטה",
        createProject: "צור פרוייקט",
        oversightProjectengagementNotConnectedMessage1: "יישום EY Canvas Oversight מסכם אבן דרך (milestone), ניהול פרויקטים (project management) והתקדמות ביקורת הקבוצה בתיקי ביקורת מקושרים. השתמש בו כדי להבטיח שביקורת הקבוצה שלך או תיק הביקורת שלך במעקב.",
        oversightProjectengagementNotConnectedMessage2: "תיק הביקורת שלך לא מקושר לשום פרויקט EY Canvas Oversight.",
        click: "לחץ",
        togetstarted: " בכדי להתחיל",
        clickProjectmessage: "לחץ על <b> + צור פרויקט </b> בכדי להתחיל.",
        lblclient: "לקוחות:",
        lblEngagementCount: "תיקי ביקורת:",
        lblTaskscompleted: "משימות שהושלמו:",
        lblMore: "עוד",
        myProject: "הפרוייקטים שלי",
        OtherProject: "פרויקטים אחרים",
        oversightNoProjectConnectedMessage: "אינך חבר באף אחד מפרויקטים של EY Canvas Oversight שאליו מקושר תיק הביקורת שלך.",
        oversightOtherProjectNotConnectedMessage: "אתה חבר בכל הפרויקטים של EY Canvas Oversight שאליו מקושר תיק הביקורת שלך.",
        draft: "טיוטה",
        allTask: "כל המשימות",
        totalTask: "סך הכל משימות"
    },

    economicsProjectTile: {
        typeEconomics: "כלכלה (economics)",
        economicsProjectengagementNotConnectedMessage1: "אפליקציית EY Canvas Economics מסכמת את ההתקדמות הכספית ואת ההתקדמות ב-EY Canvas. השתמש בה בכדי לנהל את ההיבט הכספי בתיקי הביקורת שלך.",
        economicsProjectengagementNotConnectedMessage2: "תיק הביקורת שלך אינו מקושר לפרויקטים של EY Canvas Economics.",
        clickProjectmessage: "לחץ על <b> + צור פרויקט </b> בכדי להתחיל.",
        economicsNoProjectConnectedMessage: "אינך חבר באף אחד מהפרויקטים של EY Canvas Economics שתיק הביקורת שלך מקושר אליהם.",
        lblForecasted: "צפוי:",
        lblActual: "בפועל:",
        lblETC: "ETC:",
        lblVariance: "שונות"
    },
    leftNavigation: {

        engagementOverview: "סקירת התקשרות ",
        myProgress: "ההתקדמות שלי",
        executiveTasks: "אזורי מיקוד",
        integration: "אינטגרציה",
        groupAudit: "סטטוס ביקורת קבוצה",
        pinnedDocuments: "מסמכים מוצמדים (Pinned documents)",
        Validations: "תיקוף",
        activityFeed: "הזן פעילות",
        primaryStatus: "סטטוס ראשוני",
        componentStatus: "סטטוס הרכיב",
        picProgress: "התקדמות השותף האחראי על הביקורת PIC",
        picEQRProgress: "התקדמות השותף האחראי על הביקורת PIC / השותף המלווה EQR",
        drillDown: "ירידה לפרטים",
        maps: "מפות",
        financialStatement: "דוחות כספיים"
    },
    nowRowOverlayClientRequest: {
        createNew: "לחץ על הוסף בקשה בכדי ליצור בקשה חדשה",
        all: "לא נוצרו בקשות",
        draft: "אין בקשות בסטטוס טיוטה",
        pending: "אין בקשות במצב ממתין לתגובה",
        received: "לא התקבלו בקשות",
        accepted: "לא אושרו בקשות",
        customFilter: "לא נמצאו התאמות. אנא נסה שנית."
    },

    clientRequestPrefixes: {
        draft: "טיוטה",
        returned: "הוחזר",
        recalled: "אוחזר",
        withdrawn: "ביטול"
    },

    clientRequestsTabHeader: {
        all: "הכול",
        draft: "טיוטה",
        pending: "ממתין",
        received: "התקבל",
        accepted: "אושר"
    },

    clientRequestsPriorityFilters: {
        all: "הכול",
        normal: "נוֹרמָלִי",
        high: "High",
        critical: "Critical",
        highAndCritical: "High + Critical"
    },

    requestTableHeader: {
        requestId: "חתימה(ות) שאינן של צוות הביקורת",
        title: "כותרת",
        receivedDate: "עליך להיות בעל הרשאת <b> ניהול תיק הביקורת</b> בכדי לבצע פעולה זו. שוחח עם <b> מנהל תיק הביקורת </b> בכדי לבקש הרשאה.",
        dueDate: "תאריך יעד",
        sentDate: "תאריך שליחה",
        acceptedDate: "תאריך קבלה",
        assignedTo: "הוקצה ל",
        group: "קבוצה",
        status: "סטטוס",
        priorityType: "עדיפות",
        tags: "תגים"
    },

    dropdownColumnsFilter: {
        1: "הוקצה ל",
        2: "קבוצה",
        3: "תאריך יעד",
        4: "תאריך שליחה",
        5: "עליך להיות בעל הרשאת <b> ניהול תיק הביקורת</b> בכדי לבצע פעולה זו. שוחח עם <b> מנהל תיק הביקורת </b> בכדי לבקש הרשאה.",
        6: "תאריך קבלה",
        7: "סטטוס",
        8: "עדיפות",
        9: "תגים"
    },

    requestTableDropdownFilter: {
        customizeTable: "התאם אישית את הטבלה",
        selectInfo: "בחר עד 4 אפשרויות",
        selectInfoTooltip: "בחר עד ארבע עמודות. בטל את הבחירה באפשרות אחת או יותר כדי להמשיך."
    },

    ClientStatus: {
        1: "טיוטה",
        2: "טיוטה - אין איש קשר",
        3: "נשלח",
        4: "שגיאת מערכת",
        5: "איש קשר לא חוקי ללקוח",
        6: "ממתין למענה",
        7: "התקבל",
        8: "התקבל",
        9: "הוחזר",
        10: "נדחה",
        11: "השליחה מתבצעת",
        12: "קבלה בתהליך",
        13: "דחייה בתהליך",
        14: "מחיקה בתהליך",
        15: "החזרה בתהליך",
        16: "מתן מענה בתהליך",
        17: "נמחק",
        18: "איש קשר לא חוקי ללקוח",
        19: "הוחזר במעבר",
        20: "אוחזר",
        21: "השלמה בתהליך",
        22: "איחזור בתהליך"
    },

    analyticStatus: {
        1: "טיוטה",
        2: "ממתין לאישור",
        3: "אושר",
        4: "לא בתוקף"
    },

    paginationControl: {
        firstPage: "הדף הראשון",
        lastPage: "הדף האחרון",
        previousPage: "הדף הקודם",
        nextPage: "הדף הבא",
		show: "הצג"
    },

    auditPlanFilterLabels: {
        showMore: "עוד",
        filterTypeOfScots: "תת התהליך המהותי (SCOT)",
        noScotsAvailable: "אין SCOTs זמינים",
        filterTypeOfITProcess: "תהליך IT",
        noITProcessAvailable: "אין תהליכי IT זמינים"
    },

    controlListBuildStep4FilterLabels: {
        scots: {
            filterTypeOfScots: "SCOTs",
            noScotsAvailable: "אין SCOTs זמינים"
        },
        testing: {
            filterTypeOfTesting: "בדיקה",
            noTestingAvailable: "אין בדיקה זמינה"
        },
        designEffectiveness: {
            filterTypeOfDesignEffectiveness: "אפקטיביות תכנון הבקרה",
            noDesignEffectivenessAvailable: "המידע על אפקטיביות תכנון הבקרה לא זמין"
        },
    },

    clientRequestsFilterLabels: {
        filterAssignedTo: "הוקצה ל",
        filterAttachmentsLabel: "סוג קובץ מצורף",
        filterCreatedByLabel: "נוצר על ידי",
        filterStatusLabel: "סטטוס",
        filterDueAfterLabel: "אחרי התאריך",
        filterDueBeforeLabel: "עד לתאריך",
		filterErrorsLabel: "שגיאות",
        filterOverdueLabel: "תאריך היעד חלף",
        filterTagLabel: "תָג",
        filterTimePhaseLabel: "Time Phase",
        filterTypeLabel: "סוג",
        filterPriorityLabel: "עדיפות",
        searchMembers: "חפש חברי צוות",
        noTags: "לא נוצרו תגים",
        noTimephase: "אין time phase",
        clearAll: "נקה הכל",
        clearHoverText: "Clear",
        noResultsFound: "לא נמצאו תוצאות",
        yes: "כן",
        no: "לא",
        showMore: "הצג עוד",
        // Check this
        filterNoMatchesFound: "לא נמצאו התאמות. אנא נסה שנית.",
        filter: "סנן",
        title: "מסננים",
        noRelatedTask: "אין משימה קשורה"
    },
    //Dashboard - integration

    collaborationInstruction: "הצג את בקשות שיתוף הפעולה שלך לפי סטטוס למטה. <br/> לחץ על ספירה כדי לנווט לרשימת הבקשות עם מסננים שהוחלו.",
    noValidationsAvailable: "אין אימותים (validations) לשלב הביקורת (audit phase) הזה.",
    individualView: "תצוגה אישית",
    engagementView: "תצוגת תיק הביקורת",
    centralizedServiceInstruction: "הצג את אחוז המשימות הממנפות שירותים מרכזיים וכן בקשות לפי סטטוס למטה. <section >כדי ליצור בקשה חדשה בחר <b>בקש שירותים.</b></section>",
    // Dashboard - todo list
    todoList: "רשימת מטלות",
    todoListInProgress: "נוכחי",
    todoListOpen: "בקרוב",
    todoListClosed: "הושלם",
    todoListInstruction: "צפה בהקצאות ובהערות סקירה לקראת תאריך היעד לפי סטטוס. <br /> בחר מסגרת זמן או קטגוריה בכדי לחדד את התצוגה שלך. <br /> כדי לפתוח פריט, לחץ על שם המשימה או על שם הערת הסקירה.",
    noOpenAssignments: "אין לך משימות פתוחות.",
    noInProgressAssignments: "אין לך משימות בתהליך.",
    noClosedAssignments: "אין לך משימות סגורות.",
    allLabel: "הכול",
    dueLabel: "היעד בעוד",
    noAssignments: "לא הוקצו לך משימות.",
    executiveReview: "סקירת מנהלים",
    epTasksStatusSignOffWithoutDetails: "ראה סיכום של סטטוס שותף אחראי על הביקורת (PIC) למטה.",
    epTasksStatusSignOff: "ראה סיכום של סטטוס שותף אחראי על הביקורת (PIC) למטה. לתצוגה  מפורטת, בחר <b>הצג פרטים</b>.",
    epeqrTasksStatusSignOffWithoutDetails: "ראה למטה סיכום של מצב שותף אחראי על הביקורת (PIC) ו-שותף מלווה (EQR).",
    epeqrTasksStatusSignOff: "ראה להלן סיכום של סטטוס השותף האחראי על הביקורת PIC  והשותף המלווה EQR. לתצוגה מפורטת, בחר <b>הצג פרטים</b>.",
    eqrDefaultMessage: "התקשרות זו אינה דורשת מעורבות שותף מלווה (EQR).",
    selectPartners: "בחר שותף",
    noPartnersInEng: "אין שותפים בתיק הביקורת שלך.",
    epTasks: "משימות השותף האחראי על הביקורת PIC",
    eqrTasks: "משימות EQR",
    viewDetails: "הצג פרטים",
    picReview: "סקירת השותף האחראי על הביקורת PIC ",
    eqrReview: "סקירת השותף המלווה EQR",
    eqrtasksWithSignOff: "משימות עם חתימות EQR <br /> לא הושלמו",
    eqrdocumentsWithSignOff: "מסמכים עם חתימות EQR <br /> לא הושלמו",
    pictasksWithSignOff: "משימות עם חתימות PIC <br /> לא הושלמו",
    picdocumentsWithSignOff: "מסמכים עם חתימות PIC <br /> לא הושלמו",
    partnerSignoffs: "חתימות (sign-offs) שותף",
    epTaskswithpartnersignoffs: "לחץ על ספירה כדי לנווט לרשימת המשימות עם מסננים שהוחלו.",
    allDocssignedoff: "כל המסמכים <br/>נחתמו",
    someDocssignedoff: "חלק מהמסמכים <br/>נחתמו",
    noDocssignedoff: "אין מסמכים <br/>נחתמו",
    partnernotinvited: "שותף לא הוזמן",
    noEQRsinyourengagement: "אין שותפים מלווים (EQRs) בתיק הביקורת שלך.",
    selectEQRs: "בחר שותף מלווה (EQR)",
    eqrNotinvited: "שותף מלווה (EQR) לא הוזמן",
    eqrsignoffs: "חתימות (sign-offs) שותף מלווה (EQR)",
    eqrtaskswithpartnersignoffs: "לחץ על ספירה כדי לנווט לרשימת המשימות עם מסננים שהוחלו.",
    allpartners: "כל השותפים",
    allEQRs: "כל השותפים המלווים (EQRs)",
    reviewComments: "סקירת הערות",
    noOpenReviewComments: "אין לך הערות סקירה פתוחות.",
    noClearedReviewComments: "אין לך הערות סקירה שנוקו (cleared).",
    noClosedReviewComments: "אין לך הערות סקירה סגורות.",
    noReviewCommentsForSelectedTime: "אין לך הערות סקירה עבור מסגרת הזמן שנבחרה. בחר מסגרת זמן אחרת כדי להמשיך.",
    picTasksSomeDocSignOff: "משימות עם כמה מסמכים חתומים על ידי השותף האחראי על הביקורת (PIC)",
    picTasksNoDocSignOff: "משימות ללא מסמכים חתומים על ידי השותף האחראי על הביקורת (PIC)",
    eqrTasksSomeDocSignOff: "משימות עם כמה מסמכים חתומים על ידי השותף המלווה (EQR)",
    eqrTasksNoDocSignOff: "משימות ללא מסמכים חתומים על ידי השותף המלווה (EQR)",
    picNotIdentified: "לא זוהה שותף אחראי על הביקורת (PIC)",
    eqrNotIndentified: "לא זוהה שותף מלווה (EQR)",
    todoReviewNote: "הערת סקירה",

    // Dashboard - Executive Tasks
    executiveTasks: "אזורי מיקוד",
    executiveTasksInstruction: "בחר כדי להציג משימות לפי סיכון או לפי חשבון למטה. <br/> לאחר שבחרת, העבר את העכבר מעל ספירה כדי לראות פרטים נוספים או בחר משימה כדי לנווט לדף הפרטים הספציפיים שלה.",
    byRisk: "לפי סיכון",
    byAccount: "לפי סעיף",
    responsiveTasks: "משימות קשורות",
    openNotes: "הערות (notes) פתוחות",
    lowLabel: "Low",
    mediumLabel: "Medium",
    highLabel: "High",
    criticalLabel: "Critical",
    epRequired: "השותף האחראי על הביקורת (PIC) נדרש",
    eqrRequired: "נדרש על ידי השותף המלווה (EQR)",
    noDocumentsSignedOff: "אין מסמכים שנחתמו",
    someDocumentsSignedOff: "חלק מהמסמכים נחתמו",
    allDocumentsSignedOff: "כל המסמכים חתומים",
    completedAssignments: "משימות שהושלמו",
    designation: "ייעוד",
    significantAccount: "סעיף מהותי",
    epSignOff: "חתימת השותף האחראי על הביקורת PIC",
    eqrSignOff: "חתימת EQR",
    someLabel: "Some",
    riskNoDataLabel: "סיכון זה לא היה קשור למשימות.",
    accountNoDataLabel: "חשבון זה וההצהרות שלו לא היו קשורים למשימות כלשהן.",
    NoDataLabel: "אין נתונים זמינים עבור האקורדיון שנבחר",
    // Manage tags
    manageTagsInstructionalText: "`צור כאן תגים חדשים. תוכל גם לערוך ולמחוק תגים קיימים. בקשות תיוג יכולות לשפר את הארגון ואת הניהול של תיק הביקורת שלך. '",
    noTagsAdded: "לא נוספו תגים. צור תג כדי להתחיל.",

    // Client Request Comments
    noCommentsCreatedYet: "עדיין לא נוצרו הערות.",
    addCommentTitleTip: "הוסף הערה",
    addReplyTitleTip: "הוסף תגובה",
    addAComment: "השאר תגובה...",
    addAReply: "הוסף תשובה",
    deleteCommentConfirmationModalTitle: "מחק הערה",
    deleteCommentConfirmationModalMessage: "האם אתה בטוח שברצונך למחוק את המענה הזה? גם כל התשובות לתגובה זו יימחקו.",

    // Client Request Voice Note Comment Labels
    voiceNoteCommentRecordLabel: "הודעה קולית",
    voiceNoteCommentStopLabel: "הפסק",
    voiceNoteCommentPlayLabel: "להפעיל",
    voiceNoteCommentDeleteLabel: "מחק",

    //Client Request Status/Tooltip messages
    SendRequestSuccess: "הבקשה נשלחה בהצלחה",
    BulkSendRequestSuccess: "{0} בקשות נשלחו בהצלחה",
    BulkSendOneRequestSuccess: "בקשה אחת נשלחה בהצלחה",
    SendInProgress: "השליחה מתבצעת",
    AcceptInProgress: "קבלה בתהליך",
    CompleteInProgress: "הושלם בתהליך ",
    HasErrorState: "לא ניתן היה לשלוח את הבקשה. בבקשה נסה שוב.",
    WithdrawRequestSuccess: "הבקשה בוטלה",
    WithdrawInProgress: "דחייה בתהליך",
    WithdrawRequestError: "לא ניתן היה לבטל את הבקשה, אנא נסה שוב.",
    DeleteRequestError: "לא ניתן היה למחוק את הבקשה. רענן את הדף ונסה שוב.",
    AcceptRequestError: "לא ניתן לאשר את הבקשה, אנא נסה שוב.",
    CompleteRequestError: "לא ניתן היה להשלים את הבקשה, אנא נסה שוב.",
    InvalidClientContact: "איש קשר לא חוקי של לקוח.",
    BulkSendInvalid: "לא ניתן לשלוח בקשה אחת או יותר שנבחרו מבלי לנקוט בפעולה נוספת. אנא בדוק ונסה שוב.",
    returnInProgress: "החזרה בתהליך",
    returnRequestError: "לא ניתן היה להחזיר את הבקשה אנא נסה שוב",

    //Client Withdraw Request
    WithdrawRequest: "בטל בקשה",
    WithdrawReuestConfirmMsg: "האם אתה בטוח שברצונך לבטל בקשה זו? לאחר הביטול, הלקוח לא יוכל עוד לצפות בה. הבקשה תעבור לרשימת הטיוטה לאחר השלמתה",
    WithdrawMenuOption: "לדחות",
    MoreOptions: "אפשרויות נוספות",
    Complete: "המשימות למענה  בביקורת הושלמו",
    WithdrawLabel: "נדחה",
    CompleteInstructionalText: "השתמש הושלם כאשר המידע כבר סופק על ידי הלקוח",

    //Client Complete Request
    CompleteRequestConfirmMsg: "השלמת בקשה מסירה את הבקשה מרשימת המטלות של הלקוח ומעדכנת את הסטטוס ל'נשלח עבור הלקוח'. הבקשה תועבר לרשימת 'התקבלו' ב-EY Canvas. ניתן להשתמש בבקשה זו, למשל, כאשר המידע המבוקש כבר התקבל באמצעים חלופיים.",
    CompleteRequest: "השלם את הבקשה",
    CompleteRequestSuccess: "הבקשה הושלמה",

    //Client Accept Return Request
    AcceptLabel: "קבל",
    ReturnLabel: "החזר",
    ReturnRequest: "בקשה להחזרה",
    acceptRequest: "קבל בקשה",
    acceptRequestWithoutTask: "האם אתה בטוח שברצונך לאשר את הבקשה שנבחרה?",
    acceptRequestWithTask: "<b>האם אתה בטוח שברצונך לקבל את הבקשה שנבחרה?</b> המסמכים המצורפים יהיו זמינים בלשונית המסמכים החיצוניים של {0} המשימות הקשורות.",
    acceptRequestSuccess: "הבקשה התקבלה",
    returnedRequestSuccess: "הבקשה הוחזרה -",

    // Client Request Relate Files modal
    noRecordsFound: "לא נמצאו רשומות",
    relateSelected: "קישור נבחר",
    relateFilesModalHeader: "כדי לקשר מסמכים קיימים לבקשה זו, בחר במסמכים ולחץ על קישור שנבחר.",
    relateAnalyticModalHeader: "כדי לקשר את הניתוח הקיים לבקשה זו, סמן את התיבה עבור הניתוח שנבחר. לתצוגה מקדימה של ניתוח זמין אחר, לחץ",
    relateAnalyticHereModalHeader: "כאן",
    noAnalyticsRecordsFound: "אין ניתוח זמין לשיתוף. לחץ",
    noAnalyticsRecordsFoundGetStarted: "בכדי להתחיל.",
    associateExistingDocumentsSelected: "נוספו מסמכים",
    associateExistingDocumentSelected: "נוסף מסמך",

    // Client Request Details Header
    timePhaseLabel: "שלב הזמן (Time phase):",
    receivedDateLabel: "התקבל:",
    dueDateLabel: "תאריך היעד:",
    sentDateLabel: "נשלח:",
    acceptedDateLabel: "התקבל:",
    clientRequestSyncLabel: "עדכונים נשלחים ל- EY Canvas Client Portal",
    editDescriptionLabel: "ערוך תיאור",
    createdDateLabel: "נוצר:",

    //Client Advance Search
    advancedSearch: "חיפוש מתקדם",
    advancedSearchRefereceNumberCheck: "הפניה #",
    advancedSearchTitleCheck: "כותרת",
    advancedSearchDocumentsCheck: "מסמכים",
    advancedSearchCommentsCheck: "הערות",
    advancedSearchApplyButton: "להגיש מועמדות",
    searchRequest: "חפש",
    clearSearch: "נקה חיפוש",

    //Adjustment Topup module
    adjustmentModule: {
        currencyType: "סוג המטבע",
        currencyCode: "קוד מטבע",
        businessUnit: "יחידה עסקית",
        all: "הכול",
        moduleName: "מודול התאמה",
        financialStatement: "דוחות כספיים",
        viewByTrialBalanceType: "הצג לפי סוג מאזן בוחן",
        multiEntry: "ריבוי ישויות",
        balanceSheet: "מאזן",
        incomeStatement: "דוח רווח והפסד",
        currentperiodUnadjusted: "Analysis date ",
        unadjusted: "(לא מותאם)",
        currentperiodAdjusted: "Analysis date ",
        adjusted: "(מוּתאָם)",
        adjustment: "התאמה",
        newAdjustment: "עדכון חדש ",
        noRecordsFound: "לא נמצאו רשומות",
        periodEnded: " התאריך הסתיים",
        periodsEnded: " התאריכים הסתיימו",
        noResultsFound: "לא נמצאו תוצאות",
        notApplicableAbbreviation: "לא רלוונטי",
        noAdjustmentCreated: "לא נוצרה התאמה.",
        createAdjustment: "צור {0}.",
        next: "הדף הבא",
        previous: "הדף הקודם",
        reclassification: "Reclassification - בשל סיווג מחדש",
        manageAdjustment: "ניהול התאמות",
        lastPage: "הדף האחרון",
        firstPage: "הדף הראשון",
        filterYes: "כן",
        filterNo: "לא",
        showOnlyAdjustedAccountClasses: "הצג רק סוגי חשבון שהותאמו",
        noneAvailable: "אף אחד לא זמין",
        noImportedTrialbalanceAvailable: "אין מאזן בוחן (TB) מיובא.",
        trialBalanceRequired: "מאזן בוחן",
        comparativeperiodUnadjusted: "תאריך השוואתי",
        comparativeperiodAdjusted: "תאריך השוואתי",
        multityEntityRequired: "ריבוי ישויות",
        placeHolderMessageWhenHelixMappingIsTrue: "אין מאזן בוחן (TB) מיובא. לחץ על {0} כדי לקשר כלי ניתוח (analyzer) חדש.",
        placeHolderMessageWhenHelixMappingIsFalse: "אינטגרציה עם EY Helix אינה זמינה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
        eyHelixIntegrationLinkText: "חיבורי EY Helix",
        noEntitiesAvailablePlaceholder: "לא נוצרו ישויות. צור ישויות כדי להתחיל.",
        search: "חפש",
        viewAdjustmentWithValidations: "הצג התאמות באמצעות אימותים ({0})",
    },

    misstatementLabels: {
        name: "שם",
        notes: "הערות",
        signOffs: "Sign-offs",
        open: "פתח",
        openReadOnly: "פתוח לקריאה בלבד",
        delete: "מחק",
        rename: "שנה שם",
        signOffRequirements: "דרישות חתימה",
        confidentiality: "סודיות",
        unlink: "בטל קישור",
        removeFromAdjustment: "הסר מההתאמה"
    },

    allControls: "כל הבקרות",
    //Client Request Document labels
    clientRequestDocuments: {
        externalDocuments: "חיצוני",
        taskDocuments: "מסמכים",
        deletedDocuments: "נמחק",
        priorPeriodDocuments: "שנה קודמת",
        priorPeriodInfoMessage: "לא ניתן להוריד מסמכים אלו",
        uploadedBy: "הועלה על ידי",
        deletedBy: "נמחק על ידי",
        lastModifiedBy: "שונה לאחרונה על ידי",
        eyBadge: "נמחק ממסמכים",
        externalBadge: "נמחק מהחיצוניים (External)",
        uploadInProgress: "ההעלאה מתבצעת",
        refreshdocuments: "רענן מסמכים",
        disabledDocument: "פעולות בכמות גדולה אינן מותרות עבור סוג זה של מסמך.",
        menuOptions: {
            delete: "מחק",
            open: "פתח",
            openr: "פתוח לקריאה בלבד",
            restore: "שוחזר",
            remove: "הסר",
            rename: "שנה שם",
            editInHelix: "ערוך ב-EY Helix"
        },
        externalPriorPeriod: "לקוח",
        eyPriorPeriod: "EY",
        uploadedByEY: "EY"
    },

    //Client Request Assigned To Errors
    clientRequestAssignedToErrorLabel: "המשתמש או הקבוצה שהוקצו אינם חוקיים. עדכן את ההקצאה בכדי להמשיך. לחץ",
    clientRequestAssignedToErrorLabelEnd: "בכדי לערוך חברי צוות חיצוניים.",
    clickHereLabel: "כאן",
    clientRequestAssignedToIconErrorLabel: "לקבוצה שהוקצתה אין חברים פעילים. הקצה את הבקשה למשתמש/קבוצה פעילים או הוסף חברים לקבוצה בכדי להמשיך.",
    clientRequestDueDateErrorLabel: "נדרש תאריך יעד. עדכן את תאריך היעד כדי להמשיך.",

    clientRequestDocumentsNoDocsFound: [{
            id: 'externalDocuments',
            label: "לא נוספו מסמכים חיצוניים"
        },
        {
            id: 'taskDocuments',
            label: "גרור ושחרר מסמך אחד או יותר או לחץ על הוסף מסמך"
        },
        {
            id: 'deletedDocuments',
            label: "אף מסמך לא נמחק"
        },
        {
            id: 'searchRequestDocuments',
            label: "לא נמצאו התאמות, אנא נסה שוב"
        },
        {
            id: 'priorPeriodDocuments',
            label: "אין מסמכים זמינים לשנה קודמת"
        }
    ],

    liveNotifications: {
        "ey.at.hercules.annotation.created": "נוצר ביאור",
        "ey.at.hercules.annotation.edited": "הביאור נערך",
        "ey.at.hercules.annotation.replied": "הערה השיבה",
        "ey.at.hercules.contentupdate.updated": "התוכן עודכן",
        "ey.at.hercules.contentupdate.failed": "עדכון התוכן נכשל"
    },

    //Assign to
    usersOption: "משתמשים",
    externalUsersOption: "משתמשים חיצוניים",
    groupsOption: "קבוצות",
    lblassignedto: "הוקצה ל",
    searchGroup: "קבוצת חיפוש",
    requiredAssignedTo: "נדרשת הקצאה",
    rdSubmitRequest: "שלח בקשה",

    closeDrawer: "סגור ובטל את כל הסינונים",
    requestSelected: "בקשה שנבחרה",
    requestsSelected: "בקשות שנבחרו",
    //GA Scopes labels
    engagementScopesAndCustomSubScopes: "היקפי הביקורת ותתי היקפים (sub-scopes) מותאמים אישית",
    defineGroupScopes: "הגדר היקף ביקורת קבוצה",
    gaScopeIntro: "היקפי תיק הביקורת לכל EY GAM כלולים כאן כברירת מחדל. אם אתה צריך להתאים אישית משימות והנחיות קבוצתיות עבור צוותים שחולקים את אותו היקף, שקול ליצור תת-היקף. כאשר תשלחו הנחיות, תוכל לשלוח גרסאות שונות לכל תת-היקף.",
    addSubScope: "הוסף תת-היקף (sub-scope)",
    customSubScope: "תת-היקף (sub-scope) מותאם אישית",
    noCustomSubscopes1: "אין תתי-היקפים (sub-scopes) מותאמים אישית עבור ההיקף שהוקצה לתיק ביקורת זה.",
    noCustomSubscopes2: "בחר <b>הוסף תת-היקף  <b> בכדי להתחיל.",
    subScopeName: "שם תת-היקף (Sub-scope)",
    addDescription: "הוסף תיאור",
    textExceedsLength500: "טקסט לא יכול לעלות על 500 תווים.",
    manageGroupPermission: "עליך להיות בעל הרשאת <b>ניהול קבוצה</b> בכדי לבצע פעולה זו. צור קשר עם מנהל ההתקשרות בכדי לבקש הרשאה.",
    deleteCustomSubScope: "מחק תת-היקף מותאם אישית",
    areYouSureDeleteCustomSubScope: "האם אתה בטוח שברצונך למחוק תת-היקף מותאם אישית (custom sub-scope) זה?",

    //GA Component labels
    newTeam: "קבוצה חדשה",
    teamName: "שם קבוצה",
    legalEntityName: "שם הישות המשפטי",
    parentTeam: "צוות ביקורת ראשי",
    isReferenceOnly: "לצרכי סימוכין בלבד",
    isNotUsingCanvas: "הצוות לא משתמש ב-EY Canvas",

    referenceOnlyTooltip: "צוותים המוגדרים כ<b>לצרכי סימוכין בלבד</b> לא יקבלו בקשות קישור, הנחיות או משימות. הם משמשים למטרות ארגוניות בלבד.",

    canvasFormNotOwnedByEng: "לא ניתן לשלוח טופסי קנבס משותפים שאינם בבעלות ההתקשרות הזו לפורטל הלקוחות של EY Canvas. צור עותק של הטופס בתיק הביקורת אם אתה צריך לשלוח אותו, או שלח אותו מההתקשרות המקור.",
    canvasFormNotAllowedInCtry: "שיתוף טפסי קנבס עם לקוחות אינו זמין במדינה שלך.",
    on: "על",
    sendRequest: "שלח בקשה",
    selectUserOrGroup: "בחר משתמש או קבוצה",
    canvasFormShowAttachments: "הצג {0} קבצים מצורפים",
    canvasFormShowOneAttachment: "הצג קובץ מצורף אחד",
    canvasFormHideAttachments: "הסתר {0} קבצים מצורפים",
    canvasFormHideOneAttachment: "הסתר קובץ מצורף אחד",

    //GA Components
    createGroupStructure: "יצירת מבנה קבוצה",
    componentText: 'Create regions and components for each engagement team that will send deliverables through EY Canvas. You have the option to designate teams as <b>Not using EY Canvas</b> if they will not send deliverables through EY Canvas. You can also create teams for organizational purposes and designate them as <b>Reference only</b>. These teams will not receive link requests, instructions or tasks. When you are done, select <b>Send link requests</b>.',
    addTeam: "הוסף צוות",
    sendLinkRequests: "שלח בקשות קישור",
    noComponents: "עדיין לא נוצרו צוותים. בחר <b> הוסף צוות <b> בכדי להתחיל.",
    editTeam: "ערוך צוות",
    deleteTeam: "מחק את הצוות",
    deleteInstructional: "האם אתה בטוח שברצונך למחוק את הצוות הזה? <br/><br/> הקישור לצוות זה יבוטל וההתקשרויות שלך לא יוכלו עוד להחליף תיעוד. בנוסף, כל ההנחיות והמשימות המותאמות אישית שהוקצו לצוות זה יימחקו.",
    linkRequestHasBeenSent: "אינך יכול לערוך את היקף הביקורת או את הייעוד עבור צוות הביקורת הזה, מכיוון שכבר נשלחה בקשת קישור או שההקצאה כבר הוגדרה.",
    selectScopes: "בחר היקפ(י) ביקורת",
    searchScopes: "חיפוש היקפי ביקורת",
    selectTeams: "בחר צוות(ים) ביקורת",
    sendLinkRequestsDescription: "בחר את ההיקפים או הצוותים אליהם תרצה לקשר את תיק הביקורת שלך.<br> בקשת קישור תישלח לאיש הקשר של כל צוות. לאחר שאיש הקשר יקבל את בקשת הקישור, הם יקבלו הנחיות ומשימות קבוצתיות דרך EY Canvas.",
    sendVersionsDescription: "בחר את הסקופינג או הצוותים אליהם תרצה לשלוח את הגרסה העדכנית ביותר של הנחיות ומשימות קבוצתיות.<br>יש לקשר צוות לתיק הביקורת שלך בכדי לקבל הנחיות ומשימות קבוצתיות. לאחר שהצוות יקבל את הגרסה העדכנית ביותר, היא תהיה זמינה בתיק הביקורת שלהם.",
    notSentYet: "עדיין לא נשלחה גרסה",
    notLinkedYet: "בקשת הקישור לא נשלחה",
    cardView: "תצוגת כרטיס",
    noItemsPlaceholder: "עדיין לא פורסמה גרסה. פרסם כאן גרסה של הנחיות ומשימות קבוצתיות כדי לראות נתונים.",

    //GA Instructions
    customizeGroupInstructions: "התאם אישית את הנחיות הקבוצה",
    gaInstructionsIntro: 'Group instructions per EY GAM are included by default and are informational by nature. They are meant to inform region and component teams of key information, work scope and procedures performed centrally. Customize the instructions from EY GAM, add additional instructions if needed and designate whether each instruction should be assigned to a scope or a team. Once you are done, publish your instructions so they become available to send to the assigned scopes or teams.',
    addInstruction: "הוסף הנחיה",
    instruction: "הנחיה",
    groupTaskSelected: "ערוך הוראה מותאמת אישית",
    assignScopes: "הקצה להיקפי הביקורת",
    assignTeams: "הקצה לצוותי ביקורת",
    maxLengthMessage: "הטקסט לא יכול לעלות על <b>500<b> תווים.",
    addScope: "הוסף היקף ביקורת",
    editInstruction: "ערוך הוראת ידע",
    editKnowledgeInstruction: "ערוך הוראת ידע",
    editKnowledgeTask: "עריכת משימת ידע",
    editCustomTask: "ערוך משימה מותאמת אישית",
    saveChangesInstruction: "שמור שינויים",
    updatedOnInstruction: "עודכן לאחרונה:",
    knowledgeDescriptionInstruction: "תיאור הידע",
    editDisabledTitle: "עליך להיות בעל הרשאת <b>ניהול קבוצה</b> בכדי לבצע פעולה זו. צור קשר עם מנהל ההתקשרות בכדי לבקש הרשאה.",
    deleteCustomInstruction: "מחק הנחיות",
    deleteGroupTask: "מחק משימה קבוצתית",
    areYouSureDeleteCustomInstruction: "האם אתה בטוח שברצונך למחוק הוראה מותאמת אישית זו?",
    areYouSureDeleteCustomTask: "האם אתה בטוח שברצונך למחוק משימה מותאמת אישית זו?",
    publishAfterDelete: "אם תמחק הוראה זו, עליך לפרסם את השינויים שלך ולשלוח מחדש את קבוצת ההוראות החדשה שפורסמה לטווחים או לצוותים שהוקצו.",
    publishAfterDeleteGroupTask: "אם תמחק את המשימה הקבוצתית הזו, עליך לפרסם את השינויים שלך ולשלוח מחדש את קבוצת המשימות שפורסמה לאחרונה להיקפים או לצוותים שהוקצו.",
    resendPublishInformation: "תוכל לפרסם את השינויים שלך בשלב זה. אתה יכול לשלוח מחדש את ערכת ההוראות שפורסמה לאחרונה מהתקציר.",
    resendPublishInformationGroupTask: "תוכל לפרסם את השינויים שלך בשלב זה. אתה יכול לשלוח מחדש את קבוצת המשימות שפורסמה לאחרונה מהסיכום.",
    compareVersionsNoVersionSelectedTitle: "לא נבחרה גרסה להשוואה!",
    compareVersionsNoVersionSelectedSubtitle: "אנא בחר את הגרסה מהתפריט הנפתח כדי להשוות לגרסה העדכנית ביותר",

    //Add Section
    addSection: "הוסף סעיף",
    addSectionInstructionalText: "הוסף מקטע בכדי לארגן את ההנחיות המותאמות אישית שלך.",
    addSectionPlaceholder: "שם המקטע",

    //Edit Section
    editSection: "ערוך את שם המקטע",
    editSectionInstructionalText: "בצע שינויים בשם של המקטע המותאם אישית. <br> כשתסיים, פרסם את השינויים שלך, בכדי לשלוח גרסה מעודכנת לאתרים שנבחרו לבצע ביקורת או לצוותים מסוימים.",
    editSectionSave: "שמור שינויים",

    //Delete Section
    deleteCustomSection: "מחק מקטע",
    areYouSureDeleteCustomSection: "האם אתה בטוח שברצונך למחוק את המקטע הזה?<br>כל ההנחיות במקטע הזה יימחקו. כשתסיים, פרסם את השינויים שלך כדי לשלוח גרסה מעודכנת להיקפים או לצוותים שנבחרו.",
    customSection: "מקטע",

    //Publish Changes
    publishChanges: "פרסם שינויים",
    publishChangesInstructional: "האם אתה בטוח שברצונך לפרסם שינויים בסט הנוכחי של הוראות ומשימות? <br><br>מערכת ההוראות והמשימות הקודמת יוחלפו. לאחר שתפרסם את השינויים שלך תוכל לשלוח את סט ההוראות והמשימות המעודכן מהסיכום.",
    publishChangesNotAvailable: "עדיין לא זמין",

    //GA Tasks
    costomizeGroupTasks: "התאמה אישית של משימות קבוצתיות (group tasks)",
    gaTasksIntro: 'Group tasks per EY GAM are included by default and sent to linked engagements. Customize the tasks from EY GAM, add additional tasks if needed and designate whether each task should be assigned to a scope or a team. Once you are done, publish your tasks so they become available to send to the assigned scopes or teams.',
    addCustomTask: "הוסף משימה מותאמת אישית",
    groupTask: "משימות ברמת הקבוצה",
    gaTasks: "משימות",
    attachments: "קבצים מצורפים",
    notAvailable: "לא זמין",
    gaDocument: "Document",
    gaDocuments: "מסמכים",
    gaScope: "היקף",
    gaScopes: "היקפים (scopes)",
    gaScopesCapitalized: "היקפים (scopes)",
    gaTeam: "צוות",
    gaTeams: "צוותים",
    gaUnassignedScopeTeam: "Unassigned",
    hideDetails: "הסתר פרטים",
    gaAssignedScopes: "היקפים שהוקצו (Assigned scopes)",
    gaAssignedTeams: "צוותים שהוקצו",
    addTask: "משימה חדשה",
    due: "היעד בעוד",
    noAttachments: "לא נוספו קבצים מצורפים.",

    // Chip component
    chipMore: "עוד",

    // GS Group Summary labels
    assignedTeam: "צוות שהוקצה",
    lastPublished: "פורסם לאחרונה",
    versionStatus: "מצב גרסה",
    lastSent: "נשלח לאחרונה",
    lastSentTooltip: "זהו התאריך שבו נשלחה לאחרונה גרסה של הוראות ומשימות לכל צוות. לחץ על התאריך לצפייה בגרסה שנשלחה לצוות.",
    lastSentBeforeTooltip: "יש גרסה חדשה של הוראות ומשימות זמינה עבור <b><<Scope name>><b>. שקול אם עליך לשלוח את הגרסה העדכנית ביותר לצוות זה.",
    groupSummary: "סיכום קבוצה",
    summarySubTitle: 'Review the most recent version of the instructions and tasks assigned to each scope and team below. To send this version to the assigned scopes and teams, select <b>Send version</b>.<br/>You may also view the version sent to a specific team by selecting the relevant sent date.',
    compareVersions: "השווה גרסאות",
    sendVersion: "שלח גרסה",
    compareVersionsInstructional: "השווה את הגרסה העדכנית ביותר של הוראות ומשימות שפורסמו לגרסה שנשלחה לצוות על מנת לזהות הבדלים. אם יש הבדלים בין הגרסאות, הערך אם יש לשלוח גרסה חדשה לצוות.",
    publishedVersion: "גרסה שפורסמה",
    sentVersion: "גרסה שנשלחה",
    emptyPublishedVersion: "אין היקפים זמינים. <br/>היקפים המוקצים לקבוצות המרכיבים מפורטים כאן.",
    emptySentVersion: "אין צוותים זמינים.",
    selectPublishedVersion: "בחר גרסה שפורסמה כדי לראות נתונים כאן.",
    selectSentVersion: "בחר גרסה שנשלחה כדי לראות נתונים כאן.",
    dueDate: "תאריך יעד",
    emptyPublishedSnapshot: "אין גרסה זמינה של הנחיות ומשימות עבור היקף הביקורת שנבחר. <br/>פרסם גרסה בכדי לראות את הנתונים כאן.",
    emptySentSnapshot: "ההנחיות והמשימות לא נשלחו לצוות הנבחר. <br/>פרסם ושלח הנחיות ומשימות לצוות בכדי שיוכל לראות את הנתונים כאן.",
    update: "עידכון",
    updates: "עדכונים",
    noTeamsPlaceholder: "אין מציין מיקום (Placeholder) של צוותים",
    noTeamSelected: "בחר לפחות היקף (scope) אחד או צוות אחד בכדי להמשיך.",
    latestVersionAlreadySent: "עדיין לא נוצרו צוותים. צור צוות אחד או יותר כדי לפרסם גרסה של הנחיות ומשימות.",
    latestHasBeenSended: "הגרסה האחרונה של הנחיות ומשימות כבר נשלחה לצוות זה",
    noNewVersionToSend: "היקפי הביקורת או הצוותים שנבחרו כבר קיבלו את הגרסה העדכנית ביותר של הנחיות ומשימות. אין עדכונים זמינים לשליחה.",
    notSelectedTask: "לא נבחר",
    assignedTeams: "צוותים שהוקצו",
    noTeamsCreatedYet: "עדיין לא נוצרו צוותים. צור צוות אחד או יותר כדי לפרסם גרסה של הנחיות ומשימות.",
    newersTeamsSended: "הגרסה העדכנית ביותר של הנחיות ומשימות נשלחה לאתרים שנבחרו לבצע ביקורת או לצוותים מסוימים.",
    LinkRequestNotSent: "בקשת הקישור לא נשלחה",
    lastVersionSentInstructionalText: "גרסת המשימות וההנחיות שנשלחו אל <b>{teamName}</b> ב-<b>{sentDate}</b> מוצגת למטה. זו הגרסה האחרונה שנשלחה לצוות זה.",

    // ReceiveInstructions labels
    receiveInstructionsTitle: "גרסה של {versionType} של הנחיות ומשימות קבוצתיות",
    receiveInstructionsInstructional: "{primaryEng} שלח גרסה של {versionType} של הנחיות ומשימות קבוצתיות בתאריך {sentDate}. עיין בגרסה זו ובחר אם לקבל אותה או להחזיר אותה. אתה יכול להשתמש באפשרות <b>השווה גרסאות</b> כדי להשוות גרסה זו לגרסאות קודמות.",
    fromLabel: "מ",
    assignedScope: "ההיקף שהוקצה (assigned scope)",
    dateSent: "תאריך שליחה",
    acceptVersion: "קבל את הגרסה",
    returnVersion: "החזר גרסה",
    returnPrimaryButton: "החזר",
    returnVersionDescription: "האם אתה בטוח שברצונך להחזיר גרסה זו של הנחיות ומשימות לצוות הביקורת של חברת האם? <br>גרסה זו לא תיובא לתיק הביקורת שלך. השאר הערה לצוות הביקורת של חברת האם (primary team) שמסביר את הרציונל שלך.",
    noContent: "אין הנחיות זמינות כרגע, אנא נסה שוב מאוחר יותר או פנה לתמיכה הטכנית",
    editorPlaceHolder: "הערה",
    receiveCompareVersionInstructional: "השווה את הגרסה שנבחרה של הנחיות ומשימות שהתקבלו מ-{primaryEng} לגרסה קודמת שהתקבלה, בכדי לזהות הבדלים.",
    latestReceiveCompareVersionInstructional: "השווה את הגרסה העדכנית ביותר של ההנחיות והמשימות שהתקבלו מ-{primaryEng} לגרסה הקודמת שהתקבלה בכדי לזהות הבדלים.",
    latestVersion: "הגרסה העדכנית ביותר",
    earlierVersion: "גרסה מוקדמת יותר",
    earlierVersionEmpty: "אין גרסאות קודמות זמינות להשוואה.",
    selectEarlierVersion: "בחר גרסה קודמת כדי לראות נתונים כאן.",
    pstName: "עיין בהנחיות תיק הביקורת של הקבוצה",
    pstDescription: "סקור את חבילת הדיווח בביקורת הקבוצה. השלם את משימות הביקורת של הקבוצה בשלב 'ביקורת מבססת- כללי' (Execution - General). משימות אלה יתווספו לרשימת המשימות בעת קבלת חבילת הדיווח בביקורת הקבוצה.",
    selectedVersion: "גרסה שנבחרה",
    issuingEngagement: "הנפקת תיק הביקורת",
    accountsAndDisclosureLink: "חשבון וגילוי",
    openRiskAssessmentDocuments: "פתח מסמכי הערכת סיכונים",
    openRiskAssessmentDocument: "פתיחת מסמך הערכת סיכונים",

    //Client engagement name labels
    successQueueMessage: "שם התצוגה של הלקוח עודכן בהצלחה בפורטל הלקוחות של ה- EY Canvas.",
    clientEngagementInstructionalText: "הוסף או ערוך שם תצוגה מותאם אישית של תיק הביקורת כאן. שם זה יהיה גלוי לחברי צוות חיצוניים שניגשים לתיק ביקורת זה בפורטל הלקוחות של ה- EY Canvas.",
    clientEngagementPlaceholder: "שם תיק הביקורת שמוצג",
    clientEngagementModalTitle: "שם תצוגה של תיק הביקורת בפורטל הלקוחות של ה- EY Canvas",
    clientDisplayName: "שם התצוגה של הלקוח",
    textExceedsLength: "טקסט לא יכול לעלות על 100 תווים.",

    // Manage client access locations
    location: "Location",
    locationName: "שם מיקום",
    accessLocations: "גישה למיקומים",
    inputType: "סוג קלט",
    ipAddress: "כתובת ה - IP",
    ipAddresses: "כתובות IP",
    startOfIpRange: "תחילת טווח IP",
    endOfIpRange: "סוף טווח IP",
    cidrNotation: "סמן CIDR",
    manageClientAccessLocationsLink: "הוסף מיקום",
    manageClientAccessLocationsModalTitle: "נהל מיקומי גישה (client access locations) ללקוח",
	manageClientAccessLocationsInstructionalText: "הוסף כתובות IP לרשימה למטה כדי לאפשר גישה מבוססת מיקום לפורטל הלקוחות של EY Canvas. <br> אם קיימת גישה מבוססת מיקום לקוח,    אז רק לחברי צוות חיצוניים עם כתובות ה - IP המפורטות כאן תהיה גישה להתקשרות זו.אם לא יתווספו כתובות IP, חברי צוות חיצוניים יוכלו לגשת להתקשרות זו מכל מיקום. <br> לחץ <b> כאן <b> למידע נוסף.",
    manageClientAccessLocationsNoResultFound: "לא נוספו כתובות IP עבור התקשרות זו. חברי צוות פנימיים וחיצוניים יכולים לגשת להתקשרות זו מכל מקום.",
    deleteAccessLocations: "מחק מיקומ(י) גישה",
    deleteAccessLocationsInstructionalText: "האם אתה בטוח שברצונך למחוק את מיקום הגישה שנבחר? <b>אם חבר צוות חיצוני ינסה לגשת לפורטל הלקוחות של EY Canvas ממיקום זה, הוא לא יוכל עוד לגשת להתקשרות זו.",
    locationLengthError: "המיקום לא יעלה על 100 תווים.",
    oneOrMoreIpAddressFormatError: "אחת או יותר מכתובות ה-IP שסופקו אינן חוקיות.",
    ipAddressFormatError: "כתובת ה-IP שסופקה אינה חוקית.",
    ipSuffixError: "סיומת CIDR עבור כתובת ה-IP חייבת להיות בעל סיומת עשרונית ≥ 1 ו≤ 32.",
    ipRangeStartSmallerThanEnd: "IP התחלה צריך להיות קטן מ-IP סוף.",
    ipInputTypeInfo: "בחר כתובת IP בכדי להזין כתובת IP בודדת או רשימה של כתובות IP. רק כתובות IPv4 נתמכות. <br>בחר טווח IP כדי להזין טווח של כתובות IP שחולקות את אותה קידומת רשת (כלומר את שלושת המקטעים הראשונים של הכתובת). <br>בחר חסימת CIDR בכדי להזין טווח של כתובות IP עם סימון CIDR. רק כתובות CIDR נתמכות",
    ipAddressInfo: "ניתן להזין כתובות IP בנפרד, ברשימה מופרדת בפסיקים, או ברשימה עם כל כתובת בשורה חדשה. <br>כתובות IPv4 חוקיות מכילות ארבעה מספרים שלמים הנעים בין 0 ל-255, מופרדים על ידי נקודות",
    ipCidrInfo: "הזן את סימון ה-CIDR המייצג טווח של כתובות IP שאמורות לאפשר גישה להתקשרות זו. <br>סימון CIDR חוקי מכיל כתובת IPv4 חוקית, קו לוכסן / תו וסיומת עשרונית ≥ 1 ו≤ 32.",
    ipAddressEg: "לְמָשָׁל 192.XXX.X.1 192.XXX.X.2",
    ipRangeStartEg: "לְמָשָׁל 192.XXX.X.1",
    ipRangeEndEg: "לְמָשָׁל 192.XXX.X.2",
    ipCidrEg: "לְמָשָׁל 192.XXX.X.1/22",
    searchIpPlaceholder: "בדוק כתובת IP",
    ipNotAddedMessage: "לא התווסף לרשימה המותרת.",
    ipIsAllowedMessage: "כתובת IP מותרת.",
    importAccessLocationsLink: "ייבוא ​​מיקומי גישה",
    importAccessLocationsInstructionalText: "ניתן לייבא מיקומי גישה מסביבת העבודה הקודמת שלך. <br>האם אתה בטוח שברצונך לייבא מיקומי גישה?",
    importAccessLocationsCloseButton: "Close",
    importAccessLocationsCancelButton: "בטל",

    // Export Requests
    exportRequests: "בקשות ייצוא",

    // Add custom request labels
    addCustomRequestModal: {
        titleTip: "בקשה חדשה",
        titleTipAddButton: "הוסף חדש",
        closeTitleTip: "סגור",
        modalTitle: "בקשה חדשה",
        returnModalTitle: "בקשה להחזרה",
        modalHeader: "הוסף בקשה חדשה לשליחה לפורטל הלקוחות של EY Canvas",
        requiredAssignedTo: "(נדרש)",
        assignToError: "נדרשת הקצאה",
        dueDate: "תאריך יעד (חובה)",
        dueDateError: "נדרש תאריך יעד",
        titlePlaceholder: "כותרת (חובה)",
        titleError: "נדרשת כותרת",
        description: "תיאור",
        descriptionplaceholder: "הזן תיאור",
        descriptionError: "תיאור הבקשה חורג מהאורך המירבי (4,000 תווים)",
        associateDocuments: "מסמכים משוייכים",
        emptyAssociatedDocumentsList: "גרור ושחרר מסמך אחד או יותר או לחץ על הוסף מסמך",
        addDocumentButton: "הוסף מסמך",
        signOffCheckbox: "מסמכים שהועלו בפורטל הלקוחות של EY Canvas ידרשו חתימה",
        sendRequest: "שלח בקשה",
        returnRequest: "בקשה להחזרה",
        saveAsDraft: "שמור כטיוטה",
        cancel: "בטל",
        copyTitleAndDescription: "העתק כותרת ותיאור מהמשימה",
        copyAssociatedDocuments: "העתק מסמכים מהמשימה",
        priority: "בקש עדיפות",
        addNewRequestButton: "הוסף בקשה חדשה",
        addExistingRequestButton: "הוסף בקשות קיימות",
    },
    addCustomEventModal: {
        titleTip: "אירוע חדש",
        closeTitleTip: "סגור",
        modalTitle: "אירוע חדש",
        eventDate: "תאריך אירוע",
        eventDateError: "נדרש תאריך",
        titlePlaceholder: "כותרת",
        titleError: "נדרשת כותרת",
        description: "תיאור (אופציונאלי)",
        descriptionplaceholder: "הזן תיאור",
        descriptionError: "תיאור האירוע חורג מהאורך המרבי (4,000 תווים)",
        sendEvent: "שלח אירוע",
        saveAsDraft: "שמור את האירוע כטיוטה",
        cancel: "בטל",
        eyParticipantsCollaborationError: "נדרש לפחות משתתף EY אחד",
        externalParticipantsCollaborationError: "נדרש לפחות משתתף חיצוני אחד"
    },
    eyHelixInstructionText: "סקור פרויקטים מקושרים של EY Helix ומנתחים מוצעים למטה. <br/> לחץ על כל אחד מהפרויקטים או הנתחים כדי לנווט לדף ה-EY Helix הספציפי שלו.",
    smartAutomationInstrText: "סקור את פתרונות האוטומציה החכמה שבהם אתה משתמש כעת למטה. <br/> לחץ על פתרון כדי לנווט אל מרכז האוטומציה החכמה.",
    smartAutomationSolutionsNotAvailable: "פתרונות אוטומציה חכמים אינם זמינים עבור סביבת העבודה שלך בשלב זה.",
    noSmartAutomationAvailable: "אין פתרונות אוטומציה חכמים זמינים להתקשרות שלך.",
    availableSolutions: "פתרונות זמינים",
    useOfSuggestedSolutions: "שימוש בפתרונות מוצעים",
    useOfOtherSolutions: "שימוש בפתרונות אחרים",
    suggestedSolutions: "פתרונות מוצעים",
    otherSolutions: "פתרונות אחרים",
    currentlyusing: "כרגע בשימוש",
    suggested: "מוּצָע",
    primaryProject: "פרויקט ראשי (Primary Project)",
    noLinkedProjects: "אין פרויקטים מקושרים בהתקשרות שלך.",
    noSuggestedAnalyzers: "אין ניתוחים מוצעים (suggested analyzers) להתקשרות שלך.",
    eyHelixNotAvailable: "EY Helix אינו זמין",
    helixNotAvailableMessage: "EY Helix אינו זמין להתקשרות שלך בשלב זה.",

    noGroupTaskCreatedYet: "עדיין לא נוצרו משימות קבוצתיות.",
    noInstructionsCreatedYet: "עדיין לא נוצרו הנחיות.",
    documentsReceived: "מסמכים שהתקבלו",
    documentsPending: "מסמכים בהמתנה",

    teamLabel: "צוות",
    scopeLabel: "היקף",

    documentSignOffby: "המסמך נחתם על ידי",
    documentAddedBy: "המסמך נוסף על ידי",
    documentModifiedBy: "המסמך שונה על ידי",
    documentDeletedBy: "המסמך נמחק על ידי",
    commentAddedBy: "הערה נוספה על ידי",
    commentClearedBy: "הערה נוקתה (cleared) על ידי",
    commentClosedBy: "הערה נסגרה על ידי",
    commentReopenedBy: "הערה נפתחה מחדש על ידי",

    documentAssignedTo: "מסמך שהוקצה ל",
    draftDocReceivedFrom: "טיוטת מסמך התקבלה מ",
    finalDocReceivedFrom: "מסמך סופי שהתקבל מ",
    documentReturnedBy: "המסמך הוחזר על ידי",
    returnedDocumentClearedBy: "מסמך שהוחזר נוקה על ידי",
    documentConflictResolvedBy: "קונפליקט במסמך נפתר על ידי",
    draftDocumentSentBy: "טיוטת מסמך נשלחה על ידי",
    documentReturnedFrom: "המסמך הוחזר מ",
    finalDocumentSentBy: "מסמך סופי נשלח על ידי",
    noActivityAvailable: "אין פעילות זמינה.",
    allEngagementFilterLabel: "כל שאר ההתקשרויות",
    otherEngagementComments: "הערות אחרות בהתקשרות",
    engagements: "תיקי הביקורת",
    engagement: "תיק ביקורת",
    view: "הצג",
    notesModalInstructionalText: "הצג והשב להערות עבור {0} הנבחרים למטה.",

    //New collaboration Related Labels
    searchRelateFileNoMatchesFound: "לא נמצאו תוצאות תואמות. בבקשה נסה שוב.",

    //New collaboration Related tasks
    relatedTasksLabel: "משימות קשורות",
    selectRelatedTasks: "בחר משימה",
    searchAndPressEnter: "חפש והקש enter",
    noRelatedTasksSelected: "לא נבחרו משימות קשורות",
    relatedTasksCount: "משימות קשורות",
    notFoundTasks: "המשימה לא נמצאה",
    dueDateDetailLabel: "תאריך יעד",
    requestType2MessageTitle: "בקשה זו תיפתח בכרטיסייה חדשה",
    requestType2MessageSubtitle: "רענן את העמוד כדי לראות עדכונים שנעשו.",
    requestType2InTrnasitMessageTitle: "לא ניתן לפתוח בקשה זו מכיוון שהיא במעבר.",
    requestType2InTrnasitMessageSubtitle: "המתן עד להשלמת הסנכרון ורענן את הדף ונסה שוב.",

    //New collaboration Time Phase
    selectTimePhase: "בחר שלב זמן",
    timePhaseNotFound: "שלב הזמן לא נמצא",

    understandITProcess: "הבנת תהליכי IT",

    //New collaboration Access Location
    accessLocationLabel: "הגישה למיקום מופעלת",
    accessLocationTitle: "רק למשתמשים המתחברים ממיקום רשת מורשה תהיה גישה לפורטל הלקוחות של EY Canvas עבור תיק ביקורת זה. ניתן לנהל מיקומים מותרים מתוך מיקומי גישה בתפריט האפשרויות.",

    // Reporting Labels
    summaryScreenLabel: "מסך סיכום",
    dataExportLabel: "ייצוא נתונים",
    projectManagementLabel: "ניהול פרויקטים",
    reportingHeaderName: "דוחות",
    repAllTasks: "כל המשימות",
    repDeletedTasks: "משימות שנמחקו",
    repMultiEntityTasks: "משימות מרובות ישויות",
    repAllAuditPlan: "תוכנית ביקורת",
    repITAppSOSummary: "סיכום יישומי IT/SO",
    repITProcessScotControls: "תהליכי IT, תת תהליך מהותי (SCOT) ובקרות",
    repTaskAssignments: "הקצאת משימות",
    repTaskDetails: "פרטי המשימה",
    repTaskAnalysis: "ניתוח משימות",
    repTaskSummary: "סיכום משימה (פיילוט)",
    repExportToExcel: "ייצוא נתונים",
    repExportDate: "תאריך ייצוא",
    repEngInfo: "מידע על תיק הביקורת",
    repNoRecordMessage: "אין רשומות להצגה",
    dateInUTC: "ב-UTC",
    repSCOTsControls: "תתי תהליכים מהותיים (SCOT) ובקרות",
    repITProcessSummary: "סיכום תהליכי IT",
    repCanvasForms: "טפסי Canvas",
    repControlForms: "Control Forms",
    projectInsight: "Project Insight",
    archiveForm: "טופס ארכיב",
    archive: "העבר לארכיב",
    repCanvasFormResponse: "תגובות בטופס ה- Canvas",
    repCanvasFormRelatedComments: "הערות קשורות",
    repControlFormResponse: "טפסי בקרת מענה",
    repNoRecordFound: "לא נמצאו רשומות",
    repCanvasFormsIncomplete: "מענה שלא שולם",
    repCanvasFormRelatedObjects: "אובייקטים קשורים",
    voiceNoteLabel: "הודעה קולית",
    repComponentTeamGroup: "צוות הביקורת של ישות מדווחת",
    componentTeamCanvasFormExport: "ייצוא טפסי Canvas",

    // Reporting Tasks
    repTaskTitle: "כותרת המשימה",
    repTaskDescription: "תיאור המשימה",
    repTaskSource: "מקור המשימה",
    repTaskNature: "אופי המשימה",
    repTaskCloseEarly: "מוקדם",
    repTaskCloseLate: "מאוחר",

    // Reporting Documents
    repAllDocuments: "כל הקבצים",
    repSignOffs: "חתימה",
    repDocumentsModified: "מסמכים שונו לאחר RRD",

    //Reporting Collaboration
    repRequestsAndTasks: "בקשות ומשימות",
    repRequestsTasksComments: "הערות בקשות/משימות",

    SCOTSummaryReportHeader: "סיכום תתי התהליכים המהותיים (SCOTs)",
    GroupReportHeader: "דוח קבוצה",
    SCOTSummaryEffective: "יעיל",
    GroupInstructionSummary: "סיכום הנחיות הקבוצה",
    GroupActivity: "היסטוריית מיפוי חשבון לישות מוחזקת",
    SEMReportHeader: "SEM",
    GroupComponentAccountReportHeader: "מיפוי חשבונות לישות מוחזקת בקבוצה",
    AccountDisclosuresReportHeader: "סעיפים וגילויים",

    //Reporting Collaboation Details
    collaborationDetails: "Collaboration Details",
    collaborationSummary: "סיכום",
    collaborationActivity: "פרטי פעילות",
    ReviewNotesReportHeader: "סקירת הערות",

    GroupStructureSummary: "סיכום מבנה הקבוצה",

    //Reporting CRT Summary
    wcgwSummary: "סיכום WCGW",
    crtlabel: "כלי סקירת בקרות (CRT)",
    assertionSummary: "סיכום מצג הנהלה",
    scotSummary: "סיכום תתי התהליכים המהותיים (SCOTs)",
    noRecordsToExport: "אין רשומות לייצוא",
    statisticsSummary: "סטָטִיסטִיקָה",
    qualityChecks: "בדיקות איכות",
    controlSummary: "סיכום בקרה",
    filterBySCOT: "סנן לפי SCOT",

    //Reporting manage team
    independenceSummaryReportTabName: "סיכום אי התלות",

    //MEST dashboard
    viewAllRiskTypesAndAssertions: "הצג את כל סוגי הסיכונים ומצגי ההנהלה (assertions)",
    riskRelatedToAssertion: "סיכון הקשור למצג הנהלה (assertion)",
    higherRiskRelatedToAssertion: "סיכון גבוה יותר הקשור למצג הנהלה (assertion)",
    noRisksAvailable: "אין סיכונים זמינים",
    relatedEstimates: "אומדנים קשורים",
    viewAllAssertions: "ראה את כל מצגי ההנהלה (assertions)",
    wcgwRelatedToAssertion: "WCGW קשור למצגי הנהלה (assertion)",
    noWcgwsAvailable: "אין WCGWs זמינים",
    goTo: "לך ל",
    allItems: "כל הפריטים",

    // Create TimePhase Labels
    createTimePhaseLabels: {
        modalTitle: "הוסף שלב זמן (time phase)",
        modalDescription: "הוסף את המאפיינים ולחץ על שמור וסגור או שמור והוסף.",
        timephaseNameLabel: "שם שלב הזמן (Time phase)",
        milestoneSelectLabel: "אבן דרך",
        timephaseLabel: "Time Phase",
        startDateLabel: "תחילת תקופה",
        endDateLabel: "סוף תקופה",
        startDateErrorMessage: "נדרש תאריך התחלה.",
        endDateErrorMessage: "נדרש תאריך סיום.",
        timephaseNameErrorMessage: "נדרש שם.",
        milestoneErrorMessage: "נדרשת אבן דרך (milestone).",
        isKeyEvent: "אירוע משמעותי",
        timephaseDescription: "תיאור (אופציונאלי)",
        addSuccessMessage: "שלב הזמן (Time phase) נוסף בהצלחה."
    },

    AccountListHeaderLabels: {
        pspAndosp: "PSPs/OSPs",
        limitRiskAssertionLabel: "סעיף בסיכון מוגבל (limited risk account)",
        heading: "חשבונות וגילויים קשורים",
        accountsOrDisclosure: "סעיפים וגילויים",
        psps: "PSPs",
        rejected: "נדחה",
        remove: "הסר",
        risks: "סיכונים",
        assertions: "יעדי ביקורת",
        noRecordsFound: "אין חשבונות או גילויים זמינים",
        noResultsFound: "לא נמצאו תוצאות",
        responsiveHeading: "תגובה",
        rejectedPspsHeading: "PSPs שנדחו",
        importPsps: "ייבא PSPs",
        importOsps: "ייבוא ​​OSPs",
        addOsps: "הוסף OSPs",
        pspEnded: "בכדי להתחיל.",
        noPspsandOsps: "אין {0} זמין.",
        allAreRejected: "כל ה-PSP נדחו.",
        rejectButton: "דחה",
        acceptButton: "קבל",
        additionalInfo: "הסבר:",
        noAssertionsAvailableLabel: "אין מצגי הנהלה זמינים",
        noAssertionAvailableTooltip: "אין מצג הנהלה זמין. לחץ על <strong>נהל סעיפים וגילויים</strong> בכדי להוסיף מצגי הנהלה.",
        importFromKnowledge: "ייבוא ​​מתוך ידע",
        disabledAddOspTooltip: "לפחות מצג הנהלה אחד חייב להיות זמין בכדי להוסיף משימה מבססת. לחץ על <strong>נהל סעיפים וגילויים</strong> בכדי להוסיף מצגי הנהלה.",
        noPsps: "אין PSPs זמינים. {0} כדי להתחיל.",
        noOspsPsps: "אין PSPs/OSPs זמינים. {0}, {1} או {2} כדי להתחיל.",
		acceptErrorMsg: "לא ניתן לקבל את המשימה שנדחתה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
        build7NoPspOrOspAttachedToAssertion: "לכל מצג הנהלה חייב להיות לפחות נוהל מבסס אחד הנותן לו מענה. למצגי ההנהלה הבאים אין PSP/OSP אשר נותן מענה: <b>{orphanAssertions}</b>. {0}, {1}, או הוסף {2} בכדי לטפל בכל מצגי ההנהלה עבור הסעיף או לחץ על סמל העריכה עבור PSPs/OSPs קיימים הנותנים מענה לסעיף זה בכדי לקשר אותם למצגי הנהלה אחרים.",
        build7NoPspOrOsp: "לכל מצג הנהלה חייב להיות לפחות נוהל מבסס אחד הנותן לו מענה. לאף אחד ממצגי ההנהלה PSP/OSP למתן מענה. {0}, {1} או צור {2} בכדי לטפל בכל מצגי ההנהלה לגבי הסעיף.",
        build7NoOspsAndAllPspAreRejected: "לכל מצג הנהלה חייב להיות לפחות נוהל מבסס אחד הנותן לו מענה. כל ה-PSPs נדחו ולאף אחד ממצגי ההנהלה אין PSPs/OSPs למתן מענה. {0} או צור {1} כדי לטפל בכל מצגי ההנהלה עבור הסעיף.",
        build6And7NoAssertions: "לכל סעיף מהותי או גילוי מהותי חייב להיות לפחות מצג הנהלה אחד אשר הוא קשור וזמין בכדי להוסיף נוהל מבסס. לחץ על {0} כדי להוסיף מצגי הנהלה.",
        build7LimitedAccountNoPspOsp: "לכל חשבון בעל סיכון מוגבל חייב להיות לפחות נוהל מבסס אחד כמתן מענה. {0} או צור {1} כדי להגיב לסיכונים של חשבון זה.",
        manageAccountAndDisclosures: "ניהול סעיפים וגילויים"
    },

    AddTaskLabels: {
        accountLabel: "חשבון:",
        taskSectionLabel: "מקטע משימה:",
        ospModelTitle: "OSP חדש",
        ostModelTitle: "OST חדש",
        saveAndClose: "שמור",
        saveAndCreate: "שמור וצור אחד נוסף",
        cancel: "בטל",
        prefix: "קידומת",
        title: "כותרת",
        suffix: "סיומת",
        timePhase: "Time Phase",
        description: "תיאור מותאם אישית",
        descriptionPlaceholder: "תיאור משימה מותאם אישית (חובה)",
        assertions: "יעדי ביקורת",
        optional: "(אופציונלי)",
        required: "נדרש",
        noResultFound: "לא נמצאו תוצאות",
        of: "של",
        characters: "תווים",
        descriptionMaxLengthError: "אורך התיאור חרג מהאורך המירבי המותר",
        noteDiscriptionErrorMessage: "תגובה מכילה תווים {0} החורגים ממקסימום של {1} תווים. התאם את התיאור על-ידי הפחתת טקסט או עיצוב ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
        customizeDescription: "תיאור משימה מותאם אישית (חובה)",
        errorMsg: "הוספת ה-OSP נכשלה. רענן את הדף ונסה שוב. אם הבעיה נמשכת פנה לתמיכה הטכנית.",
        customizeTaskDescription: "התאמה אישית של תיאור משימה"
    },

    RemoveTaskLabels: {
        modelOspTitle: "מחק OSP",
        modelOstTitle: "מחק OST",
        deleteBtn: "מחק",
        cancel: "בטל",
        confimationOspMsg: "האם אתה בטוח שברצונך למחוק את ה-OSP שנבחר?",
        confimationOstMsg: "האם אתה בטוח שברצונך למחוק את ה-OST שנבחר?",
        warning1Msg: "ראיות קשורות שאינן משויכות למשימות אחרות בהתקשרות זו יועברו לקבצים זמניים.",
        warning2Msg: "ממצאים ומשימות מענה שלא קשורות לשום ראיה אחרת יימחקו'."
    },

    TaskReportHeaderLabels: {
        Tasktype: "סוג משימה",
        Taskstatus: "סטטוס המשימה",
        Taskassignedto: "המשימה הוקצתה ל",
        Tasktitleprefix: "קידומת כותרת המשימה",
        Tasktitle: "כותרת המשימה",
        Tasktitlesuffix: "סיומת כותרת המשימה",
        Taskdescription: "תיאור המשימה",
        Knowledgetasktitle: "כותרת משימת ידע",
        Knowledgetaskdescription: "תיאור משימת ידע",
        Oldtaskname: "שם משימה ישן",
        Oldtaskdetail: "פרטי המשימה הישנה",
        Rejected: "נדחה",
        Rationalforrejection: "הסבר לדחייה",
        Auditphase: "שלב בביקורת",
        Timephasetype: "אבן דרך",
        Timephase: "Time Phase",
        Timephasestartdate: "תאריך תחילת שלב הזמן (Time Phase)",
        Timephaseduedate: "תאריך היעד שלב הזמן (Time Phase)",
        Keyevent: "אירוע משמעותי",
        Tasksource: "מקור המשימה",
        Tasknature: "אופי המשימה",
        Lasttaskstatuschangedate: "תאריך שינוי הסטטוס של המשימה האחרונה",
        Taggroup: "קבוצת תגים",
        Tags: "תגים",
        RelatedMESTentities: "ישויות MEST קשורות",
        Schedulednextwaveservices: "שירותי nextwave מתוזמנים",
        Priority: "עדיפות",
        Taskid: "מזהה משימה",
        Roleid: "מזהה תפקיד (Role ID)",
        Tasktypeid: "מזהה סוג משימה",
        Taskstatusid: "מזהה סטטוס משימה",
        Auditphaseid: "מזהה שלב הביקורת",
        Timephasetypeid: "מזהה אבן דרך",
        Tasksourceid: "מזהה מקור המשימה",
        Tasknatureid: "מזהה אופי המשימה"
    },

    glAccountDocumentLabels: {
        modelTitle: "חשבון GL",
        modelName: "קשר ראיות",
        documentName: "שם המסמך",
        documentCounter: "מסמך {0}",
        documentsCounter: "{0} מסמכים",
        btnCancel: "בטל",
        btnSave: "שמור",
        errorMessage: "בחר מסמך בכדי להמשיך",
        noResultsFound: "לא נמצאו תוצאות",
        newTickMark: "tickmark חדש",
        bulkModePlaceholder: "בחר ראיה לקשר ובחר <strong>\'שמור\'</strong> כדי לסיים."
    },

    // Edit TimePhase Labels
    editTimePhaseLabels: {
        modalTitle: "ערוך את שלב הזמן",
        modalDescription: "ערוך את המאפיינים ולחץ על <b>שמור.</b>",
        editSuccessMessage: "שלב הזמן (Time phase) עודכן בהצלחה."
    },

    // Delete TimePhase Labels
    deleteTimePhaseLabels: {
        deleteTimePhaseModalTitle: "מחק את שלב הזמן",
        deleteDescription: "האם אתה בטוח שברצונך למחוק את שלב הזמן הזה?",
        showTimePhaseName: "Time Phase",
        showMileStone: "אבן דרך",
        showStartDate: "תחילת תקופה",
        showEndDate: "סוף תקופה",
        showDescription: "תיאור:",
        showAssignedTasks: "כמות המשימות שהוקצו",
        showAssignedAssignments: "כמות הקצאות",
        deleteSuccessMessage: "שלב הזמן (Time phase) נמחק בהצלחה."
    },

    // Create Tag Labels
    createTagGrouplabels: {
        modalTitle: "הוסף קבוצת תגים",
        modalDescription: "הזן שם ולחץ על שמור וסגור או שמור והוסף כדי להמשיך.",
        tagGroupNameLabel: "קבוצת תגים",
        tagGroupNameErrorMessage: "נדרשת קבוצת תגים",
        saveAndClose: "שמור וסגור",
        saveAndAdd: "שמור והוסף",
        addSuccessMessage: "קבוצת תגים נוספה בהצלחה."
    },

    // Bulk Tags
    tags: {
        noTagsAvailabel: "אין תגים זמינים",
        deleteTag: "מחק תג",
        deleteDescription: "לא ניתן לבטל את מחיקת התג. האם אתה בטוח שברצונך להמשיך?",
        showDeleteTagName: "תָג",
        showDeleteTagGroupName: "קבוצת תגים",
        showAssignedTasks: "משימות שהוקצו",
        deleteSuccessMessage: "התג נמחק בהצלחה.",
        task: "מְשִׁימָה",
        tasks: "משימות",
        addTagGrouplabels: "הוסף קבוצת תגים",
        addTag: "הוסף תג",
        action: "פעולה",
        addTagDesc: "<h3>הוסף תג</h3><p>לחץ על 'הוסף קבוצת תגים' כדי ליצור קבוצת תגים חדשה שניתן להשתמש בה כדי להוסיף תגים.</p>",
        assignTagDesc: "<h3>הקצה תגים</h3><p>גרור ושחרר פריטים נבחרים לתג הרצוי מתחת לקבוצת תגים.</p>",
        editTagDesc: "<h3>ערוך תגים</h3><p>לחץ על התפריט, באמצעות לחיצה על שלוש הנקודות ובחר 'ערוך' כדי לערוך את מאפייני התג.</p>",
        deleteTagDesc: "<h3>מחק תגים</h3><p>לחץ על התפריט, באמצעות לחיצה על שלוש הנקודות ובחר 'מחק' כדי למחוק את התג.</p>",
        removeTagDesc: "<h3>הסר תג</h3><p>כדי להסיר תג, גרור פריט אחד או יותר עם תג קיים לשם התג המשויך מתחת לקבוצת תגים.</p>",
        expand: "הרחב",
        collapse: "צמצם",
        TagName: "שם תג",
        TagGroupName: "שם קבוצת תגים",
        addTagSuccessMessage: "התג נוסף בהצלחה.",
        editTagSuccessMessage: "התג עודכן בהצלחה.",
        addTagModalTitle: "הוסף תג ל",
        editTagModalTitle: "ערוך תג",
        addTagModalDescription: "צור תג חדש ולחץ על שמור וסגור או שמור והוסף כדי להמשיך.",
        editTagModalDescription: "ערוך את המאפיינים ולחץ על <b>שמור.</b>",
        tagSetSuccessMessage: "התג הוגדר בהצלחה.",
        tagsSetSuccessMessage: "התגים הוגדרו בהצלחה.",
        tagRemoveSuccessMessage: "התג הוסר בהצלחה.",
        tagsRemoveSuccessMessage: "התגים הוסרו בהצלחה.",
        tagRemovedSuccessfully: "התג הוסר בהצלחה."
    },

    relateEvidenceHeader: "קשר ראיות המספקות מידע על העדכון .",
    relatedDocumentCounter: "מסמך {0}",
    relatedDocumentsCounter: "{0} מסמכים",
    documentsLocationLabel: "מיקום המסמכים",
    relateTemporaryFilesHeader: "קשר מסמך זמני מהתקשרות זו.",

    // Create Assignment Labels
    addAssignmentlabels: {
        modalTitle: "הוסף הקצאה",
        modalDescription: "בסיום, הזן שם ולחץ על שמור.",
        assignmentNameLabel: "שם חבר הצוות שהוקצה",
        assignmentNameErrorMessage: "שם ההקצאה לא יכול להיות ריק",
        saveAndClose: "שמור וסגור",
        saveAndAdd: "שמור והוסף",
        addSuccessMessage: "ההקצאה נוספה בהצלחה."
    },
    addUserOrRoleLabelto: "הוסף משתמש או תפקיד ל",
    addUserOrRoleheader: "חפש את חבר הצוות או התפקיד שברצונך להוסיף.",
    saveAndAdd: "שמור והוסף",

    // Bulk Assignment
    BulkActionsLabel: "פעולות בכמות גדולה",
    BulkAssignmentAction: "פעולה",
	BulkShow: "הצג",
    BulkActionsInstructionalText: "בצע פעולות בכמות גדולה עבור קיבוץ משימות באמצעות גרירה ושחרור. בכדי להציג משימות בודדות עבור קיבוץ משימות, העבר את העכבר מעל קבוצת המשימות ולחץ על סמל החץ.",
    bulkOperationsModalDescription: "בצע פעולות בכמות גדולה עבור משימות. כדי להציג משימות בודדות עבור קיבוץ משימות, העבר את העכבר מעל קבוצת המשימות ולחץ על סמל החץ.",
    selectRequest: "בחר בקשה לשליחה.",
    replaceLabel: "החלף",
    labelStaff: "מתמחה-",
    addModeLabel: "הוסף",
    replaceModeLabel: "החלף",
    dueDateModeLabel: "עדכן את תאריך היעד",
    searchByAssignmentName: "חפש",
    addTeamMemberLabel: "הוסף חבר צוות",
    noTeamMembersFound: "אין חברי צוות זמינים",
    addMemberSuccessMessage: "חבר צוות נוסף בהצלחה.",
    addAssignmentLabel: "הוסף הקצאה",
    addAssignmentNameLabel: "הוסף שם הקצאה",
    noAvailableAssignmentsMessage: "אין הקצאות זמינות",
    showDuplicateError: "לחבר הצוות או לתפקיד שנבחרו אי אפשר שתהיה הקצאה כפולה עבור המשימה(ות) שנבחרה(ו). בחר הקצאה אחרת, חבר צוות אחר או תפקיד אחר בכדי להמשיך.",
    infoBulkAssignments: "הקצאות בכמות גדולה",
    infoBulkAssignmentDesc: "בחר קבוצה אחת או יותר של משימות בכדי ליצור הקצאות חדשות או להחליף הקצאות קיימות. כאשר הקצאות נוצרות או נערכות, ההקצאה הנוכחית שהוקצתה לחבר הצוות תחושב מחדש לפי חבר הצוות שההקצאה שלו היא הכי מוקדמת.",
    infoAssignmentsDueDate: "קביעת תאריך יעד להקצאה(ות)",
	infoAssignmentsDueDateDesc: 'השתמש בלחצן "בחר תאריך/חשב תאריך" בכדי להגדיר את תאריך היעד של ההקצאה(ות). ניתן להשתמש בלחצן בכדי לתת תאריך יעד ספציפי למשימה(ות) או בכדי לספק ימים לפני תאריך סיום שלב הזמן.',
    infoAddAssignmentExisting: "הוסף הקצאה לחבר צוות קיים",
    infoAddAssignmentExistingDesc: "הוספת הקצאות מחייבת להגדיר מספר ימים לפני תאריך היעד. לחלופין, תאריך יעד מדויק עשוי להיות מוגדר באמצעות לוח השנה. לאחר שזה נעשה, גרור ושחרר את הפריטים שנבחרו כדי ליצור קבוצה חדשה של הקצאות.",
    infoAddAssignmentNew: "הוסף הקצאה לחבר צוות חדש",
    infoAddAssignmentNewDesc: "אם חבר הצוות או התפקיד לא מופיע עבור ההקצאה הנתונה, לחץ על הוסף חבר צוות כדי לראות רשימה של חברי צוות ותפקידים זמינים. לאחר הבחירה, חבר הצוות הזה יתווסף לתחתית הרשימה וניתן יהיה להקצות עבורו באמצעות גרור ושחרר.",
    infoRemove: "הסר הקצאה",
    infoRemoveDesc: "כדי להסיר הקצאה, גרור פריט אחד או יותר לחבר צוות תחת שם הקצאה. כל ההקצאות שלא הושלמו עבור אותו חבר צוות יוסרו. הקצאות שהושלמו לא יוסרו.",
    infoReplace: "החלף הקצאה",
    infoReplaceDesc: "בעת החלפת הקצאה, תגרור פריט אחד או יותר לחבר צוות תחת שם ההקצאה. כל המטלות הקיימות עם אותו שם הקצאה יוקצו מחדש לחבר הצוות שנבחר. אם למספר חברי צוות היו מטלות עבור שם ההקצאה, הן יאוחדו למשתמש הנבחר. קביעה מראש של תאריך היעד לביצוע היא אופציונלית בעת שימוש בהחלפת ההקצאה. אם לא נקבע תאריך יעד חדש, ייעשה שימוש בתאריך היעד הקיים.",
    infoUpdateDueDate: "עדכן את מספר הימים (Days Due)",
	infoUpdateDueDateDesc: 'הגדר את ה"מספר הימים(Days Due)" החדש באמצעות "בחר תאריך " או "חשב תאריך " ולאחר מכן גרור ושחרר אל חבר הצוות שאת מספר הימים שלו אתה רוצה לשנות. הקצאות פתוחות וכאלו שבתהליך עבודה עבור אותו חבר צוות יעודכנו. הקצאות שהושלמו לא ישתנו.',
    infoDelete: "מחק הקצאה",
    infoDeleteDesc: "לחץ על ההקצאה באמצעות הלחצן הימני בעכבר ותופיע אפשרות למחוק את סט ההקצאות.",
    infoExecutive: "הקצאה למנהלים",
    infoExecutiveDesc: "השתמש במסננים ובאפשרויות החיפוש בכדי לסנן את המשימות הרלוונטיות עבור המנהלים, בכדי לבצע את ההקצאות בצורה מהירה יותר.",
    infoSpecificTask: "הקצאות למשימות ספציפיות",
    infoSpecificTaskDesc: "אם יש צורך לבצע הקצאות ברמת משימה, העבר את העכבר מעל המקבץ  ובחר באפשרות להצגת משימות בודדות. זה יציג את המשימות הבודדות עבור הקבוצה ויאפשר הקצאות בודדות",
    unassignedLabel: "Unassigned",
    replaceSignleSuccessMessage: "המשימה עודכנה בהצלחה.",
    replaceMultipleSuccessMessage: "המשימות עודכנו בהצלחה.",
    dueDateSingleSuccessMessage: "ההקצאה עודכנה בהצלחה.",
    dueDateMultipleSuccessMessage: "ההקצאות עודכנו בהצלחה.",
    invalidAssignmentUpdate: "הקצה את המשימה לאותו אדם כדי להמשיך בעדכון ימי היעד.",
    removeSuccessMessage: "ההקצאות עודכנו בהצלחה.",
    colorCode: "קוד צבע",
    removeSuccessSingleMessage: "ההקצאה עודכנה בהצלחה.",
    removeSuccessMultipleMessage: "ההקצאות עודכנו בהצלחה.",
    assignmentRemovedSuccessfully: "ההקצאה הוסרה בהצלחה.",

    // Bulk Task
    itemsSelected: "משימות שנבחרו",
    itemSelected: "משימה שנבחרה",
    dragAndDrop: "גרור ושחרר",
    currentApplication: "יישום נוכחי",
    allAssignmentsClosed: "כל ההקצאות נסגרו",
    allAssignmentsCompleted: "כל ההקצאות הושלמו",

    onOrBeforeCurrentDate: "בתאריך הנוכחי או לפניו",
    withInCurrentWeek: "השבוע",
    quickFilter: "מסנן מהיר",
    suggestedFilters: "מסננים מוצעים",
    showXMore: "הצג עוד {0}",

    // Task due date Events
    addEventlabels: {
        modalTitle: "הוסף אירוע",
        startDateLabel: "תחילת תקופה",
        modalDescription: "הוסף את המאפיינים ולחץ על שמור וסגור או שמור והוסף.",
        eventNameLabel: "שם אירוע",
        eventType: "סוג אירוע",
        singleDay: "יום אחד",
        dateRange: "טווח תאריכים",
        eventDate: "תאריך אירוע",
        eventDescription: "תיאור (אופציונאלי)",
        isEvent: "שתף את האירוע עם הלקוח",
        EventNameErrorMessage: "שם האירוע נדרש.",
        eventDateErrorMessage: "תאריך האירוע נדרש.",
        addSuccessMessage: "האירוע נוסף בהצלחה."
    },

    // Bulk Notes
    DeleteSomeNotesAreClosed: "<b>רק חלק מההערות שבחרת הן בסטטוס סגור (closed) וניתן למחוק אותן.</b> <br /> אם תבחר להמשיך, ההערות המפורטות להלן יימחקו.",
    DeleteSomeNotesAreNotClosed: "לא ניתן למחוק את ההערות המפורטות להלן כי הן לא בסטטוס סגור (closed).",
    DeleteDontHaveClosedNotes: "לא ניתן למחוק את ההערות המפורטות להלן כי הן לא בסטטוס סגור (closed).",
    someNotesAreOpen: "<b>רק לחלק מההערות שבחרת יש סטטוס פתוח (open).</b> <br/> אם תבחר להמשיך, ההערות המפורטות להלן יעודכנו.",
    someNotesAreNotOpen: "ההערות המפורטות להלן לא יעודכנו כי הן כבר נוקו (cleared) או נסגרו (closed).",
    dontHaveOpenNotes: "לא ניתן לעדכן את ההערות המפורטות להלן כי הן כבר נוקו (cleared) או נסגרו (closed).",
    ShowNumberMore: "הצג עוד {0}",

    // Drag and Drop
    assignmentLabel: "הקצאה",
    assignmentsLabel: "משימות לביצוע",
    singleAssignmentCreatedMessage: "ההקצאה נוצרה בהצלחה.",
    multipleAssignmentCreatedMessage: "ההקצאות נוצרו בהצלחה.",
    daysPriorWarning: "הגדר את מספר הימים (days due) לפני הקצאה המשימות.",



    // Related Tasks - Engagement selector
    selectEngagement: "בחר התקשרות",
    thisEngagement: "התקשרות זו",
    noResultsFoundLabel: "לא נמצאו תוצאות",
    taskLocationLabel: "מיקום המשימה",

    // Delete Assginment
    deleteDescription: "לא ניתן לבטל מחיקת הקצאה, האם אתה בטוח שברצונך להמשיך?",
    deleteAssignmentModalTitle: "מחק הקצאה",
    deleteSingleSuccessMessage: "ההקצאה נמחקה בהצלחה.",
    deleteMultipleSuccessMessage: "ההקצאות נמחקו בהצלחה.",
    teamMemberLabel: "חבר צוות",
    assignedTasksCountLable: "משימות שהוקצו",
    deleteAssignmentLabel: "הקצאה",
    selectengagement: "בחר התקשרות",

    //Due Days
    dueDateTitle: "הזן את תאריך היעד",
    dueDatedescription: "הזן את מספר הימים לפני תאריך היעד של שלב הזמן (time phase) בהם יש להשלים את ההקצאה.",
    dueDateAssign: "Assign",
    dueDateSelect: "בחר",
    dueDateCalculate: "לחשב",

    // Tasklist - bulk markcomplete
    markComplete: "סמן כהושלם",
    markCompleteMessgae1: "האם אתה בטוח שברצונך <b>להשלים את המשימות שנבחרו</b>? <br /> אם יש לך הקצאות שטרם הושלמו עבור המשימות שנבחרו, הן תיסגרנה.",
    markCompleteMessgae2: "רק חלק מהמשימות שבחרת ניתנות לסימון ככאלו שהושלמו.<br /> אם תבחר להמשיך, <b>המשימות המפורטות להלן יסומנו ככאלו שהושלמו</b>. אם יש לך מטלות לא הושלמו, הן תיסגרנה.",
    markCompleteMessgae3: "<b>המשימות המפורטות להלן לא יסומנו ככאלו שהושלמו</b> מכיוון שאין להן שום ראיות המשויכות אליהן או שהראיות המשויכות חסרות חתימות (sign-offs).",
    markCompleteMessgae4: "<b>לא ניתן לסמן את המשימות המפורטות להלן ככאלו שהושלמו</b> מכיוון שאין להן שום ראיה המשויכת אליהן או שהראיות המשויכות חסרות חתימות (sign-offs).",

    // Tasklist - bulk handoff
    handOffLabel: "מסירה (hand-off)",
    confirmHandOff: "אשר את המסירה (hand-off)",
    handOffMessgae1: "האם אתה בטוח שברצונך <b>להעביר את המשימות שנבחרו</b> לחבר הצוות הבא שהוקצה? <br /> אם יש לך הקצאות שטרם הושלמו עבור המשימות שנבחרו, הן תיסגרנה.",
    handOffMessgae2: "רק לחלק מהמשימות שבחרת הוקצה חבר צוות אחר. <br />אם תבחר להמשיך, <b>המשימות המפורטות להלן יועברו</b>. אם יש לך מטלות לא הושלמו עבור המשימות שנבחרו, הן תיסגרנה.",
    handOffMessgae3: "<b>המשימות המפורטות להלן לא יועברו (handed-of) </b> מכיוון שאין להן הקצאות שטרם הושלמו.",
    handOffMessgae4: "<b>לא ניתן למסור את המשימות המפורטות להלן</b> מכיוון שאין להן הקצאות שטרם הושלמו.",
    closeMyAssignments: "סגור את ההקצאות שלי",

    saveQuickFilter: "שמור מסנן מהיר",
    saveQuickFilterModalHeader: "שמור את הסינון של ה- Chips שהחלת כמסנן מהיר.",
    saveQuickFilterModalText: "בחר מסננים מהירים שמורים ומוצעים כדי לחסוך זמן כשתיגש שוב להתקשרות הזו. אתה יכול ליצור עד חמישה מסננים מהירים שמורים לכל התקשרות.",
    quickfiltername: "שם מסנן מהיר",
    taskCategory: "קטגוריית משימות",

    cannotsavefilter: "לא ניתן לשמור מסנן מהיר מותאם אישית",
    cannotsavefiltermodalheadertext: "<b>תוכל לשמור רק חמישה מסננים מהירים מותאמים אישית לכל תיק ביקורת.</b> <br /> אם אתה רוצה להמשיך, מחק אחד מהמסננים המהירים המותאמים אישית הקיימים שלך ונסה שוב.",
    savedFilters: "מסננים שמורים",
    taskassignedto: "המשימה הוקצתה ל",
    noteassignedto: "הערה הוקצתה ל",
    taskPrefix: "קידומת משימה",
    taskSuffix: "סיומת משימה",

    // Mark complete/HandOff Evidences category
    noSignOffs: "אין חתימות",
    noSignOffsByMe: "אין חתימות שבוצעו על ידי",
    myPreparerSignOffs: "חתימה שלי כמכין",
    myReviewerSignOffs: "חתימה שלי כסוקר",
    myPreparerAndReviewerSignOffs: "חתימה שלי כמכין וכסוקר",

    notificationDownErrorMessage: "אופציית ההתראות אינה זמינה זמנית. רענן את הדף ונסה שוב. אם הודעה זו ממשיכה, פנה לתמיכה הטכנית.",
    notificationUpbutSomeLoadingErrorMessage: "מרכז ההתראות אינו זמין באופן זמני. רענן את הדף ונסה שוב - הוא יהיה זמין בקרוב.",

    timeTrackerErrorFallBackMessage: "אופציית מעקב הזמן אינה זמינה זמנית. רענן את הדף ונסה שוב. אם הודעה זו ממשיכה, פנה לתמיכה הטכנית.",
    timeTrackerLoadingFallbackMessage: "אופציית מעקב הזמן (Time Tracking) אינה זמינה כעת. זה יהיה זמין בקרוב.",

    signOffOnAllAs: "חתום על הכל כ-",
    accountType: "סוג סעיף (Account Type)",

    openDocumentInstructionalText: "מסמך זה ייפתח אוטומטית. <b>אינך צריך ללחוץ כדי לפתוח אותו.</b> <br>לאחר פתיחת המסמך, תוכל לסגור כרטיסייה זו.",
    closeTab: "סגור כרטיסייה",

    // Build Step - Add Due Date
    milestones: "אבני דרך (Milestones )",
    events: "אירועים",
    noTimePhasesHaveBeenIdentified: "לא זוהו שלבי זמן (Time phases).",

    wcgws: "WCGWs",
    relatedControls: "בקרות קשורות",
    relatedControlsWCGWsRatio: "בקרות קשורות / WCGWs",
    wcgwsToControlsRatio: "יחס WCGWs לבקרות",
    controlsToWCGWsRatio: "יחס בקרות ל-WCGWs",
    testedControls: "בקרות שנבדקו",

    // Collaboration request to Task relation
    CollaborationModalTitle: "קישור בקשות למשימות",
    CollaborationModalDescription: "כדי לקשר בקשה למשימה, גרור ושחרר בקשה אחת או יותר למשימה שלהלן.",
    noDataFound: "לא נמצאו נתונים",
    taskName: "משימה",
    showMessage: "בחר קטגוריה וקבוצת משימות כדי להתחיל",
    showCategory: "קטגוריה",
    showTaskGroup: "קבוצת משימות",
    optionITProcesses: "תהליכי IT",
    optionExecutionGeneral: "ביצוע - כללי",
    relatedRequestsLabel: "בקשות קשורות",
    relatedRequestsFormatted: "{0} בקשות קשורות",
    relatedRequestFormatted: "{0} בקשה קשורה",
    relatedRequests: "בקשות קשורות",
    relatedTasks: "משימות קשורות",
    relatedSuccessSingleMessage: "בקשה {0} קושרה למשימה בהצלחה.",
    relatedSuccessMultipleMessage: "{0} בקשות קושרו למשימה בהצלחה.",
    showUnrelated: "הצג {0} לא קשור",
    unrelate: "לא קשור",
    noRequestsMessage: "אין בקשות זמינות",
    requestNumber: "מספר בקשה",
    sortAscending: "מיין בסדר עולה",
    sortDescending: "מיין בסדר יורד",
    removeSorting: 'Remove sorting',

    // PIC Dashboard
    groupBy: "קבץ לפי",
    allTasks: "כל המשימות",
    iTSOs: "IT/Sos",
    generalExecution: "ביצוע הביקורת - כללי",
    PICSignOff: "חתימת השותף האחראי על הביקורת (PIC)",
    EQRSignOff: "חתימת שותף מלווה (EQR)",
    completed: "הושלם",
    allAssigned: "הכל הוקצה",
    picTaskAssignmentLabel: "המשימות שהוקצו לך",
    assignReadyForReview: "נוכחי",
    assignUpcomingForReview: "בקרוב",
    assignReadyForReviewTasks: "הקצאות נוכחיות",
    assignUpcomingForReviewTasks: "הקצאות קרובות",
    picTaskSignoffInComplete: "משימות עם חתימות <b>PIC</b> לא הושלמו",
    picDocSignoffInComplete: "מסמכים עם חתימות <b>PIC</b> לא הושלמו",
    eqrTaskSignoffInComplete: "משימות עם חתימות <b>EQR</b> לא הושלמו",
    eqrDocSignoffInComplete: "מסמכים עם חתימות <b>EQR</b> לא הושלמו",
    collapseCards: "צמצם כרטיסים",
    expandCards: "הרחב כרטיסים",
    noUserSelectedPlaceholder1: "ה-{0} לא זוהה או הוזמן לתיק הביקורת.",
    noUserSelectedPlaceholder2: "לחץ כאן",
    noUserSelectedPlaceholder3: "כדי לזהות או להזמין את ה-{0}.",
    notInvitedLabel: "לא מוזמן",
    noTasksPlaceholder: "אין משימות הקשורות ל<br/>אבני הדרך (milestones) בשלב הביקורת (audit phase) הזה.",
    noTasksTilesPlaceholder: "לא הוקצו משימות למשתמש הנבחר",
    noAssignmentPlaceholder: "לא נמצאו הקצאות",
    dueDateAssignmentPlaceholder: "הקצאות לפי תאריך יעד",
    countAssignmentPlaceholder: "כמות ההקצאות",
    OverduetPlaceholder: "תאריך היעד חלף",
    TodayPlaceholder: "היום",
    tasksView: "תצוגת משימות",
    documentsView: "תצוגת מסמכים",
    picAndEqr: "PIC & EQR",
    ResponsiveToSR: "קשור ל-⚡SR",
    responsiveToFR: "קשור ל-⚡FR",
    relatedTasksFormatted: "{0} משימות קשורות",
    relatedTaskFormatted: "{0} משימה קשורה",
    autoAssignWarning2: "לחץ כאן",
    toAssign: "להקצות",
    taskAssignWarning: "משימה, עם {0} דרישות חתימה, לא הוקצתה,",
    tasksAssignWarning: "משימות, עם {0} דרישות חתימה, לא הוקצו,",
    taskAdditionalFuncText1: "<b>למשימה זו יש פונקציונליות נוספת. בבקשה </b>",
    taskAdditionalFuncText2: "<b> כדי לנווט אליו.</b><p>משימות מובנות אינן דורשות לשייך ראיות ביקורת בכדי לסמן שהן הושלמו, אלא אם המשימה דורשת סקירת PIC/EQR.</p>",
    taskadditionalfunctionality: "<b>למטלה זו יש פונקציונליות נוספת. אנא</b> {0} <b>כדי לנווט למטלה זו.</b><p>מטלות אלו אינן מצריכות שיוך ראיות כדי לסמן שהמשימה הושלמה, אלא אם המשימה דורשת סקירת PIC/EQR.</p>",
    taskclickhere: "לחץ כאן",
    taskAutoAssignModalTitle: "הקצאה אוטומטית",
	taskAutoAssignModalDescription: 'ישנן {0} משימות עם דרישת חתימה של השותף המלווה EQR שלא הוקצו ל-{1}. לחץ על "הקצה" כדי ליצור הקצאת EQR עבור {1}.',
	tasksAutoAssignModalDescription: 'ישנן {0} משימות עם דרישת חתימה של השותף המלווה EQR שלא הוקצו ל-{1}. לחץ על "הקצה" כדי ליצור הקצאות לשותף המלווה EQR עבור {1}.',
    picTaskAutoAssignSuccessMessage: "משימה עם דרישת חתימה של השותף האחראי על הביקורת PIC שהוקצתה ל",
    picTasksAutoAssignSuccessMessage: "משימות עם דרישת חתימה של השותף האחראי על הביקורת PIC שהוקצתה ל",
    eqrTaskAutoAssignSuccessMessage: "משימה עם דרישת חתימה של השותף המלווה EQR שהוקצתה ל",
    eqrTasksAutoAssignSuccessMessage: "משימות עם דרישת חתימה של השותף המלווה EQR",
    taskEntityDocumentValidationMsg: "למשימה זו יש ישויות שאין להן ראיות מענה (responsive evidence). עבור אל תצוגה לפי ישויות כדי לראות אילו ישויות זקוקות לתיעוד נוסף.",
    // PIC/EQR Sign-Off validation message
    picSignOffValidationMsg: "משימה זו דורשת חתימת השותף האחראי על הביקורת PIC, אך לא משויכים מסמכי PIC. הוסף לפחות מסמך אחד עם דרישה זו.",
    eqrSignOffValidationMsg: "משימה זו דורשת חתימת השותף המלווה EQR, אך לא משויכים מסמכי EQR. הוסף לפחות מסמך אחד עם דרישה זו.",
    picAndEQRSignOffValidationMsg: "משימה זו דורשת אישור השותף האחראי על הביקורת PIC או חתימת השותף המלווה EQR, אך לא משויכים מסמכי PIC/EQR. הוסף לפחות מסמך אחד עם דרישה זו.",
    updateDataOnPicEqrDashboardBannerMessage: "שינויים שבוצעו לא עודכנו למטה. אנא {0} כדי לרענן את הדף.",
    showMissingSignOffByLabel: "הצג מסמכים אשר חסרים בהם {0} חתימות",

    FindingsReportName: "ממצאים",
    FindingsDeficiencyReportTabName: "ליקוי",
    FindingsMisstatementReportTabName: "הצגה מוטעית",
    FindingsDeficiencyITReportTabName: "ליקוי IT",
    auditPlanRelatedEvidenceReporLabel: "תוכנית ביקורת עם ראיות קשורות",
    groupStructureSummaryReportReportLabel: "סיכום מבנה הקבוצה",
    auditPlanReportLabel: "דוח של תוכנית הביקורת",
    itAppSOSummaryReportLabel: "סיכום ייישומי IT & SO",
    craSummaryReportLabel: "סיכום הערכת הסיכון המשולב (CRA)",
    teamMembersLabel: "חברי הצוות",
    ipeLabel: 'Information produced by the entity (IPE)',
    validationChecksReportLabel: "בדיקות אימות",
    trialBalanceReportLabel: "מאזן בוחן",
    trialBalanceReportTabLabel: "דוח מאזן בוחן",
    reportLabelYes: "כן",
    reportLabelNo: "לא",
    assignedBy: "שהוקצה על ידי",
    openInReviewNotesHub: "פתח ב- HUB לריכוז הערות הסקירה (review notes)",
    nextNote: "הבא",
    previousNote: "הקודם",

    //component team group tab names
    accountInfoCanvasFormExport: "פרטי הסעיף",

    //project insight tab names
    projectInsightCanvasFormExport: "ייצוא טפסי Canvas",
    projectInsightSCOTToWCGWToControl: "תת תהליך מהותי (SCOT) ל-WCGW לבקרה",
    projectInsightControlToITApplication: "בקרה ליישום IT",
    projectInsightControlToAssertion: "בקרה למצג הנהלה (assertion)",
    projectInsightRiskToWCGW: "סיכונים ל-WCGWs",

    //IPE Report
    ipeControlsReport: 'Controls',
    ipeSubstantiveReport: 'Substantive',
    ipeITGCReport: 'ITGC',

    // Milestone tab names
	milestonesReport: 'דו"ח Milestones',
    unmappedTasks: "משימות שלא מופו ",

    // Effective
    isEffective: "יעיל",
    inEffective: "לא יעיל",
    nonEffective: "לא יעיל",

    clientRequests: "בקשות לקוח",
    externalTasks: "משימות חיצוניות",
    requestPriority: "בקש עדיפות",
    scot: "תת התהליך המהותי (SCOT)",
    assertionR: "יעד הנהלה",
    wcgwToControlMappingTotal: "WCGW לסיכומי מיפויי הבקרה",

    //CRA build step
    buildStep2EntityHeaderText: "סעיפים וגילויים משמעותיים, מצגי הנהלה, WCGWs ובקרות קשורות",
    buildStep4EntityHeaderText: "סעיפים משמעותיים, גילויים ומצגי הנהלה קשורים",
    accountNameHeader: "סעיפים וגילויים משמעותיים",
    noAssertionsLabel: "אין מצגי הנהלה קשורים. לחץ על <a>נהל חשבונות וגילויים</a> כדי להתחיל.",
	noAssertionsBuildStep2text1: "לפחות מצג הנהלה אחד חייב להיות קשור לסיכון הזה. לחץ על ",
    accountWithoutAssertionsBuildStep2text1: "לכל סעיף או גילוי משמעותי חייב להיות לפחות מצג הנהלה אחד קשור. לחץ",
    noAssertionsBuildStep2text2: "ניהול סעיפים וגילויים",
	noAccountsLabel: 'לא נוצרו חשבונות או גילויים משמעותיים. לחץ על <span class="bold-text">נהל חשבונות וגילויים</span> כדי להתחיל.',
	noAccountsLabelPlaceHolder: 'לא נוצרו חשבונות או גילויים משמעותיים. <span class="bold-text">נהל חשבונות וגילויים</span> כדי להתחיל.',
    noAccountsOrDiscloserPreText: "לא נוצרו חשבונות או גילויים משמעותיים.",
    noAccountsOrDiscloserText: "ניהול סעיפים וגילויים",
    noAccountsOrDiscloserPostText: " בכדי להתחיל.",
	noAssertionsBuildStep1text1: "לפחות מצג הנהלה אחד חייב להיות קשור לסיכון הזה. לחץ על ",
    noAssertionsBuildStep1text1Msg: "לכל סיכון חייב להיות לפחות מצג הנהלה אחד קשור.",
    noAssertionsBuildStep1text2: "קשר מצגי הנהלה",
    noAssertionsBuildStep1text3: " בכדי להתחיל.",
    editRisk: "ערוך סיכון",
    deleteRisk: "מחק סיכון",
    noControlsRelatedWWCGW: "אין בקרות קשורות. ",
    noControlsRelatedWCGW: "עבור כל WCGW הקשור למצג הנהלה עם סיכון בקרה של Rely (CR=Rely), יש לבחור לפחות בקרה אחת לבדיקה. צור ",
    noControlsRelatedWCGWNewCont: " בקרה חדשה",
    noControlsRelatedWCGWor: "או",
    noControlsRelatedWCGWRelateCont: " קשר בקרה קיימת",
    noControlsForWCGW: "למצגי הנהלה עם סיכון בקרה של Not Rely אין דרישה לזהות בקרות.",
    noControlsRelatedWCGWFooter: "בכדי להתחיל.",
    relateWCGWs: "<a>קשר WCGWs</a>",
    noWCGWs: "אין WCGWs קשורים.",
    noWCGWsClick: "לחץ",
    noWCGWsFooter: " בכדי להתחיל.",
    showOnlyRisksWithNoAssertion: "הצג רק סיכונים ללא כל מצגי הנהלה קשורים",
    showIncomplete: "הצג רק מצגי הנהלה עם CRA לא שלם",
    showOnlyInvalidBuildStep2: "הצג רק סעיפים עבורם חסרים פרטים נדרשים",
    noTestedControlsWithRelyAssertion: "עבור כל WCGW הקשור למצג הנהלה עם סיכון בקרה של Rely, יש לבחור לפחות בקרה אחת לבדיקה.",

    // Account build step
    accountOrDisclosure: "סעיף / גילויים",
    relatedAssertions: "מצגי הנהלה מקושרים",
    relatedAccountsAndAssertions: "סעיפים ומצגי הנהלה (assertions) קשורים",
    pspIndexTitle: "אינדקס PSP",
    statementTypeTitle: "סוג דוח",
    significantAccountLabel: "משמעותי",
    limitedRiskLabel: "סיכון נמוך (מוגבל)",
    insignificant: "לא משמעותי",
    significantDiscloure: "גילוי משמעותי",
	accountAddedMessage: 'הסעיף "##" נוצר בהצלחה',
    accounHeaderText: "סעיפים וגילויים",

    // Add accounts / disclosures Modal labels
    accountsListTitle: "סעיפים / גילויים ומצגי הנהלה מקושרים",
    addAccountsDisclosures: "הוסף סעיפים / גילויים",
    editAccountsDisclosures: "ערוך סעיפים / גילויים",
    accountNameLabel: "שם סעיף (חובה)",
    accountDesignationLabel: "ייעוד (חובה)",
    accountEstimateLabel: "סעיף הכולל אומדן",
    accountStatementTypeLabel: "סוג דוח (חובה)",
    pspIndexDropdownLabel: "אינדקס PSP (חובה)",
    removePSPIndexLabel: "הסר אינדקס PSP",
    assertionsLabel: "מצגי הנהלה (חובה)",
    noAccounsMessage: "לא נמצאו סעיפים. הוסף סעיפים כדי להתחיל.",

    //Delete account / disclosure modal labels
    deleteAccountDisclosure: "מחק סעיף / גילוי",
    deleteAcConfirmMessage: "האם אתה בטוח שברצונך למחוק את הסעיף/הגילוי {0}? כל מצגי ההנהלה הקשורים יימחקו. כל המשימות הקשורות רק לסעיף/הגילוי הנבחר יימחקו גם כן.",

    true: "נָכוֹן",
    false: "לא נכון",
    taskSummaryReportEngagementInfo: "התקשרויות מרובות (Multiple engagements)",
    viewPriority: "הצגת Priority",
    priorityRequestsSent: "נשלחו בקשות Priiority",

    //reactive frame
    maxTabsLocked: "הגעתם למקסימום הכרטיסיות המותרות. בטל את ההצמדה וסגור אחת מהכרטיסיות כדי לפתוח אחת חדשה.",
    openInNewTab: "פתח בלשונית חדשה",
    copyLink: "העתק קישור",
    copySuccess: "הקישור הועתק ללוח",
    copyFailure: "העתקת הקישור ללוח נכשלה",
    minimize: "לְצַמְצֵם",

    //Risk status for account cards
    riskStatusLabels: {
        NoAssertionsAvailableLabel: "אין מצגי הנהלה זמינים",
        SignificanceNotSelectedLabel: "מידת המהותיות (significance) לא נבחרה",
        InsignificantLabel: "לא משמעותי"
    },

    lockTab: "הצמד כרטיסייה",
    keyDocuments: "מסמכי מפתח",
    suggestedDocuments: "מסמכים מוצעים",
    noSuggestedDocuments: "אין הצעות למסמכים",
    exitBulkMode: "צא ממצב כמות גדולה",
    bulkLabel: "כמות גדולה",

    me: "לִי",
    viewByUser: "הצג לפי משתמש",
    unsentDraftCapitalized: "טיוטות שלא נשלחו",
    picSignoffInComplete: "  חתימת PIC לא הושלמה",
    eqrSignOffIncomplete: "חתימת EQR לא הושלמה",

    tableView: "תצוגת טבלה",
    noRelatedAssertions: "אין מצגי הנהלה קשורים.",

    multiEntityTileMessage1: "לחץ",
    multiEntityTileMessage2: "כאן",
    multiEntityTileMessage3: "  כדי לראות סטטוס לפי ישות",
    allItemsMessage: " כדי לראות את כל הפריטים",

    EntitySelector: "בחר ישות כדי להתחיל",
    allEntities: "כל הישויות",
    multiEntity: "ריבוי ישויות",
    ungrouped: "לא מקובצים",
    numberSelected: "נבחרו {0}",
    allTimePhases: "הכול",
    timePhases: "Time Phase",
    noTimePhaseFound: "לא נמצאו שלבי זמן",
    unrelatedAssignments: "משימות לא קשורות",
    unrelatedRequests: "בקשות לא קשורות",
    relateRequests: "קשר בקשות",
    taskWithoutAnyAssignments: "משימות ללא כל הקצאות",
    privacyNotice: "הודעת פרטיות",
    lastPublishedAndSent: "פורסם ונשלח לאחרונה",
    drafts: "טיוטות",
    allEntitiesTask: "זוהי משימה רחבית בתיק הביקורת הקשורה לכל הישויות",
    noRelatedEntities: "אין ישויות קשורות",
    clickNewRisk: "בכדי להתחיל.",
    relatedAccountsDisclosuresAndAssertions: "סעיפים וגילויים משמעותיים ומצגי הנהלה קשורים",
    relateAssertion: "קשר מצגי הנהלה",
    taskByEntity: "משימה לפי ישות",
    engagementWideTask: "משימה רוחבית של ההתקשרות",
    componentEngagementPill: "CT",
    primaryAndComponentEngagementPill: "PT/CT",
    // Scot build steps
    scotHeader: "SCOTs",
    searchScot: "חפש",
    manageScots: "נהל תתי תהליכים מהותיים (SCOT)",
    superModelStep1ScotMessage: "סעיפים מהותיים וגילויים משמעותיים ותתי תהליכים מהותיים (SCOTs) קשורים",
    scotRelatedITApplicationServiceOrg: "SCOTs ויישומי IT קשורים ולשכות שירות",
    noScotsAvailable: "לא נמצאו תוצאות",
    searchScotPlaceholder: "חפש",
    searchScotClearHoverText: "Clear",
    showOnlyUnrelatedScotToggleSwitch: "הצג רק כאלו שלא קשורים",
    newScot: "SCOT חדש",
    importFromKnowledgeScot: "ייבוא ​​SCOTs",
    importAccountsAndDisclosures: "ייבוא ​​סעיפים וגילויים",
    showOnlyAccountRelatedScot: "הצג רק SCOTs ללא כל קישור לסעיף מהותי ולגילוי משמעותי",
    warningMessageEstimateScotNotAssociatedWithEstimatedAccount: "כל אומדן SCOT חייב להיות קשור לפחות לסעיף מהותי אחד או לגילוי משמעותי עם אומדן. גרור ושחרר את ה-SCOT הזה לסעיף מהותי או לגילוי משמעותי רלוונטי.",
    warningMessageScotNotAssociatedWithAccount: "כל SCOT חייב להיות קשור לפחות לסעיף מהותי אחד או לגילוי משמעותי. גרור ושחרר את ה-SCOT הזה לסעיף מהותי או לגילוי משמעותי רלוונטי.",
    showvalidations: "הצג אימותים (validations)",

    scotRelatedWCGWandControls: "SCOTs ו-WCGWs ובקרות קשורות",
    newWcgw: "WCGW חדש",
    manageWCGWs: "ניהול WCGWs",
    manageControl: "נהל בקרות",
    importWCGWs: "ייבוא ​​WCGWs",
    relateWCGWs: "קשר WCGWs",
    newControl: "בקרה חדשה",
    importControl: "ייבא בקרה",
    importControls: "ייבא בקרות",
    relateControl: "קשר בקרות",
    scotStrategyIsControlMessage: "לא זוהו בקרות עבור WCGW זה. אסטרטגיית תת התהליך המהותי (SCOT) אינה מוגדרת.",
    scotStrategyIsWCGWMessage: "לא זוהו WCGWs עבור SCOT זה. אסטרטגיית SCOT אינה מוגדרת.",
    controlsPlaceholderWithNoRelatedWCGWsMessage: "כל SCOT חייב להיות קשור ל-WCGW אחד לפחות. צור",
    controlsPlaceholderWithNoRelatedControlsMessage: "כל WCGW חייב להיות קשור לבקרה אחת לפחות. צור",
    noITApplicationSOMessage: "לא זוהו יישומי IT או ארגוני שירות עבור SCOT זה. לחץ",
    relatedItAppSOHeaderMessage: "יישומי IT קשורים ולשכות שירות",
    substantivePlaceholderWithNoRelatedControlsMessage: "לא זוהו בקרות עבור תת תהליך (SCOT) זה. עבור SCOTs עם אסטרטגיה מבססת אין צורך לזהות בקרות.",
    substantivePlaceholderWithNoRelatedWCGWsMessage: "לא זוהה סיכון ( WCGW) עבור תת תהליך מהותי ( SCOT) זה. עבור SCOTs עם אסטרטגיה מבססת, יש לזהות WCGWs.",
    noITApplicationSOMessageText: "לקשר היכן שנדרש.",
    notSelected: "לא נבחר",
    or: "אוֹ",

    //WCGWControls
    showOnlyWCGWRelatedControls: "הצג רק כאלו שקשורים",

    createorRelateControl: "צור בקרה חדשה או קשר בקרה קיימת",

    //Accounts Scot build steps
    accountHeader: "סעיפים",
    searchAccount: "חפש חשבון",
    searchAccountPlaceholder: "חפש",
    manageAccounts: " ניהול חשבונות וגילויים",
    showOnlyUnrelatedAccountToggleSwitch: "הצג רק כאלו שלא קשורים",
    searchAccountClearHoverText: "Clear",
    noAccountsAvailable: "לא נמצאו תוצאות",
    showOnlyScotRelatedAccount: "הצג רק סעיפים מהותיים וגילויים משמעותיים ללא כל SCOT קשור",
    warningMessageEstimateAccountNotAssociatedWithEstimatedScot: "כל סעיף מהותי או גילוי משמעותי הכרוך באומדן חייב להיות קשור לתת תהליך מהותי אחד לפחות הכרוך באומדן ESTIMATE SCOT. גרור ושחרר SCOT רלוונטי קיים לסעיף מהותי זה או לגילוי משמעותי זה",
    warningMessageAccountNotAssociatedWithScot: "כל סעיף מהותי או גילוי משמעותי חייב להיות קשור לתת תהליך מהותי (SCOT) אחד לפחות. גרור ושחרר SCOT רלוונטי קיים לסעיף מהותי זה או לגילוי משמעותי זה",
    significantAccountsAndDisclosures: "סעיפים וגילויים משמעותיים",
    // Independence Only

    independenceOnlyStatus: "אי תלות בלבד",

    //Controls
    controlDesignEffectivenessWarningValidation: "הבקרות חייבות להיות עם הערכה של תכנון אפקטיבי (design effectiveness)",
    controlHeader: "SCOTs ובקרות קשורות",
    manageControls: "נהל בקרות",
    manageITApplications: "ניהול יישומי IT",
    searchControlClearHoverText: "Clear",
    searchControlPlaceholder: "חפש",
    noControlsAvailable: "לא נמצאו תוצאות",
    controlName: "שם בקרה",
    frequency: "תדירות",
    type: "סוג",
    newSO: "SO חדש",
    designEffectiveness: "Design Effectiveness",
    testing: "בודק",
    strategyTypeName: "Scot Strategy",
    controlTestingYes: "כן",
    controlTestingNo: "לא",
    effective: "יעיל",
    ineffective: "לא יעיל",
    noControlsResult: "לא נמצאו תוצאות",
    noControlsLabel: "לא נמצאו תוצאות",
    relatedControl: "בקרה קשורה",
    relateControls: "קשר בקרות",
    controlTypeValues: {
        itApplication: "בקרות יישומי IT",
        itDependentManual: "IT Dependent Manual Control",
        manualPrevent: "מונעת ידנית",
        manualDetect: "בקרה ידנית מגלה"
    },
    controlFrequencyTypes: {
        manyTimesPerDay: "הרבה פעמים ביום",
        daily: "יומי",
        weekly: "שבועי",
        monthly: "חודשי",
        quarterly: "רבעוני",
        annually: "שנתי",
        iTApplicationControl: " בקרת אפליקציית IT",
        other: "אחר"
    },
    filterTypeOfScots: "SCOTs",
    noScotsAvailable: "לא נמצאו תוצאות",


    onlyShowControlsWithNoDesignEffectiveness: "הצג רק בקרות ללא אפקטיביות בתכנון הבקרה שנבחרה",

    // control Tasks
    controlCount: "{0} בקרות",

    //Create and Edit WCGW
    wcgwInputName: "שם WCGW",
    editWCGW: "עריכת WCGW",
    createNewWCGW: "צור WCGW חדש",
    editTheWCGW: "ערוך את ה-WCGW",
    createEditWCGWSave: "שמור",
    createEditWCGWClose: "לְבַטֵל",
    createEditWCGWModelScot: "תת תהליך מהותי SCOT",
    newWCGWTitel: "WCGW חדש",
    wcgwNameIsRequired: "נדרש שם WCGW",
    deleteWCGW: "מחק את WCGW",


    //Audit Plan
    importPSPButtonText: "ייבא PSPs",
    commonContentUpdateSuccessMessage: "עדכון תוכן מתבצע. השלמת פעולה זו עשויה להימשך עד חמש עשרה דקות. רענן את הדף כדי לראות PSPs שיובאו לאחרונה.",
    responsivetoRisks: "מענה לסיכונים",
    procedures: "נהלים",
    toc: "TOC",
    significantandFraudRisksHeading: "סיכונים משמעותיים וסיכוני הונאה, והנהלים והבקרות כמענה לאותם סיכונים",
    risksBeingRespondedToByComponentTeam: "סיכונים מקבלים תגובה על ידי צוות/ים של הישויות המוחזקות.",
    responsivecontrolsandTOCs: "מענה באמצעות בקרות ובדיקת בקרות TOCs",
    ResponsivePSPOSP: "מענה באמצעות PSP/OSP",
    responsivePSPsOSPs: "מענה באמצעות PSPs/OSPs",
    responsiveTOC: "מענה באמצעות בדיקת בקרה TOC",
    responsiveControl: "מענה באמצעות בקרה",
    responsivePSPOPSMessage: "יש לזהות לפחות נוהל מבסס אחד ככזה הנותן תגובה למצג ההנהלה בגין סיכון זה. לחץ על {0} כדי לזהות מתן מענה באמצעות נהלים מבססים.",
    responsiveControlMessage: "יש לזהות לפחות בקרה אחת (עם הערכת אפקטיביות התכנון (design effectiveness) שהושלמה) כמענה למצג ההנהלה לגבי סיכון זה. לחץ על {0} כדי לזהות בקרות הנותנות מענה. לחץ על {1} כדי להגדיר את יעילות האפקטיביות או אסטרטגיית הבדיקה.",
    responsiveTOCMessage: "עבור מצגי הנהלה עם סיכון בקרה של Rely חייבת להיות מקושר לפחות בדיקת בקרה (TOC ) אחת כמענה לסיכון שהבקרה (1) לא מוגדרת ככזו בעלת סיכון נמוך יותר ו-(2) עם הערכת אפטיביות התכנון (dsign effctivenss) שהשולמה.  לחץ על<b>Responsive TOC</b> כדי לזהות מענה באמצעות בדיקות הבקרה (TOCs).",
    notcompleted: "לא הושלם",
    noResponsiveTOCAvailable: "לא זוהו בדיקות בקרה TOCs לצורך מתן מענה עבור בקרה זו.",
    refresh: "רענן נתונים",
	tocHoverOverWhenControlTestingHasNoorNotCompleted: "בקרה זו לא נבחרה לבדיקה. השתמש ב<b>נהל בקרות</b> בכדי לשנות את בחירת הבדיקה.",
	noresponsiveTOCIdentified: "לא זוהתה בדיקת בקרה TOC למתן מענה (responsive TOC).",
	taskAssertionnotModified: "מצגי ההנהלה הקשורים למשימה לא שונו. ערוך את קישורי מצגי ההנהלה בכדי להמשיך או לחץ על ביטול בכדי לצאת.",
    failedToEditRelatedAssertions: "לא הצליח לערוך את ההצהרות הקשורות למשימה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, צור קשר עם התמיכה הטכנית.",
    assertionCannotEdited: "מצגי הנהלה עם תיבת סימון (checkbox) מושבתת הוגדרו על ידי מתודולוגיית EY ולא ניתן לערוך אותן.",
    editAssertionInfoMessage: "הוסף או הסר מצגי הנהלה עבור המשימה. חייב להיבחר לפחות מצג הנהלה אחד.",
    editRelatedAssertions: "ערוך מצגי הנהלה קשורים",
    loweRiskHeader: "בסיכון נמוך",
    placeholderWhenControlTestingHasNotCompleted: "בקרה זו לא נבחרה לבדיקה. השתמש ב-{0} כדי לשנות את בחירת הבדיקה.",
    pspandOSP: "PSPs/OSPs",
    tocs: "בדיקת בקרות TOCs",
    norelatedAssertionPlaceHolder: "לכל סיכון משמעותי (SR) או סיכון הונאה (FR) חייב להיות לפחות מצג הנהלה אחד המזוהה ככזה הקשור לסיכון זה. לחץ על {0} כדי לזהות מצגי הנהלה קשורים.",
    assertionMustHaveOneControlWithCompleteDesignEffectiveness: "לכל מצג הנהלה חייבת להיות לפחות בקרה אחת עם אפקטיביות בתכנון שזוהתה ככזו המגיבה לסיכון ושהושלמה. לחץ על {0} כדי לזהות בקרה למתן תגובה  (responsive control).",
    controlRiskRelyNotLowerRisk: "לכל מצג הנהלה עם סיכון בקרה של Rely חייבת להיות לפחות בקרה אחת אשר (1) אינה מוגדרת כסיכון נמוך יותר, (2) עם אפקטיביות בתכנון הבקרה ו-(3) נבחרה לבדיקה. לחץ על {0} כדי לזהות בקרה למתן תגובה  (responsive control).",
    controlRiskRelyWithDesignEffectively: "לכל מצג הנהלה עם סיכון בקרה של Rely חייבת להיות לפחות בקרה אחת שתוכננה ביעילות (1) ו-(2) נבחרה לבדיקה. לחץ על {0} כדי לזהות  בקרה למתן תגובה  (responsive control).",

    assertionWithControlRiskNotRely: "לא נדרש לזהות בדיקות בקרה (TOC) עבור מצגי הנהלה עם סיכון בקרה של ​​Not Rely.",
    thisControlNotSelectedForTesting: "בקרה זו לא נבחרה לבדיקה. לחץ על {0} כדי לשנות את בחירת הבדיקה.",
    testControlRelatedToControlAsLowerRisk: "בדיקת הבקרה (TOC) הקשורה לבקרה המוגדרת כסיכון נמוך יותר לא תיתן את המענה לסיכון עבור מצג הנהלה זה.",
    testControlWithoutCompleteDE: "בדיקת הבקרה (TOC) הקשורה לבקרה ללא הערכה של תכנון אפקטיבי (design effectiveness) שהושלמה לא תיתן את המענה לסיכון של מצג הנהלה זה. לחץ על {0} כדי להגדיר את הערכת אפקטיביות התכנון (design effectiveness).",
    testControlrelatedToineffective: "בדיקת הבקרה (TOC) הקשורה לבקרה שזוהתה ככזו שאינה אפקטיבית בתכנון שלה לא תיתן מענה לסיכון של מצג הנהלה זה. לחץ על {0} כדי לשנות את הערכת אפקטיביות התכנון (design effectiveness).",
    anotherTestControlIdentified: "זוהתה בדיקת בקרה (TOC) נוספת ככזו הנותנת מענה לסיכון של מצג הנהלה זה ואין צורך לזהות בדיקות נוספות של בקרות. לא זוהו TOCs כמתן מענה עבור בקרה זו.",
    eachControlMustHaveOneToc: "כל מצג הנהלה עם סיכון בקרה של Rely חייבת להיות בעלת בדיקת בקרה (TOC) אחד לפחות הנותן מענה לסיכון עבור בקרה ש (1) אינה מוגדרת כסיכון נמוך יותר, (2) אפקטיבית בתכנון שלה (designed effectively) ו-(3) נבחרה לבדיקה. לא זוהו TOCs ככאלו הנתונים מענה עבור בקרה זו. לחץ על {0} כדי לזהות TOCs ככאלו הנתונים מענה .",
    eachAssertionControlHaveAtleasetOneTOC: "כל מצג הנהלה עם סיכון בקרה של Rely חייבת להיות בעלת TOC אחד לפחות הנותן מענה לסיכון עבור בקרה ש (1) אפקטיבית בתכנון שלה (designed effectively)  ו-(2) נבחרה לבדיקה. לא זוהו TOCs ככאלו הנתונים מענה עבור בקרה זו. לחץ על {0} כדי לזהות TOCs ככאלו הנתונים מענה .",
    norepsonsivePSPOSPplaceholder: "לכל מצג הנהלה חייב להיות לפחות נוהל מבסס אחד המזוהה ככזה הנותן מענה לסיכון זה. לחץ על {0} כדי לזהות נוהל מבסס למתן מענה (responsive substantive procedure).",

    //Reject Task
    rejectPspModalTitle: "דחה PSP",
    rationaleRequired: "נדרש",
    rationaleTextEditorLabel: "נימוק לדחיית PSP",
    rejectTaskErrorMessage: "לא ניתן לדחות את המשימה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, צור קשר עם התמיכה הטכנית.",
    rejectTaskModalHeader: "האם אתה בטוח שברצונך לדחות את ה-PSP שנבחר?",
    rejectTaskModaWarningText: "ראיות קשורות שאינן משויכות למשימות אחרות בהתקשרות זו יועברו לקבצים זמניים.",
    rejectTaskRationaleLabel: "רציונל (חובה)",

    // Adobe Analytics
    aaCookieConsentTitle: "ברוכים הבאים אל",
    aaCookieContentPrompt: "האם ברצונך לאפשר קבצי Cookie?",
	aaCookieConsentExplanation: '<p> בנוסף לעוגיות Cookie הנחוצות בהחלט להפעלת אתר זה, אנו משתמשים בסוגי Cookies הבאים כדי לשפר את חווייתך ואת שירותינו: <strong> קבצי Cookies פונקציונליים </strong> לשיפור חווייתך (למשל זכירת הגדרות), <strong> קבצי Cookie של ביצועים </strong> למדידת הביצועים של האתר ושיפור החוויה שלך, <strong> קבצי עוגיות של פרסום / פילוח </strong>, המוגדרים על ידי צדדים שלישיים שאיתם אנו מבצעים קמפיינים פרסומיים ומאפשרים לנו לספק לך פרסומות רלוונטיות עבורך. </p> <p> סקור את ה <a target="_blank" href="https://www.ey.com/en_us/cookie-policy"> מדיניות קובצי cookie </a> שלנו בנושא למידע נוסף. </p>',
	aaCookieConsentExplanationWithDoNotTrack: "<p> בנוסף לעוגיות Cookie הנחוצות בהחלט להפעלת אתר זה, אנו משתמשים בסוגי Cookies הבאים כדי לשפר את חווייתך ואת שירותינו: <strong>קבצי Cookie פונקציונליים</strong> כדי לשפר את החוויה שלך (למשל זכור הגדרות), <strong>עוגיות ביצועים</strong> למדידת ביצועי האתר ולשיפור חווייתך, <strong>קבצי עוגיות של פרסום / פילוח</strong>, המוגדרים על ידי צדדים שלישיים שאיתם אנו מבצעים קמפיינים פרסומיים ומאפשרים לנו לספק לך פרסומות רלוונטיות עבורך.</p><p>זיהינו שהפעלת את ההגדרה 'אל תעקוב' בדפדפן שלך; כתוצאה מכך, קובצי עוגיות של פרסום / פילוח מושבתים אוטומטית.</p><p>עיין ב<a target='_blank' href='https://www.ey.com/en_us/cookie-policy'>מדיניות קבצי העוגיות שלנו </a> למידע נוסף.</p>",
    aaCookieConsentDeclineOptionalAction: "אני דוחה קבצי Cookie אופציונליים",
    aaCookieConsentAcceptAllAction: "אני מאשר את כל קבצי ה- Cookie",
    aaCookieConsentCustomizeAction: "התאמה אישית של קבצי Cookie",
    aaCookieConsentCustomizeURL: 'https://www.ey.com/en_us/cookie-settings',

    //Task Sections
    taskSectionLabels: {
        taskSectionHeader: "קבוצות משימות ומשימות נלוות",
        manageTaskSections: "ניהול קבוצות משימות",
        taskSectionsAccordionHeader: "קבוצות משימות",
        phaseAccordionHeader: "שלב",
        tasksAccordionHeader: "משימות",
        rejectedAccordionHeader: "נִדחֶה",
        noRelatedTasksMessage: "אין PSTs/OSTs זמינים. צור {0} כדי להתחיל.",
        taskSectionTaskHeader: "משימות",
        newOSTButtonText: "OST חדש",
        cutomTaskSectionBadgeText: "מותאם אישית",
        rejectedTasksLabel: "PSTs שנדחו",
        additionalInfo: "הסבר לאפיון הסעיף",
        rejectButton: "דחה",
        acceptButton: "קבל",
        removeButton: "הסר",
        addButton: "הוסף",
        allPSTsRejectedMessage: "כל ה-PSTs נדחו.",
        rejectModalTitle: "דחה PST",
        rationaleTextEditorLabel: "רציונל לדחיית PST",
        rejectTaskModalHeader: "האם אתה בטוח שאתה רוצה לדחות את ה-PST שנבחר?",
        noResultsMessage: "לא נמצאו תוצאות",
        noTaskSetionsAvailableMessage: "אין מקטעי משימות זמינים",
        rejectTaskModaWarningText: "ראיות קשורות שאינן משויכות למשימות אחרות בהתקשרות זו יועברו לקבצים זמניים. אין אפשרות לדחות PSTs עם מסמכים שיובאו מה- EY Canvas.",
        rejectTaskRationaleLabel: "רציונל (חובה)"
    },

    // Cookie Settings
    cookieSettings: {
        title: "הגדרות קבצי cookie",
        explanation: "אנא ספק את הסכמתך לשימוש בקבצי cookie ב-ey.com ובפלטפורמת My EY. בחר אחד או יותר מסוגי קבצי ה- cookie המפורטים להלן, ולאחר מכן שמור את הבחירות שלך. עיין ברשימה למטה לפרטים על סוגי קבצי ה- cookies ומטרתם.",
        emptyCookieListNotice: "קובצי Cookie מקטגוריה זו אינם משמשים באפליקציה זו",
        nameTableHeader: "שם קובץ ה cookie",
        providerTableHeader: "ספק קובץ ה cookie",
        purposeTableHeader: "מטרת קובץ ה cookie",
        typeTableHeader: "סוג קובץ ה cookie",
        durationTableHeader: "משך קובץ ה cookie",
        formSubmit: "שמור את הבחירה שלי",
        requiredCookieListTitle: "קבצי cookies חובה",
        functionalCookieListTitle: "קבצי cookies פונקציונאליים",
        functionalCookieAcceptance: "אני מקבל את קבצי ה- cookies הפונקציונליים להלן",
        functionalCookieExplanation: "קבצי cookies פונקציונאליים, המאפשרים לנו לשפר את חווייתך (למשל על ידי זכירת כל ההגדרות שבחרת).",
        performanceCookieListTitle: "קבצי Cookies של ביצועים",
        performanceCookieAcceptance: "אני מקבל את קבצי ה- Cookies של הביצועים שלהלן",
        performanceCookieExplanation: "קובצי Cookie לביצועים, שעוזרים לנו למדוד את ביצועי האתר ולשפר את החוויה שלך. בשימוש בקבצי cookie לביצועים איננו אוגרים נתונים אישיים כלשהם, אלא רק משתמשים במידע שנאסף באמצעות קבצי cookie אלה בצורה מצטברת ואנונימית.",
        advertisingCookieListTitle: "פילוח קבצי cookie",
        advertisingCookieAcceptance: "אני מקבל את קבצי ה cookie לפרסום/פילוח להלן",
        advertisingCookieExplanation: "קבצי cookie לפרסום/פילוח, בהן אנו משתמשים כדי לעקוב אחר פעילות המשתמשים והפעולות שלהם בכדי שנוכל לספק שירות מותאם אישית יותר, ו(במקרה של קבצי cookie לפרסום) אשר נקבעות על ידי הצדדים השלישיים איתם אנו מבצעים קמפיינים פרסומיים ומאפשרים לנו לספק פרסומות רלוונטיות עבורך.",
        doNotTrackNotice: "זיהינו שהפעלת את ההגדרה 'אל תעקוב' בדפדפן שלך; כתוצאה מכך, קבצי עוגיות של פרסום / פילוח מושבתים אוטומטית.",
    },

    //Task Sections and related Tasks
    taskSectionAndRelatedTask: "מקטעי משימות ומשימות קשורות",
    manageTaskSections: "נהל קטעי משימות",

    // Financial Statments
    financialStatementLabels: {
        financialStatements: "דוחות כספיים",
        trialBalance: "מאזן בוחן",
        okButton: "אשר",
        leadSheet: "גיליון ראשי (Lead sheet)",
        balanceSheet: "מאזן",
        incomeStatement: "דוח רווח והפסד",
        eyreferences: "הפנייה",
        currenPeriod: "תאריך Analysis",
        comparativePeriod: "תאריך השוואתי",
        changeFrom: "שנה מ",
        percentageChangeFrom: "% שינוי מ",
        notesColumn: "הערות",
        viewTrialBalanceType: "הצג לפי סוג מאזן בוחן",
        multiEntity: "ריבוי ישויות",
        placeHolderText: "חיפוש מחלקות חשבון",
        currencyType: "סוג המטבע",
        currencyCode: "קוד מטבע",
        businessUnit: "יחידה עסקית",
        periodEnded: "תאריך סיום",
        periodsEnded: "תאריכי סיום",
        searchGLAccountPlaceholder: "חפש חשבונות GL",
        eyReferenceDocuments: "{0} מסמכים",
        relatedNotes: "הערות קשורות",
        notAvailable: "לא זמין",
        significantDisclosures: "גילויים משמעותיים",
        noResultFound: "לא נמצאו תוצאות",
        openEYHelixProjects: "פתח פרויקטים של EY Helix",
        openAdjustmentModule: "פתח את מודול ההתאמה",
        goToSubstantiveProcedureLink: "עבור לנהלים מבססים",
        cancel: "בטל",
        remove: "הסר"
    },

    financialStatementsClassView: {
        bulk: "כמות גדולה",
        eyAccount: "חשבון EY",
        placeHolderText: "חפש בחשבונות GL",
        noAccountDesignation: "ייעוד החשבון לא הוגדר.",
        insignificantLeadSheetMessage: "גיליונות ראשיים (Lead sheets) אינם מוצגים עבור חשבונות לא מהותיים (insignificant accounts)",
        unmappedGLAccounts: "גיליונות ראשיים (Lead sheets) אינם מוצגים עבור חשבונות שלא מופו",
        unmappedAccountText: 'Unmapped'
    },
    financialStatementTypeIds: [{
            id: 1,
            label: "נכסים"
        },
        {
            id: 4,
            label: "התחייבויות"
        },
        {
            id: 7,
            label: "הון "
        },
        {
            id: 8,
            label: "הַכנָסָה"
        },
        {
            id: 9,
            label: "הוצאות"
        },
        {
            id: 17,
            label: "רווח נקי"
        }
    ],
    copyrightMessage: "זכויות יוצרים © <year> כל הזכויות שמורות",
    createNotes: {
        notesPlaceholderText: "הוסף הערות על ידי לחיצה על {0} או {1}.",
        newNote: "הוסף הערה",
        relateNote: "הערה קשורה",
        addNewNotesHeader: "הזן את פרטי ההערה למטה ובחר <b>\'שמור וסגור\'</b> כדי לסיים. כדי ליצור הערה נוספת, בחר <b>\'שמור וצור עוד\'</b>.",
        noteIndex: "אינדקס",
        noteIndexRequired: "אינדקס (חובה)",
        noteDescription: "תיאור",
        noteDescriptionRequired: "תיאור (חובה)",
        saveAndClose: "שמור וסגור",
        newTickmarkDescription: "בחר את הסיבה לכך שאין ראיות המופנות לחשבון GL זה.",
        newTickmarkBulkModalDescription: " בחר את הסיבה לכך שאין ראיות המופנות לחשבונות GL שנבחרו."
    },
    deleteNotes: {
        deleteNote: "מחק הערה",
        deleteNoteTitle: "האם הינך בטוח שברצונך למחוק את ההערה שנבחרה?",
        delete: "מחק",
        cancel: "בטל"
    },
    editNotes: {
        editNote: "ערוך הערה",
        editNotesHeader: "ערוך את פרטי ההערה למטה ובחר <b>\'שמור וסגור\'</b> כדי לסיים.",
        edit: "ערוך",
        cancel: "בטל"
    },
    notesListLabels: {
        actions: "פעולות",
        noteCount: "הערה {0}",
        notesCount: "{0} הערות"
    },
    relateNotes: {
        relateNoteLabel: "הערה קשורה",
        searchPlaceholder: "חפש",
        accountLabel: "סעיף",
        indexLabel: "אינדקס",
        descriptionLabel: "תיאור",
        addedLabel: "נוסף",
        showOnlyRelatedLabel: "הצג רק כאלו שקשורים",
        noResultsFoundMessage: "לא נמצאו תוצאות",
        noteCount: "הערה {0}",
        notesCount: "{0} הערות",
        closeBtnTitle: "סגור"
    },
    uploadEvidenceDocuments: {
        addnewEvidencesPlaceholderandLinks: "הוסף ראיות על ידי לחיצה על {0}, {1} או ציין כי לא נדרשות ראיות על ידי לחיצה על {2}.",
        newEvidence: "ראיה חדשה",
        relateEvidence: "קשר ראיות",
        newTickMark: "tickmark חדש",
        relateTasks: 'Relate task',
        noTasksSeleted: "בחר משימה כדי להמשיך.",
        relateTaskPlaceholder: "הפניות חדשות חייבות להיות קשורות למשימה אחת לפחות. בחר משימה שאליה יש להוסיף את המסמך הזה כראיה.",
        confirmButtonTitle: "המשך",
        closeButtonTitle: "בטל",
        noResultsFound: "לא נמצאו תוצאות",
        taskType: "סוג",
        taskName: "שם משימה",
        taskCount: "{0} משימה",
        tasksCount: "{0} משימות",
        title: "הפנייה",
        removeReference: "הסר הפניה"
    },
    glAccountAssociatedNotes: {
        aggregatedNotesPlaceholder: "אין הערות זמינות. בחר חשבון GL כדי ליצור הערה.",
        notes: "הערות",
        relatedGlAccountPlaceholder: "חשבונות GL קשורים"

    },
    finacialStatementsBulkOperations: {
        relateEvidenceLabel: "קשר ראיות",
        selectedCountGLAccount: "נבחר חשבון GL {0}",
        selectedCountGLAccounts: "נבחרו {0} חשבונות GL",
        selectAll: "בחר הכל",
        deselectAll: "בטל את כל הסינונים",
        exitBulkMode: "צא ממצב כמות גדולה",
        noGLAccountsSelectedValidationMessageEvidence: "בחר לפחות חשבון GL אחד כדי לקשר ראיות או לחץ על צא ממצב בכמות גדולה.",
        noGLAccountsSelectedValidationMessageTickmark: "בחר לפחות חשבון GL אחד לסימון tickmark חדש או לחץ על צא ממצב בכמות גדולה.",
        noGLAccountsSelectedValidationMessageRemoveReference: "בחר לפחות חשבון GL אחד כדי להסיר הפניה או לחץ על צא ממצב בכמות גדולה.",
        relateTickmarkLabel: "סימון חדש",
        removeReferenceLabel: "הסרת הפניה",
        removeReferenceConfirmationMsg: "אשר אם ברצונך להסיר הפניות עבור כל חשבונות GL שנבחרו."

    },
    financialStatementsFilters: {
        referenceFilterKey: "חשבונות GL להם חסרות הפניות",
        accountFilterKey: "חשבונות GL ללא מיפוי",
        noResultsPlaceholder: "לא נמצאו תוצאות",
        trialBalance: "מאזן בוחן",
        noneAvailable: "אף אחד לא זמין",
        search: "חפש",
        multityEntity: "ריבוי ישויות",
        placeHolderMessageWhenHelixMappingIsTrue: "אין מאזן בוחן (TB) מיובא. לחץ על {0} כדי לקשר כלי ניתוח (analyzer) חדש.",
        placeHolderMessageWhenHelixMappingIsFalse: "אינטגרציה עם EY Helix אינה זמינה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
		eyHelixIntegrationLinkText: "אינטגרציה של EY Helix",
        noEntitiesAvailablePlaceholder: "לא נוצרו ישויות. צור ישויות כדי להתחיל."
    },
    //Group instructions
    assertionTabButton: "יעדי ביקורת",
    inherentRiskFactorButton: "גורמי סיכון מובנה",
    accountsAndDisclosure: "חשבונות/גילויים",
    assertions: "יעדי ביקורת",
    assertionC: "C",
    assertionEO: "E/O",
    assertionMV: "M/V",
    assertionRO: "R&O",
    assertionPO: "P&D",

    complexity: "מורכבות",
    subjUncertainty: "רמת אי הוודאות",
    fraudOrError: "הונאה או טעות",
    change: "שינוי",
    natureOfAccount: "אופי החשבון",
    relatedParties: "צדדים קשורים",
    higherInherentRiskLabel: "סיכון מובנה גבוה יותר",
    lowerInherentRiskLabel: "סיכון מובנה נמוך יותר",
    relevantLabel: "סיכון קשור",
    relevantContributeLabel: "סיכון מקושר הגורם לסיכון שבמהות  להיות גבוה יותר",
    incompleteInherentRiskTooltip: "סיכון מובנה בלתי שלם",
    estimateLabel: "אומדן",
    riskAssociatedLabel: "סיכון קשור",
    greaterExtentLabel: "במידה רבה יותר",
    lesserExtentLabel: "במידה פחותה",
    accordionNoRiskLabel: "אין סיכון הקשור למצג הנהלה (assertion) זה של החשבון.",
    accordionNoRiskAccountLabel: "אין סיכון הקשור לחשבון זה",
    accordionNoAssertionsLabel: "אין מצגי הנהלה הקשורים לחשבון זה.",
    accordionLimitedRiskLabel: "החשבון זוהה כחשבון בסיכון מוגבל (LRA).",

    maps: "מפות",
    financialStatements: "דוחות כספיים",
    serviceGatewayAutomation: "שער שירות (Service Gateway) ואוטומציה",
    manageTaskGroups: "ניהול קבוצות משימות",
    openAssignmentsLabel: "משימות פתוחות",
    inProgressAssignmentsLabel: "הקצאות בתהליך עבודה",
    // My Progress collaboration view.
	calendarDays: [
		"יוֹם רִאשׁוֹן",
		"יוֹם שֵׁנִי",
		"יוֹם שְׁלִישִׁי",
		"יום רביעי",
		"יוֹם חֲמִישִׁי",
		"יוֹם שִׁישִׁי",
		"יום שבת"
	],
	calendarMonths: [
		"ינואר",
		"פברואר",
		"מרץ",
		"אפריל",
		"מאי",
		"יוני",
		"יולי",
		"אוגוסט",
		"ספטמבר",
		"אוקטובר",
		"נובמבר",
		"דצמבר"
	],
    myProgressToday: "היום",
    noDueDateAssignedGroup: "לא הוקצה תאריך יעד",
    myProgressStatusTile: {
        yourRequests: "הבקשות שלך",
        totalCount: "ספירה כוללת",
        requestStatus: "מצב בקשה",
        draft: "טיוטה",
        pending: "ממתין",
        received: "התקבל",
        accepted: "התקבל",
        overdue: "תאריך היעד חלף",
        noRelatedTasks: "{0} ללא משימות קשורות",
        oneNoRelatedTask: "1 ללא משימה קשורה",
        addRequest: "בקשה חדשה",

        //Requests dues tile 2
        pendingRequestsByDueDate: "בקשות ממתינות עד תאריך היעד",
        requestsYAxisLabel: "בקשות",
		requestsXAxisLabel: "ימים,",
		tooltipDaysLabel: "ימים,",
        tooltipTotalLabel: "סַך הַכֹּל:",
        normalLabel: "נוֹרמָלִי",
        highLabel: "High",
        criticalLabel: "Critical",
        overdueLabel: "תאריך היעד חלף",
        overDueCatFirst: "איחור > 90",
        overDueCatSecond: "איחור 31-90",
        overDueCatThird: "איחור 10-30",
        overDueCatFourth: 'Overdue 1-9',
        catFifth: '1-9',
        catSixth: '10-30',
        catSeventh: '31-90',
        catEighth: '> 90',
        noRequestsFound: "לא נמצאו בקשות",
        daysOverdue: 'Days overdue',
        daysComingDue: 'Days coming due'
    },
    documentAttributeReference: {
        name: "שם",
        notes: "הערות",
        signOffs: "Sign-offs",
        tasks: "משימות קשורות",
        open: "פתח",
        openReadOnly: "פתוח לקריאה בלבד",
        delete: "מחק",
        rename: "שנה שם",
        signOffRequirements: "דרישות חתימה",
        confidentiality: "סודיות",
        unlink: "בטל קישור",
        relateTasks: "קשר משימות"
    },
    aiChatbot: 'EYQ Assurance Knowledge',
    selectDueDate: "בחר תאריך יעד",
    daysOverdue: 'Days overdue',
    daysComingdue: 'Days coming due',
    loadingDataMessage: 'Loading data... this may take a few seconds'
};

/*RBAC Errors*/
export const RbacErrors = {
    106: "הארכיב נכשל בעת המתנה להודעת הארכיב, אנא נסה שוב. אם הבעיה ממשיכה, אנא פנה לתמיכה הטכנית."
};

/*Errors*/
export const Errors = {
    /*Doc Helper Custom Messages */
    0: "החיבור אבד. התחבר מחדש ונסה שוב. אם הבעיה נמשכת, פנה לדלפק העזרה (Help desk).",
    101: "סטטוס תיק ביקורת לא חוקי",
    102: "לא נמצא משתמש תיק ביקורת חוקי",
    103: "לא הושלמו דרישות אי תלות של המשתמש (Engagement User Independence) בתיק הביקורת",
    104: "חסרים Azure AD Scopes נדרשים",
    105: "אירעה שגיאה בקבלת הרשאות תיק הביקורת. רענן את הדף ונסה שוב. אם הבעיה נמשכת, אנא פנה לתמיכה הטכנית.",
    106: "אין לך את ההרשאות הנדרשות לביצוע פעולה זו.",
    107: "משתמש מעורבות חוקי לא נמצא. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לדלפק העזרה.",
    108: "פרופיל ההתקשרות אינו שלם. נא עבור לדף הפתיחה והשלם את הפרופיל.",
    303: "מסך עם שם זהה הועלה כעת.",
    401: "לא ניתן להשלים את הפעולה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה אל התמיכה הטכנית.",
    403: "הוא פורמט קובץ שאינו נתמך ולא הועלה. שמור מחדש את המסמך בפורמט קובץ חוקי ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית (Help Desk).",
    410: "מסמך זה נמחק ולכן לא ניתן לפתוח אותו.",
    411: "מסמכים ריקים אינם מותרים.",
    412: "מסמך עם שם זהה כבר קיים בתיק הביקורת הזה.",
    413: "המסמך חורג מגודל הקובץ המרבי המותר (250MB) ולא ניתן להעלותו. הקטן את גודל הקובץ ונסה שוב.",
    500: "החיבור אבד. התחבר מחדש ונסה שוב. אם הבעיה נמשכת, פנה לדלפק העזרה (Help desk).",
    414: "השם חורג מהאורך המרבי ({0} תווים).",
    600: "לא ניתן להשלים את הפעולה בשלב זה. רענן את הדף ונסה שוב. אם הבעיה נמשכת פנה לתמיכה הטכנית.",
    601: "קיים מסמך בעל שם זהה.",
    602: "המסמך כבר נמצא בשיתוף פעולה",
    603: "המסמך לא נמצא.",
    'zip': "לא ניתן להעלות את קובץ ה- zip מכיוון שהוא מכיל סוג קובץ אחד או יותר שאינו נתמך, או שהוא מכיל יותר מהכמות המרבית של קבצי zip .",
    401000: "אותר שינוי ברשת, אנא טען מחדש את הדף כדי להמשיך",

    /*Accounts*/
    1001: "יצירת החשבון נכשלה.",
    1002: "חסר שם הסעיף.",
    1003: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1004: "לא נמצאו תוצאות. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    1005: "Engagement ID שגוי.",
    1006: "סוג סעיף לא חוקי.",
    1007: "סוג דוח לא חוקי.",
    1008: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1009: "הבקשה להציג סעיף לפי מזהה ID נכשלה.",
    1010: "הבקשה לחיפוש סעיף לפי מזהה תיק הביקורת נכשלה.",
    1011: "הבקשה להציג סיכום SEM למזהה ID לסעיף נכשלה, הואיל ואינה חוקית. ",
    1012: "סוג סיכום לא חוקי.",
    1013: "יצירת קריאה לסקירת הסעיף (Account Review) נכשלה.",
    1014: "מחיקת הקריאה לסקירת הסעיף (Account Review) נכשלה.",
    1015: "בקשת היצירה של סקירת הסעיף (Account Review) אינה חוקית.",
    1016: "מספר זיהוי ID סקירת חשבון לא חוקי.",
    1017: "החשבון אינו חלק מתיק ביקורת זה או שהוא נמחק.",
    1018: "סקירת הסעיף (Account Review) נוצרה על ידי משתמש אחר.",
    1019: "סעיף נמחק על-ידי משתמש אחר. רענן את הדף ונסה שוב.",
    1020: "נדרש לעדכן PSP לסעיף",
    1024: "שם הסעיף הוא יותר מ-500 תווים.",
    1025: "בלתי אפשרי שחשבון בסיכון מוגבל LRA או חשבון לא משמעותי Insignificant account יהיה מקושר לאומדן",
    1026: "הסעיף לא יכול לכלול מצגי הנהלה כפולים",
    1027: "מזהה מצג הנהלה (assertion) לא חוקי",
    1037: "לא יכולים להיות אינדקסים כפולים של PSP",
    1039: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1048: "סוג הביצוע של החשבון אינו חוקי.",
    1053: "לסעיף יש סיכון או אומדן משויך, לא ניתן להגדיר אותו כחשבון בסיכון מוגבל ( Limited Risk Account) או לחשבון לא משמעותי (Insignificant Account).",
    1054: "מצגי הנהלה שיש למחוק היו קשורים לסיכון או אומדן",
    1065: "לא ניתן לבצע שינויים במצגי ההנהלה שמקושרים אליהם סיכון משמעותי (SR), או סיכון הונאה (FR), או סיכון להצגה מוטעית מהותית (ROMM) או אומדן קשור. אתה צריך להסיר את היחסים האלה קודם.",

    1266: 'Engagement has reached maximum number of multi-edit mode documents.  Check some documents back in and try again.  If the issue persists contact the Help Desk.',
    1267: 'Document is conflicted. Resolve conflicts and try again.  If the issue persists, contact the Help Desk.',
    1268: 'Document is already in co-edit mode. end co-edit mode and try again.  If the issue persists, contact the Help Desk.',
    1269: 'Document is a shared evidence. Unlink and try again.  If the issue persists, contact the Help Desk.',

    /*Assertions*/
    2001: "הבקשה ליצירה לא חוקית.",
    2002: "שם מצג ההנהלה (assertion) חסר.",
    2003: "חסר מצג הנהלה (assertion).",
    2004: "הבקשה להציג מצג הנהלה (assertion) נכשלה.",
    2005: "Engagement ID שגוי.",
    2006: "הבקשה להציג מצג הנהלה (assertion) לפי מזהה ID נכשלה.",
    2007: "הבקשה להציג מצג הנהלה (assertion) ל- WCGWs נכשלה.",
    2050: "מצג ההנהלה לא נמצא. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    /*Tags*/
    5120: "כתובת ה- URL של ARC לא הוגדרה. אנא נסה שוב. אם הבעיה ממשיכה, אנא פנה לתמיכה הטכנית.",
    5121: "שגיאת אימות ARC, רענן את הדף ופתור את האימות ונסה שוב את תהליך הארכיב. אם הבעיה ממשיכה, אנא פנה לתמיכה הטכנית.",
    5123: "שיוך תגים כפול",
    5124: "שיוך תג לא נמצא",


    /*Risks*/
    4001: "לא היתה אפשרות להשלים את הפעולה כעת. רענן את הדף ונסה שוב. במידה והבעיה נמשכת, אנא פנה לתמיכה הטכנית. ",
    4002: "חסר שם הסיכון.",
    4003: "חסר סיכון.",
    4004: "הבקשה להציג סיכון נכשלה.",
    4005: "Engagement ID שגוי.",
    4006: "הבקשה להציג סיכון באמצעות מזהה ID נכשלה.",
    4007: "בקשת שאילתה לא חוקית.",
    4008: 'The selected Risk has been deleted. Close this modal to see the updated list.',
    4009: "בקשת עדכון לא חוקית.",
    4010: "כבר הוקצה WCGW ספציפי לסיכון זה",
    4011: "רשימת WCGW אינה יכולה להיות לא בתוקף.",
    4012: "נכשל הנסיון להגדיר סוגי סיכון.",
    4013: "הבקשה ליצירה לא חוקית.",
    4014: "מצג ההנהלה (assertion) המקושר אינו חוקי. אנא רענן את הדף ונסה שוב. אם שגיאה זו נמשכת, פנה אל התמיכה הטכנית.",
    4015: "ה- WCGW אינו חוקי. אנא רענן את הדף ונסה שנית. במידה ושגיאה זו נמשכת, אנא פנה לתמיכה הטכנית.",
    4016: 'The selected Risk has been deleted. Close this modal to see the updated list.',
    4017: "מצג ההנהלה (assertion) אינו זמין לסיכון. אנא רענן את הדף ונסה שוב. אם שגיאה זו נמשכת, פנה אל התמיכה הטכנית.",
    4018: "מזהה סוג הסיכון (risk type ID) שהועבר אינו חוקי.",
    4019: "שם הסיכון אינו חוקי.",
    4020: "מזהה המסמך (Document ID) לא חוקי.",
    4021: "שם הסיכון לא יכלול יותר מ -500 תווים.",
    4023: "רשימת מזהי מצגי ההנהלה לא יכולה להיות null.",
    4024: "לא ניתן ליצור טופס תיעוד לסיכון מוגבל עקב שגיאה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    4025: "Account Id שגוי.",
    4026: "מזהה מצג הנהלה (Assertion ID) לא חוקי.",
    4027: "AssertionRisk Modelלא יכול להיות ריק",
    4031: "אפשרות לא חוקית של סיכון או גוף טופס.",

    4035: "לא ניתן לערוך את IsHigherRisk עבור סיכוני משמעותי (SR) או סיכון הונאה (FR).",
    4036: "KnowledgeAssertionId לא יכול להיות ריק אם לא הועבר מזהה מצג הנהלה. KnowledgeAssertionId חייב להיות ב-enums",
    4037: "KnowledgeAssertionId כבר קיים עבור סעיף זה.",
    4038: "RiskTypeId אינו תואם לאפשרויות המותרות.",
    4040: "לא ניתן לבצע פעולה זו. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",

    /*TASK*/
    5001: "הבקשה 'חפש הכל' נכשלה.",
    5002: "משימה זו אינה זמינה עוד בהתקשרות זו.",
    5003: "הבקשה 'הצג מסמכים קשורים למשימה' נכשלה. הפרמטרים לבקשה לא חוקיים. ",
    5004: "הבקשה 'הצג מסמך קשור למשימה' נכשלה. הפרמטרים לבקשה לא חוקיים. ",
    5005: "הבקשה 'הצג משימה לפי מזהה ID' נכשלה.",
    5006: "הבקשה להציג קטגוריות משימה נכשלה.",
    5007: "הבקשה להציג משימת תת קטגוריות נכשלה. ",
    5008: "הבקשה להציג תיאור משימה נכשלה.",
    5009: "הבקשה להציג משימת בקשות לקוח נכשלה.",
    5010: "הבקשה לשמירת משימות ללקוח נכשלה.",
    5011: "המשימה שאתה מנסה לקשר פריטים אליה נמחקה או נדחתה.",
    5012: "הפריט שאתה מנסה לקשר נמחק.",
    5013: "המשימה שאתה מנסה לקשר פריטים אליה נמחקה או נדחתה.",
    5014: "המסמך שאתה מנסה לקשר נמחק.",
    5015: "הבקשה להציג משימת ראיות ביקורת נכשלה.",
    5016: "הבקשה להציג משימת WCGW נכשלה.",
    5017: "ה- Engagement ID אמור להיות גדול מ- 0.",
    5018: "לא ניתן לבצע פעולה זו. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    5019: "תיאור המשימה ריק",
    5020: "המשימה שנבחרה נמחקה או נדחתה. בהתאם, אין אפשרות להשלים פעולה זו בשלב זה.",
    5021: "מזהה  (ID) מקור תיק הביקורת חסר.",
    5022: "שמירת ההערה נכשלה",
    5023: "משתמש תיק הביקורת לא נמצא.",
    5024: "בקשה למחיקת משימה נכשלה.",
    5025: "בקשה למחיקת משימות נכשלה.",
    5026: "רשימת המשימות ריקה",
    5027: "לא נמצאו הערות סקירה.",
    5028: "נדרש שם קובץ.",
    5029: "סיומת הקובץ נדרשת.",
	5030: 'אין אפשרות לכלול בשם הקובץ: */:< > \ \? | \"',
    5031: "שגיאה בעת עדכון שם המסמך.",
    5032: "מזהה המסמך (Document ID) לא חוקי.",
    5033: "סוג הפעולה לא נמצא.",
    5034: "שינוי סטטוס המשימה נכשל",
    5035: "לא ניתן להשלים את הפעולה שאתה מנסה לבצע בשלב זה. נא נסה שוב מאוחר יותר. צור קשר עם דלפק העזרה (Help Desk) אם שגיאה זו נמשכת.",
    5036: "התוכן לא יכול להיות לא בתוקף או ריק בתא.",
    5037: "הבקשה אינה יכולה להיות ריקה או לא בתוקף.",
    5038: "הזן שם קובץ ייחודי כדי להמשיך.",
    5039: "נדרש שם קובץ.",
    5040: "שם הקובץ מוגבל ל-100 תווים.",
	5041: 'אין אפשרות לכלול בשם הקובץ: */:< > \ \? | \"',
    5042: "המשימה שנבחרה נדחתה.",
    5043: "המשימה היא תת-תהליך של מספר משימות.",
    5044: "המשימה היא משימת סיום שלב (Milestone Task).",
    5045: "המשימה היא לא מסוג PSP או OSP.",
    5046: "חריגה ממגבלת התווים.",
    5047: "חריגה ממגבלת התווים.",
    5048: "שדה חובה.",
    5049: "אין אפשרות להסיר את המסמך שנבחר ממשימה זו. אנא רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה אל התמיכה הטכנית.",
    5050: "מזהה  (ID) משימת קבוצה לא יכול להיות אפס או לא חוקי",
    5051: "מזהה מקטע המשימה (Task section ID) אינו אמור להיות אפס או לא חוקי",
    5052: "שגיאה בעת ניסיון להוסיף מסמך זה לפעילות הנוכחית. הבקשה נכשלה.",
    5053: "שגיאה בעת ניסיון לעדכן מסמך זה במשימה הנוכחית. הבקשה נכשלה.",
    5054: "שגיאה בעת ניסיון להוסיף עותק של מסמך זה במשימה הנוכחית. הבקשה נכשלה.",
    5055: "שגיאה בעת ניסיון לשנות את שם המסמך. הבקשה נכשלה.",
    5056: "אין אפשרות לערוך את כותרת המשימה עבור לידע כללי או משימת קבוצה",
    5057: "סוג המשימה אמור להיות מסוג Ost",
    5058: "לא ניתן להסיר את המסמך הזה מהמשימה מכיוון שהוא משויך למערכת.",
    5059: "ערך ה- Time Phase לא חוקי.",
    5060: "שגיאה בהוספת ראיית ביקורת. הבקשה נכשלה.",
    5061: "משתמש אחר עדכן את המידע המוצג. רענן את הדף ונסה שוב. אם השגיאה נמשכת, פנה אל התמיכה הטכנית.",
    5062: "המסמך המבוקש אינו זמין עבור הערוץ (Channel) שנבחר לתיק הביקורת שלך ב- EY Atlas. אנא צור קשר עם התמיכה הטכנית (Help Desk) על מנת שיינתן מידע לכותבי התוכן לצורך הכללתם בעתיד.",
    5063: "פעולת תיקון לא חוקית.",
    5064: "המשימה שנבחרה נמחקה או נדחתה. בהתאם, אין אפשרות להשלים פעולה זו בשלב זה.",
    5065: "אין אפשרות לעדכן את סוג מקור המשימה. הבקשה שגויה.",
    5066: "תקלה בקבלת ההנחיות. הבקשה נכשלה.  ",
    5067: "אין אפשרות לעדכן את סוג אופי המשימה. הבקשה שגויה.",
    5068: "אין אפשרות לעדכן את סוג אופי המשימה. הבקשה שגויה.",
    5069: "מחק הקצאת משימה שנכשלה.",
    5070: "אחת או יותר מהמשימות שנבחרו נמחקו. אנא נסה שוב או צור קשר עם התמיכה הטכנית אם השגיאה נמשכת.",
    5071: "אין אפשרות לעדכן את ההקצאה. הבקשה שגויה.",
    5072: "לא נמצא מכין. הבקשה שגויה.",
    5073: "לא נמצאה הקצאה.",
    5074: "שמירת המשימה שהוקצתה נכשלה",
    5075: "לחבר הצוות או לבעל התפקיד שנבחר לא יכולה להיות הקצאה כפולה למשימה(ות) שנבחרו. בחר הקצאה, חבר צוות או בעל תפקיד אחר כדי להמשיך. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    5076: "חברת הצוות הנבחר אינו חבר פעיל בתיק ביקורת זה. אנא נסה שנית או צור קשר עם התמיכה הטכנית אם השגיאה נמשכת.",
    5077: "אחת או יותר מהמשימות שנבחרו נמחקו. אנא נסה שוב או צור קשר עם התמיכה הטכנית אם השגיאה נמשכת.",
    5078: "הקצאת המשימה הנבחרת הוסרה. אנא נסה שוב או צור קשר עם התמיכה הטכנית אם השגיאה נמשכת.",
    5079: "אחת או יותר מהמשימות שנבחרו נמחקו. אנא נסה שוב או צור קשר עם התמיכה הטכנית אם השגיאה נמשכת.",
    5080: "רשומת גרסת המסמך אינה קיימת.",
    5081: "לא ניתן להקצות מחדש משתמש אשר כבר הוקצה למשימה. נסה שנית או צור קשר עם התמיכה הטכנית במידה והבעיה נמשכת.",
    5082: "העדכון נכשל. שם המסמך צריך להיות ייחודי עבור ההתקשרות. יש לרענן את הדף כדי להסיר הודעה זו.",
    5083: "חריגה ממגבלת כמות תוים למשימה.",
    5084: "הבקשה ליצירת הקובץ עבור משימה זו נכשלה.",
    5085: "הבקשה למחיקת מסמך משימה נכשלה.",
    5086: "הבקשה ליצירת משימה להעברה נכשלה.",
    5087: "הבקשה למשימת תיקון תוכן נכשלה.",
    5088: "משימה זו חייבת להכיל ראיות למסירה. נסה שוב או צור קשר עם דלפק העזרה (Help Desk).",
    5089: "כל הראיות הקשורות למשימה זו (למעט paper profiles) חייבות לכלול לפחות מכין אחד (preparer) ובודק אחד (reviewer) כדי לסמן שהושלם. נסה שוב ופנה לדלפק העזרה (Help Desk) אם השגיאה נמשכת.",
    5091: "שם paper profile כבר קיים בתיק הביקורת.",
    5092: "השם אינו יכול להכיל את אחד מהתווים הבאים: */:<>\\?|\\",
    5093: "שם paper profile חורג מהאורך המירבי (100 תווים).",
    5101: "יצירת משימה נכשלה.",
    5102: "תיאור המשימה חסר.",
    5103: "חסרה שם המשימה.",
    5104: "חסר שלב הזמן של המשימה.",
    5105: "לא ניתן לערוך את קישור המשימה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    5106: "שלב הביקורת אינו חוקי.",
    5107: "שלב הביקורת צריך להיות 'היקף ואסטרטגיה' או 'ביצוע'.",
    5108: "תיאור המשימה ארוך מדי.",
    5109: "פרמטר סוג תפקיד לא חוקי.",
    5110: "מזהה המשימה חייב להיות גדול מאפס.",
    5111: "הפריט שאליו אתה מנסה לקשר משימות נמחק. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    5112: "הפריט שאליו אתה מנסה לקשר משימות נמחק. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    5113: "הפריט שאליו אתה מנסה לקשר משימות נמחק. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    5116: "סוג מסמך אינו חוקי",
    5119: "סטטוס המשימות עבור אחת או יותר מהמשימות שנבחרו לא עודכן. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית (Help Desk) אם השגיאה נמשכת.",
    5127: "לא ניתן להשלים את השיוך. רענן את הדף ונסה שוב. אם הבעיה נמשכת, צור קשר עם התמיכה הטכנית.",
    5129: "לא ניתן להשלים את השיוך. רענן את הדף ונסה שוב. אם הבעיה נמשכת, צור קשר עם התמיכה הטכנית.",
    5133: "לא ניתן להשלים את השיוך. רענן את הדף ונסה שוב. אם הבעיה נמשכת, צור קשר עם התמיכה הטכנית.",
    5137: "לא ניתן לערוך את קישור המשימה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    5138: "לא ניתן לערוך את קישור המשימה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    5140: "לא ניתן לערוך את קישור המשימה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    5146: "כדי לסמן משימה שהושלמה, כל הראיות המשויכות (למעט paper frofiles) חייבות להיות בעלות חתימת מכין וסוקר אחד לפחות. רענן את הדף ונסה שוב. פנה  לתמיכה הטכנית אם השגיאה נמשכת.",
    5150: "אין אפשרות לקשר אוטומציה אחת או יותר למשימה שנבחרה כעת. רענן את הדף ונסה שוב. אם השגיאה נמשכת, פנה לתמיכה הטכנית.",
    5156: "לא ניתן לערוך את קישור המשימה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    5157: "לא ניתן לערוך את קישור המשימה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    5159: "סוג המסמך המשותף אינו חוקי.",
    5160: "אירעה שגיאה בעת ניסיון לקשר את המסמך. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    5174: "המשימה חייבת להיות קשורה לישות אחת או יותר. כדי להפוך את המשימה לרוחבית בהתקשרות, שנה את הלחצן 'משימות לפי ישות'.",
    5184: "סוג המשימה אינו  Primary Standard Task או Primary Substantive Procedure (PST/PSP).",
    5185: "לא ניתן לדחות משימה עם מסמכים שיובאו מה-EY Canvas.",
    5188: "מסמך לא חוקי או ביטול קישור מתבצע.",
    5189: "למשימה יש מסמכים שהם Linked Evidence או Linked Response.",
    5190: "למשימה צריך להיות מקושר מצג הנהלה אחד לפחות.",
    5191: "לא ניתן להשלים את השיוך. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לעזרה הטכנית.",
    5192: "הפריט שאליו אתה מנסה לקשר משימות נמחק. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    5193: "הפריט שנבחר נמחק. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",


    /*WCGW*/
    6001: "יצירת WCGW נכשלה.",
    6002: "חסר שם WCGW.",
    6003: "חסר WCGW.",
    6004: "קבלת ה- WCGW נכשל.",
    6005: "Engagement ID שגוי.",
    6006: "לא ניתן היה להשלים את הפעולה המבוקשת, מכיוון שמזהה הטענה אינו חוקי או נמחק. רענן את הדף ונסה שוב.",
    6007: "הבקשה להציג WCGW לפי מזהה ID נכשלה.",
    6008: "בקשה לא חוקית.",
    6009: "לא ניתן היה להשלים את הפעולה המבוקשת, מכיוון שמזהה WCGW אינו חוקי או נמחק. רענן את הדף ונסה שוב.",
    6010: "לא היתה אפשרות לשייך את המשימה ל-WCGW.",
    6011: "ה- WCGW שנבחר נמחק.",
    6012: "המשימה וה- WCGW לא מקושרים לאותו מצג הנהלה (assertion).",
    6013: "המשימה שנבחרה לא שייכת לאותו תיק ביקורת.",
    6014: "לא ניתן היה לנתק את המשימה מה- WCGW.",
    6015: "לא היתה אפשרות לשייך את המשימה ל-WCGW.",
    6016: "משימה זו נדחתה ולכן אינה יכולה להיות משויכת ל WCGW. ",
    6017: "המשימה אינה משימת סיום שלב (Milestone Task), ולכן אינה יכולה להיות משויכת ל WCGW.",
    6018: "המשימה אינה תת-תהליך של מספר משימות (build step task) ואינה יכולה להיות משויכת ל- WCGW.",
    6019: "המשימה אינה PSP / OSP, ולכן אינה יכולה להיות משויכת ל WCGW.",
    6020: "המשימה ו- WCGW משויכים לאותו יעד ביקורת ולא ניתן לשייך ל- WCGW.",
    6027: "מזהה WCGW או מזהה בקרה לא חוקיים.",
    6028: "לא ניתן להשלים את השיוך. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לעזרה הטכנית.",
    6029: "לא ניתן להשלים את ההסרה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לעזרה הטכנית.",

    /*Engagement*/
    7001: "הבקשה באמצעות מספר  ID לא נמצא.",
    7002: "קבלת תיקי ביקורת על ידי מספר מספר  נכשלה",
    7003: "קבלת בקשות כל יישויות תיקי הביקורת נכשלה.",
    7004: "קבלת תיק ביקורת על ידי מספר מספר  נכשלה.",
    7005: "קבלת בקשות כל משתמשי תיקי הביקורת נכשלה.",
    7006: "שם המשפחה לא יכול לעלות על 250 תווים",
    7007: "Invalid User Type Error.",
    7008: "השם הפרטי לא יכול לעלות על 250 תווים",
    7009: "מספר ה- GUI של המשתמש לא יכול להיות null.",
    7010: "Invalid User Status Error",
    7011: "בקשה ליצירת משתמש תיק ביקורת נכשלה",
    7012: "{0} {1} לא יכולים להיות מוזמנים מכיוון שהוא/היא כבר חברי צוות פעילים או ממתינים.",
    7013: "ראשי התיבות לא יעלו על 3 תווים",
    7014: "לא ניתן לגשת לדף הבית (Landing Page) של EY Canvas כעת. נסה שוב ואם הבעיה נמשכת , צור קשר עם התמיכה הטכנית (help desk).",
    7015: "לא ניתן להזמין {0} {1} כקבוצת הגישה(ות) הבאה(ות): {2} נמחקו מתיק הביקורת. רענן ונסה שוב.",
    7016: "לא ניתן להזמין {0} {1} מכיוון שהמשתמש כבר חבר בצוות פעיל בקבוצות הגישה הבאות: {2}",
    7017: "הדומיין אינו אפשרי עבור הקבוצה(ות) הנבחרת(ות): {0}",
    7018: "כתובת דואר אלקטרוני אינה יכולה להיות null.",
    7019: "השם הפרטי אינו יכול להיות null.",
    7020: "שם משפחה אינו יכול להיות null",
    7021: "ראשי התיבות של המשתמש אינם יכולים להיות null.",
    7022: "המשרד הראשי של המשתמש אינו יכול להיות null.",
    7023: "שם הכניסה של המשתמש אינו יכול להיות null.",
    7024: "תפקיד המשתמש ב EY אינו יכול להיות null.",
    7025: "תפקיד המשתמש בהתקשרות אינו יכול להיות null.",
    7026: "לא ניתן להשלים את הפעולה. נסה שוב ואם הבעיה נמשכת צור קשר עם התמיכה הטכנית (help desk)",
    7027: "כתובת דואר אלקטרוני לא חוקית",
    7028: "בקשה לחיבור (patch) משתמש תיק הביקורת נכשלה.",
    7029: "משתמש תיק הביקורת - מספר זיהוי סטטוס מתשמש תיק הביקורת לא חוקי",
    7030: "משתמש תיק הביקורת - מספר זיהוי תפקיד משתמש תיק הביקורת לא חוקי",
    7031: "מספר זיהוי של משתמש אחד או יותר בתיק הביקורת לא נמצא",
    7032: "כתובת דואר אלקטרוני אינה יכולה להיות גדולה מ-250 תווים.",
    7033: "המשתמש המבוקש אינו יכול להיות Null.",
    7034: "Universal Message Processor Queue Failed.",
    7035: "ראשי התיבות לא יעלו על 3 תווים",
    7036: "השם הפרטי לא יכול לעלות על 250 תווים",
    7037: "שם המשפחה לא יכול לעלות על 250 תווים",
    7038: "בקשה ליצירת משתמש חיצוני נכשלה",
    7039: "לא ניתן להזמין משתמש אחד או יותר מכיוון שהם כבר חברי צוות פעילים או ממתינים. רענן את העמוד ונסה שוב, אם הבעיה נמשכת צור קשר עם התמיכה הטכנית (help desk)",
    7040: "השם הפרטי לא יכול לעלות על 250 תווים",
    7041: "שם המשפחה לא יכול לעלות על 250 תווים",
    7042: "ראשי התיבות לא יעלו על 3 תווים",
    7043: "GPN לא יכול להיות גדול מ 250 תווים.",
    7044: "GUI לא יכול להיות גדול מ 250 תווים.",
    7045: "קבלת משתמש חיצוני על פי מספר זיהוי ID נכשלה",
    7046: "המשתמש אינו יכול להיות null.",
    7047: "לא ניתן לשמור שינויים כעת. נסה שוב ואם הבעיה נמשכת, צור קשר עם התמיכה הטכנית (Help Desk).",
    7048: "ה- EY Canvas Landing Page אינו נגיש כעת והוא נדרש לעריכה. נסה שוב ואם הבעיה נמשכת, פנה אל התמיכה הטכנית (Help Desk).",
    7049: "הקריאה לעדכון משתמש תיק הביקורת נכשלה. ",
    7050: "לא ניתן להפוך את חברי הצוות ללא פעילים. לתיק הביקורת  חייב להיות לפחות חבר צוות אחד שיש לו את ההרשאות לניהול תיק הביקורת (Administer Engagement). עדכן את הבחירה שלך ונסה שוב. אם הבעיה נמשכת, פנה אל התמיכה הטכנית. ",
    7051: "קבלת משתמש פנימי על פי מספר זיהוי ID נכשלה",
    7052: "המשתמש לא נמצא.",
    7053: "הבקשה באמצעות מספר זיהוי ID ID' לא נמצא.",
    7054: "בקשה לקבלת קישורים מהירים על פי מספר זיהוי ID תיק ביקורת (engagement ID) נכשלה.",
    7055: "אין לך הרשאה להוסיף חברי צוות קודמים. פנה אל חבר צוות ביקורת אחר עם הרשאות מתאימות לבצע פעולה זו.",
    7056: "EY Canvas לא יכול לשמור שינויים כעת. נסה שוב ואם הבעיה נמשכת, צור קשר עם התמיכה הטכנית (Help Desk).",
    7057: "אין הרשאה להוסיף חברי צוות חדשים. פנה אל חבר צוות ביקורת אחר עם הרשאות מתאימות לבצע פעולה זו.",
    7058: "סטטוס המשתמש השתנה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית (Help Desk).",
    7062: "פורטל הלקוחות של EY Canvas אינו זמין כעת ונדרש לעדכן את פרטי חברי הצוות הקיימים. נסה שוב ואם הבעיה נמשכת, פנה לתמיכה הטכנית (Help Desk).",
    7063: "לא ניתן להפוך חברים חיצוניים ללא פעילים. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית (Help Desk).",
    7064: "פעולת תיקון (Patch Operation) לא חוקית.",
    7065: "{0} {1} לא ניתנים להפעלה באחת או יותר מקבוצות למתן הרשאות גישה. הדומיין (domain) אסור לקבוצות שנבחרו: {2}.",
    7066: "{0} אינו משתמש חוקי",
    7067: "בקשה לרישום משתמש חיצוני נכשלה",
    7068: "פורטל הלקוחות של EY Canvas אינו זמין כעת ונדרש לעדכן את פרטי חברי הצוות הקיימים. נסה שוב ואם הבעיה נמשכת, פנה לתמיכה הטכנית (Help Desk).",
    7069: "קבוצות למתן הרשאות הגישה שנבחרו אינן פעילות: {0}. הסר ונסה שוב.",
    7072: "אירעה שגיאה במהלך ביטול קישור תהליך תיק הביקורת. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית (Help Desk) אם השגיאה נמשכת.",
    7074: "הארכיב הצליח, אך אירעה שגיאה בעדכון דף הנחיתה (Landing Page) . ארכיב תיק הביקורת ימשיך ודף הנחיתה (Landing Page)  יעודכן לאחר השלמתו. אם דף הנחיתה (Landing Page)  אינו מתעדכן במהלך 24 השעות הקרובות, אנא פנה לתמיכה הטכנית.",
    7075: "לא ניתן להזמין את {0} {1} מכיוון שהוא / היא כבר חבר צוות פעיל.",
    7077: "לא ניתן להפוך משתמש אחד או יותר ללא פעיל(ים). רענן את הדף ונסה שוב אם הבעיה נמשכת פנה אל התמיכה הטכנית.",
    7079: "הדומיין אינו מורשה. נסה שוב ובמידה הבעיה נמשכת, פנה אל התמיכה הטכנית. ",
    7080: "אין לך הרשאה להזמין גורמים חיצוניים. רענן את הדף ונסה שנית. אם הבעיה נמשכת, פנה אל התמיכה הטכנית לקבלת אישור במידת הצורך.",
    7094: "חבר הצוות שנבחר חתם על מסמכים בהתקשרות זו ולא ניתן להסירו.",
    7100: "לא ניתן לעבד עריכות בשדות מוגבלים. רענן ונסה שוב.",

    /*SCOT*/
    8001: "יצירת תת תהליך מהותי (SCOT) נכשלה.",
    8002: "חסר שם תת תהליך מהותי (SCOT).",
    8003: "חסר תת תהליך מהותי (SCOT)",
    8004: "קבלת תת תהליך מהותי (SCOT) נכשל.",
    8005: "Engagement ID שגוי.",
    8006: "מזהה מצג הנהלה (Assertion ID) לא חוקי.",
    8007: "הבקשה להציג תת תהליך מהותי (SCOT) באמצעות מזהה ID נכשלה.",
    8008: "בקשה לא חוקית.",
    8009: 'The selected SCOT has been deleted. Close this modal to see the updated list.',
    8028: 'The selected SCOT has been deleted. Close this modal to see the updated list.',

    /*User*/
    10001: "העדפות המשתמש המחובר כעת לא נמצאו.",
    10002: "בקשות GetAll של המשתמש לא נמצאו.",
    10003: "בקשת קבלת נוכחות משתמש נכשלה.",

    /*Risk Type*/
    11001: "הבקשה ליצירה לא חוקית.",
    11002: "חסר שם של סוג הסיכון.",
    11003: "חסר סוג סיכון.",
    11004: "הבקשה להציג סוג סיכון נכשלה.",
    11005: "Engagement ID שגוי.",

    /* Annotation Errors*/
    12001: "הפרמטרים של הבקשה שגויים.",
    12002: "בקשת יצירת הסבר נכשלה.",
    12003: "קבלת הסבר נכשל.",
    12004: "Engagement ID שגוי.",
    12005: "מספרי זיהוי  חייבים להיות גדולים מאפס.",
    12006: "מספר זיהוי לאיסוף לא יכול להיות ריק.",
    12007: "מספר  משימה לא חוקי.",
    12008: "מספר  המסמך (Document ID) שגוי.",
    12009: "חייב להיות מזהה מסמך או מזהה משימה או משהה דוח כספי חוקי.",
    12010: "המענה דורש את חברת האם",
    12011: "מספר  סטטוס שגוי.",
    12012: "סוג המסמך צריך להיות GL440.",
    12013: "סוג הסבר שגוי.",
    12014: "משתמש תיק ביקורת לא חוקי.",
    12015: "מסמך זה נמחק על-ידי משתמש אחר.",
    12016: "בקשת עידכון הסבר נכשלה",
    12017: "ההערה שאתה משיב לה נמחקה על-ידי חבר צוות אחר. רענן את הדף ונסה שוב.",
    12018: "פעולת ביצוע לא יכולה להיות ריקה.",
    12019: "הערת סקירה נמחקה.",
    12020: "פעולה לא חוקית לביצוע.",
    12021: "משתמש אינו מקשר את הביאור.",
    12022: "משתמש מחבר (authoring user) חסר",
    12023: "משתמש מחבר (authoring user) לא קיים או שייך להתקשרות.",
    12024: "נדרש משתמש שהוקצה (Assigned user).",
    12025: "המשתמש שהוקצה (Assigned user) לא קיים או שייך להתקשרות.",
    12026: "הערות לא חוקיות.",
    12027: "הערות לא יכולות להיות ריקות.",
    12028: "נדרש תאריך יעד.",
    12029: "נדרש דירוג עדיפות בתוקף.",
    12030: "סטטוס הערה זו השתנה. אינך יכול עוד לערוך או להגיב להערה. אנא סגור ופתח את החלון מחדש כדי לראות נתונים מעודכנים ולהמשיך בעריכה.",
    12031: "ביאור חייב להיות ברמה עליונה.",
    12032: "ביאור חייב שלא להיות ברמה עליונה.",
    12033: "לפחות אחד מהערכים הבאים אסור שיהיה ריק: סוג עדיפות, תאריך יעד, סטטוס או משתמש שהוקצה.",
    12034: "הערות חורגות מהאורך המרבי (4,000 תווים).",
    12035: "חפש קטע החורג מהאורך המירבי (500 תווים).",
    12036: "אפשרי לקבל רק מספר זיהוי משימה (TaskId) או מספר זיהוי מסמך (DocumentId), אין אפשרות לקבל את שניהם.",
    12037: "פעולת תיקון (Patch Operation) לא חוקית.",
    12038: "אתה מנסה לערוך הערה שכבר לא קיימת. רענן את הדף ונסה שוב.",
    12039: "הינך מנסה לערוך את אותה הערה כמו חבר צוות אחר. רענן את העמוד ונסה שוב.",
    12040: "קבלת בקשה לביאורי משתמשים נכשלה.",
    12041: "קבלת ביאורי משתמשים נכשלה. ערוך שאילתה לא חוקית.",
    12042: "סוג המסמך לא חוקי כדי ליצור ביאור.",
    12043: "הינך מנסה להוסיף הערה למשימה או מסמך אינם קיימים עוד. רענן את העמוד ונסה שוב.",
    12044: "אתה מנסה לערוך תשובה להערה שכבר לא קיימת. רענן את הדף ונסה שוב.",
    12045: "הערת סקירה לא נמצאה",
    12046: "אתה מנסה למחוק הערה (note) שכבר לא קיימת. רענן את הדף ונסה שוב.",
    12047: "אתה יכול למחוק רק תגובות להערות שנמצאות במצב פתוח. רענן את הדף ונסה שוב.",
    12048: "אתה מנסה לשנות סטטוס של ההערה (note) שכבר לא קיימת. רענן את הדף ונסה שוב.",
    12049: "הינך מנסה למחוק תשובה להערה שכבר נמחקה על ידי חבר צוות אחר. רענן את הדף ונסה שוב.",
    12050: "הארכיב הצליח, אך אירעה שגיאה בעדכון פורטל לקוח Canvas (CCP). ארכיב תיק הביקורת ימשיך וה- CCP יעודכן לאחר השלמתו. אם CCP לא מתעדכן ב -24 השעות הקרובות, אנא פנה לתמיכה הטכנית.",
    12059: "הערות סקירה יכולות להימחק רק על ידי המשתמש שיצר את ההערה.",
    12066: "אתה יכול להשיב רק להערות פתוחות.",
    12067: "אתה מנסה למחוק תשובה למענה שכבר נמחק על ידי חבר צוות אחר. רענן את הדף ונסה שוב.",
    12068: "לא ניתן להוסיף תגובה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    12070: "ניתן להוסיף הערה אחת בלבד לכל דוח כספי. אנא ערוך את הקיים.",
    12071: "מחיקת המידע נכשלה. בבקשה נסה שוב. אם הבעיה נמשכת, צור קשר עם התמיכה הטכנית.",

    /*Configuration*/
    13001: "התצורות (Configurations) לא נמצאו.",
    13002: "הקריאה לקבלת תצורות API (Configurations) נכשלה.",

    /*Documents*/
    14001: "לא ניתן לבצע את הבקשה כיוון שהיא לא בתוקף.",
    14002: "המסמך לא נמצא. הבקשה נכשלה.",
    14003: "ה- Engagement ID אמור להיות גדול מ- 0.",
    14004: "ה- Document ID אינו יכול להיות לא בתוקף או ריק.",
    14005: "אירעה שגיאה בעת ניסיון להשיג משימות משויכות. הקריאה נכשלה. ",
    14006: "אין אפשרות למחוק את המסמך שנבחר. אנא נסה שוב מאוחר יותר. אם הבעיה נמשכת, פנה אל התמיכה הטכנית.",
    14007: "אירעה שגיאה בלתי צפויה.",
    14008: "אירעה תקלה בלתי צפויה במהלך החתימה.",
    14009: "אירעה שגיאה בעת הוספת חתימה.",
    14010: "מספר האישור (approval ID) צריך להיות גדול מאפס.",
    14011: "אירעה שגיאה בעת מחיקת החתימה.",
    14012: "התוכן לא יכול להיות ריק.",
    14013: "לא ניתן להסיר את הקישור מהמסמך שנבחר. נסה שוב במועד מאוחר יותר. במידה והבעיה נמשכת, פנה לתמיכה הטכנית.",
    14014: "הקריאה לקבלת סעיף (account) לפי מזהה מסמך (document ID) נכשלה. ",
    14015: "ישות קשורה לא חוקית.",
    14016: "קבלת בקשה לאישור המסמך נכשלה.",
    14017: "בקשות GetAll למציאת המסמכים נכשלו.",
    14018: "בקשות GetAll למסמכים נכשלו.",
    14019: "החתימה לא נמצאה.",
    14020: "ערך פעולה לא חוקי.",
    14021: "סוג ממצא לא חוקי.",
    14022: "המסמך אינו שייך להתקשרות.",
    14023: "סוג שינוי המסמך המבוקש אינו תקף",
    14024: "בקשות GetAll למסמכים נכשלו. הפרמטר אינו תקף.",
    14025: "אירעה שגיאה בעת יצירת סקירת המסמך. קריאת ה-API נכשלה.",
    14026: "אירעה שגיאה בעת מחיקת סקירת המסמך. קריאת ה-API נכשלה.",
    14027: "מזהה תיק הביקורת (Engegment ID) אינו יכול להיות null או ריק.",
    14028: "מספר זיהוי המשתמש אינו חוקי",
    14029: "המשתמש אינו מורשה לבצע את הפעולה הזו",
    14030: "לא נמצא מסמך עם מספר הזיהוי שהועבר בתיק הביקורת",
    14031: "מספר זיהוי מסמך הסקירה (Document Review) אינו חוקי",
    14032: "מסמך הסקירה (Document Review) לא נמצא",
    14033: "המסמך כבר אושר",
    14034: "מתבצע תהליך ביטול הקישור לתיק ביקורת אחר בסביבת העבודה או שכבר בוטל הקישור למסמך זה. רענן את הדף ונסה שוב. אם הבעיה נמשכת פנה לתמיכה הטכנית (help desk).",
    14035: "המסמך אינו משותף לתיק הביקורת הנתון.",
    14036: "מספר הגירסה צריך להיות גדול יותר מאפס.",
    14037: "לא ניתן להשלים את הפעולה כעת. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית (Help Desk)",
    14038: "קבלת הסיבות לשינוי המסמך נכשלה.",
    14039: "השגת הסיבה לשינוי המסמך לפי מספר זיהוי ID נכשלה.",
    14040: "עדכון סיבת השינוי נכשל.",
    14041: "הסיבה לשינוי אינה חוקית. ",
    14042: "עדכון סיבת השינוי נכשל.",
    14043: "יצירת סיבת השינוי נכשלה. ",
    14044: "מחיקת סיבת השינוי נכשלה.",
    14045: "מזהה סיבת השינוי אינו חוקי.",
    14046: "המסמך אינו זמין. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה אל התמיכה הטכנית.   ",
    14047: "למסמך כבר הוקצתה סיבה לשינוי.",
    14048: "יש קונפליקט במסמך, נא פתור את הקונפליקט לפני שתמשיך.",
    14049: "הנתונים לבדיקת שיוך המסמך לצוות או למשתמש ספציפי אינם חוקיים. ",
    14050: "שגיאה בעת הסרת מסמך תומך. ",
    14051: "בטל את קישור כל רשימת הפעולות לביצוע של הראיות המשותפות שלא נמצאו.",
    14052: "טקסט החיפוש חורג מהאורך המירבי המותר (500 תווים).",
    14053: "לא ניתן לבצע את הבקשה כיוון שהיא לא בתוקף.",
    14054: "פעולת תיקון (Patch Operation) לא חוקית.",
    14055: "בקשה לפתור היסטוריית מסמך נכשלה",
    14056: "אירעה שגיאה בעת ניסיון לאחזר את ההודעה.",
    14057: "סטטוס תיק הביקורת צריך להיות בסטטוס  שגיאת ארכיב (Archive Error) בכדי שניתן יהיה לנסות שוב את תהליך הארכיב.",
    14058: 'More than one document version with the same number has been found. Please contact Help Desk for further assistance.',
    14059: 'The selected document version couldnt be found. Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.',
    14060: 'The operation couldnt be completed at the time. Please try again later. If the issue persists, please contact Help Desk for further assistance.',
    14061: 'Document is not shared, cant unlink the document. If the issue persists, please contact Help Desk for further assistance.',
    14062: 'The document confidentiality type id is not valid.',
    14063: 'Cannot change confidentiality type of this document type.',
    14064: 'User doesnt have permission.',
    14065: 'Invalid custom description.',
    14066: 'Failed to update extension.',
    14067: 'Invalid extension.',
    14068: 'Failed to get document extensions.',
    14069: "חבר צוות אחר כבר ביטל את הקישור של מסמך זה. רענן את הדף ובמידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    14070: "סוג קובץ לא חוקי.",
    14071: "גרסת המסמך שנבחרה אינה זמינה עוד. אנא סגור ופתח מחדש חלון זה כדי לראות את קבוצת הגרסאות ההיסטוריות העדכניות ביותר עבור המסמך.",
    14072: 'Source document Id should not be null or empty.',
    14073: 'Canvas form ids should not be null or empty.',
    14074: "Canvas form ID's should not be duplicates.",
    14075: 'Failed to associate document to canvas forms.',
    14076: "לא נמצאו טפסי Canvas המשויכים למסמך המקור.",
    14077: 'Source document not found. Call failed.',
    14078: 'Current document is already associated with given canvas forms.',
    14079: "מסמך זה נמחק ולכן לא ניתן לפתוח אותו.",
    14080: 'The source approval user id is invalid.',
    14081: 'The source approval user id should valid GUID and must not be empty GUID.',
    14082: 'The modify user id is invalid.',
    14083: 'The modify user id should be a valid GUID and must not be empty GUID.',
    14084: 'File name cannot include: */:<>\\?|""',
    14085: 'The document name exceeded maximum length allowed.',
    14086: 'DocService failed while updating document details.',
    14087: 'The input is not valid.',
    14088: 'A input has duplicate document names.',
    14089: "תצפית הסימניה אינה חוקית.",
    14090: "סטטוס הבקשה השתנה. אנא רענן את הדף ונסה שוב במידת הצורך. אם הבעיה נמשכת, צור קשר עם התמיכה הטכנית.",
    14091: "בקשה זו נמחקה. רענן את הדף כדי להציג נתונים מעודכנים. אם הבעיה נמשכת, צור קשר עם התמיכה הטכנית.",
    14092: 'Document not eligible for update. Refresh the page and try again.  If the issue persists, contact the Help Desk.',

    /*SEM*/
    15001: "הבקשה להציג סיכום SEM למזהה ID לסעיף נכשלה, הואיל ואינה חוקית. ",
    15002: "Account Id שגוי.",
    15003: "Engagement ID שגוי.",
    15004: "סוג סיכום לא חוקי.",
    15005: "לא ניתן למצוא חשבון קשור. רענן את הדף ונסה שוב. צור קשר עם דלפק העזרה (Help Desk) אם הבעיה נמשכת.",

    /*Timephase*/
    16001: "קבלת time phases נכשלה.",
    16002: "תיק הביקורת חייב להיות גדול מאפס",
    16003: "ה- time phases חייב להיות גדול מאפס.",
    16004: "מספר זיהוי למשימה שגוי.",
    16005: "ערך ה- Time Phase שגוי.",

    /*Validations*/
    17001: "חסר מזהה (ID) בניית שלבים או מזהה (ID) של סוג מסמך.",

    /*TaskGroupSection*/
    18001: "הקריאה לקבלת קבוצת המשימות נכשלה.",
    18005: "קבוצת משימות זו אינה זמינה יותר בהתקשרות זו.",
    18006: 'This task group is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    18016: "ניתן למחוק קבוצות משימות רק כאשר אין משימות קשורות. מחק או העבר את המשימות הקשורות ונסה שוב.",
    18019: "קבוצת המשימות שאתה מנסה לעדכן כבר נמחקה.",

    /*Assignments*/
    19001: "הבקשה ליצירת משימה נכשלה.",
    19002: "קבלת בקשה למשימה נכשלה.",
    19003: "שם ההקצאה חייב להיות ייחודי",
    19004: "שם הקצאה לא חוקי",
    19005: "אורך שם הקצאה חורג יותר מ- 100 תווים",
    19006: "סוג הקצאה לא חוקי",
    19007: "אורך הקצאת החיפוש עולה על יותר מ -500 תווים.",
    19008: "שם ההקצאה נמחק על ידי חבר צוות אחר. רענן את הדף ונסה שוב.",

    19012: "לא ניתן לחזור על מזהה המשימה.",
    19013: "השדות מזהה תפקיד (RoleId) ומזהה משתמש (UserId) אינם יכולים לכלול ערכים בו-זמנית.",
    19014: "מזהה משתמש (UserID) לא יכול להיות בעל ערך ברירת המחדל.",
    19016: "משתמש בתפקיד השותף האחראי על הביקורת PIC לא חוקי או משתמש בתפקיד השותף האחראי על הביקורת PIC לא הוזמן.",
    19017: "משתמש בתפקיד השותף המלווה EQR לא חוקי או משתמש בתפקיד השותף המלווה EQR לא הוזמן.",
    19018: "ערך תאריך היעד חייב להיות גדול מ-0 וקטן מ-1000.",
    19019: "הקריאה ליצירת הקצאה אוטומטית למשימה נכשלה.",

    /*Client Request*/
    21001: "לא ניתן לשלוח את הבקשה ל- EY Canvas Client Portal. רענן את הדף ונסה שוב. אם הבעיה נמשכת, אנא פנה לתמיכה הטכנית.",
    21002: "בקשה זו נמחקה. רענן את הדף כדי להציג נתונים מעודכנים. אם הבעיה נמשכת, פנה לתמיכה הטכנית",
    21009: "הבקשה למחיקת מסמך בקשת הלקוח נכשלה.",
    21010: "ההערה שאתה משיב עליה נמחקה על ידי חבר צוות אחר. רענן את הדף ונסה שוב.",
    21011: "מסמך בקשת הלקוח נמחק.",
    21012: "מסמך בקשת הלקוח לא נמצא.",
    21013: "בקשת המסמך ריקה.",
    21014: "מזהה המסמך ריק.",
    21015: "מזהה בקשת הלקוח ריק.",
    21016: "הבקשה ליצירת מסמך בקשת לקוח נכשלה.",
    21017: "אחד או יותר מהמסמכים המשויכים נמחקו מתיק הביקורת. אנא הסר את המסמכים שנמחקו מבקשה זו או רענן את הדף ונסה שוב.",
    21018: "המסמך לא נמצא.",
    21019: "סטטוס בקשת הלקוח השתנה.",
    21030: "מזהה קבוצת הללקוחות אינו תואם.",
    21031: "סטטוס הבקשה השתנה. אנא רענן את הדף ונסה שוב במידת הצורך. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    21032: "משתמש לא פעיל ליצירת קשר של קבוצת הלקוחות.",
    21033: "קבוצת לקוחות אינה פעילה.",
    21034: "קבוצת לקוחות לא מכילה משתמש פעיל.",
    21045: "סטטוס הבקשה השתנה. אנא רענן את הדף בכדי לראות את השינויים האחרונים.",
    21046: "לא ניתן לשלוח את הבקשה ל- EY Canvas Client Portal. רענן את הדף ונסה שוב. אם הבעיה נמשכת, אנא פנה לתמיכה הטכנית.",
    21050: "לא ניתן היה למחוק בקשות. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לדלפק העזרה",
    21053: "המשימה אינה זמינה יותר בהתקשרות. רענן את הדף כדי לעדכן את הרשימה.",
    21057: "לא ניתן היה להקצות EY Contact. רענן את הדף ונסה שוב.",
    21028: "נדרש תאריך יעד.",
    21036: "שלב הזמן לא נמצא",
    21064: "לא ניתן לשייך משימה לבקשה. ניתן לשייך בקשות לעד 25 משימות. הסר משימה משויכת אחת או יותר, בכדי שתוכל לשייך משימה חדשה.",
    21065: "לבקשה נוספו מסמך סודי אחד או יותר. אין לך את רמת הסודיות המתאימה כדי לשלוח אחד או יותר מהמסמכים האלה לפורטל הלקוחות של ה- Canvas. אנא הסר את כל המסמכים הסודיים שאין לך גישה אליהם כדי להמשיך.",
    21066: "אירעה שגיאה באחזור הנתונים. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    21067: "לא ניתן היה לעדכן את העדיפות. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    21035: "בקשת הלקוח לא נמצאה.",
    21074: "הבקשה שהתקבלה אינה מותרת בשינויים של הכותרת, התיאור, התעדוף.",
    21075: "הבקשה שהתקבלה אינה מותרת בשינויים של הכותרת, התיאור, ההקצאה ל (קבוצה), ההקצאה ל (משתמש), תאריך היעד, התעדוף.",
    21077: "תאריך יעד נדרש עבור בקשות לקוח במצב 'התקבל' ו'בהמתנה'.",
    21039: "מזהה הקבוצה לא נמצא.",
    21078: "הן קבוצה והן משתמש נדרשים שניהם בעת עדכון ה-Assigned To Group או Assigned To User.",
    21079: "פורמט התאריך אינו חוקי.",
    21027: "נדרשת כותרת בקשה.",
    21041: "אורך כותרת הבקשה חורג ממקסימום התווים המותרים.",
    21042: "אורך תיאור הבקשה חורג ממספר התווים המרבי המותר.",
    21060: "זיהוי המשתמש של הלקוח ריק.",
    21076: "סוג עדיפות אינו מותר.",

    /* Group Components*/
    22001: "קבלת חברות מוחזקות (components) רלוונטיות נכשלה.",
    22002: "הבקשה לקבלת רכיבי הקבוצה נכשלה.",
    22003: "יצירת הישויות המוחזקות בקבוצה נכשלה.",
    22004: "מזהה ישות מוחזקת ראשית (parent component) לא חוקי, הישות המוחזקת הראשית שציינת לא קיימת.",
    22005: "שם הצוות חרג מהאורך המרבי.",
    22006: "השם החוקי של הקבוצה חרג מהאורך המרבי.",
    22008: "ההיקף שציינת אינו קיים.",
    22009: "שם קצר של ישות מוחזקות לא חוקי.",
    22010: "שם הישות המוחזקת המשפטי לא חוקי.",
    22011: "מזהה היקף הישות המוחזקת לא חוקי.",
	22012: 'אם כתובת הדוא"ל של איש הקשר סופקה, המדריך לאיש הקשר לא יכול להיות ריק או null.',
	22013: 'אם כתובת הדוא"ל של איש הקשר סופקה, התוכן לאיש הקשר לא יכול להיות ריק או null.',
    22016: "צוות זה כבר נמחק על ידי חבר צוות אחר. רענן את הדף ונסה שוב.",
    22022: "שם הצוות כבר קיים בהתקשרות זו.",
    22043: "הקריאה לשליחת ההנחיות נכשלה.",

    /*User Presence*/
    23001: "לא נמצאה נוכחות משתמש מחובר.",
    23002: "בקשת קבלת נוכחות משתמש נכשלה.",
    23003: "אימות מסמך נוכחות המשתמש נכשל.",
    23004: "בקשת מחיקת נוכחות משתמש נכשלה.",
    23005: "המסמך לא נפתח על ידי משתמשים אחרים. רענן את הדף ונסה שוב. פנה  לתמיכה הטכנית (Help Desk) אם הבעיה נמשכת.",

    /* Forms */
    24001: "קבלת בקשה לטופס (form) נכשלה.",
    24002: "מספר זיהוי התקשרות (Engagement ID) שגוי.",
    24003: "מספר זיהוי המסמך (Document ID) אינו יכול להיות לא בתוקף (null) או ריק (empty).",
    24004: "מספר זיהוי המסמך (Document ID) לא חוקי.",
    24005: "מספר זיהוי כותרת טופס (Form Header) לא חוקי.",
    24006: "מספר זיהוי סעיף טופס (Form Section) לא חוקי",
    24007: "הפרמטרים של הבקשה שגויים.",
    24008: "מספר זיהוי כותרת אינו יכול להיות לא חוקי (null) או ריק (empty).",
    24009: "מספר זיהוי סעיף אינו יכול להיות לא חוקי (null) או ריק (empty).",
    24010: "פעולת עדכון המענה בגוף הטופס נכשלה.",
    24011: "בקשה לא חוקית לעדכון המענה בגוף הטופס.",
    24012: "מספר זיהוי גוף לא חוקי.",
    24013: "מספר זיהוי אפשרות גוף טופס לא חוקי.",
    24014: "מספר זיהוי סוג גוף טופס לא חוקי.",
    24015: "מספר זיהוי גוף בקשה לסוג גוף נתון לא חוקי.",
    24016: "מספר זיהוי טקסט חופשי לסוג גוף נתון לא חוקי .",
    24017: "מספר תווים מירבי, כולל תגיות (tags) עיצוב טקסט עשיר. צמצם את האורך או הסר עיצוב מיותר ונסה שוב.",
    24018: "עבור סוג התוכן הנתון, מתן מענה הינו אסור",
    24019: "מספר זיהוי גוף לא יכול להיות לא תקף (null) או ריק",
    24020: "תוכן הבקשה לא חוקי.",
    24021: "התוכן נמחק. ",
    24038: "המסמך אינו חוקי או שאינו קיים.",
    24049: "האובייקטים שנבחרו נמחקו. רענן את הדף ונסה שנית. אם הבעיה נמשכת, פנה אל התמיכה הטכנית. ",
    24057: "אימות FormProfile של המסמך נכשל.",
    24063: "מזהה מדינה לא חוקי",
    24064: "מזהה שפה לא חוקי",

    /*Document Change Types*/
    25001: "הקריאה לקבלת סוגי שינויים במסמך (Document Change Types) נכשלה.",
    25002: "מספר זיהוי ID התקשרות (Engagement ID) שגוי.",
    25003: "בקשה לא חוקית.",

    /* Manage team */
	26001: "הקריאה לקבלת קבוצות משתמשים ללקוח (ClientUserGroups) נכשלה. ",
	26002: 'יצירת קבוצת לקוחות / דומיין לדוא"ל חדש נכשלה.',
	26003: "שם קבוצה (GroupName) אינו יכול להיות null.    ",
    26004: "דומיין הדואר האלקטורני (Email Domain) אינו יכול להיות null.",
	26005: '{0} תווית דומיין הדוא"ל לא יכולה להיות מעל 263 תווים.',
	26006: '{0} דומיין הדוא"ל לא יכול להיות מעל 263 תווים.',
	26007: '{0} החלק הראשון של הדומיין של הדוא"ל יכול להיות * או אלפאנומרי, תווים מיוחדים אחרים אינם מותרים.',
	26008: "{0} אם החלק הראשון הוא תו כללי (wildcard), אז הוא חייב להיות מלווה בלפחות בועד שני תווים אחריו. ",
    26009: "{0} החלק הראשון יכול להיות * או אלפאנומרי, חלקים אחרים של דומיין ותווים מיוחדים אינם מותרים.",
	26010: 'הדומיין של הדוא"ל צריך להיות ייחודי. ',
	26011: "מזהה קבוצת הגישה של הלקוח שסופק אינו חוקי. ",
    26012: "אירעה שגיאה בעת מחיקת קבוצת הגישה. ודא כי אין בקשות / משימות חיצוניות שהוקצו לקבוצה זו או לחברי הקבוצה ונסה שוב",
    26013: "קבוצת הגישה נמחקה כבר, אנא רענן את הדף כדי לקבל את הנתונים העדכניים ביותר.",
    26014: "נדרש לפחות אימייל דומיין אחד",
    26015: "פורטל הלקוחות של EY Canvas אינו זמין כעת ונדרש לעדכן את פרטי חברי הצוות הקיימים. נסה שוב ואם הבעיה נמשכת, פנה לתמיכה הטכנית (Help Desk).",
    26016: "אירעה שגיאה במהלך פעולת המחיקה",
    26017: "פעולת קבלת נתונים נכשלה.",
    26018: "בעיה בו זמנית, קבוצה למתן הרשאות גישה אינה פעילה עוד. רענן את הדף ונסה שוב.",
    26019: "פעולת השמירה נכשלה",
    26020: "לא ניתן להסיר אימייל של דומיינים כאשר הוקצו להם משתמשים פעילים. השינויים לא נשמרו.",


    /* TimePhaseTypes - Milestones */
    27001: "קבלת הפרטים של השלבים (milestone) נכשלה",

    /*Client Request Counts*/
    28001: "שירות ' קבלת מידע אודות בקשות לקוח ' לא הניב תוצאות.",

    /*Content updates Error messages*/
    29001: "הבקשה באמצעות מספר זיהוי ID ID' לא נמצא.",
    29002: "סוג האקטון (Acton) לא נמצא.",
    29003: "מספר(י) זיהוי תוכן לא נמצאו",
    29004: "בקשה לעדכון תוכן API נכשלה",
    29005: "עדכון תוכן בתהליך. נסה שוב מאוחר יותר ואם הבעיה נמשכת, צור קשר עם התמיכה הטכנית (help desk).",
    29006: "הפרמטרים לבקשה לא חוקיים.",
    29010: "התוכן עובר רענון כעת. אנא נסה שוב מאוחר יותר. אם השגיאה נמשכת זמן ממושך, אנא פנה לתמיכה הטכנית של IT (IT Help Desk).",
    29012: "במעורבות חסרה שאלת פרופיל הסטנדרטים הרלוונטיים. פנה ל-IT Help Desk.",
    29013: "משימות חובה סטנדרטיות (PSTs) ועדכוני תוכן פרופיל אינם מותרים כאשר ישנן פעילויות הפעלת EY Canvas FIT ששותפו. בכדי לעדכן PSTs או תוכן פרופיל, אנא בטל את הקישור של פעילויות אלו. אם נבחרו מספר סוגי עדכון תוכן, בטל את הבחירה במשימות חובה סטנדרטיות (PSTs) ו/או תוכן הפרופיל ואתחל מחדש את העדכון.",
    /*IT Process*/
    30001: "קבלת כל תהליכי ה IT נכשלה.",
    30002: "קבל את כל ה- ITProcess - מספר זיהוי ID תיק ביקורת לא חוקי.",
    30003: "שם תהליך ה- IT לא יכול להיות ריק.",
    30004: "שם תהליך ה IT לא יכול להיות יותר מ 500 תווים.",
    30005: "מזהה תהליך ה IT אינו חוקי.",
    30006: "הבקשה לאיתור תהליך ה IT באמצעות מזהה נכשל.",
    30007: "בקשה לא חוקית.",
    30008: "תהליך ה-IT אינו חוקי.",
    30009: "המסמך לא נמצא.",
    30010: "מחיקת תהליך ה- IT נכשלה.",
    30012: "סיכון ה- IT לא חוקי.",

    /*Checklist*/
    31001: "הקריאה לקבלת כל הצ'קליסטים נכשלה.",
    31002: "הקריאה להצבת הצ'קליסטים נכשלה.",
    31003: "פרמטר לא חוקי של הצ'קליסט.",
    31004: "Invalid Engagement Error.",
    31005: "Invalid Request Parameters Error.",
    31006: "שגיאה בהזנת פרמטר לא חוקי לבקשת IsChecked.",

    /*Archive*/
    32001: "סטטוס תיק הביקורת אינו חוקי, פתור את האימות (validation) ונסה שוב את תהליך הארכיב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    32002: "הארכיב נכשל בעת עדכון סטטוס התצוגה של גופי הטפסים, אנא נסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    32003: "הארכיב נכשל בעת עדכון סטטוס תיק הביקורת, אנא נסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    32004: "הארכיב נכשל בעת ביטול תוקף אימות ההתקשרות (engagement cache), אנא נסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    32005: "עדכון תוכן מתבצע. אינך יכול לארכב את תיק הביקורת הזה עד להשלמת עדכון התוכן. נסה שוב מאוחר יותר. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    32006: "ישנם אימותים (validations) שלא נפתרו בתיק ביקורת זה. רענן את הדף, פתור את האימותים ונסה שוב לארכב. צור קשר עם התמיכה הטכנית (Help Desk) אם השגיאה נמשכת.",
    32007: "הארכיב נכשל בעת בניית  ARC Request Model, אנא נסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    32008: "הארכיב נכשל בעת קבלת כתובת ה- Arc API, אנא נסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    32009: "הארכיב נכשל בעת ביצוע קריאת Arc API, אנא נסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    32010: "הארכיון נכשל בגלל נתונים חסרים בתגובת Arc API, נסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    32011: "הארכיב נכשל בעת שמירת פרטי טופס ה- ARC, אנא נסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    32012: "הארכיב נכשל בעת עדכון סטטוס תיק הביקורת לניסיון חוזר, נסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    32013: "הארכיב נכשל בזמן המתנה להודעת הארכיב, נסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    32014: "הארכיב הצליח, אך אירעה שגיאה בעת העמדת הודעת עדכון מצב אוניברסלי בתור. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    32015: "הארכיב הצליח, אך אירעה שגיאה בעת העמדת הודעת עדכון מצב CCP בתור. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    32016: "סטטוס תיק הביקורת צריך להיות בסטטוס  שגיאת ארכיב (Archive Error) בכדי שניתן יהיה לנסות שוב את תהליך הארכיב.",
    32017: "תיק הביקורת לא נמצא, אנא נסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
    32019: "איננו יכולים לעבד את בקשתך בשלב זה. בבקשה נסה שוב. אם הבעיה נמשכת, אנא פנה לתמיכה של EY.",
    32020: "כתובת האתר של ARC אינה מוגדרת, אנא נסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית. ",
	32200: 'יש אימותים (validations) לא פתורים בתיק הביקורת שלך. הפעל את דוח בדיקות האימות (Validations Checks) דרך אופציית הדיווח (Reporting) או עיין בקישור "עזרה באימותים" (Validations help) בתפריט "עוד" לפרטים נוספים. אם השגיאה נמשכת, פנה לתמיכה הטכנית.',
    32400: "השגיאות הבאות אירעו בעת תקשורת עם מערכת ה- ARC. צור קשר עם התמיכה הטכנית והצג להם את הודעת השגיאה שקיבלת בכדי להמשיך.",

    /*RBAC*/
    33001: "מספר זיהוי ID תיק ביקורת לא נמצא.",
    33002: "מספר זיהוי ID משתמש לא נמצא.",

    /*Helix Linked Projects*/
    34001: "הקישור של EY Helix Project כבר בוטל, רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    34002: "מספר זיהוי תיק הביקורת לא יכול להיות null או ריק.",
    34003: "התוכן לא יכול להיות לא בתוקף או ריק בתא.",
    34004: "מספר זיהוי הפרויקט לא יכול להיות null או ריק.",
    34005: "שם הפרויקט לא יכול להיות null או ריק.",
    34006: "EY Helix Project כבר מקושר, רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    34007: "הקריאה לקבלת כל ה- Helix Projects נכשלה.",
    34008: "ה- Engagement ID אמור להיות גדול מ- 0.",
    34009: "לא ניתן היה להשלים את הפעולה. אנא רענן את הדף ונסה שנית. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    34020: "לא ניתן לקשר את Helix Project. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    34024: "לא ניתן לשלוח הודעה ל- Helix. חסר מידע אזורי (Region information) עבור הפרויקט.",
    34029: "הפרויקט לא מקושר כי המיקום שלו אינו תואם את המיקום של EY Canvas Engagement.",
    34030: "לא ניתן לקשר את כלי הניתוח Analyzer. אינך חבר צוות מורשה של כלי הניתוח שנבחר. פנה למנהל הפרויקט של EY Helix כדי לקבל גישה ולנסות שוב.",
    34031: "נראה שלא ניגשת ליישום ה- EY Helix בעבר.",
    34038: "הניתוח שנבחר אינו זמין עוד. רענן את הדף ונסה שוב. אם הבעיה נמשכת, צור קשר עם התמיכה הטכנית.",
    34043: "`פרויקט EY Helix שנבחר אינו זמין עוד. לחץ על 'קשר פרויקט' כדי לקשר פרויקט אחר.",
    34044: "פרויקט EY Helix שנבחר מסומן למחיקה. לחץ על 'קשר פרויקט' כדי לקשר פרויקט אחר.",
    34045: "פרויקט EY Helix שנבחר מסומן לאחסון. לחץ על 'קשר פרויקט' כדי לקשר פרויקט אחר.",
    34046: "`כלי ניתוח (analyzer) לא חוקי או חסר ב-EY Helix. רענן את הדף ונסה שוב. אם הבעיה נמשכת פנה לתמיכה הטכנית.",
    34047: "`כלי הניתוח (analyzer) שנבחר אינו זמין ב-EY Helix. רענן את הדף ונסה שוב. אם הבעיה נמשכת פנה לתמיכה הטכנית.",
    34048: "`הניתוח לא זמין בפרויקט המקושר. עבור אל EY Helix והשלם את שלבי עיבוד הנתונים והניתוחים כדי להמשיך.",
    34080: "קיימת חריגה מהמספר המרבי של חיבורי Engagement Helix.",

    /* PAANS */
    35001: "הארכיב נכשל בעת עדכון סטטוס תיק הביקורת לניסיון חוזר, אנא נסה שוב. אם הבעיה ממשיכה, אנא פנה לתמיכה הטכנית.",

    /*Engagement Comments*/
    38001: "שירות יצירת הערות להתקשרות נכשלה",
    38002: "שירות 'קבל את כל הערות ההתקשרות/ נכשלה",
    38003: "לא ניתן להשלים פעולה זו. אנא רענן את הדף ונסה שנית. אם השגיאה נמשכת, פנה אל התמיכה הטכנית",
    38004: "לא ניתן להשלים פעולה זו. אנא רענן את הדף ונסה שנית. אם השגיאה נמשכת, פנה אל התמיכה הטכנית",
    38005: "לא ניתן להשלים פעולה זו. אנא רענן את הדף ונסה שנית. אם השגיאה נמשכת, פנה אל התמיכה הטכנית",
    38006: "לא ניתן להשלים פעולה זו. אנא רענן את הדף ונסה שנית. אם השגיאה נמשכת, פנה אל התמיכה הטכנית",
    38007: "לא ניתן להשלים פעולה זו. אנא רענן את הדף ונסה שנית. אם השגיאה נמשכת, פנה אל התמיכה הטכנית",
    38008: "לא ניתן להשלים פעולה זו. אנא רענן את הדף ונסה שנית. אם השגיאה נמשכת, פנה אל התמיכה הטכנית",
    38009: "לא ניתן להשלים פעולה זו. אנא רענן את הדף ונסה שנית. אם השגיאה נמשכת, פנה אל התמיכה הטכנית",
    38010: "הגוף לא צריך להיות ריק",
    38011: "טקסט ההערה לא צריך להיות null או ריק",
    38012: "ישות לא קיימת בהתקשרות נתונה",
    38013: "זיהוי סטטוס הערת התקשרות צריך להיות גדול מ-0",
    38014: "זיהוי הערת התקשרות של חברת האם צריך להיות גדול מ-0",
    38015: "לא היה גוף של טופס קנבס התואם לקריטריונים שצוינו",
    38016: "ההערה שאתה משיב לה נמחקה על ידי חבר צוות אחר. רענן את הדף ונסה שוב",
    38017: "הערת התקשרות של חברת האם שסופקה נמחקה",
    38018: "הערת התקשרות של חברת האם שסופקה היא בעצמה התשובה",
    38019: "טקסט ההערה שסופק לא צריך להיות קצר מ-1 ולא ארוך יותר מ-4000 תווים",
    38020: "ה-UI של הישות שסופק אינו חוקי",
    38021: "ה-UID של חברת האם שסופק אינו חוקי",
    38022: "שיחת מחיקת הערות התקשרות נכשלה",
    38023: "מזהה ההערה לא צריך להיות ריק",
    38024: "הפעולה צריכה להיות פעולה חוקית",
    38025: "סטטוס ההערה השתנה. רענן את הדף ונסה שוב.",
    38026: "הערות סקירה יכולות להימחק רק על ידי המשתמש שיצר את ההערה.",
    38027: "אתה מנסה לערוך הערה שאינה קיימת יותר. רענן את הדף ונסה שוב.",
    38028: "עדכונים על הערות שנמחקו אסורים",
    38029: "רק הכותב יכול לשנות את טקסט התגובה",
    38030: "מזהה הערת התקשרות אינו חוקי",
    38031: "מזהה סטטוס ההערה לא צריך להיות ריק",
    38032: "לא היה תיעוד של הקשר בין המשתמש המבוקש לבין תיק הביקורת. רענן את הדף ונסה שוב. אם השגיאה נמשכת פנה לתמיכה הטכנית",
    38033: "פעולת העדכון אינה חוקית",
    38034: "מזהה ההערה המבוקש כבר נמצא בשימוש על ידי תגובה אחרת",
    38035: "מזהה ההערה שסופק אינו חוקי",
    38036: "מזהה המסמך לא צריך להיות ריק או ריק",
    38037: "המזהה של המשתמש שאליו תוקצה ההערה לא אמור להיות ריק",
    38038: "אין להקצות מחדש את ההערה בזמן פתיחתה או סגירתה",
    38039: "ההערה שממנה אתה מנסה למחוק תגובה כבר נמחקה. רענן את הדף ונסה שוב",
    38040: "לתשובה לא אמור להיות תאריך יעד",
    38041: "לתשובה לא אמורה להיות עדיפות",
    38042: "להערה צריך להיות תאריך יעד",
    38043: "להערה צריכה להיות עדיפות",
    38044: "אתה מנסה לערוך תשובה להערה שאינה קיימת יותר. רענן את הדף ונסה שוב",
    38045: "אסור לערוך הן את מזהה סטטוס ההתקשרות והן את התוכן שלו, שהוקצה למשתמש או עדיפות",
    38046: "שיחת Update עדכון הערות התקשרות נכשלה",
    38047: "אתה יכול להשיב רק להערות פתוחות",

    /*Tags*/
    39004: "קבוצת התגים שאתה עורך נמחקה על ידי חבר צוות אחר. רענן את הדף ונסה שוב. ",
    40003: "קבוצת התגים שנבחרה נמחקה על ידי חבר צוות אחר. בחר קבוצת תגים אחרת כדי להמשיך. ",
    40007: "הערה אחת או יותר שנבחרה נמחקה. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    40011: 'Note index cannot exceed 5 characters.',
    40012: "קוד צבע התג אינו חוקי. רענן את הדף ונסה שוב.",
    40014: "קבוצת התגים שמכילה את התג שאתה עורך נמחקה על ידי חבר צוות אחר. רענן את הדף ונסה שוב.",
    40016: "לא ניתן היה להוסיף או להסיר תגים מאחת או יותר מהמשימות שבחרת. רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית.",
    40019: "אחד או יותר מהתגיות שאתה עורך נמחקו על ידי חבר צוות אחר. אנא רענן את הדף ונסה שנית.",
    40020: "לא ניתן היה לסנכרן תג אחד או יותר כרגע. רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית.",
    40021: "אחד או יותר מהתגים שבחרת נמחקו. אנא רענן את הדף ונסה שנית.",
    40022: "הוסף חבר צוות חיצוני אחד או יותר למעורבות זו, ולאחר מכן נסה את הפעולה הזו שוב. פנה לדלפק העזרה אם שגיאה זו נמשכת.",
    40027: 'Description is too long.',

    // Scheduler request
    70022: "אין משימות המשויכות לבקשת שירות זו. רענן את הדף ובחר משימה אחת או יותר שלא נמחקה בכדי להמשיך. אם השגיאה נמשכת פנה אל צוות העזרה.",
    70024: "שירותים מרכזיים אינם זמינים לתיק הביקורת שלך. רענן את הדף ונסה שוב. אם השגיאה נמשכת, פנה לתמיכה הטכנית.",
    70025: "שירותים מרכזיים אינם זמינים כעת עבור המדינה שלך. רענן את הדף ונסה שוב. אם השגיאה נמשכת, פנה לתמיכה הטכנית.",

    /* TaskDocumnet */
    80001: "יצירת שיוך מסמך למשימה נכשלה.",
    80002: "לבקשה צריכה להיות לפחות משימה אחת.",
    80003: "יש להציג מזהה מסמך.",
    80004: "המשימה(ות) שנבחרה(ו) נמחקה(ו). רענן את הדף ונסה שוב. אם השגיאה נמשכת, פנה לתמיכה הטכנית.",
    80005: "מזהה המסמך אינו חוקי.",
    80006: "למשתמש אין הרשאות מספיקות לביצוע הפעולה.",
    80007: "שיוך מסמכי המשימה נכשל.",
    80008: "לאחר שיוך מסמך למשימה, שינוי סטטוס המשימה נכשל.",
    80011: "לא ניתן לשתף מסמכים סודיים.",
    80012: "מטען בקשה לא חוקי או ריק.",
    80013: "חרגת ממגבלת המשימות. אנא בחר 300 או פחות משימות בכל פעם.",
    80014: "אירעה שגיאה בעת ניסיון לקשר את המסמך. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",

    /* ITApplication / SO */
    81001: "השגת כל יישומי ה- IT נכשלה.",
    81002: "קבל את כל יישומי ה-IT - מזהה התקשרות לא חוקי.",
    81003: "יישום ה-IT שנבחר נמחק. סגור מודל זה כדי לראות את הרשימה המעודכנת.",
    81004: "השם לא אמור להיות ריק.",
    81005: "השם לא יכלול יותר מ-500 תווים.",
    81006: "מזהה סוג אסטרטגייה (StrategyType) לא חוקי.",
    81007: "מזהה המסמך (Document ID) לא חוקי.",
    81008: "קבלת יישום IT באמצעות מזהה נכשלה.",
    81009: "סיווג לא חוקי.",
    81010: "תת תהליך מהותי (SCOT) לא חוקי.",
    81011: "בקרה לא חוקית.",
    81012: "מזהה יישום IT לא יכול להיות ריק או null.",
    81013: "יישום IT לא נמצא.",
    81014: "הקריאה למחיקת יישום IT / תהליך IT נכשלה.",
    81015: "מזהה יישום IT / תהליך IT לא יכול להיות ריק.",
    81016: "מזהה יישום IT / תהליך IT לא חוקי.",
    81017: "יישום IT / תהליך IT לא נמצא.",
    81018: "הקריאה ליצירת יישום IT / תהליך IT נכשלה.",
    81019: "העבר את לשכת השירות (SO) במקום ה- ITApplication.",

    /* Controls */
    83001: "השגת הבקרות נכשלה.",
    83002: "לא ניתן לבצע פעולה זו. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    83003: "מזהה הבקרה ריק או null.",
    83004: 'The selected Control has been deleted. Close this modal to see the updated list.',
    83005: "מזהה המסמך אינו חוקי.",
    83006: "חסר שם בקרה.",
    83007: "אורך שם בקרה לא חוקי.",
    83008: "בקשה לא חוקית",
    83009: "מזהה תדירות בקרה לא חוקי",
    83010: "מזהה סוג בקרה לא חוקי",
    83011: "יישומי בקרת IT לא חוקי.",
    83012: "מזהה סוג האפקטיביות בתכנון הבקרה לא חוקי",
    83013: "יישומי ITA לא חוקיים.",
    83014: "רק יישומי ITA מסוג SO מותרים אם  הבקרה היא מסוג מונעת ידנית או בקרה ידנית מגלה",
    83015: "רק בבקרות מסוג ITDM עשויות להיבחר בדיקות IPE ידניות.",
    83016: "בקרות בסיכון נמוך (Lower Risk controls) אינן מותרות עבור התקשרויות עם פרופיל זה.",
    83017: "סינון לפי תתי תהליכים מהותיים SCOTs כפולים ",
    83018: "שם הבקרה הוא יותר מ-500 תווים.",
    83019: "זיהויי WCGW לא חוקיים",
    83020: "אין להשתמש במזהי WCGW כפולים.",
    83021: "אין להשתמש במזהי ITApplication  כפולים.",
    83023: "העמוד הנוכחי אינו חוקי.",
    83024: "גודל עמוד לא חוקי.",
    83025: "מחרוזת חיפוש לא תכלול יותר מ-100 תווים.",
    83026: "יישום IT ללא לשכת שירות יכול להיות משוייך רק לבקרה מסוג ITDpendentManualControl או ITApplicationControl.",
    83027: "שכפל FilterWCGWs.",
    83028: "מזהה בקרת ידע לא חוקי",

    /* ITControl */
    84001: "השגת בקרות IT נכשלה.",
    84002: "השגת בקרת IT על ידי מזהה נכשלה.",
    84003: "מזהה בקרת IT הוא ריק או null.",
    84004: "מזהה בקרת IT לא חוקי.",
    84005: "מזהה המסמך אינו חוקי.",
    84006: "חסר שם בקרת IT.",
    84007: "אורך שם בקרת IT לא חוקי.",
    84008: "מזהה תדירות בקרת IT לא חוקי.",
    84009: "מזהה סוג  גישת בקרת IT לא חוקי.",
    84010: "מזהה סוג אפקטיביות תכנון (Design Effectiveness) של בקרת IT לא חוקי.",
    84011: "ערך בדיקת בקרת IT (IT Control Testing) לא חוקי.",
    84012: "מזהה סוג אפקטיביות תפעולית (Operating Effectiveness) של בקרת IT לא חוקי.",
    84013: "חסרה תדירות בקרת IT.",
    84014: "מחיקת בקרת IT נכשלה.",
    84015: "מחרוזת חיפוש לא תכלול יותר מ-100 תווים.",

    /*GroupTasks*/
    85001: "לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85002: "לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85003: "לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85004: "לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85005: "לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85006: "לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85007: "לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85008: "לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85009: "לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85010: "לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85011: "לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85012: "המסמך שנבחר כבר הוקצה לאזור או רכיב אחר. לכן, הוא אינו זמין להקצאה. רענן את הדף ונסה שוב.",
    85013: "לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85014: "לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85015: "לא ניתן היה להשלים את הפעולה שנבחרה בשלב זה. רענן את הדף ונסה שנית. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85016: "מספר ההתקשרות (Engagement Id) צריך להיות גדול מאפס.",
    85017: "משימה זו אינה זמינה יותר בתיק ביקורת זה.",
    85018: "מזהה מסמך לא חוקי.",
    85019: "אין לך את רמת הסודיות המתאימה לשליחת מסמכים אלה. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85020: "אחד או יותר מהמסמכים שאתה מנסה לשלוח אינם זמינים עוד לשליחה. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    85021: "טפסים אינם זמינים לשליחה לצוות הראשי (PT).",
    85022: "שליחה של מסמך אחד או יותר נכשלה. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",

    /* ITRisk */
    86001: "שם ITRisk אינו יכול להיות ריק.",
    86002: "שם ITRisk אינו יכול להיות יותר מ- 500 תווים.",
    86003: "מזהה ITRisk לא חוקי.",
    86004: "הבקשה לקבלת ITRisk באמצעות מזהה ID נכשלה.",
    86005: "ITRisk לא נמצא.",
    86006: "יצירת קריאת סיכון IT / בקרת IT נכשלה.",
    86007: "מזהה בקרת IT לא חוקי.",
    86008: "מחיקת שיחת סיכון IT / בקרת IT  נכשלה.",
    86009: "מזהה סיכון IT / בקרת IT  לא חוקי.",
    86010: "מחיקת סיכון IT נכשלה.",


    /*Copyhub*/
    88017: "שירות תהליך הייצוא מושבת - יצירת החבילה הושלמה באופן חלקי",
    88018: "המשתמש שנבחר לשליחת חבילה אינו חוקי (דואר אלקטרוני, Gui או שם מלא לא חוקיים)",
    88033: "סטטוס חבילת העתקה לא חוקי לייבוא.",
    88042: "אין לך הרשאה לייצוא בכמות גדולה.",
    88045: "אין לך הרשאה ליצור מעורבות בתבנית.",
    88048: "החבילה מיובאת כעת על ידי משתמש אחר. בבקשה נסה שוב מאוחר יותר.",
    88049: "החבילה כבר לא קיימת. אנא רענן את הכרטיסייה.",
    88050: "יצירת עותק נוסף של תיק הביקורת מתבצעת כעת.",
    88051: "לתיק הביקורת יש יותר מדי עותקים בתהליך. המתן עד להשלמת העותקים לפני שתתחיל הפעלה נוספת.",
    88056: "לא ניתן להשלים את הפעולה. רענן את הדף ונסה שוב. אם הבעיה נמשכת פנה לתמיכה הטכנית.",
    88057: "מסמכים מסוימים שנבחרו מכילים ראיות קשורות במצב עריכה פעילה מרובת משתמשים. אנא בדוק את הראיות הקשורות כדי להמשיך. אם השגיאה נמשכת, פנה לתמיכה הטכנית.",

    /* Group Scopes */
    92001: "הקריאה לקבלת כל היקפי הביקורת של הקבוצה נכשלה.",
    92002: "הקריאה ליצירת היקף ביקורת של הקבוצה נכשלה.",
    92003: "בקשת עדכון לא חוקית של היקפי הביקורת של הקבוצה.",
    92004: "שם היקף לא חוקי.",
    92005: "מזהה היקף הביקורת של חברת האם לא חוקי.",
    92006: "היקף הביקורת של חברת האם אינו קיים.",
    92007: "תיאור היקף הביקורת לא חוקי.",
    92008: "אורך שם היקף הביקורת של הקבוצה עולה על יותר מ-100 תווים.",
    92009: "אורך תיאור היקף הביקורת של הקבוצה עולה על יותר מ-500 תווים.",
    92010: "הבקשה למחיקת טווחי קבוצה נכשלה.",
    92011: "תת-ההיקף המותאם אישית (custom sub-scope) שאתה עורך נמחק על ידי חבר צוות אחר. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    92012: "מזהה ההיקף שצוין אינו חוקי.",
    92013: "תת-היקף מותאם אישית (custom sub-scope) זה הוקצה לצוות אחד או יותר ולא ניתן למחוק אותו.",
    92014: "תת-ההיקף המותאם אישית (custom sub-scope) שאתה מנסה למחוק כבר נמחק על ידי חבר צוות אחר. רענן את הדף ונסה שוב.",
    92015: "למשתמש אין הרשאות לבצע את הפעולה.",
    92016: "שם היקף הביקורת כבר קיים בתיק ביקורת זה",
    92017: "הקריאה לקבלה לפי מזהה סקופינג לביקורת לקבוצה נכשלה.",

    /* Group Sections */
    101001: "הקריאה ליצירת מקטעים לקבוצה נכשלה.",
    101002: "שם הקבוצה לא יכול להיות ריק או null.",
    101003: "אורך שם המקטע של הקבוצה עולה על יותר מ-100 תווים.",
    101004: "שם המקטע כבר קיים בתיק ביקורת זה.",
    101005: "הקריאה לעריכת מקטעי הקבוצה נכשלה.",
    101006: "מזהה מקטע לא חוקי.",
    101007: "המקטע של הקבוצה לא קיים.",
    101008: "Engagement ID שגוי.",
    101009: "מקטע הידע לביקורת הקבוצה לא חוקי.",

    /* Group Documents */
    110001: "Engagement ID שגוי.",
    110002: "סטטוס ההנחיות לא חוקי.",
    110003: "בקשה לקבל ישויות לפי מספר זיהוי נכשלה.",

    /* ClientEngagement */
    93001: "תיאור תיק הביקורת של הלקוח לא נמצא.",
    93002: "תיאור תיק הביקורת של הלקוח לא צריך להיות יותר מ-100 תווים.",
    93003: "בקשת תיק הביקורת של הלקוח ריקה.",
    93004: "הקריאה לקבלת הלקוח נכשלה.",
    93005: "הקריאה לעדכון הלקוח נכשלה.",
    93006: "לא ניתן היה לעדכן את שם התצוגה של תיק הביקורת בשלב זה. רענן את הדף ונסה שוב. במידה והשגיאה נמשכת, אנא פנה לתמיכה הטכנית.",

    /*IP FIltering */
    96005: "{0} לא התווסף לרשימה המותרת.",
    96015: "אין מיקומי גישה זמינים לייבוא ​​מתיק הביקורת המקורי.",
    96016: "אין מיקומי גישה זמינים לייבוא ​​מתיק הביקורת המקורי.",

    /*RBAC SchedulerRequests */
    'permissionIssueForScheduler': "אין לך הרשאה לבקש שירותים. פנה למנהל ההתקשרות ובקש הרשאה לביצוע פעולה זו.",

    /* GroupInstructions */
    98001: "הקריאה לקבלת הנחיות הביקורת של הקבוצה נכשלה.",
    98002: "אחד או יותר מפסקאות ממוספרות מהנחיות מאגר הידע אינם חוקיים.",
    98003: "הקריאה ליצירת הנחיות ביקורת של הקבוצה נכשלה.",
    98004: "שם ההנחייה לא יכול להיות ריק.",
    98005: "שם ההוראה לא יכול לעלות על 500 תווים.",
    98006: "תיאור ההנחיות לא יכול להיות ריק.",
    98007: "תיאור ההנחיות אינו יכול לעלות על 4,000 תווים.",
    98008: "יש להקצות הנחיה להיקפי הביקורת או לצוותי הביקורת.",
    98009: "שם ההנחיה כבר קיים בתיק ביקורת זה.",
    98011: "הוראת קבוצה זו כבר נמחקה על ידי חבר צוות אחר. רענן את הדף ונסה שוב. פנה לדלפק העזרה אם השגיאה נמשכת.",
    98012: "הוראת קבוצה זו נמחקה על ידי חבר צוות אחר. רענן את הדף ונסה שוב. פנה לדלפק העזרה אם השגיאה נמשכת.",
    98016: "הוראת הקבוצה שאתה עורך נמחקה על ידי חבר צוות אחר. רענן את הדף ונסה שוב. פנה לדלפק העזרה אם השגיאה נמשכת.",
    98017: "משימה קבוצתית זו כבר נמחקה על ידי חבר צוות אחר. רענן את הדף ונסה שוב. פנה לדלפק העזרה אם השגיאה נמשכת.",
    98018: "משימה קבוצתית זו נמחקה על ידי חבר צוות אחר. רענן את הדף ונסה שוב. פנה לדלפק העזרה אם השגיאה נמשכת.",
    98019: "הישות לא נמצאה",

    /* Group Snapshots */
    102001: "הקריאה ליצירת תמונת מצב של הנחיות ביקורת לקבוצה נכשלה.",
    102002: "שגיאת פרמטרים של בקשה לא חוקית.",
    102003: "שגיאת תיק ביקורת לא חוקית.",
    102004: "הקריאה לקבלת כל תמונות המצב בקבוצה נכשלה.",
    102005: "הקריאה לקבלת תמונת מצב של הקבוצה נכשלה.",
    102006: "תמונת המצב לא נמצאה.",
    102007: "נבחר צילום מצב לא חוקי.",

    /* Group Links - Send link request */
    106001: "הקריאה לשליחת קישור לקבוצה נכשלה.",
    106002: "רשימת חברי הצוות לא יכולה להיות ריקה.",
    106003: "אחד או יותר מהצוות שנבחר אינו חוקי.",
    106004: "הודעת קישור לקבוצה נכשלה.",
    106005: "לא ניתן לחזור על הקבוצות.",
    106006: "לא ניתן לחזור על טוקנים (tokens) במקביל.",

    /* GroupInstructions - Send Version request */
    22019: "הצוות נדחה.",
    22023: "הקריאה לשליחת ההנחיות נכשלה.",
    22024: "הישות המוחזקת שאליה אתה מנסה לשלוח הנחיות אינה זמינה עוד או שכבר נמחקה.",
    22025: "מזהה תיק הביקורת לא יכול להיות ריק.",
    22026: "מזהה הישות המוחזקת לא יכול להיות ריק.",
    22027: "נמצאה הנחייה קבוצתית ללא תאריך יעד.",
    22028: "טרם פורסמה הנחיית היקף עבור הישות המוחזקת.",
    22029: "לא פורסמה הנחיה חדשה עבור הישות המוחזקת לשליחה.",
    22030: "גרסה זו של הנחיות ומשימות כבר התקבלה על ידי חבר צוות אחר. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",

    22031: "הקריאה לקבלת גרסה של הקבוצה נכשלה.",

    /* GroupVersion */
    22032: "ההנחיות לא קיימות.",

    22034: "הקריאה לקבלה לפי מזהה גרסה של הקבוצה נכשלה.",
    22035: "מזהה ערכת ההנחיות לא יכול להיות ריק.",

    /* Return instruction concurrency scenario*/
    22036: "גרסה חדשה של הנחיות ומשימות זמינה כעת. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    22037: "גרסה זו של הנחיות ומשימות כבר התקבלה על ידי חבר צוות אחר. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    22038: "גרסה זו של הנחיות ומשימות כבר הוחזרה על ידי חבר צוות אחר. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",

    37018: "חשבון GL זה אינו זמין עוד. רענן את הדף ונסה שוב. פנה ללתמיכה הטכנית אם השגיאה נמשכת.",
    37019: "לא ניתן לערוך את הקישור למסמך. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    37030: "חשבון GL זה אינו זמין עוד. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    37032: "לא ניתן לערוך את הקישור למסמך. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    37033: "לא ניתן לערוך את הקישור למסמך. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    37034: "לא ניתן לערוך את הקישור למסמך. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    37037: "התאמה זו אינה זמינה יותר. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",

    /* EngagementReports */
    111001: "הקריאה לקבלת דוח לפי סוג דוח נכשלה.",
    113015: "מאזן הבוחן (TB) לא זמין. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    113025: "נדרש סינון לפי מזהה סוג חשבון או סינון לפי מזהה חשבון, לא ניתן להמשיך.",
    113050: "מאזן בוחן או דוחות כספיים אינם שייכים להתקשרות זו או שהם עשויים להימחק, לא ניתן להמשיך.",

    /*Information Security */
    200001: "הפעולה שננקטה נאסרה על ידי EY Information Security. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",

    /*GL account concurrency scenario*/
    113043: "חשבון התאמה (reconciling account) זה אינו זמין עוד. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    113019: "חשבון התאמה (reconciling account) זה אינו זמין עוד. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    113022: "לא ניתן להשלים את הפעולה. רענן את הדף ונסה שוב. אם הבעיה נמשכת פנה לתמיכה הטכנית.",
    113039: "הפניה כבר משויכת לחשבון GL זה. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    113021: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
    113035: "הפניה כבר משויכת לחשבון GL זה. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    113020: "ראייה זו אינה זמינה עוד. רענן את הדף ונסה שוב. פנה לתמיכה הטכנית אם השגיאה נמשכת.",
    113037: "חשבון GL זה אינו זמין עוד. רענן את הדף ונסה שוב. פנה ללתמיכה הטכנית אם השגיאה נמשכת.",
    40029: "חשבון GL זה אינו זמין עוד. רענן את הדף ונסה שוב. פנה ללתמיכה הטכנית אם השגיאה נמשכת.",

    /*Trial balance*/
    113060: "MultiEntity נדרש עבור התקשרות מסוג MEST.",
    113061: "MultiEntity אינו נדרש עבור התקשרות שאינה מסוג MEST.",
    113057: "Engagement helix לא נמצא.",
    113094: "מאזן הבוחן (TB)  חייב להיות Planning and IstrialBalance מעודכן.",
    113095: "מאזן הבוחן (TB) לא אמור להיות Planning and IstrialBalance מעודכן כאשר הסוג הפיננסי הוא מאזן בוחן.",
    113069: "היקף ואסטרטגיה כבר קיימים עבור ההתקשרות.",
    113009: "מזהה מאזן בוחן לא חוקי, לא ניתן להמשיך.",
    113092: "מאזן בוחן הוא רלוונטי גם לתכנון וגם לצורך הדוחות הכספיים. לא ניתן להמשיך למחיקה זמנית (soft delete).",
    114033: "All business units mapped to a given entity must share at least one currency type and currency code. Please re-map your data and try again."

};

export const controlRiskTypeStep2 = [{
        id: 1,
        name: "הסתמכות על בקרות"
    },
    {
        id: 2,
        name: "לא להסתמך"
    },
    {
        id: 3,
        name: "בדיקת MP"
    }
];

/*Label Collections */
//Canvas Forms Statuses
export const canvasFormStatus = [{
        id: 1,
        value: "עדכון בתהליך"
    },
    {
        id: 3,
        value: "שגיאה"
    },
    {
        id: 5,
        value: "עדכון בתהליך"
    },
    {
        id: 6,
        value: "שגיאה"
    }
];

export const riskTypes = [{
        id: 1,
        name: "סיכונים משמעותיים",
        abbrev: "SR",
        title: "סיכון משמעותי (Significant Risk)"
    },
    {
        id: 2,
        name: "סיכוני הונאה",
        abbrev: "FR",
        title: "סיכון תרמית"
    },
    {
        id: 3,
        name: "סיכונים להצגה מוטעית מהותית (ROMM)",
        abbrev: "R",
        title: "ROMM/סיכון שבמהות (IR)"
    }
];

export const riskTypesToolTip = [{
        id: 1,
        name: "סיכונים משמעותיים",
        abbrev: 'SR',
        label: "משמעותי",
        title: "סיכון משמעותי (Significant Risk)"
    },
    {
        id: 2,
        name: "סיכוני הונאה",
        abbrev: "FR",
        label: "הונאה",
        title: "סיכון תרמית"
    },
    {
        id: 3,
        name: "סיכון להצגה מוטעית מהותית",
        abbrev: "R",
        label: "סיכון להצגה מוטעית מהותית",
        title: "סיכון להצגה מוטעית מהותית"
    }
];

export const risksTypes = [{
        id: 1,
        name: "סיכונים משמעותיים",
        abbrev: "SR",
        title: "סיכונים משמעותיים"
    },
    {
        id: 2,
        name: "סיכוני הונאה",
        abbrev: "FR",
        title: "סיכוני הונאה"
    },
    {
        id: 3,
        name: "סיכונים להצגה מוטעית מהותית (ROMM)",
        abbrev: "R",
        title: "סיכונים להצגה מוטעית מהותית (ROMM)"
    }
];

export const emptyRiskTypes = [{
        id: 1,
        label: "לא זוהו סיכונים משמעותיים"
    },
    {
        id: 2,
        label: "לא זוהו סיכוני הונאה"
    },
    {
        id: 3,
        label: "לא זוהו סיכונים להצגה מוטעית מהותית ROMM"
    }
];

export const controlRiskType = [{
        id: 1,
        name: "להסתמך"
    },
    {
        id: 2,
        name: "לא להסתמך"
    },
    {
        id: 3,
        name: "בדיקת MP"
    }
];
export const inherentRiskType = [{
        id: 1,
        name: "Higher"
    },
    {
        id: 2,
        name: "Lower"
    }
];
export const CRAStrings = {
    Minimal: "Minimal",
    Low: "Low",
    'Low +SC': "Low + SC",
    Moderate: "Moderate",
    High: "High",
    'High +SC': "High + SC"
};
export const priorityType = [{
        id: 1,
        name: "נמוך",
        className: 'Low',
        label: "L"
    },
    {
        id: 2,
        name: "בינוני",
        className: 'Medium',
        label: "M"
    },
    {
        id: 3,
        name: "גבוה",
        className: 'High',
        label: "H"
    },
    {
        id: 4,
        name: "קריטי",
        className: 'Critical',
        label: "C"
    }
];
export const reviewNoteFilterTypes = [{
        value: 0,
        label: "הכל"
    },
    {
        value: 1,
        label: "פתוח"
    },
    {
        value: 2,
        label: "נוקה"
    },
    {
        value: 3,
        label: "סגור"
    }
];
export const reviewStatus = [{
        id: 1,
        name: "פתוח"
    },
    {
        id: 2,
        name: "נוקה"
    },
    {
        id: 3,
        name: "סגור"
    }
];
export const reviewNoteOpenStatusOption = [{
        value: 2,
        label: "נקה"
    },
    {
        value: 3,
        label: "סגור"
    }
];
export const reviewNoteClearedStatusOption = [{
        value: 1,
        label: "לפתוח מחדש"
    },
    {
        value: 3,
        label: "סגור"
    }
];
export const reviewNoteBulkClearedStatusOption = [{
        value: 1,
        label: "לפתוח מחדש"
    },
    {
        value: 2,
        label: "נקה"
    },
    {
        value: 3,
        label: "סגור"
    }
];
export const reviewNoteClosedStatusOption = [{
    value: 1,
    label: "לפתוח מחדש"
}];
export const signOffTypes = [{
        value: 0,
        label: "מכין"
    },
    {
        value: 1,
        label: "סוקר"
    },
    {
        value: 2,
        label: "אף אחד"
    }
];
export const RNHNoteStatusOptions = [{
        value: 1,
        label: "פתוח"
    },
    {
        value: 2,
        label: "סגור"
    },
    {
        value: 3,
        label: "נוקה"
    }
];
export const assertions = [{
        id: 1,
        assertionname: "שלמות",
        assertionabbreviation: "C",
        statementtypeid: 2,
        displayorder: 1
    },
    {
        id: 2,
        assertionname: "קיום",
        assertionabbreviation: "E",
        statementtypeid: 2,
        displayorder: 2
    },
    {
        id: 3,
        assertionname: "ערך",
        assertionabbreviation: "V",
        statementtypeid: 2,
        displayorder: 3
    },
    {
        id: 4,
        assertionname: "זכויות ובעלות",
        assertionabbreviation: "R&O",
        statementtypeid: 2,
        displayorder: 4
    },
    {
        id: 5,
        assertionname: "הצגה וגילוי",
        assertionabbreviation: "P&D",
        statementtypeid: 2,
        displayorder: 5
    },
    {
        id: 6,
        assertionname: "שלמות",
        assertionabbreviation: "C",
        statementtypeid: 1,
        displayorder: 6
    },
    {
        id: 7,
        assertionname: "התרחשות",
        assertionabbreviation: "O",
        statementtypeid: 1,
        displayorder: 7
    },
    {
        id: 8,
        assertionname: "מדידה",
        assertionabbreviation: "M",
        statementtypeid: 1,
        displayorder: 8
    },
    {
        id: 9,
        assertionname: "הצגה וגילוי",
        assertionabbreviation: "P&D",
        statementtypeid: 1,
        displayorder: 9
    },
    {
        id: 10,
        assertionname: "שלמות",
        assertionabbreviation: "C",
        statementtypeid: 3,
        displayorder: 10
    },
    {
        id: 11,
        assertionname: "קיום/התרחשות",
        assertionabbreviation: "E/O",
        statementtypeid: 3,
        displayorder: 11
    },
    {
        id: 12,
        assertionname: "מדידה/ערך",
        assertionabbreviation: "M/V",
        statementtypeid: 3,
        displayorder: 12
    },
    {
        id: 13,
        assertionname: "זכויות ובעלות",
        assertionabbreviation: "R&O",
        statementtypeid: 3,
        displayorder: 13
    },
    {
        id: 14,
        assertionname: "הצגה וגילוי",
        assertionabbreviation: "P&D",
        statementtypeid: 3,
        displayorder: 14
    }
];
//Add Review Note
export const priorityTypes = [{
        value: 1,
        label: "נמוך"
    },
    {
        value: 2,
        label: "בינוני"
    },
    {
        value: 3,
        label: "גבוה"
    },
    {
        value: 4,
        label: "קריטי"
    }
];
/*Cog Menu*/
export const cogMenuOptions = {
    Open: "פתח",
    'Start Co-edit mode': "התחל בעריכה מרובת משתמשים",
    'End Co-edit mode': "סיום עריכה מרובת משתמשים",
    'Open read-only': "פתוח לקריאה בלבד",
    'View history': "הצג היסטוריה",
    CopyLink: "העתק את הקישור",
    Rename: "שנה שם",
    Delete: "מחק",
    'Remove from task': "הסר מהמשימה",
    Remove: "הסר",
    Unlink: "בטל קישור",
    RelateTasks: "קשר משימות",
    RelateEntities: "ישויות קשורות",
    Restore: "שוחזר",
    PermanentlyDelete: "מחיקה לצמיתות",
    ChangeReason: "ערוך את הסיבה",
    Confidentiality: "סודיות",
    SignoffRequirements: "דרישות חתימה",
    AssignRegionComponent: "הקצה לישות מחזיקה או לישות מוחזקת",
    UnassignRegionComponent: "בטל הקצאה מישות מחזיקה או מישות מוחזקת",
    ReturnToRegionComponent: "החזרה לישות מחזיקה או לישות מוחזקת",
    ClearReturnToRegionComponent: "בטל החזרה לישות מחזיקה או לישות מוחזקת",
    OverwriteForm: "החלף טופס",
    Finalize: "סיים את המסמך"
};

export const pagingSvgHoverText = {
    first: "הדף הראשון",
    previous: "הדף הקודם",
    next: "הדף הבא",
    last: "הדף האחרון"
};
export const controlFrequencyType = {
    1: "הרבה פעמים ביום",
    2: "יומי",
    3: "שבועי",
    4: "חודשי",
    5: "רבעוני",
    6: "שנתי",
    7: " בקרת אפליקציית IT",
    8: "אחרים"
};
export const itApproachType = {
    1: "בקרות",
    2: "ביקורת מבססת"
};
export const controlType = {
    1: "אפליקציית IT",
    2: "בקרה ידנית תלויית מחשב (ITDM)",
    3: "מונעת ידנית",
    4: "בקרה ידנית מגלה"
};
export const aggregateITEvaluationType = {
    1: "תמיכה",
    2: "לא נתמך",
    3: "תמיכה ב-FS & ICFR",
    4: "תמיכה ב-FS בלבד"
};
export const entityType = {
    'ENTITY3': "סעיף",
    'ENTITY4': "תת התהליך המהותי (SCOT)",
    'ENTITY5': "ITProcess",
    'ENTITY7': "סיכון",
    'ENTITY18': "WCGW",
    'ENTITY19': "בקרה",
    'ENTITY20': "יישום ITSO",
    'ENTITY24': "יעד הנהלה",
    'ENTITY34': "ITControl",
    'ENTITY35': "ITRisk"
};
export const trueFalseToYesNo = {
    'true': "כן",
    'false': "לא"
}
export const trueFalseToYesOnly = {
    'true': "כן"
}
export const yesNoLocalized = {
    'Yes': "כן",
    'No': "לא"
}
export const iTProcessEvaluationType = {
    1: "יעיל",
    2: "לא יעיל",
    3: "אמין",
    4: "לא נבחן"
};

export const strategyType = {
    1: "בקרות",
    2: "ביקורת מבססת",
    3: "הסתמכות על בקרות",
    4: "לא להסתמך"
};
export const accountType = {
    1: "סעיפים מהותיים",
    2: "סעיף בסיכון מוגבל (Limited risk account)"
};

export const scotTypes = {
    1: "Routine",
    2: "Non Routine",
    3: "Estimation"
};
export const taskNavigation = {
    1: "המשימות שלי",
    2: "כל המשימות",
    3: "היקף ואסטרטגיה",
    4: "תתי תהליכים מהותיים (SCOTs)",
    5: "IT/SOs",
    6: "סעיפים",
    7: "נוהל ביקורת כללי",
    8: "מסקנה",
    9: "סיכום צוות (Team Summary)",
    10: "סיכונים"
};
export const subCategoty = {
    1: "הצג הכול",
    2: "להכין",
    3: "לסקירה"
};
export const subCategoryType = {
    AllTasks: {
        id: 1,
        title: "הצג הכל",
        label: "הצג הכל"
    },
    ToPrepare: {
        id: 2,
        title: "להכין",
        label: "להכין"
    },
    ToReview: {
        id: 3,
        title: "לסקירה",
        label: "לסקירה"
    },
    Preparers: {
        id: 2,
        title: "מכינים (Preparers)",
        label: "מכינים (Preparers)"
    },
    Reviewers: {
        id: 3,
        title: "סוקרים",
        label: "סוקרים"
    }
};
/*Task Types*/
export const taskType = {
    1: "משימה רגילה",
    2: "משימה סטנדרטית של חברת האם",
    3: "משימת Walkthrough",
    4: "משימת בקרה",
    5: "משימה מבססת",
    6: "משימת מבססת של חברת האם",
    7: "משימת מענה",
    8: "משימה לביקורת קבוצה (Group Task)"
};

export const taskTypesForAddTask = {
    importfromknowledge: "ייבא מהידע (Knowledge)",
    custom: "מותאם אישית",
    account: "סעיף",
    itsubstantive: "נהלי IT מבססים",
    scotwalkthroughtask: "SCOT walkthrough",
    scotcontroltask: "בקרת SCOT",
    itwalkthroughtask: "IT walkthrough",
    itcontroltask: "בקרת IT"
};

export const taskTypeBadge = {
    1: "OST",
    2: "PST",
    3: "WT",
    4: "TOC",
    5: "OSP",
    6: "PSP",
    7: "RT",
    8: "GT",
    9: "PIC",
    10: "EQR",
    11: "PIC/EQR",
    22: "ACT",
    23: "UDP"
};
/*Task Types*/
export const taskTypeAbbreviation = {
    1: "TOC",
    2: "TOC",
    3: "TOC",
    4: "TOC",
    5: "TOC",
    6: "TOC",
    7: "RT",
    8: "RT",
    9: "RT",
    10: "RT",
    11: "RT",
    13: "OST",
    14: "PST",
    16: "OSP",
    17: "PSP",
    18: "WT",
    19: "UDP",
    20: "WT",
    22: "ACT",
    23: "GT",
    24: "GT",
    25: "GT",
    26: "OSP",
    27: "GT"
};
export const auditPhase = {
    1: "היקף ואסטרטגיה",
    2: "ביצוע הביקורת",
    3: "מסקנה"
};
export const ProfileActionType = {
    1: "Profile Submit - First Time",
    2: "Profile Submit - RollForward",
    3: "Profile Edit",
    4: "Global Content Update",
    5: "ייבא PSPs",
    6: "ייבא PSTs",
    7: "Canvas Form Content Update",
    8: " ייבא חבילות דיווח לרואי החשבון של הקבוצה",
    9: "הוסף טופס ידני",
    10: "פרופיל (Profile Delivery)",
    11: "עדכון תוכן חובה (Mandatory Content Update)",
    12: "סנכון פרופיל טופס Canvas (Canvas Form Profile Sync)"
};

export const taskGroup = {
    1: "בצע נהלי תכנון ביקורת נוספים",
    2: "תהליך יצירת הסעיפים",
    3: "תהליך יצירת תתי תהליכים מהותיים (SCOT)",
    4: "תהליך יצירת יישומי (אפליקציות) IT ולשכות שירות",
    5: "תהליך יצירת הערכת הסיכון המשולב (CRA)",
    6: "תהליך יצירת תכנית הביקורת",
    7: "בצע נהלי ביקורת לסיכום ההתקשרות",
    8: "סיכום הפרשי הביקורת (SAD)",
    9: "הערכת תוצאות הביקורת",
    10: "בצע נהלי ביקורת נוספים",
    11: "מבנה הביקורת של הקבוצה",
    12: "הנחיות הביקורת של הקבוצה",
    13: "משימות ראשיות לביקורת הקבוצה",
    14: "משימות לביקורת הקבוצה בישות המוחזקת (Component)",
    15: "תוכנית הביקורת",
    16: "Accounts Flow - MEST",
    17: "בצע נהלי סקירה",
    18: "השלם משימות תכנון ראשוניות",
    19: "קבע את צוות ההתקשרות",
    20: "אפשר קבלת נתונים להתקשרות",
    21: "בצע נהלים אנליטיים להערכת סיכונים וקבע ספי מהותיות",
    22: "Identify significant accounts - MEST",
    23: "נהלים נוספים כדי לעדכן את הערכת הסיכונים שלנו",
    24: "זהה את המקור",
    25: "זהה סעיפים מהותיים",
    26: "זהה והשג הבנה של ה -  SCOTs",
    27: "זהה והשג הבנה של תהליכי IT ולשכות שירות",
    28: "אשר את איסטרטגיית הביקורת וה - CRA",
    29: "בצע נהלים נוספים לזיהוי סיכונים",
    30: "הפעל שיקול דעת בקשר לשימוש בעבודת מבקר הפנים",
    31: "תן מענה לסיכונים שזוהו",
    32: "סכם את האיסטרטגיה של הביקורת",
    33: "נהלי שותף מלווה (EQR)",
    34: "תכנן נהלי ביקורת",
    35: "הערך וקבע מסקנות בקשר לראיות הביקורת",
    36: "בצע תקשורת של ממצאי הביקורת ",
    37: "נהלי ביקורת של שותף מלווה (EQR)",
    38: " הכן וגבש את חוות דעת רואה החשבון המבקר",
    39: "השלם תיעוד וארכב את תיק הביקורת",
    40: "בצע דגימה לבקרות ברמת בקרת העל",
    41: "הערך את תוצאות של הנתונים שנעשה בהם שימוש בכלים דיגיטליים",
    42: "בצע את הנהלים הדרושים בקשר לתרמיות",
    43: "בצע נהלים של הסתמכות על עבודת מבקר הפנים ומומחים",
    44: "הערך תהליכי IT",
    45: "פרוקולים של ישיבות, חוזים ומכתבים מיועצים משפטיים",
    46: "בצע נהלים על דוחות כספיים",
    47: "בצע נהלי RPTs, עסק חי ובחינה של עמידה בחוקים ורגולציה",
    48: "דון בשינויים באיסטרטגיית הביקורת",
    49: " סיכום ממצאי הביקורת ",
    50: "נהלי ביקורת של שותף מלווה (EQR)",
    51: "השלם את פעילויות האיכות בשלב ההיקף והאסטרטגיה",
    52: "בצע נהלי ביקורת התחלתיים",
    53: "בצע נהלים להערכת סיכונים",
    54: "זיהוי ארגוני שירות",
    55: "Digital -  קבוצת משימות  5",
    56: "זיהוי והבנת תהליכי IT",
    57: "ביצוע הליכי תכנון",
    58: "מבנה הקבוצה, הנחיות ומעורבות",
    59: "זיהוי גילויים משמעותיים",
    60: "זיהוי והבנה של תהליכי דיווח משמעותיים",
    61: "Digital -  קבוצת משימות  11",
    62: "Digital -  קבוצת משימות  12",
    63: "Digital -  קבוצת משימות  13",
    64: "Digital -  קבוצת משימות  14",
    65: "Digital -  קבוצת משימות  15",
    66: "Digital -  קבוצת משימות  16",
    67: "Digital -  קבוצת משימות  17",
    68: "השלם נהלים של תקופת ביניים בקשר לתכנון הביקורת על ידי המנהלים ",
    69: 'Execute substantive procedures - Governance',
    70: 'Execute substantive procedures - Strategy',
    71: 'Execute substantive procedures - Risk Management',
    72: 'Execute substantive procedures - Metrics and Targets',
    73: "ביצוע נהלים מבססים - אחר",
    74: "להעריך עבודה של אחרים",
    75: "Digital -  קבוצת משימות  25",
    76: "Digital -  קבוצת משימות  26",
    77: "Digital -  קבוצת משימות  27",
    78: "Digital -  קבוצת משימות  28",
    79: "Digital -  קבוצת משימות  29",
    80: "Digital -  קבוצת משימות  30",
    81: "Digital -  קבוצת משימות  31",
    82: "Digital -  קבוצת משימות  32",
    83: "Digital -  קבוצת משימות  33",
    84: "Digital -  קבוצת משימות  34",
    85: "הערך וקבע מסקנות בקשר לסקירה של ראיות הביקורת",
    86: "בצע נהלים מבססים כלליים",
    87: "להעריך ולהסיק על ראיות",
    88: "Digital -  קבוצת משימות  38",
    89: "Digital -  קבוצת משימות  39",
    90: "Digital -  קבוצת משימות  40",
    91: "Digital -  קבוצת משימות  41",
    92: "Digital -  קבוצת משימות  42",
    93: "Digital -  קבוצת משימות  43",
    94: "Digital -  קבוצת משימות  44",
    95: "Digital -  קבוצת משימות  45",
    96: "Digital -  קבוצת משימות  46",
    97: "Digital -  קבוצת משימות  47",
    98: "Digital -  קבוצת משימות  48",
    99: "Digital -  קבוצת משימות  49",
    100: "Digital -  קבוצת משימות  50"
};
export const AutomationHubRequestStatus = {
    Draft: "טיוטה",
    Submitted: "נשלח",
    Sent: "השליחה מתבצעת",
    InProgress: "Processing",
    Failed: "שגיאת עיבוד",
    Completed: "הושלם",
    FailedToSendToBP: "שגיאת עיבוד",
    QueueingFailed: "השליחה נכשלה",
    ActionRequired: "פעולה נדרשת"
};
export const milestonesLabels = {
    1: "היקף",
    2: "אסטרטגיית תת התהליך המהותי (SCOT)",
    3: "Walkthroughs",
    4: "טסטים על בקרות בתקופות ביניים",
    5: "בדיקות מבססות בתקופות ביניים",
    6: "Walkthroughs (תהליכי סוף השנה)",
    7: "טסטים על בקרות בסוף שנה",
    8: "בדיקות מבססות בסוף שנה",
    9: "מסקנה",
    10: "לא ישים",
    11: "ביצוע הביקורת",
    12: "פעילויות איכות בשלב ההיקף והאסטרטגיה",
    13: "תכנון ואסטרטגיה אחרים",
    14: "CRA",
    15: "הערכת סיכונים ומהותיות",
    16: "גיבוש סופי של היקף ואסטרטגית הביקורת ",
    17: "Post-interim project management"
};

export const TasksFilterGroups = {
    Tasks: "משימות",
    Assignments: "משימות לביצוע",
    ReviewNotes: "סקירת הערות",
    ProjectManagement: "ניהול פרויקטים",
    Other: "אחרים"
};

export const TasksFilterTypes = {
    TaskStatus: "סטטוס המשימה",
    TaskType: "סוג משימה",
    AssignedTo: "הוקצה ל",
    OpenAssignments: "משימות פתוחות",
    ReviewNotesStatus: "סטטוס הערות סקירה",
    ReviewNotesAssignedTo: "הערות סקירה הוקצו ל",
    ReviewNotesCreatedBy: "הערות סקירה נוצרו על ידי",
    TimePhase: "Time Phase",
    Milestone: "אבן דרך",
    AuditPhase: "שלב בביקורת",
    DocumentConflict: "קונפליקט בסנכרון מסמכים",
    Findings: "ממצאים",
    Entity: "ישות",
    IsBookmarked: "הורד  לעבודה במצב לא מקוון"
};

export const quickFilterTaskStatus = [{
        value: '1',
        label: "פתח"
    },
    {
        value: '2',
        label: "מתבצע"
    },
    {
        value: '3',
        label: "בסקירה"
    },
    {
        value: '4',
        label: "המשימות למענה  בביקורת הושלמו"
    }
];

export const quickFilterAssignmentStatus = [{
        value: '1',
        label: "פתח"
    },
    {
        value: '2',
        label: "מתבצע"
    },
    {
        value: '3',
        label: "סגור"
    },
    {
        value: '4',
        label: "Unassigned"
    }
];

export const dataExport = [
	// 'Archive Form',
	// 'Canvas Forms',
	"שיתוף פעולה",
	// 'Control Forms',
	"מסמכים",
	"משימות",
	"סיכום תת תהליך מהותי (SCOT)",
	// 'Team Members',
	// 'Trial Balance'
];
export const dataExportReportNames = {
    'Archive Form': "טופס ארכיב",
    'Canvas Forms': "דוח טופס Canvas (Canvas Form Report)",
    'Collaboration': "שיתוף פעולה",
    'Control Forms': "דוח בקרה (Control Report)",
    'Documents': "דוח כל המסמכים (All Documents Report)",
    'Tasks': "דוח כל המשימות (All Tasks Report)",
    'Team Members': "חברי הצוות",
    'Trial Balance': "דוח מספרים (Numbers Report)"
};
export const projectManagement = [
	"Collaboration Details",
	// 'Digital scorecard',
	// 'Milestones',
	// 'Review Notes',
	// 'Validation Checks'
];

export const projectManagementReportNames = {
    'Collaboration Details': "לוח מחוונים (Dashboard) לשיתוף פעולה עם לקוחות",
    'Milestones': "דוח אבן דרך (Milestone Report)",
    'Review Notes': "סקור את דוח ההערות",
    'Validation Checks': "דוח בדיקות אימות (Validation Checks)"
};

export const taskQuickFilterOptions = [{
        id: 'taskToPreparer',
        label: "משימות להכנה",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'tasksReadyForReview',
        label: "משימות מוכנות לסקירה",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allAssignedTasks',
        label: "כל המשימות שהוקצו",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allOverdueTasks',
        label: "משימות שתאריך היעד שלהם עבר",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allTasksDueThisWeek',
        label: "משימות שתאריך היעד שלהן השבוע",
        uiViewId: uiViews.taskSystemSuggestedFilter
    }
];

export const noDefaultFilter = {
    id: 'noDefaultFilter',
    label: "אין מסנן ברירת מחדל"
};

export const taskTypes = [{
        id: '1',
        label: "משימת בקרה"
    },
    {
        id: '2',
        label: "משימת בקרה - בקרה"
    },
    {
        id: '3',
        label: "משימת בקרה - ELC"
    },
    {
        id: '4',
        label: "משימת בקרה - IT/SO"
    },
    {
        id: '5',
        label: "משימת בקרה - MP"
    },
    {
        id: '6',
        label: "משימת בקרה - SO"
    },
    {
        id: '7',
        label: "משימת מענה"
    },
    {
        id: '8',
        label: "משימה למענה על טעות מהותית בתזרים מזומנים"
    },
    {
        id: '9',
        label: "משימת מענה לליקוי"
    },
    {
        id: '10',
        label: "משימת מענה לטעות בגילוי"
    },
    {
        id: '11',
        label: "משימת מענה לטעות מהותית"
    },
    {
        id: '12',
        label: "משימה רגילה"
    },
    {
        id: '13',
        label: "משימה רגילה אחרת"
    },
    {
        id: '14',
        label: "משימה סטנדרטית של חברת האם"
    },
    {
        id: '15',
        label: "נוהל מבסס"
    },
    {
        id: '16',
        label: "משימת נוהל מבסס אחר"
    },
    {
        id: '17',
        label: "משימת מבססת של חברת האם"
    },
    {
        id: '18',
        label: "משימת Walkthrough"
    },
    {
        id: '19',
        label: "משימת Walkthrough - IT/SO"
    },
    {
        id: '20',
        label: "משימת Walkthrough - SCOT"
    },
    {
        id: '21',
        label: "משימות לביצוע"
    },
    {
        id: '22',
        label: "משימת סיכום ומסקנה לסעיף"
    },
    {
        id: '23',
        label: "משימה לביקורת קבוצה (Group Task)"
    },
    {
        id: '24',
        label: "משימה לביקורת קבוצה"
    },
    {
        id: '25',
        label: "משימה לביצוע של ישויות בקבוצה"
    },
    {
        id: '26',
        label: "IT/SO משימת נוהל ביקורת מבסס אחר"
    },
    {
        id: '27',
        label: "משימה לביצוע של ישויות בקבוצה אינה מקושרת"
    }
];

export const filterAssignmentType = [{
        value: '1',
        label: "P"
    },
    {
        value: '2',
        label: "סוקר לסקירה מפורטת"
    },
    {
        value: '3',
        label: "סוקר כללי"
    },
    {
        value: '4',
        label: "שותף"
    },
    {
        value: '5',
        label: "EQR"
    },
    {
        value: '6',
        label: "אחרים"
    }
];

export const filterTaskStatus = [{
        value: '1',
        label: "פתח"
    },
    {
        value: '2',
        label: "מתבצע"
    },
    {
        value: '3',
        label: "בסקירה"
    },
    {
        value: '4',
        label: "המשימות למענה בביקורת הושלמו"
    },
    {
        value: '5',
        label: "אין ראיות"
    }
];

export const filterAssignmentStatus = [{
        value: '1',
        label: "פתח"
    },
    {
        value: '2',
        label: "בתהליך"
    },
    {
        value: '3',
        label: "סגור"
    },
    {
        value: '4',
        label: "Unassigned"
    }
];

export const filterTaskType = [{
        value: '1',
        label: "משימת בקרה"
    },
    {
        value: '7',
        label: "משימת מענה"
    },
    {
        value: '13',
        label: "משימה רגילה אחרת"
    },
    {
        value: '14',
        label: "משימה סטנדרטית של חברת האם"
    },
    {
        value: '16',
        label: "משימת נוהל מבסס אחר"
    },
    {
        value: '17',
        label: "משימה קבוצתית"
    },
    {
        value: '18',
        label: "משימת Walkthrough/ UDP"
    },
    {
        value: '22',
        label: "משימת סיכום ומסקנה לסעיף"
    },
    {
        value: '999',
        label: "נדרשת אישור השותף האחראי על הביקורת PIC"
    },
    {
        value: '1000',
        label: "נדרשת חתימה של השותף המלווה (EQR)"
    }
];

export const filterTaskTypeGroupEngagement = [{
        value: '1',
        label: "משימת בקרה"
    },
    {
        value: '7',
        label: "משימת מענה"
    },
    {
        value: '13',
        label: "משימה רגילה אחרת"
    },
    {
        value: '14',
        label: "משימה סטנדרטית של חברת האם"
    },
    {
        value: '16',
        label: "משימת נוהל מבסס אחר"
    },
    {
        value: '17',
        label: "משימה קבוצתית"
    },
    {
        value: '18',
        label: "הדרכה/מטלת UDP"
    },
    {
        value: '22',
        label: "משימת סיכום ומסקנה לסעיף"
    },
    {
        value: '23',
        label: "סריקת וירוסים והעברה בתהליך"
    },
    {
        value: '999',
        label: "נדרשת אישור השותף האחראי על הביקורת PIC"
    },
    {
        value: '1000',
        label: "נדרשת חתימה של השותף המלווה (EQR)"
    }
];

export const filterTaskTypeInterimEngagement = [{
        value: '14',
        label: "משימה סטנדרטית של חברת האם"
    },
    {
        value: '13',
        label: "משימה רגילה אחרת"
    },
    {
        value: '23',
        label: "סריקת וירוסים והעברה בתהליך"
    },
    {
        value: '999',
        label: "נדרשת אישור השותף האחראי על הביקורת PIC"
    },
    {
        value: '1000',
        label: "נדרשת חתימה של השותף המלווה (EQR)"
    }
];

export const filterMilestones = [{
        value: '1',
        label: "היקף",
        hideFromMenu: true
    },
    {
        value: '2',
        label: "אסטרטגיית תת התהליך המהותי (SCOT)",
        hideFromMenu: true
    },
    {
        value: '12',
        label: "פעילויות איכות בשלב ההיקף והאסטרטגיה"
    },
    {
        value: '13',
        label: "תכנון ואסטרטגיה אחרים"
    },
    {
        value: '14',
        label: "CRA"
    },
    {
        value: '15',
        label: "הערכת סיכונים ומהותיות"
    },
    {
        value: '16',
        label: "גיבוש סופי של היקף ואסטרטגית הביקורת"
    },
    {
        value: '17',
        label: "Post-interim project management"
    },
    {
        value: '3',
        label: "Walkthroughs"
    },
    {
        value: '4',
        label: "טסטים על בקרות בתקופות ביניים"
    },
    {
        value: '5',
        label: "בדיקות מבססות בתקופות ביניים"
    },
    {
        value: '6',
        label: "Walkthroughs (תהליכי סוף השנה)"
    },
    {
        value: '7',
        label: "טסטים על בקרות בסוף שנה"
    },
    {
        value: '8',
        label: "בדיקות מבססות בסוף שנה"
    },
    {
        value: '11',
        label: "ביצוע הביקורת"
    },
    {
        value: '9',
        label: "מסקנה"
    },
    {
        value: '10',
        label: "לא רלוונטי"
    },
    {
        value: '0',
        label: "אין אבן דרך"
    }
];

export const documentListMilestones = [{
        value: '1',
        label: "היקף"
    },
    {
        value: '12',
        label: "project management - היקף ואסטרטגיה"
    },
    {
        value: '13',
        label: "תכנון ואסטרטגיה אחרים"
    },
    {
        value: '2',
        label: "אסטרטגיית תת התהליך המהותי (SCOT)"
    },
    {
        value: '14',
        label: "CRA"
    },
    {
        value: '15',
        label: "הערכת סיכונים ומהותיות"
    },
    {
        value: '16',
        label: "גיבוש סופי של היקף ואסטרטגית הביקורת "
    },
    {
        value: '17',
        label: "Post-interim project management"
    },
    {
        value: '3',
        label: "Walkthroughs"
    },
    {
        value: '4',
        label: "טסטים על בקרות בתקופות ביניים"
    },
    {
        value: '5',
        label: "בדיקות מבססות בתקופות ביניים"
    },
    {
        value: '6',
        label: "Walkthroughs (תהליכי סוף השנה)"
    },
    {
        value: '7',
        label: "טסטים על בקרות בסוף שנה"
    },
    {
        value: '8',
        label: "בדיקות מבססות בסוף שנה"
    },
    {
        value: '11',
        label: "ביצוע הביקורת"
    },
    {
        value: '9',
        label: "מסקנה"
    },
    {
        value: '10',
        label: "לא רלוונטי"
    }
];

export const filterAuditPhases = [{
        value: '1',
        label: "היקף ואסטרטגיה"
    },
    {
        value: '2',
        label: "ביצוע הביקורת"
    },
    {
        value: '3',
        label: "מסקנה"
    }
];


export const filterDocListReviewNoteStatus = [{
        value: 1,
        label: "פתח"
    },
    {
        value: 5,
        label: "Cleared"
    },
    {
        value: 2,
        label: "סגור"
    }
];

export const filterDocumentConflicts = [{
    value: '1',
    label: "כן"
}, {
    value: '0',
    label: "לא"
}];
export const filterDownloadedForOffline = [{
    value: '1',
    label: "כן"
}, {
    value: '2',
    label: "לא"
}];

export const missingEntityDocuments = [{
    value: 10034,
    label: "כן"
}]


export const filterTaskFindings = [{
        value: '1',
        label: "ליקוי"
    },
    {
        value: '2',
        label: "הצגה מוטעית"
    }
];

export const ConfidentialityTypes = [{
        id: 1,
        Name: "בְּרִירַת מֶחדָל"
    },
    {
        id: 2,
        Name: "Low"
    },
    {
        id: 3,
        Name: "Moderate"
    },
    {
        id: 4,
        Name: "High"
    },
    {
        id: 5,
        Name: "סודי"
    }
];

export const RoleForMember = [{
        id: 1,
        role: "Partner in Charge",
        roleAbbreviation: "PIC",
        displayOrder: 9
    },
    {
        id: 2,
        role: "Engagement Partner",
        roleAbbreviation: "EP",
        displayOrder: 8
    },
    {
        id: 3,
        role: "Executive Director",
        roleAbbreviation: "ED",
        displayOrder: 5
    },
    {
        id: 4,
        role: "שותף",
        roleAbbreviation: "שותף",
        displayOrder: 6
    },
    {
        id: 5,
        role: "סניור מנג'ר",
        roleAbbreviation: "SR.MANAGER",
        displayOrder: 4
    },
    {
        id: 6,
        role: "Manager",
        roleAbbreviation: "מנג'ר",
        displayOrder: 3
    },
    {
        id: 7,
        role: "Senior",
        roleAbbreviation: "סניור",
        displayOrder: 2
    },
    {
        id: 8,
        role: "Staff",
        roleAbbreviation: "מתמחה",
        displayOrder: 1
    },
    {
        id: 9,
        role: "מתמחה",
        roleAbbreviation: "מתמחה"
    },
    {
        id: 10,
        role: "Engagement Quality Reviewer",
        roleAbbreviation: "EQR",
        displayOrder: 10
    },
    {
        id: 11,
        role: "שותף אחר",
        roleAbbreviation: "שותף אחר",
        displayOrder: 7
    },
    {
        id: 12,
        role: "GDS - Staff",
        roleAbbreviation: "צוות GDS",
        displayOrder: 13
    },
    {
        id: 13,
        role: "ייעוץ (ITRA,TAS,Human Capital או אחר)",
        roleAbbreviation: "ADV"
    },
    {
        id: 14,
        role: "TAX",
        roleAbbreviation: "TAX"
    },
    {
        id: 15,
        role: "שירותי תמיכה ניהוליים",
        roleAbbreviation: "ESS"
    },
    {
        id: 16,
        role: "יועץ משפטי",
        roleAbbreviation: "GCO",
        displayOrder: 12
    },
    {
        id: 17,
        role: "סוקר AQR",
        roleAbbreviation: "AQR",
        displayOrder: 11
    },
    {
        id: 18,
        role: "ML צוות הביקורת של ישות מוחזקת (Component Team) ",
        roleAbbreviation: "MCT"
    },
    {
        id: 19,
        role: "Client Supervisor",
        roleAbbreviation: "ג. Supervisor'"
    },
    {
        id: 20,
        role: "צוות הלקוח",
        roleAbbreviation: "ג Staff"
    },
    {
        id: 21,
        role: "אחראי על הביקורת הפנימית",
        roleAbbreviation: "מפקח IA"
    },
    {
        id: 22,
        role: "צוות ביקורת פנימית",
        roleAbbreviation: "צוות IA"
    },
    {
        id: 23,
        role: "רגולטור",
        roleAbbreviation: "רגולטור"
    },
    {
        id: 24,
        role: "אחר (למשל בדיקה נאותות)",
        roleAbbreviation: "אחרים"
    },
    {
        id: 25,
        role: "משרד",
        roleAbbreviation: "משרד"
    },
    {
        id: 26,
        role: "אזור",
        roleAbbreviation: "אזור"
    },
    {
        id: 27,
        role: "תעשייה",
        roleAbbreviation: "IND"
    },
    {
        id: 28,
        role: "National",
        roleAbbreviation: "NAT"
    },
    {
        id: 29,
        role: "Global",
        roleAbbreviation: "GBL"
    },
    {
        id: 30,
        role: "GDS - Senior",
        roleAbbreviation: "סניור בצוות GDS",
        displayOrder: 14
    },
    {
        id: 31,
        role: "GDS - Manager",
        roleAbbreviation: "מנהל GDS",
        displayOrder: 15
    }
];

export const SubServiceLines = [{
        subServiceLineId: 1,
        subServiceLineName: "ביקורת",
        displayOrder: 1
    },
    {
        subServiceLineId: 2,
        subServiceLineName: "FIDS",
        displayOrder: 2
    },
    {
        subServiceLineId: 9,
        subServiceLineName: "FAAS",
        displayOrder: 3
    },
    {
        subServiceLineId: 11,
        subServiceLineName: "CCaSS",
        displayOrder: 4
    },
    {
        subServiceLineId: 12,
        subServiceLineName: "BTS",
        displayOrder: 5
    },
    {
        subServiceLineId: 13,
        subServiceLineName: "Human Capital",
        displayOrder: 6
    },
    {
        subServiceLineId: 14,
        subServiceLineName: "חוֹק",
        displayOrder: 7
    },
    {
        subServiceLineId: 15,
        subServiceLineName: "Indirect Tax",
        displayOrder: 8
    },
    {
        subServiceLineId: 16,
        subServiceLineName: "GCR",
        displayOrder: 9
    },
    {
        subServiceLineId: 17,
        subServiceLineName: "Transaction Tax",
        displayOrder: 10
    },
    {
        subServiceLineId: 18,
        subServiceLineName: "ITS",
        displayOrder: 11
    },
    {
        subServiceLineId: 19,
        subServiceLineName: "GCO",
        displayOrder: 12
    },
    {
        subServiceLineId: 20,
        subServiceLineName: "Business Consulting",
        displayOrder: 13
    },
    {
        subServiceLineId: 21,
        subServiceLineName: "Technology Consulting",
        displayOrder: 14
    },
    {
        subServiceLineId: 22,
        subServiceLineName: "Transactions and Corporate Finance",
        displayOrder: 15
    },
    {
        subServiceLineId: 23,
        subServiceLineName: "EY Parthenon",
        displayOrder: 16
    },
    {
        subServiceLineId: 24,
        subServiceLineName: "אחרים",
        displayOrder: 17
    },
    {
        subServiceLineId: 25,
        subServiceLineName: "סיכון טכנולוג",
        displayOrder: 18
    }
];

export const SchedulerRequestRole = [{
        id: 31,
        userTypeId: 4,
        label: "מנהל GDS"
    },
    {
        id: 31,
        userTypeId: 3,
        label: "מנהל בקשות"
    }
];

/* Task Status */
export const TaskStatus = [{
        id: 1,
        label: "פתוח (Open)"
    },
    {
        id: 2,
        label: "מתבצע (In Progress)"
    },
    {
        id: 3,
        label: "בעיון (In Review)"
    },
    {
        id: 4,
        label: "הושלם (Complete)"
    },
    {
        id: 5,
        label: "הוסר"
    },
    {
        id: 6,
        label: "חתימת השותף האחראי על הביקורת PIC / השותף המלווה EQR הושלמה"
    }
];
/* GATaskSendStatus*/
export const GATaskSendStatus = [{
        id: 1,
        label: "לא נשלח"
    },
    {
        id: 2,
        label: "מתבצע"
    },
    {
        id: 3,
        label: "נשלח"
    },
    {
        id: 4,
        label: "הוחזר"
    }
];
// 9 - Return error (UI value, doesn't exist in database)
export const GAComponentDocumentStatusLabels = [{
        id: GAComponentDocumentStatus.Open,
        label: "פתח"
    },
    {
        id: GAComponentDocumentStatus.InProgress,
        label: "התקבל"
    },
    {
        id: GAComponentDocumentStatus.Submitted,
        label: "נשלח"
    },
    {
        id: GAComponentDocumentStatus.Returned,
        label: "הוחזר"
    },
    {
        id: GAComponentDocumentStatus.InReview,
        label: "מוּכָן"
    },
    {
        id: GAComponentDocumentStatus.Complete,
        label: "נבדק"
    },
    {
        id: GAComponentDocumentStatus.Dismissed,
        label: "משוחרר"
    },
    {
        id: GAComponentDocumentStatus.RejectInTransit,
        label: "החזרה בתהליך"
    },
    {
        id: GAComponentDocumentStatus.ReturnError,
        label: "שגיאת החזרה"
    }
];
export const TeamSummaryPreparerTaskStatus = [{
        id: 1,
        label: "פתח"
    },
    {
        id: 2,
        label: "מתבצע"
    },
    {
        id: 3,
        label: "סגור"
    }
];
export const TeamSummaryReviewerTaskStatus = [{
        id: 1,
        label: "פתח"
    },
    {
        id: 2,
        label: "מתבצע"
    },
    {
        id: 3,
        label: "סגור"
    }
];

export const DocumentHelper = {
    401: "לא ניתן להשלים את הפעולה. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה אל התמיכה הטכנית.",
    413: "המסמך עולה על גודל הקובץ המקסימלי המותר (250 MB) ולכן לא ניתן להעלותו. הורד את גודל הקובץ ונסה שנית.",
    412: "כבר קיים מסמך בשם זהה בתיק הביקורת",
    414: "השם חורג מהאורך המרבי ({0} תווים).",
    410: "מסמך זה נמחק ולכן לא ניתן לפתוח אותו.",
    411: "מסמכים ריקים אינם מותרים."
};

export const reviewNoteCategories = [{
        value: reviewNoteRoutes.path.all.id,
        path: reviewNoteRoutes.path.all.path,
        label: "כל ההערות"
    },
    {
        value: reviewNoteRoutes.path.document.id,
        path: reviewNoteRoutes.path.document.path,
        label: "הערות במסמך"
    },
    {
        value: reviewNoteRoutes.path.task.id,
        path: reviewNoteRoutes.path.task.path,
        label: "הערות משימה"
    },
    {
        value: reviewNoteRoutes.path.form.id,
        path: reviewNoteRoutes.path.form.path,
        label: "הערות על טופס קנבס"
    }
];

export const reviewNoteStatus = [{
        value: '1',
        label: "פתוח"
    },
    {
        value: '2',
        label: "נוקה"
    },
    {
        value: '3',
        label: "סגור"
    }
];

/* RNH Review note hub */
export const reviewNoteTypes = [{
        id: 1,
        type: 'document',
        label: "הערת מסמך"
    },
    {
        id: 2,
        type: 'task',
        label: "הערה המשויכת למשימה"
    }
];

export const accountConclusionTabs = {
    details: "פרטים",
    conclusions: "מסקנות"
};


export const rnhFilterType = [{
        id: 0,
        filterType: rnhFilterTypeQuery.annotationStatusIds,
        name: "מספר הערה לסטטוס",
        inDropDown: false
    },
    {
        id: 1,
        filterType: rnhFilterTypeQuery.authoredBy,
        name: "חובר על ידי",
        inDropDown: true
    },
    {
        id: 2,
        filterType: rnhFilterTypeQuery.assignedTo,
        name: "הוקצה ל",
        inDropDown: true
    },
    {
        id: 3,
        filterType: rnhFilterTypeQuery.priority,
        name: "עדיפות",
        inDropDown: true,
        filterOptions: [{
            id: "1",
            label: "נמוך"
        }, {
            id: "2",
            label: "בינוני"
        }, {
            id: "3",
            label: "גבוה"
        }, {
            id: "4",
            label: "קריטי"
        }]
    },
    {
        id: 4,
        filterType: rnhFilterTypeQuery.dueBefore,
        name: "עד לתאריך או לפני",
        inDropDown: true,
        isDateTime: true
    },
    {
        id: 5,
        filterType: rnhFilterTypeQuery.dueAfter,
        name: "מהתאריך או אחרי",
        inDropDown: true,
        isDateTime: true
    }
];

export const rnhSortingOptions = [{
        id: 'Number',
        label: '#'
    },
    {
        id: 'DueDate',
        label: "היעד בעוד"
    },
    {
        id: 'Priority',
        label: "עדיפות"
    },
    {
        id: 'Status',
        label: "סטטוס"
    }
];

export const userConfidentiality = [{
        id: 1,
        value: "ראשי / כללי (General)"
    },
    {
        id: 2,
        value: "נמוך (Low)"
    },
    {
        id: 3,
        value: "בינוני (Medium)"
    },
    {
        id: 4,
        value: "גבוה (High)"
    },
    {
        id: 5,
        value: "מוגבל"
    },
    {
        id: 6,
        value: "חסוי / סודי"
    }
];

export const externalUserStatus = {
    active: "פעיל",
    inactive: "לא פעיל"
};

export const engagementStatus = {
    1: "פעיל",
    2: "ממתין",
    3: "נדחה",
    4: "לא פעיל",
    13: "מתוזמן - לא פעיל"
};

export const copyRequestStatus = {
    0: "לא בתוקף",
    1: "מוכן",
    2: "נשלח",
    3: "התקבל",
    4: "הייצוא בתהליך",
    5: "היצוא בוצע בהצלחה",
    6: "שגיאה ביצוא",
    7: "היבוא בתהליך",
    8: "היבוא בוצע בהצלחה",
    9: "שגיאה ביבוא",
    10: "נדחה",
    11: "העתקה בתהליך",
    13: "טיוטה",
    14: "השליחה מתבצעת",
    15: "מסירה בתהליך",
    16: "שגיאה במסירה"
}

export const copyObjectGrouptype = {
    21: "תיק ביקורת",
    22: "סעיפים",
    23: "SCOTs",
    20: "ראיות",
    24: "גלגול קדימה (Roll forward) מהקיים",
    25: "תבנית",
    26: "ייצוא בכמות גדולה",
    27: "מסמך חיצוני",
    28: "Guided Workflows",
    29: "התקשרות לפי ישות"
}

export const independenceStatus = {
    0: labels.undefined,
    1: labels.incomplete,
    2: labels.nomattersidentified,
    3: labels.matteridentifiedpendingaction,
    4: labels.matterresolveddeniedaccess,
    5: labels.matterresolvedgrantedaccess,
    6: labels.notapplicable,
    7: labels.restored,
    8: labels.overriden,
    9: labels.priornomattersidentified,
    10: labels.priormatteridentifiedpendingaction,
    11: labels.priormatterresolvedgrantedaccess,
    12: labels.priormatterresolveddeniedaccess
};

export const independenceStatusFilterOptions = [{
        value: 3,
        label: labels.matteridentifiedpendingaction
    },
    {
        value: 4,
        label: labels.matterresolveddeniedaccess
    },
    {
        value: 5,
        label: labels.matterresolvedgrantedaccess
    },
    {
        value: 8,
        label: labels.override
    },
    {
        value: 1,
        label: labels.incomplete
    },
    {
        value: 2,
        label: labels.nomattersidentified
    },
    {
        value: 7,
        label: labels.restored
    },
    {
        value: 6,
        label: labels.notapplicable
    }
];

export const independenceConfirmationStatus = {
    0: labels.undefined,
    1: labels.incomplete,
    2: labels.nomattersidentified,
    3: labels.matteridentifiedpendingaction,
    4: labels.matterresolveddeniedaccess,
    5: labels.matterresolvedgrantedaccess,
    6: labels.notapplicable,
    7: labels.restored,
    8: labels.override,
    9: labels.priornomattersidentified,
    10: labels.priormatteridentifiedpendingaction,
    11: labels.priormatterresolvedgrantedaccess,
    12: labels.priormatterresolveddeniedaccess
};

export const timePhaseTypes = {
    1: "היקף",
    2: "אסטרטגייה",
    3: "Walkthroughs",
    4: "דגימת בקרות בתקופות ביניים",
    5: "בדיקות מבססות בתקופות ביניים",
    6: "Walkthroughs (תהליכים לסגירת השנה)",
    7: "דגימת בקרות בסוף שנה",
    8: "בדיקות מבססות בסוף שנה",
    9: "מסקנה",
    10: "לא רלוונטי (N/A)",
    11: "ביצוע (Execution)",
    12: "פעילויות איכות בשלב ההיקף והאסטרטגיה",
    13: "היקף ואסטרטגיה אחרים",
    14: "הערכת הסיכון המשולב (CRA)",
    15: "הערכת סיכונים ומהותיות",
    16: "גיבוש סופי של היקף ואסטרטגית הביקורת ",
    17: "ניהול פרוייקט (project management) לאחר תקופת הביניים"
};

export const engagementMetricsComingDueOptions = [{
        value: 1,
        label: "מחר"
    },
    {
        value: 3,
        label: "3 הימים הבאים"
    },
    {
        value: 5,
        label: "ב- 5 הימים הבאים",
        isDefault: true
    },
    {
        value: 10,
        label: "בעשרת הימים הבאים"
    },
    {
        value: 30,
        label: "30 הימים הבאים",
        isMax: true
    }
];

export const engagementMetricsWhatsNewOptions = [{
        value: 1,
        label: "אתמול"
    },
    {
        value: 3,
        label: "3 המים האחרונים"
    },
    {
        value: 5,
        label: "5 הימים האחרונים",
        isDefault: true
    },
    {
        value: 10,
        label: "10 הימים האחרונים",
        isMax: true
    }
];

export const engagementMetricsDisplayedAttributes = {
    preparer: "להכין",
    forMyReview: "לסקירה",
    upcomingReview: "הסקירה הקרובה",
    reviewNotesAssigned: "הערות שנכתבו עבורי",
    reviewNotesAuthored: "הערות שנכתבו על ידי",
    partnerTasks: "משימות שותפים",
    eqrTasks: "משימות EQR",
    timephases: "לוח זמנים",
    groupTasks: "משימות ברמת הקבוצה",
    groupDeliverables: "תוצרי הקבוצה",
    automation: "אוטומציה",
    requests: "בקשות"
};

export const quickLinks = {
    linkAccountSummary: "סיכום סעיפים ",
    linkScotSummary: "סיכום SCOTs",
    linkITSummary: "סיכום IT",
    linkCRASummary: "סיכום הערכת הסיכון המשולב (CRA)",
    linkGAStructureSummary: "סיכום מבנה הקבוצה",
    linkGAInstrcutionSummary: "סיכום הנחיות לקבוצה",
    linkSEM: "מטריצת הערכת הביקורת המבססת (Substantive Evaluation Matrix (SEM))",
    linkAuditPlan: "תוכנית ביקורת",
    linkWorkPlan: "תוכנית עבודה",
    linkITProcessEvaluation: "הערכות IT",

    linkGeneral: "ראשי / כללי (General)",
    linkScots: "SCOTs",
    linkITSO: "IT/SO",
    linkAccounts: "סעיפים",
    linkResponseTask: "משימות מענה",
    linkWrapupEngagement: "סיום עבודת הביקורת בהתקשרות (Wrap up engagement)",
    linkArchive: "שאלון לביצוע ארכיב"
};

export const customKeyEvents = {
    reportDate: "תאריך הדוח",
    endDatePeriodCovered: "תאריך סיום של התקופה המבוקרת/נסקרת",
    archiveDeadlineDate: "תאריך יעד לארכיב"
};

export const filterReviewNoteStatus = [{
        value: filters.reviewNoteStatus.open,
        label: "פתח"
    },
    {
        value: filters.reviewNoteStatus.cleared,
        label: "נסגר (Cleared)"
    },
    {
        value: filters.reviewNoteStatus.closed,
        label: "סגור"
    }
];

export const filterFileExtension = [{
        value: filters.fileExtension.canvasForm,
        label: "Canvas form"
    },
    {
        value: filters.fileExtension.email,
        label: "דואל"
    },
    {
        value: filters.fileExtension.excel,
        label: "Excel"
    },
    {
        value: filters.fileExtension.paperProfile,
        label: "Paper profile"
    },
    {
        value: filters.fileExtension.pdf,
        label: "PDF"
    },
    {
        value: filters.fileExtension.powerPoint,
        label: 'PowerPoint'
    },
    {
        value: filters.fileExtension.smartAutomation,
        label: 'Smart Automation'
    },
    {
        value: filters.fileExtension.visio,
        label: "Visio"
    },
    {
        value: filters.fileExtension.word,
        label: "Word"
    },
    {
        value: filters.fileExtension.zip,
        label: "Zip"
    },
    {
        value: filters.fileExtension.other,
        label: "אחרים"
    }
];

export const filterDocumentContent = [{
        value: filters.documentContent.trackedChanges,
        label: "עקוב אחר שינויים"
    },
    {
        value: filters.documentContent.comments,
        label: "הערות"
    },
    {
        value: filters.documentContent.formulaError,
        label: "שגיאות נוסחה (קבצי אקסל בלבד)"
    },
    {
        value: filters.documentContent.highlightsWordFilesOnly,
        label: "הדגשות (קבצי Word בלבד)"
    },
    {
        value: filters.documentContent.hiddenSheets,
        label: "גיליונות מוסתרים"
    },
    {
        value: filters.documentContent.embeddedFiles,
        label: "קבצים אפשריים"
    },
    {
        value: filters.documentContent.ProtectedFiles,
        label: "מוּגָן"
    },
    {
        value: filters.documentContent.DocumentContentNotAvailable,
        label: "תוכן המסמך אינו זמין"
    },
    {
        value: filters.documentContent.DocumentsInCollaborationMode,
        label: "מסמכים במצב עריכה מרובת משתמשים"
    },
];

export const filterSharedEvidence = [{
        value: filters.sharedEvidence.source,
        label: "מקור"
    },
    {
        value: filters.sharedEvidence.target,
        label: "יעד"
    }
];

export const filterFindings = [{
        value: filters.findings.misstatement,
        label: "הצגה מוטעית"
    },
    {
        value: filters.findings.deficiency,
        label: "ליקוי"
    }
];

export const filterSignoffRequirements = [{
        value: filters.signoffRequirements.picMandatory,
        label: "השותף האחראי על הביקורת PIC - חובה"
    },
    {
        value: filters.signoffRequirements.picTeamAssigned,
        label: "צוות השותף האחראי על הביקורת PIC הוקצה"
    },
    {
        value: filters.signoffRequirements.eqrMandatory,
        label: "השותף המלווה EQR - חובה"
    },
    {
        value: filters.signoffRequirements.eqrTeamAssigned,
        label: "צוות השותף המלווה EQR הוקצה"
    }
];

export const filterResponsiveToRisks = [{
        value: filters.responsiveToRisk.responsiveToSignificantRisk,
        label: "סיכונים משמעותיים"
    },
    {
        value: filters.responsiveToRisk.responsiveToFraudRisk,
        label: "סיכוני הונאה"
    },
    {
        value: filters.responsiveToRisk.responsiveToHigherInherentRisk,
        label: "סיכונים במהות (IR) גבוהים יותר"
    }
];

export const filterMissingRelatedTask = [{
        value: filters.missingRelatedTask.picSignoffRequired,
        label: "נדרשת אישור השותף האחראי על הביקורת PIC"
    },
    {
        value: filters.missingRelatedTask.eqrSignoffRequired,
        label: "נדרשת חתימת EQR"
    }
];

export const filterCanvasForms = [{
        value: filters.canvasForms.incompleteResponses,
        label: "מענה שלא שולם"
    },
    {
        value: filters.canvasForms.unresolvedComments,
        label: "הערות (comments) לא פתורות"
    }
];

export const documentChangeTypes = {
    0: "לא מופיעה סיבה לשינוי שנבחר",
    1: "שינוי לא אדמרניסטטיבי",
    2: "קבל תיקונים כאשר נעשה שימוש בפונקציית 'עקוב אחר שינויים'",
    3: "הוספת הפניות (cross referencing) לראיות ביקורת קיימות",
	4: 'הוספת האישוריים המקוריים לתגובות שהתקבלו בעבר באמצעות פקס או דוא"ל',
    5: "שינוי קוסמטי",
    6: "מילוי AP Form ובעלי תפקידים משמעותיים בביקורת",
    7: "מחיקה של תיעוד שהוחלף",
    8: "הכנת הצהרות בכתב",
    9: "חתימה על רשימת התיוג הקשורה לתהליך הארכיב",
    10: "מיון, איסוף וביצוע הפניות למסמכים סופיים",
    11: "כאשר מותאם לאזור הזמן המקומי, השינוי הוא בתאריך הדוח או לפניו (אמריקה בלבד)"
};

export const documentChangeTypesOptions = [{
        value: 1,
        label: "שינוי שאינו אדמינסטרטיבי"
    },
    {
        value: 2,
        label: "קבלת תיקונים/הערות כאשר נעשה שימוש בפונקציות כאלה"
    },
    {
        value: 3,
        label: "הוספת הפניות (cross referencing) לראיות ביקורת קיימות"
    },
    {
        value: 4,
		label: 'הוספת האישוריים המקוריים לתגובות שהתקבלו בעבר באמצעות פקס או דוא"ל'
    },
    {
        value: 5,
        label: "שינוי קוסמטי"
    },
    {
        value: 6,
        label: "מילוי AP Form ובעלי תפקידים משמעותיים בביקורת"
    },
    {
        value: 7,
        label: "מחיקה או ביטול של תיעוד שאינו מהווה ראיות ביקורת"
    },
    {
        value: 8,
        label: "הכנה או הוספה של מסמכים שאינם תומכים בחוות הדעת שלנו"
    },
    {
        value: 9,
        label: "חתימה על רשימת התיוג הקשורה לתהליך הארכיב"
    },
    {
        value: 10,
        label: "מיון, איסוף וביצוע הפניות למסמכים סופיים"
    },
    {
        value: 12,
        label: "חובה: שינוי בראיות הקשורות לישויות עם תאריך דיווח המאוחר מתאריך הדיווח ב- EY Canvas בלבד"
    },
    {
        value: 11,
        label: "כאשר מותאם לאזור הזמן המקומי, השינוי הוא בתאריך הדוח או לפניו (אמריקה בלבד)"
    }
];

export const FourFortyFilterTypes = [{
        id: 0,
        filterType: 'QuickFilter',
        name: "מסננים מהירים",
        hasChild: false
    },
    {
        id: 1,
        filterType: 'TaskStatus',
        name: "סטטוס המשימה",
        hasChild: false
    },
    {
        id: 2,
        filterType: 'TaskType',
        name: "סוג משימה",
        hasChild: false
    },
    {
        id: 3,
        filterType: 'AssignedTo',
        name: "הוקצה ל",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 4,
        filterType: 'OpenAssignment',
        name: "פתח משימות שהוקצו",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 5,
        filterType: 'AssignmentsUsersEngagementRoles',
        name: "פתח משימות שהוקצו",
        hideDisplay: true,
        loadOptionsFromServer: true
    },
    {
        id: 6,
        filterType: 'ReviewNotesStatus',
        name: "סטטוס הערות סקירה",
        hasChild: false
    },
    {
        id: 7,
        filterType: 'ReviewNotesAssignedTo',
        name: "הערות סקירה הוקצו ל",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 8,
        filterType: 'ReviewNotesCreatedBy',
        name: "הערות סקירה נוצרו על ידי",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 9,
        filterType: 'TimePhase',
        name: "לוח זמנים (Time Phase)",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 10,
        filterType: 'Milestone',
        name: "אבן דרך",
        hasChild: false
    },
    {
        id: 11,
        filterType: 'AuditPhase',
        name: "שלב בביקורת",
        altName: "שלב בתיק הביקורת",
        hasChild: false
    },
    {
        id: 12,
        filterType: 'DocumentConflict',
        name: "קונפליקט בסנכרון מסמכים",
        hasChild: false
    },
    {
        id: 13,
        filterType: 'Findings',
        name: "ממצאים",
        hasChild: false,
        hideForNonAudit: true
    },
    {
        id: 14,
        filterType: 'Entity',
        name: "ישות",
        hasChild: false,
        loadOptionsFromServer: true,
        hideForNonMest: true
    },
    {
        id: 15,
        filterType: 'IsBookmarked',
        name: "הורד לצורך עבודה במצב לא מקוון",
        hasChild: false
    }
];

/* Arc Timeline */
export const arcValidationGroups = [{
        id: 1,
        label: "בניית שלב 29 ???"
    },
    {
        id: 2,
        label: "בניית שלב 30 ???"
    },
    {
        id: 3,
        label: "SEM (Evaluation Matrix) ???"
    },
    {
        id: ArcTimelineGroups.FinalizeEvidence,
        label: "השלמת ראיות ביקורת"
    },
    {
        id: ArcTimelineGroups.CompleteRemainingTasks,
        label: "השלם את המשימות שנותרו"
    },
    {
        id: ArcTimelineGroups.ResolveValidations,
        label: "פתור validations שנותרו פתוחים"
    },
    {
        id: 7,
        label: "הכנה לארכיב"
    },
    {
        id: 8,
        label: "Engagement Dashboard"
    },
    {
        id: 9,
        label: "טופס Canvas (בודד)"
    },
    {
        id: 10,
        label: "טופס Canvas (הכל)"
    }
];

export const checkListTypes = [{
        id: 7,
        label: "השלמת עותקים ותיקיות קשיחים"
    },
    {
        id: 13,
        label: "אשר את נכונות של תאריכי המפתח של תיק הביקורת"
    },
    {
        id: 14,
        label: "אשר את נכונות קודי תיק הביקורת"
    },
    {
        id: 15,
        label: "אשר את נכונות של קוד הלקוח"
    },
    {
        id: 10,
        label: "בטל קישור של תיק ביקורת זה מהקבוצה"
    },
    {
        id: 16,
        label: "אמת את סוג הדוח"
    },
    {
        id: 17,
        label: "סקור קבצים זמניים עבור הקבצים ששונו לאחר תאריך הפרסום של הדוח"
    },
    {
        id: 18,
        label: "סקור קבצים שנמחקו עבור הקבצים ששונו לאחר תאריך הפרסום של הדוח"
    },
    {
        id: 19,
        label: "ודא שהוגשו שינויים בפרופיל ההתקשרות"
    },
    {
        id: 20,
        label: "סקור מסמכים מוגנים"
    },
    {
        id: 95,
        label: "קבע את האחראי הכולל"
    }
];

export const arcValidationTypes = [{
        id: ArcTimeLineValidationTypes.DocumentConflict,
        label: "פתור קונפליקטים במסמכים שנשארו"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentsInMultiUserEditMode,
        label: "מסמכים בעריכה מרובת משתמשים"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentsWithIsProtected,
        label: "סקור מסמכים מוגנים"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentIsNotFinalized,
        label: "תוכן המסמך אינו זמין"
    },
    {
        id: ArcTimeLineValidationTypes.AddressAllOpenReviewNotes,
        label: "סגור את כל הערות הסקירה הלא פתורות"
    },
    {
        id: ArcTimeLineValidationTypes.RemoveTrackedChangesFromEvidence,
        label: "הסר מעקב שינויים במסמכים של ראיות ביקורת "
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeSmartAutomationEvidenceFiles,
        label: "השלמת קבצי הראיות של Smart Automation"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeCompleteAllPICSignoffRequirements,
        label: "השלם את כל דרישות החתימה של השותף האחראי על הביקורת PIC"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeCompleteAllEQRSignoffRequirements,
        label: "השלם את כל דרישות החתימה של השותף המלווה EQR"
    },
    {
        id: ArcTimeLineValidationTypes.PICEvidenceWithoutAtLeastOneRelatedPICTask,
        label: "קשר את מסמכי השותף האחראי על הביקורת PIC  למשימות PIC"
    },
    {
        id: ArcTimeLineValidationTypes.EQREvidenceWithoutAtLeastOneRelatedEQRTask,
        label: "קשר מסמכי שותף מלווה EQR למשימות EQR"
    },
    {
        id: ArcTimeLineValidationTypes.EvidencemissingSignoffs,
        label: "חתימה על כל ראיות הביקורת"
    },
    {
        id: ArcTimeLineValidationTypes.CanvasFormComment,
        label: "פתור הערות (comments) טופס Canvas"
    },
    {
        id: ArcTimeLineValidationTypes.UnlinkedSharedEvidence,
        label: "בטל קישור של ראיות ששותפו"
    },
    {
        id: ArcTimeLineValidationTypes.TaskswithoutEvidence,
        label: "הוסף ראיות למשימות פתוחות"
    },
    {
        id: ArcTimeLineValidationTypes.PICTaskWithoutAtLeastOneRelatedPICEvidence,
        label: "ודא שכל משימות השותף האחראי על הביקורת PIC  מכילות מסמכי PIC"
    },
    {
        id: ArcTimeLineValidationTypes.EQRTaskWithoutAtLeastOneRelatedEQREvidence,
        label: "ודא שכל משימות השותף המלווה EQR מכילות מסמכי EQR"
    },
    {
        id: ArcTimeLineValidationTypes.RelateEvidenceToEntityTask,
        label: "קשר ראיות למשימה ברמת הישות"
    },
    {
        id: ArcTimeLineValidationTypes.MarkTasksComplete,
        label: "סמן משימות שהושלמו"
    },
    {
        id: ArcTimeLineValidationTypes.AccountsSummary,
        label: "סיכום הסעיפים"
    },
    {
        id: ArcTimeLineValidationTypes.ScotSummary,
        label: "סיכום תתי התהליכים המהותיים (SCOTs)"
    },
    {
        id: ArcTimeLineValidationTypes.CraSummary,
        label: "סיכום הערכת הסיכון המשולב (CRA)"
    },
    {
        id: ArcTimeLineValidationTypes.ITSummary,
        label: "סיכום IT"
    },
    {
        id: ArcTimeLineValidationTypes.ConfirmAccuracyOfAuditorReport,
        label: "אשר את נכונות הנתונים בחוות דעת רואי החשבון"
    },
    {
        id: ArcTimeLineValidationTypes.CompleteArchiveForm,
        label: "השלם את טופס הארכיב"
    },
    {
        id: ArcTimeLineValidationTypes.CompleteArchiveTask,
        label: "השלם את משימת הארכיב"
    },
    {
        id: ArcTimeLineValidationTypes.UnlinkGroupSharedEvidence,
        label: "בטל קישור לתיקייה המשותפת של ראיות הביקורת בקבוצה"
    },
    {
        id: ArcTimeLineValidationTypes.AuditPlan,
        label: "תוכנית ביקורת"
    },
    {
        id: ArcTimeLineValidationTypes.UnassociateFinding,
        label: "ממצאים שאינם קשורים"
    },
    {
        id: ArcTimeLineValidationTypes.IndependenceCompliance,
        label: "ציות לנהלי אי תלות"
    },
    {
        id: ArcTimeLineValidationTypes.IncompleteCanvasFormResponses,
        label: "עדכון סופי של טפסי CANVAS שלא הושלמו כמענה לביקורת"
    },
    {
        id: ArcTimeLineValidationTypes.WCGWwithNoRelatedsubstantivetask,
        label: "מטריצת הערכת הביקורת המבססת (Substantive Evaluation Matrix (SEM))"
    },
    {
        id: ArcTimeLineValidationTypes.ITEvaluation,
        label: "הערכות IT"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentModifiedAfterReportReleaseDate,
        label: "מסמכים ששונו לאחר תאריך פרסום הדוח"
    },
    {
        id: ArcTimeLineValidationTypes.DuplicateFileNames,
        label: "שנה שם של קבצי ראיות עם שמות קבצים כפולים"
    },
    {
        id: ArcTimeLineValidationTypes.ITFlowCanvasForm,
        label: "IT Flow"
    },
    {
        id: ArcTimeLineValidationTypes.AdjustmentsModule,
        label: "התאמות"
    },
    {
        id: ArcTimeLineValidationTypes.CanvasFormsWithNoContent,
        label: "סקור טפסי Canvas ללא תוכן"
    },
    {
        id: ArcTimeLineValidationTypes.PersonInCharge,
        label: "האחראי"
    },
    {
        id: ArcTimeLineValidationTypes.EstimateAccountWithoutEstimatePSPindex,
        label: ''
    },
    {
        id: ArcTimeLineValidationTypes.TempFilesWithPreparerAndReviewerSignoffsError,
        label: "סקור קבצים זמניים שיש להם חתימות של מכין וסוקר עבור קבצים שיש לכלול בראיות או למחוק"
    },
    {
        id: ArcTimeLineValidationTypes.TemporaryFilesWithPICRequirementUserOrKnowledge,
        label: "סקור קבצים זמניים שיש להם תיוג לשותף אחראי על הביקורת (PIC) עבור קבצים שיש לכלול בראיות או עבור תגים שיש למחוק"
    },
    {
        id: ArcTimeLineValidationTypes.TemporaryFileWithEQRRequirementUserOrKnowledge,
        label: "סקור קבצים זמניים שיש להם תיוג לשותף המלווה (EQR) עבור קבצים שיש לכלול בראיות או עבור תגים שיש למחוק"
    },
    {
        id: ArcTimeLineValidationTypes.DeletedFilesWithPICRequirementUserOnly,
        label: "סקור קבצים שנמחקו שיש להם תיוג לשותף אחראי על הביקורת (PIC) עבור קבצים שיש לכלול בראיות או תגים שיש למחוק"
    },
    {
        id: ArcTimeLineValidationTypes.DeletedFilesWithEQRRequirementUserOnly,
        label: "סקור קבצים שנמחקו שיש להם תיוג לשותף המלווה (EQR) עבור קבצים שיש לכלול בראיות או תגים שיש למחוק"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentAssociatedToInvalidObject,
        label: "מסמכים הקשורים לאובייקטים שאינם זמינים עוד בהתקשרות"
    }
];

export const ArchiveErrors = {
    32204: "לתיק הביקורת יש משימה ללא ראיות ביקורת.",
    32209: "לתיק הביקורת יש טופס Canvas עם תגובות לא מלאות.",
    32210: "לתיק הביקורת יש הערות סקירה פתוחות (Open Review Notes).",
    32212: "לתיק הביקורת יש משימה לא הושלמה.",

    32402: "מזהה הארכיב ריק או null.",
    32403: "הקובץ GUID הוא ריק או null.",
    32404: "ARC FileStoreHost הוא ריק או null.",
    32424: "קוד ההתקשרות הראשי חסר או לא חוקי.",
    32425: "תאריך פרסום הדוח אינו יכול להיות תאריך עתידי.",
    32426: "תאריך פרסום הדוח חייב להיות לאחר תאריך סיום ההתקשרות.",
    32427: "יש להזמין שותף לתיק הביקורת.",
    32428: "ב-ARC חסרים נתונים על סוג נייר העבודה.",
    32429: "נדרשת בחירה בטופס הארכיב עבור סוג חוות הדעת.",
    32430: "נדרשת בחירה בטופס הארכיב עבור חוות דעת בנוסח האחיד.",
    32431: "אירעה שגיאה במהלך תהליך הארכיב עקב אינטגרציה עם ARC. צור קשר עם התמיכה הטכנית בכדי לדווח על שגיאה זו."
};

export const validationTypes = [{
        id: 1,
        label: "מילוי יוצא מן הכלל לדרישות אי תלות",
        altLabel: "טופס לא שלם",
        errorLabel: "מילוי יוצא מן הכלל לדרישות אי תלות"
    },
    {
        id: 2,
        label: "גרסת טופס אי תלות אינה עדכנית",
        altLabel: "טופס ישן",
        errorLabel: "גרסת טופס אי תלות אינה עדכנית"
    },
    {
        id: 3,
        label: "גישה הניתנת על ידי גורם לא מתאים",
        altLabel: "לא אושר על ידי PPEDD",
        errorLabel: "גישה הניתנת על ידי גורם לא מתאים"
    },
    {
        id: 4,
        label: "בוצע שינוי על ידי גורם לא מורשה",
        altLabel: "לא נעקף על ידי PPEDD",
        errorLabel: "בוצע שינוי על ידי גורם לא מורשה"
    },
    {
        id: 5,
        label: "SCOTs שאינם קשורים (ללא חשבון)",
        errorLabel: "SCOTs לא מקושרים"
    },
    {
        id: 6,
        label: "בקרות לא קשורות (ללא WCGW)",
        errorLabel: "בקרות לא מקושרות"
    },
    {
        id: 7,
        label: "אסטרטגיית בקרות נבחרה ללא WCGWs קשורים",
        errorLabel: "נבחרה אסטרטגיית הסתמכות על בקרות אך ללא קישור של WCGW"
    },
    {
        id: 8,
        label: "אסטרטגיית בקרות נבחרה ללא בקרות קשורות",
        errorLabel: "אסטרטגיית בקרות נבחרה ללא בקרות קשורות"
    },
    {
        id: 9,
        label: "אסטרטגיית בקרות נבחרה ללא בקרות קשורות שנבחרו לבדיקה ",
        errorLabel: "אסטרטגיית בקרות נבחרה ללא בקרות קשורות שנבחרו לבדיקה "
    },
    {
        id: 10,
        label: "אסטרטגיית בקרות נבחרה וישנם WCGW ללא בקרות קשורות שנבחרו לבדיקה",
        errorLabel: "אסטרטגיית בקרות נבחרה וישנם WCGW ללא בקרות קשורות שנבחרו לבדיקה"
    },
    {
        id: 11,
        label: "סיכונים שאינם קשורים",
        errorLabel: "סיכונים שאינם קשורים"
    },
    {
        id: 12,
        label: "השלם את הערכת הסיכון המשולב (CRA) ליעד ביקורת זה",
        errorLabel: "השלם את הערכת הסיכון המשולב (CRA) ליעד ביקורת זה"
    },
    {
        id: 13,
        label: "WCGWs שאינם קשורים",
        errorLabel: "WCGWs שאינם קשורים"
    },
    {
        id: 14,
        label: "לסעיף מהותי אין SCOTs קשורים",
        errorLabel: "לסעיף מהותי אין SCOTs קשורים"
    },
    {
        id: 15,
        label: "אסטרטגיה הסתמכות על בקרות נבחרה ללא WCGW קשורים",
        errorLabel: "אסטרטגיית הסתמכות על בקרות נבחרה ללא WCGWs קשורים'"
    },
    {
        id: 16,
        label: "אסטרטגיה הסתמכות על בקרות נבחרה ללא בקרות קשורות",
        errorLabel: "אסטרטגיה הסתמכות על בקרות נבחרה ללא בקרות קשורות"
    },
    {
        id: 17,
        label: "אסטרטגיה הסתמכות על בקרות נבחרה ללא בקרות קשורות שנבחרו לבדיקה",
        errorLabel: "אסטרטגיה הסתמכות על בקרות נבחרה ללא בקרות קשורות שנבחרו לבדיקה"
    },
    {
        id: 18,
        label: "נבחרה אסטרטגיה וסמכה ויש WCGW ללא בקרות קשורות שנבחרו לבדיקה",
        errorLabel: "נבחרה אסטרטגיה וסמכה ויש WCGW ללא בקרות קשורות שנבחרו לבדיקה"
    },
    {
        id: 19,
        label: " IT App/SO שאינם קשורים",
        errorLabel: "IT App/SO שאינם קשורים"
    },
    {
        id: 20,
        label: "Unrelated Control / IT Substantive Procedure",
        errorLabel: "Control/IT Substantive Procedures לא מקושרים"
    },
    {
        id: 21,
        label: "אין IT App/SO",
        errorLabel: "אין IT App/SO"
    },
    {
        id: 22,
        label: "אין סיכונים קשורים",
        errorLabel: "אין סיכונים קשורים"
    },
    {
        id: 23,
        label: "אין בקרות קשורות / בדיקות IT מבססות",
        errorLabel: "אין בקרות קשורות / בדיקות IT מבססות"
    },
    {
        id: 24,
        label: "אין בקרות קשורות / בדיקות IT מבססות נבחרו לבדיקה",
        errorLabel: "אין בקרות קשורות / בדיקות IT מבססות נבחרו לבדיקה"
    },
    {
        id: 25,
        label: "יש סיכון ללא בקרות קשורות / נהלי IT מבססים שנבחרו לבדיקה",
        errorLabel: "יש סיכון ללא בקרות קשורות / נהלי IT מבססים שנבחרו לבדיקה"
    },
    {
        id: 26,
        label: "לסעיף בסיכון מוגבל (Limited Risk Account) אין משימות מבססות קשורות",
        errorLabel: "לסעיף בסיכון מוגבל (Limited Risk Account) אין משימות מבססות קשורות"
    },
    {
        id: 27,
        label: "אין משימות מבססות שקשורות ליעד הביקורת",
        errorLabel: "אין משימות מבססות שקשורות ליעד הביקורת"
    },
    {
        id: 28,
        label: "TOC שאינו קשור",
        errorLabel: "TOC שאינו קשור"
    },
    {
        id: 29,
        label: "Walkthrough שאינו קשור",
        errorLabel: "Walkthrough שאינו קשור"
    },
    {
        id: 30,
        label: "אף אחת ממשימות ה- walkthrough  לא קשורות ל SCOT",
        errorLabel: "אף אחת ממשימות ה- walkthrough  לא קשורות ל SCOT"
    },
    {
        id: 31,
        label: "אין משימות בקרה שקושרו לבקרה שנבחרה לבדיקה",
        errorLabel: "אין משימות בקרה שקושרו לבקרה שנבחרה לבדיקה"
    },
    {
        id: 32,
        label: "IT/SO Walkthrough שאינו קשור",
        errorLabel: "IT/SO Walkthrough שאינו קשור"
    },
    {
        id: 33,
        label: "IT/SO TOC שאינו קשור",
        errorLabel: "IT/SO TOC שאינו קשור"
    },
    {
        id: 34,
        label: "IT/SO OSP שאינו קשור",
        errorLabel: "IT/SO OSP שאינו קשור"
    },
    {
        id: 35,
        label: "לתהליך ה- IT / SO אין משימת walkthrough קשורה",
        errorLabel: "לתהליך ה- IT / SO אין משימת walkthrough קשורה"
    },
    {
        id: 36,
        label: "לבקרה אין TOC קשור",
        errorLabel: "לבקרה אין TOC קשור"
    },
    {
        id: 37,
        label: "לבדיקות IT מבססות אין OSP קשורים",
        errorLabel: "לבדיקות IT מבססות אין OSP קשורים"
    },
    {
        id: 38,
        label: "קונפליקט בסנכרון מסמכים",
        errorLabel: "קונפליקטים שאינם פתורים"
    },
    {
        id: 39,
        label: "סנכרון קונפליקט - ראיות משותפות - לא מוצג בספירת האימות (validation) ב- Canvas ",
        errorLabel: "ראיות משותפות - קונפליקט בסנכרון"
    },
    {
        id: 40,
        label: "ראיות ללא חתימות (Sign-offs)",
        errorLabel: "חתימה על כל ראיות הביקורת"
    },
    {
        id: 41,
        label: "משימות ללא ראיות",
        errorLabel: "הוסף ראיות למשימות פתוחות"
    },
    {
        id: 42,
        label: "קוד תיק הביקורת לא חוקי",
        errorLabel: "קוד תיק הביקורת לא חוקי"
    },
    {
        id: 43,
        label: "קוד לקוח לא חוקי",
        errorLabel: "קוד לקוח לא חוקי"
    },
    {
        id: 44,
        label: "כפילות בשמות הקובץ",
        errorLabel: "כפילות בשמות הקובץ"
    },
    {
        id: 45,
        label: "הערכת IT אינה עקבית",
        errorLabel: " IT Process Evaluation לא מלאה"
    },
    {
        id: 46,
        label: " IT Process Evaluation לא מלאה",
        errorLabel: " IT Process Evaluation לא מלאה"
    },
    {
        id: 47,
        label: "הערכת IT במצטבר אינה שלמה",
        errorLabel: "הערכת IT במצטבר אינה שלמה"
    },
    {
        id: 48,
        label: "מענה לא שלם",
        errorLabel: "הרציונל התומך אינו שלם"
    },
    {
        id: 49,
        label: "הצגות מוטעות שאינן קשורות",
        errorLabel: "הצגות מוטעות שאינן קשורות"
    },
    {
        id: 50,
        label: "ליקוי שאינו משוייך",
        errorLabel: "ליקויים שאינם משוייכים"
    },
    {
        id: 51,
        label: "WCGW ללא משימה מבססת קשורה",
        errorLabel: "WCGW ללא משימה מבססת קשורה"
    },
    {
        id: 52,
        label: "סיכון שלא משויך אליו WCGW",
        errorLabel: "סיכון (risk) ללא WCGW"
    },
    {
        id: 53,
        label: "סעיף הכרוך באומדנים ללא קישור ל- PSP Index לאומדנים ",
        errorLabel: "סעיף הכרוך באומדנים ללא קישור ל- PSP Index לאומדנים "
    },
    {
        id: 54,
        label: "סעיף הכרוך באומדנים ללא קישור לתהליך מהותי (SCOT) הכרוך באומדנים ",
        errorLabel: "סעיף הכרוך באומדנים ללא קישור לתהליך מהותי (SCOT) הכרוך באומדנים "
    },
    {
        id: 55,
        label: "תת תהליך מהותי (SCOT) הכרוך באומדנים ללא קישור לסעיף הכרוך באומדנים",
        errorLabel: "תת תהליך מהותי (SCOT) הכרוך באומדנים ללא קישור לסעיף הכרוך באומדנים"
    },
    {
        id: 56,
        label: "יעד ביקורת עם סיכון בקרה של הסתמכות (CR=Rely) ללא מענה באמצעות טסטים על בקרות TOC",
        errorLabel: "יעד ביקורת עם סיכון בקרה של הסתמכות (CR=Rely) ללא מענה באמצעות טסטים על בקרות TOC"
    },
    {
        id: 57,
        label: "מצג ההנהלה (assertion) עם סיכון בקרה Rely ללא לפחות טסט אחד לבקרה (TOC) הניתן כמענה והמקושר לבקרה שתוכננה בצורה אפקטיבית אשר אינה בסיכון נמוך ואשר ניתנה כמענה לסיכון.",
        errorLabel: "מצג ההנהלה (assertion) עם סיכון בקרה Rely ללא לפחות טסט אחד לבקרה (TOC) הניתן כמענה והמקושר לבקרה שתוכננה בצורה אפקטיבית אשר אינה בסיכון נמוך ואשר ניתנה כמענה לסיכון."
    },
    {
        id: 58,
        label: "יעד ביקורת ללא מענה באמצעות משימה מבססת",
        errorLabel: "יעד ביקורת ללא מענה באמצעות משימה מבססת"
    },
    {
        id: 59,
        label: "יעד ביקורת ללא מענה באמצעות בקרה",
        errorLabel: "יעד ביקורת ללא מענה באמצעות בקרה"
    },
    {
        id: 60,
        label: "הערה על טופס Canvas",
        errorLabel: "הערה על טופס Canvas"
    },
    {
        id: 61,
        label: "תגובות לא שלמות לטופס ה Canvas",
        errorLabel: "תגובות לא שלמות לטופס ה Canvas"
    },
    {
        id: 62,
        label: "הערות ביקורת פתוחות או שטופלו שיש לסגור או למחוק",
        errorLabel: "הערות ביקורת פתוחות או שטופלו שיש לסגור או למחוק"
    },
    {
        id: 63,
        label: "ראיות עם עקוב אחר שינויים",
        errorLabel: "ראיות עם עקוב אחר שינויים"
    },
    {
        id: 64,
        label: "משימות שלא סומנו ככאלו שהושלמו",
        errorLabel: "סמן משימות שהושלמו"
    },
    {
        id: 65,
        label: "ראיות משותפות שקישורן לא בוטל",
        errorLabel: "בטל קישור של ראיות ששותפו"
    },
    {
        id: 66,
        label: "נבחרו מסמכים ללא סוג שינוי",
        errorLabel: "נבחרו מסמכים ללא סוג שינוי"
    },
    {
        id: 67,
        label: "שינויים לא ניהוליים ללא סיבה לשינוי (רציונל)",
        errorLabel: "שינויים לא ניהוליים ללא סיבה לשינוי (רציונל)"
    },
    {
        id: 68,
        label: "שינויים שאינם אדמרניסטטיביים שלא אושרו על ידי הגורם המתאים ",
        errorLabel: "שינויים שאינם אדמרניסטטיביים שלא אושרו על ידי הגורם המתאים "
    },
    {
        id: 69,
        label: "חסרה חתימת סוקר (reviewer sign-off) בדרגת מנהל על טופס 440GL (ראיות ששונו לאחר תאריך הדוח)",
        errorLabel: "חסרה חתימת סוקר (reviewer sign-off) בדרגת מנהל על טופס 440GL (ראיות ששונו לאחר תאריך הדוח)"
    },
    {
        id: 70,
        label: "תיק ביקורת קבוצתי שהקישור שלה לא בוטל",
        errorLabel: "בטל קישור של תיק הביקורת מהקבוצה"
    },
    {
        id: 71,
        label: "טופס Canvas ללא כותרות",
        altLabel: "טופס Canvas ללא כותרות",
        errorLabel: "טופס Canvas ללא כותרות"
    },
    {
        id: 72,
        label: "חסר תוכן במסמך Group Component Summary Document",
        errorLabel: "חסר תוכן במסמך Group Component Summary Document"
    },
    {
        id: 73,
        label: "תגובות לא מלאות בטופס Canvas ללא קשר לאישור",
        errorLabel: "טופס Canvas לא שלם"
    },
    {
        id: 74,
        label: "שינוי פרופיל V2 לא נשלח",
        errorLabel: "שינוי פרופיל לא נשלח"
    },
    {
        id: 75,
        label: "0 byte קבצים אלקטרוניים",
        errorLabel: "0 byte קבצים אלקטרוניים"
    },
    {
        id: 76,
        label: "טופס אי התלות נערך לאחר שליחתו",
        altLabel: "הטופס לא נשלח",
        errorLabel: "טופס אי התלות נערך לאחר שליחתו"
    },
    {
        id: 77,
        label: "תבנית אי תלות שונה מיחיד",
        altLabel: "תבנית אי תלות שונה מיחיד",
        errorLabel: "תבנית אי תלות שונה מיחיד"
    },
    {
        id: 78,
        label: "יישום IT (לא SO) ללא לפחות תהליך IT קשור אחד",
        errorLabel: "יישום IT לא מקושר"
    },
    {
        id: 79,
        label: "ל-ITGC אין סיכון IT קשור או שיש קישור לסיכון IT שבו HasNoITGC = 1",
        errorLabel: "ITGC לא מקושר"
    },
    {
        id: 80,
        label: "ל-ITSP אין ITRisk קשור",
        errorLabel: "ITSP לא מקושר"
    },
    {
        id: 81,
        label: "לתהליך IT אין כל ישום IT קשור",
        errorLabel: "תהליך IT לא מקושר"
    },
    {
        id: 82,
        label: "תהליך IT ללא סיכון IT, כאשר יש ITAC או ITDM (ללא יוצא מן הכלל) המקושרים דרך יישום IT",
        errorLabel: "חסר סיכון IT"
    },
    {
        id: 83,
        label: "לסיכון IT (כאשר HasNoITGC = 0) אין ITGC קשור",
        errorLabel: "חסר ITGC או סימון לא קיים"
    },
    {
        id: 84,
        label: "ITDM/ITAC ללא יישום IT קשור",
        errorLabel: "בקרה אפליקטיבית/ITDM ללא יישום IT"
    },
    {
        id: 85,
        label: "ITSP לא נמחק כאשר הגוף המתאים אינו מוצג",
        errorLabel: "יש למחוק ITSP"
    },
    {
        id: 86,
        label: "ITGC לא נמחק כאשר הגוף המתאים אינו מוצג",
        errorLabel: "יש למחוק ITGC"
    },
    {
        id: 87,
        label: "סיכון IT לא נמחק כאשר הגוף המתאים אינו מוצג",
        errorLabel: "סיכון IT צריך להימחק"
    },
    {
        id: 88,
        label: "ITGC עם HasITControlTesting = 1 קיים כאשר הגוף המתאים אינו מוצג",
        errorLabel: "ITGC עם אסטרטגיית דגימה לא חוקית"
    },
    {
        id: 89,
        label: "ITGC ללא בחירת הערכת אפקטיביות התכנון (design evaluation)",
        errorLabel: "חסרה הערכת אפקטיביות התכנון של ה- ITGC (ITGC design evaluation)"
    },
    {
        id: 90,
        label: "בקרה ללא בחירת הערכת אפקטיביות התכנון (design evaluation)",
        errorLabel: "בקרה ללא בחירת הערכת אפקטיביות התכנון (design evaluation)"
    },
    {
        id: 91,
        label: "תת תהליך מהותי (SCOT) ללא יישומי IT כאשר HasNoITApplication = 0",
        errorLabel: "SCOT לא מקושר"
    },
    {
        id: 92,
        label: "נהלים מבססים ודגימות בקרות (tests of controls) אשר נותנים מענה לסיכון משמעותי (SR) אך לא ל-WCGW הקשור לסיכון",
        errorLabel: " RiskTaskRelation מול סיכון > WCGW > קשר משימות אינו עקבי"
    },
    {
        id: 93,
        label: "תגובה לא עקבית לדגימת בקרות",
        errorLabel: "תגובה לא עקבית לדגימת בקרות"
    },
    {
        id: 94,
        label: "ל-SCOT עם HasNoITApplication = 0 יש בקרות מסוג ITDM או אפליקטיביות",
        errorLabel: "חסר יישום IT ב-SCOT"
    },
    {
        id: 95,
        label: "לאף חבר צוות לא הוקצתה אחריות כוללת",
        altLabel: "לאף חבר צוות לא הוקצתה אחריות כוללת",
        errorLabel: "לאף חבר צוות לא הוקצתה אחריות כוללת"
    },
    {
        id: 96,
        label: "גורמי סיכון שאינם מקושרים לסיכון או שאינם מסומנים ככאלו שאינם ROMM",
        errorLabel: "גורמי סיכון שאינם מקושרים לסיכון או שאינם מסומנים ככאלו שאינם ROMM"
    },
    {
        id: 97,
        label: "Risks unrelated to an Assertion",
        errorLabel: "Risks unrelated to an Assertion"
    },
    {
        id: 98,
        label: "סכום תחזית בסיס המדידה לא מלא",
        errorLabel: "סכום תחזית בסיס המדידה לא מלא"
    },
    {
        id: 99,
        label: "רציונל תחזית סכום בסיס המדידה לא מלא",
        errorLabel: "רציונל תחזית סכום בסיס המדידה לא מלא"
    },
    {
        id: 100,
        label: "הסכום המותאם לבסיס המדידה לא מלא",
        errorLabel: "הסכום המותאם לבסיס המדידה לא מלא"
    },
    {
        id: 101,
        label: "סף המהותיות (PM) לא מלא",
        errorLabel: "סף המהותיות (PM) לא מלא"
    },
    {
        id: 102,
        label: "סף המהותיות (PM) גדול מהסכום המקסימלי",
        errorLabel: "סף המהותיות (PM) גדול מהסכום המקסימלי"
    },
    {
        id: 103,
        label: "הרציונל לקביעת סף המהותיות (PM) לא שלם",
        errorLabel: "הרציונל לקביעת סף המהותיות (PM) לא שלם"
    },
    {
        id: 104,
        label: "הטעות הנסבלת (TE) לא מלאה",
        errorLabel: "הטעות הנסבלת (TE) לא מלאה"
    },
    {
        id: 105,
        label: "הטעות הנסבלת (TE) אינה בטווח הערכים המותרים",
        errorLabel: "הטעות הנסבלת (TE) אינה בטווח הערכים המותרים"
    },
    {
        id: 106,
        label: "הרציונל לקביעת הטעות הנסבלת (TE) לא שלם",
        errorLabel: "הרציונל לקביעת הטעות הנסבלת (TE) לא שלם"
    },
    {
        id: 107,
        label: "SAD לא שלם",
        errorLabel: "SAD לא שלם"
    },
    {
        id: 108,
        label: "SAD גדול מהמקסימום",
        errorLabel: "SAD גדול מהמקסימום"
    },
    {
        id: 109,
        label: "הרציונל לקביעת ה- SAD לא שלם",
        errorLabel: "הרציונל לקביעת ה- SAD לא שלם"
    },
    {
        id: 110,
        label: "בחירת PACE לא מלאה",
        errorLabel: "בחירת PACE לא מלאה"
    },
    {
        id: 111,
        label: "אין מסמכים קשורים",
        errorLabel: "אין מסמכים קשורים"
    },
    {
        id: 112,
        label: "משימת שותף אחראי על הביקורת PIC ללא לפחות ראיית ביקורת אחת המשויכת לשותף האחראי על הביקורת",
        errorLabel: "משימת שותף אחראי על הביקורת PIC ללא לפחות ראיית ביקורת אחת המשויכת לשותף האחראי על הביקורת"
    },
    {
        id: 113,
        label: "משימת שותף מלווה EQR ללא לפחות ראיית ביקורת אחת המשויכת לשותף המלווה",
        errorLabel: "משימת שותף מלווה EQR ללא לפחות ראיית ביקורת אחת המשויכת לשותף המלווה"
    },
    {
        id: 114,
        label: "ראיית ביקורת המשויכת לשותף האחראי על הביקורת PIC ללא לפחות משימת PIC קשורה אחת",
        errorLabel: "ראיית ביקורת המשויכת לשותף האחראי על הביקורת PIC ללא לפחות משימת PIC קשורה אחת"
    },
    {
        id: 115,
        label: "ראיית ביקורת המשויכת לשותף המלווה EQR ללא לפחות משימת EQR קשורה אחת",
        errorLabel: "ראיית ביקורת המשויכת לשותף המלווה EQR ללא לפחות משימת EQR קשורה אחת"
    },
    {
        id: 116,
        label: "ראיית ביקורת המשויכת לשותף האחראי על הביקורת PIC ללא חתימת PIC אחת לפחות",
        errorLabel: "ראיית ביקורת המשויכת לשותף האחראי על הביקורת PIC ללא חתימת PIC אחת לפחות"
    },
    {
        id: 117,
        label: "ראיית ביקורת המשויכת לשותף המלווה EQR ללא חתימת EQR אחת לפחות",
        errorLabel: "ראיית ביקורת המשויכת לשותף המלווה EQR ללא חתימת EQR אחת לפחות"
    },
    {
        id: 118,
        label: "ראיית ביקורת שאין לארכב עדיין קיימת",
        errorLabel: "ראיית ביקורת שאין לארכב עדיין קיימת"
    },
    {
        id: 119,
        label: "קבצים זמניים עם חתימת היוצר והסוקר",
        errorLabel: "קבצים זמניים עם חתימת היוצר והסוקר"
    },
    {
        id: 120,
        label: "כל ההערות הפתוחות או אלו שנוקו בגין טופס ה- Canvas",
        errorLabel: "כל ההערות הפתוחות או אלו שנוקו בגין טופס ה- Canvas"
    },
    {
        id: 121,
        label: "קבצים זמניים שיש בגינם  דרישה לחתימת שותף אחראי על הביקורת PIC",
        errorLabel: "קבצים זמניים שיש בגינם  דרישה לחתימת שותף אחראי על הביקורת PIC"
    },
    {
        id: 122,
        label: "קובץ זמני שיש בגינו דרישה לחתימת שותף מלווה EQR",
        errorLabel: "קובץ זמני שיש בגינו דרישה לחתימת שותף מלווה EQR"
    },
    {
        id: 123,
        label: "קבצים שנמחקו שיש בגינם דרישה לחתימת שותף אחראי על הביקורת PIC",
        errorLabel: "קבצים שנמחקו שיש בגינם דרישה לחתימת שותף אחראי על הביקורת PIC"
    },
    {
        id: 124,
        label: "קבצים שנמחקו שיש בגינם דרישה לחתימת שותף מלווה EQR",
        errorLabel: "קבצים שנמחקו שיש בגינם דרישה לחתימת שותף מלווה EQR"
    },
    {
        id: 125,
        label: "סקור מסמכים מוגנים",
        errorLabel: "סקור מסמכים מוגנים"
    },
    {
        id: 126,
        label: "תוכן מסמך לא זמין",
        errorLabel: "תוכן מסמך לא זמין"
    },
    {
        id: 127,
        label: "גוף רווח והפסד ללא נתונים",
        errorLabel: "גוף רווח והפסד ללא נתונים"
    },
    {
        id: 128,
        label: "גוף המאזן ללא נתונים",
        errorLabel: "גוף המאזן ללא נתונים"
    },
    {
        id: 129,
        label: "MultiEntity - Multi Entity לא קשור לכל ה-PSP/ACT עבור סעיפים קשורים",
        errorLabel: "MultiEntity - Multi Entity לא קשור לכל ה-PSP/ACT עבור סעיפים קשורים"
    },
    {
        id: 130,
        label: "סעיף ללא טופס הערכת סיכונים פרטנית ( Individual Risk Assessment Form)",
        errorLabel: "סעיף ללא טופס הערכת סיכונים פרטנית ( Individual Risk Assessment Form)"
    },
    {
        id: 131,
        label: "אומדן ללא תיעוד התומך באומדן",
        errorLabel: "אומדן ללא תיעוד התומך באומדן"
    },
    {
        id: 132,
        label: "סעיף ללא טופס אנליטי אינדיבידואלי ( Individual Analytic Form)",
        errorLabel: "סעיף ללא טופס אנליטי אינדיבידואלי ( Individual Analytic Form)"
    },
    {
        id: 133,
        label: "Multi Entity ללא טופס פרופיל אישי ( Individual Profile Form)",
        errorLabel: "Multi Entity ללא טופס פרופיל אישי ( Individual Profile Form)"
    },
    {
        id: 134,
        label: "סעיף - AccountTypeID אינו תואם לפעולה",
        errorLabel: "סעיף - AccountTypeID אינו תואם לפעולה"
    },
    {
        id: 135,
        label: "סעיף - HasEstimate אינו תואם לפעולה",
        errorLabel: "סעיף - HasEstimate אינו תואם לפעולה"
    },
    {
        id: 136,
        label: "סעיף - Form AccountOption יש סיכונים קשורים שאינם קשורים לסעיף",
        errorLabel: "סעיף - Form AccountOption יש סיכונים קשורים שאינם קשורים לסעיף"
    },
    {
        id: 137,
        label: "סעיף - מצג הנהלה בעל סיכון מובנה גבוה יותר ללא סיכון IsHigher Risk קשור",
        errorLabel: "סעיף - מצג הנהלה בעל סיכון מובנה גבוה יותר ללא סיכון IsHigher Risk קשור"
    },
    {
        id: 138,
        label: "MultiEntity - Multi Entity ללא כל נהלים מבססים קשורים עבור סעיפים קשורים",
        errorLabel: "MultiEntity - Multi Entity ללא כל נהלים מבססים קשורים עבור סעיפים קשורים"
    },
    {
        id: 139,
        label: "ישות מוחזקת ללא טופס מעורבות קבוצתית (לא כולל ישויות מוחזקות לצרכי הפניה (refrences) בלבד)",
        errorLabel: "ישות מוחזקת ללא טופס מעורבות קבוצתית (לא כולל ישויות מוחזקות לצרכי הפניה (refrences) בלבד)"
    },
    {
        id: 140,
        label: "ישות מוחזקת (בהיקף ביקורת מלא (full) או ספציפי (specific)) ללא הנחיה קשורה להערכת סיכונים קבוצתית (לא כולל ישויות מוחזקות לצרכי הפניה (refrences) בלבד)",
        errorLabel: "ישות מוחזקת (בהיקף ביקורת מלא (full) או ספציפי (specific)) ללא הנחיה קשורה להערכת סיכונים קבוצתית (לא כולל ישויות מוחזקות לצרכי הפניה (refrences) בלבד)"
    },
    {
        id: 141,
        label: "MultiEntity - סעיף ללא כל MultiEntity קשור",
        errorLabel: "MultiEntity - סעיף ללא כל MultiEntity קשור"
    },
    {
        id: 142,
        label: "Document.SmartEvidenceSourceID המשויך לאובייקט לא חוקי",
        errorLabel: "Document.SmartEvidenceSourceID המשויך לאובייקט לא חוקי"
    },
    {
        id: 143,
        label: "סעיף - מצג הנהלה בעל סיכון מובנה גבוה יותר ללא סיכון IsHigher Risk קשור",
        errorLabel: "סעיף - מצג הנהלה בעל סיכון מובנה גבוה יותר ללא סיכון IsHigher Risk קשור"
    },
    {
        id: 144,
        label: "קבוצה - סעיפים (מתבצעים בהתקשרויות אחרות) ללא ישות מוחזקת קשורה",
        errorLabel: "קבוצה - סעיפים (מתבצעים בהתקשרויות אחרות) ללא ישות מוחזקת קשורה"
    },
    {
        id: 145,
        label: "סעיף - הערכת סעיף ללא אינדקס PSP לאומדנים",
        errorLabel: "סעיף - הערכת סעיף ללא אינדקס PSP לאומדנים"
    },
    {
        id: 146,
        label: "MultiEntity - שינוי פרופיל בודד של Multi Entity לא נשלח (מסמך בודד)",
        errorLabel: "MultiEntity - שינוי פרופיל בודד של Multi Entity לא נשלח (מסמך בודד)"
    },
    {
        id: 147,
        label: "MultiEntity - שינוי פרופיל בודד של Multi Entity לא נשלח (מסמך בודד)",
        errorLabel: "MultiEntity - שינוי פרופיל בודד של Multi Entity לא נשלח (מסמך בודד)"
    },
    {
        id: 148,
        label: "סעיף - מאפייני הסעיף לא שלמים או לא חוקיים",
        errorLabel: "סעיף - מאפייני הסעיף לא שלמים או לא חוקיים"
    },
    {
        id: 149,
        label: "העלאת מסמכים - חסרות חתימות PIC/EQR נדרשות",
        errorLabel: "העלאת מסמכים - חסרות חתימות PIC/EQR נדרשות"
    },
    {
        id: 150,
        label: "העלאת מסמך - חסרות דרישות חתימות PIC/EQR חובה",
        errorLabel: "העלאת מסמך - חסרות דרישות חתימות PIC/EQR חובה"
    },
    {
        id: 151,
        label: "סעיף משמעותי / גילוי משמעותי ללא כל מצגי הנהלה קשורים",
        errorLabel: "סעיף משמעותי / גילוי משמעותי ללא כל מצגי הנהלה קשורים"
    },
    {
        id: 152,
        label: "העלאת מסמכים - חסרות חתימות מכין או סוקר",
        errorLabel: "העלאת מסמכים - חסרות חתימות מכין או סוקר"
    },
    {
        id: 153,
        label: "התאמה ללא כל ראיה",
        errorLabel: "התאמה ללא כל ראיה"
    },
    {
        id: 154,
        label: "הערכה ללא קשר לחשבון",
        errorLabel: "הערכה ללא קשר לחשבון"
    },
    {
        id: 155,
        label: "אומדן בסיכון גבוה/נמוך יותר הקשור לחשבון שאינו כרוך באומדן",
        errorLabel: "אומדן בסיכון גבוה/נמוך יותר הקשור לחשבון שאינו כרוך באומדן"
    },
    {
        id: 156,
        label: "מענה לקטגוריית אומדן אינה מותאמת לייעוד ב'עריכת אומדן'",
        errorLabel: "מענה לקטגוריית אומדן אינה מותאמת לייעוד ב'עריכת אומדן'"
    },
    {
        id: 157,
        label: "אומדן ללא תת תהליך מהותי ( SCOT) חוקי",
        errorLabel: "אומדן ללא תת תהליך מהותי ( SCOT) חוקי"
    },
    {
        id: 158,
        label: "Account without valid estimate",
        errorLabel: "Account without valid estimate"
    },
    {
        id: 159,
        label: "חשבון הכרוך באומדן ללא שיוך אומדן בסיכון גבוה או נמוך יותר",
        errorLabel: "חשבון הכרוך באומדן ללא שיוך אומדן בסיכון גבוה או נמוך יותר"
    },
    {
        id: 160,
        label: "תת תהליך מהותי SCOT הכרוך באומדן ללא שיוך אומדן בסיכון גבוה או נמוך יותר",
        errorLabel: "תת תהליך מהותי SCOT הכרוך באומדן ללא שיוך אומדן בסיכון גבוה או נמוך יותר"
    },
    {
        id: 161,
        label: "התאמות שאינן נטו",
        errorLabel: "התאמות שאינן נטו"
    },
    {
        id: 162,
        label: "אומדן בסיכון גבוה יותר ללא שיוך של סיכון תקף",
        errorLabel: "אומדן בסיכון גבוה יותר ללא שיוך של סיכון תקף"
    },
    {
        id: 163,
        label: "מסמך - מסמך שבוצע לו צ'ק אאוט או בתהליך צ'ק אאוט לצורך שיתוף פעולה (collaboration)",
        errorLabel: "מסמך - מסמך שבוצע לו צ'ק אאוט או בתהליך צ'ק אאוט לצורך שיתוף פעולה (collaboration)"
    },
    {
        id: 164,
        label: "משימות רוחביות שאינן חלק מההתקשרות שחסרות להן ראיות ביקורת. ",
        errorLabel: "משימות רוחביות שאינן חלק מההתקשרות שחסרות להן ראיות ביקורת. "
    },
    {
        id: 165,
        label: "דרישת חתימה של שותף אחראי על הביקורת (PIC) או של שותף מלווה (EQR) אינה תואמת לתגובה",
        errorLabel: "דרישת חתימה של שותף אחראי על הביקורת (PIC) או של שותף מלווה (EQR) אינה תואמת לתגובה"
    },
    {
        id: 166,
        label: "סיכון משמעותי/הונאה הקשור לאומדן שאינו סיכון גבוה יותר",
        errorLabel: "סיכון משמעותי/הונאה הקשור לאומדן שאינו סיכון גבוה יותר"
    }
];

export const contentType = {
    1: "Primary standard tasks (PSTs)",
    2: "Primary substantive procedures Index (PSP index)",
    3: "Primary substantive procedures (PSPs)",
    4: "הנחיות ביקורת לקבוצה",
    5: "טפסי Canvas הנדרשים על ידי מתודולוגיה",
    6: "טפסי Canvas שנוצרו על ידי משתמשים (לדוגמה: טופס SCOT)",
    7: "אי תלות",
    9: "פרופיל",
    10: "מיפויי Canvas"
};

export const contentTypeByName = {
    'PST': "משימות חובה סטנדרטיות  (PSTs)",
    'PSPIndex': "אינדקס בדיקות מבססות עיקריות (אינדקס PSP)",
    'PSP': "בדיקות מבססות עיקריות (PSPs)",
    'GAInstructions': "הנחיות ביקורת לקבוצה",
    'CanvasFormKnowledge': "טפסי Canvas שיובאו מתוך מאגר ידע",
    'CanvasFormUserAdded': "טפסי Canvas שנוצרו על ידי משתמשים (דוגמה: טופס SCOT)",
    'IndependenceForm': "אי תלות",
    'Profile': "פרופיל",
    'Maps': "מיפויי Canvas"
};

export const reportTypes = {
    1: "דוח לא מסוייג -  עם פסקת הדגש עניין (Emphasis Of Matter)",
    2: "דוח לא מסוייג -  ללא פסקת הדגש עניין (Emphasis Of Matter)",
    3: "מסוייג - עם פסקת הדגש עניין (Emphasis Of Matter)",
    4: "מסוייג - ללא פסקת הדגש עניין (Emphasis Of Matter)",
    5: "חוות דעת שלילית - עם פסקת הדגש עניין (Emphasis Of Matter)",
    6: "חוות דעת שלילית - ללא פסקת הדגש עניין (Emphasis Of Matter)",
    7: "הסתייגות בחוות הדעת  - עם פסקת הדגש עניין (Emphasis Of Matter)",
    8: "הסתייגות בחוות הדעת - ללא פסקת הדגש עניין (Emphasis Of Matter)",
    100: "לא",
    101: "לא רלוונטי",
    102: "טרם נבחר"
};

export const internalUserRoles = [{
        roleKey: 3,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "הרשאות",
        roleNameUI: "העברת תיעוד ההתקשרות לארכיון",
        displayName: "העברת תיעוד ההתקשרות לארכיון",
        roleDisplayOrder: 2,
        tooltipText: "יכולת לארכב את תיק הביקורת"
    },
    {
        roleKey: 4,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "הרשאות",
        roleNameUI: "ניהול תיק הביקורת (Administer engagement)",
        displayName: "ניהול תיק הביקורת (Administer engagement)",
        roleDisplayOrder: 1,
        tooltipText: "יכולת להזמין חברי צוות פנימיים וחיצוניים ולהקצות הרשאות לחברי צוות פנימיים"
    },
    {
        roleKey: 5,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "הרשאות",
        roleNameUI: "עדכן תוכן",
        displayName: "עדכן תוכן",
        roleDisplayOrder: 6,
        tooltipText: "אפשרות לערוך את הפרופיל ולקבל עדכון תוכן"
    },
    {
        roleKey: 7,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "הרשאות",
        roleNameUI: "צור בקשת שירות",
        displayName: "לא ניתן היה להשלים את הניסיון הנוסף לארכב. רענן את הדף ונסה שוב. אם הבעיה ממשיכה, פנה לתמיכה הטכנית.",
        roleDisplayOrder: 4,
        tooltipText: "היכולת ליצור בקשות שירות ולסמן שהבקשות לשירות הושלמו"
    },
    {
        roleKey: 8,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "הרשאות",
        roleNameUI: "ניהול ביקורת קבוצה",
        displayName: "ניהול ביקורת קבוצה",
        roleDisplayOrder: 5,
        tooltipText: "קבל או דחה הנחיות קבוצה שהתקבלו מהצוות הראשי (PT) או האזורי (RT)"
    },
    {
        roleKey: 9,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "הרשאות",
        roleNameUI: "העתק, גלגל קדימה, שחזר תיקי ביקורת",
        displayName: "העתק, גלגל קדימה, שחזר תיקי ביקורת",
        roleDisplayOrder: 3,
        tooltipText: "יכולת להעתיק את ההתקשרות, ולגלגל קדימה ולשחזר את הארכיון שלו",
    },
    {
        roleKey: 0,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "סודיות",
        roleNameUI: "ברירת מחדל",
        displayName: "ללא (ברירת מחדל)",
        roleDisplayOrder: 1,
        tooltipText: "תפקיד ברירת מחדל למסמכים סודיים"
    },
    {
        roleKey: 10,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "סודיות",
        roleNameUI: "Low",
        displayName: "Low",
        roleDisplayOrder: 8,
        tooltipText: "Low Confidential Documents Role"
    },
    {
        roleKey: 11,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "סודיות",
        roleNameUI: "High",
        displayName: "High",
        roleDisplayOrder: 10,
        tooltipText: "High Confidential Documents Role"
    },
    {
        roleKey: 12,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "סודיות",
        roleNameUI: "Moderate",
        displayName: "Moderate",
        roleDisplayOrder: 9,
        tooltipText: "Moderate Confidential Documents Role"
    },
    // {
    // roleKey: 13,
    // sectionId:1,
    // groupDisplayOrder: 200,
    // groupName: "סודיות",
    // roleNameUI: "סודי",
    // displayName: "סודי",
    // roleDisplayOrder: 11,
    // tooltipText: "Strictly Confidential Documents Role"
    // },
    {
        roleKey: 14,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "מגבלות",
        roleNameUI: "לקריאה בלבד",
        displayName: "לקריאה בלבד",
        roleDisplayOrder: 12,
        tooltipText: "יש להשתמש באפשרות זו רק כדי להעניק לסוקרים חיצוניים גישה לתיק הביקורת. יש להשיג את האישורים וההרשאות מהתאימות מה PPD."
    },
    {
        roleKey: 16,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "מגבלות",
        roleNameUI: "סקירה בלבד",
        displayName: "סקירה בלבד",
        roleDisplayOrder: 13,
        tooltipText: "סקירה מעניקה למשתמש זה רק את היכולת להציג מידע בהתקשרות ב EY Canvas, לחתום ולהשתמש בפונקציונליות של הערת הסקירה (review note). יש להשתמש באפשרות זו כאשר משתמשי EY אחרים צריכים לבדוק התקשרות זו אך אינם יכולים לערוך. "
    },
    {
        roleKey: 37,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "מגבלות",
        roleNameUI: "אי תלות בלבד",
        displayName: "אי תלות בלבד",
        roleDisplayOrder: 14,
        tooltipText: "אי התלות רק מעניקה למשתמש זה את היכולת למלא את טופס אי התלות שלו עבור ההתקשרות, אך לא תאפשר למשתמש לגשת באופן מלא לסביבת העבודה ב- EY Canvas. יש להשתמש באפשרות זו כאשר משתמש ביצע עבודה עבור ההתקשרות, אך אין לו צורך בגישה ל-EY Canvas.",
    },
    {
        roleKey: 6,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "הרשאות",
        roleNameUI: "בטל עריכה",
        displayName: "חזרה לאחור / מחיקת מסמך בכמות גדולה",
        roleDisplayOrder: 7,
        tooltipText: "היכולת להחזיר מסמכים למצב קודם אם השינויים בוצעו בטעות לאחר תאריך פרסום הדוח (RRD) ולהסיר אותם מטופס 440 EY Canvas"
    },
    {
        roleKey: 35,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "הרשאות",
        roleNameUI: "נהל שיתוף של הפעלת EY Canvas FIT",
        displayName: "ניהול תהליכי עבודה מודרכים (guided workflow)",
        roleDisplayOrder: 14,
        tooltipText: "יכולת לשתף תהליכי עבודה מודרכים (Guided Workflows) בין התקשרויות של EY Canvas"
    },
    {
        roleKey: 36,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "הרשאות",
        roleNameUI: "ייבא נתוני EY Helix",
        displayName: "ייבא נתוני EY Helix",
        roleDisplayOrder: 15,
        tooltipText: "יכולת לייבא נתונים מ-EY Helix"
    }
];

export const ValidationSubGroups = [{
        id: 9008,
        label: "ציות לנהלי אי תלות"
    },
    {
        id: 9001,
        label: "סיכום הסעיפים"
    },
    {
        id: 9002,
        label: "סיכום תתי התהליכים המהותיים (SCOTs)"
    },
    {
        id: 9004,
        label: "סיכום IT"
    },
    {
        id: 9003,
        label: "סיכום הערכת הסיכון המשולב (CRA)"
    },
    {
        id: 9005,
        label: "תוכנית ביקורת"
    },
    {
        id: 9011,
        label: "מטריצת הערכת הביקורת המבססת (Substantive Evaluation Matrix (SEM))"
    },
    {
        id: 9012,
        label: "אימות לפי טופס Canvas"
    },
    {
        id: 9009,
        label: "הערכת IT"
    },
    {
        id: 49,
        label: "הצגות מוטעות שאינן קשורות"
    },
    {
        id: 50,
        label: "ליקויים שאינם קשורים"
    },
    {
        id: 44,
        label: "כפילות בשמות הקובץ"
    },
    {
        id: 38,
        label: "קונפליקטים שאינם פתורים"
    },
    {
        id: 9013,
        label: "שינויים לאחר תאריך פירסום הדוח"
    },
    {
        id: 9014,
        label: "IT Flow"
    },
    {
        id: 9015,
        label: "הפעלת EY Canvas FIT"
    },
    {
        id: 71,
        label: "טפסים ללא תוכן"
    },
    {
        id: 9016,
        label: 'Incomplete canvas form response'
    },
    {
        id: 9017,
        label: 'Adjustment module'
    },
];

export const engagementIndustry = {
    116: "Not Sector Specific",
    61: "Aerospace and Defense – Aerospace Manufacturing",
    112: "Aerospace and Defense – Defense Contracts Manufacturing",
    59: "Airlines – Air Transportation",
    92: "Construction – Engineering and Architectural Services",
    57: "Construction – Highway and Heavy Construction",
    43: "Construction – Specialty Contractors",
    85: "Consumer Products – Consumer Non– Durable Goods Manufacturing",
    53: "Consumer Products – Food and Beverages Manufacturing",
    60: "Consumer Products – Food Crops, Livestock, Fishing",
    10: "Consumer Products – Household Appliances and Electronics Manufacturing",
    90: "Consumer Products – Other Consumer Durable Goods Manufacturing",
    51: "Consumer Products – Textiles and Apparel Manufacturing",
    101: "Diversified Industrial Products – Fabricated Metals",
    5: "Diversified Industrial Products – Forestry, Pulp, and Paper",
    71: "Diversified Industrial Products – Industrial Instruments Manufacturing",
    89: "Diversified Industrial Products – Industrial Machines Manufacturing",
    27: "Diversified Industrial Products – Industrial Packaging",
    54: "Diversified Industrial Products – Lumber and Wood Manufacturing",
    32: "Diversified Industrial Products – Other Industrial Products",
    4: "Diversified Industrial Products – Primary Metals",
    109: "Diversified Industrial Products – Printing",
    66: "Diversified Industrial Products – Rubber and Plastics Manufacturing",
    41: "Diversified Industrial Products – Stone, Clay, and Glass Manufacturing",
    37: "Government and Public Sector – Education",
    130: "Construction – Engineering and Architectural Services",
    68: "Construction – Highway and Heavy Construction",
    65: "Construction – Specialty Contractors",
    82: "Consumer Products – Consumer Non– Durable Goods Manufacturing",
    17: "Consumer Products – Food and Beverages Manufacturing",
    35: "Consumer Products – Food Crops, Livestock, Fishing",
    33: "Consumer Products – Household Appliances and Electronics Manufacturing",
    75: "Consumer Products – Other Consumer Durable Goods Manufacturing",
    39: "Consumer Products – Textiles and Apparel Manufacturing",
    21: "Diversified Industrial Products – Fabricated Metals",
    31: "Diversified Industrial Products – Forestry, Pulp, and Paper",
    29: "Diversified Industrial Products – Industrial Instruments Manufacturing",
    40: "Diversified Industrial Products – Industrial Machines Manufacturing",
    26: "Diversified Industrial Products – Industrial Packaging",
    42: "Diversified Industrial Products – Lumber and Wood Manufacturing",
    105: "Diversified Industrial Products – Other Industrial Products",
    100: "Diversified Industrial Products – Primary Metals",
    45: "Diversified Industrial Products – Printing",
    1: "Diversified Industrial Products – Rubber and Plastics Manufacturing",
    118: "Diversified Industrial Products – Stone, Clay, and Glass Manufacturing",
    76: "Insurance – Property and Casualty Insurers",
    79: "Government and Public Sector – Education",
    78: "Government and Public Sector – Federal, National, and International Governments",
    131: "Government and Public Sector – Health Commissioner",
    132: "Government and Public Sector – Health Provider",
    97: "Government and Public Sector – Local government, including State or other levels below National",
    2: "Health – Academic Medical Centers",
    72: "Health – Government Hospitals",
    74: "Health – Managed Health Care",
    8: "Health – Multi Hospital Systems",
    128: "Health – Non System Hospitals",
    94: "Health – Other Health Care Entities",
    73: "Health – Physician Groups",
    121: "Health – Post Acute Care",
    58: "Health – Specialty Hospitals",
    16: "Hospitality and Leisure – Gaming and Gambling",
    7: "Hospitality and Leisure – Hotels, Motels, and Lodging",
    126: "Hospitality – Restaurants / Eating and Drinking Establishments",
    84: "Other Transportation – Local and Urban Transportation",
    55: "Insurance – Health Insurance",
    111: "Insurance – Insurance Agents and Brokers",
    69: "Insurance – Life Insurers",
    96: "Insurance – Other Insurance",
    11: "Insurance – Property and Casualty Insurers",
    117: "Insurance – Reinsurers",
    23: "Life Sciences – Medical Technology",
    48: "Media and Entertainment – Advertising",
    14: "Media and Entertainment – Broadcast, Cable Network, Online Video",
    18: "Media and Entertainment – Cable Provider, Satellite, MVPD",
    86: "Media and Entertainment – Film",
    46: "Media and Entertainment – Integrated Media and Entertainment",
    15: "Media and Entertainment – Music Industry",
    25: "Media and Entertainment – Other Media and Entertainment",
    20: "Media and Entertainment – Publishing",
    30: "Media and Entertainment – Sports",
    28: "Mining – Mining Operations",
    3: "Real Estate – Other Real Estate Owners/ Developers",
    120: "Not for Profit – Foundations and Charitable Trusts",
    107: "Not for Profit – Other Not For Profit Organizations",
    70: "Oil and Gas – Energy Trading",
    22: "Oil and Gas – Exploration and Production",
    67: "Oil and Gas – Refining",
    113: "Other Transportation – Local and Urban Transportation",
    38: "Other Transportation – Other Transportation",
    83: "Other Transportation – Rail Transportation",
    88: "Other Transportation – Road Transport and Warehousing",
    6: "Other Transportation – Water Transportation",
    87: "Retail and Wholesale – Wholesale Durable Goods",
    95: "Pharmaceutical – Medical Devices Manufacturing",
    123: "Pharmaceutical – Pharmaceuticals Manufacturing and Wholesale",
    115: "Power and Utilities – Electricity",
    119: "Power and Utilities – Natural Gas",
    110: "Power and Utilities – Other Utilities",
    102: "Power and Utilities – Waste and Water",
    125: "Professional Firms and Services – Business Services",
    34: "Professional Firms and Services – Other Services",
    47: "Professional Firms and Services – Personal Services",
    124: "Professional Firms and Services – Professional Service Firms",
    127: "Professional Firms and Services – Rental and Leasing Services",
    108: "Professional Firms and Services – Travel Services",
    49: "Real Estate – Commercial Real Estate Owners/ Developers",
    56: "Real Estate – Other Real Estate Owners/ Developers",
    62: "Real Estate – Real Estate Investment Trusts",
    122: "Real Estate – Real Estate Investors",
    12: "Real Estate – Real Estate Service Companies",
    91: "Real Estate – Residential Real Estate Owners/ Developers",
    24: "Retail and Wholesale – Department Stores",
    93: "Retail and Wholesale – Internet Retail and Mail Order",
    80: "Retail and Wholesale – Mass Merchandisers / Discount Stores",
    9: "Retail and Wholesale – Other Specialty Retailers",
    77: "Retail and Wholesale – Retail Apparel and Accessory Stores",
    114: "Retail and Wholesale – Supermarkets, Grocery, and Convenience Stores",
    36: "Retail and Wholesale – Wholesale Durable Goods",
    64: "Retail and Wholesale – Wholesale Non– Durable Goods",
    104: "Sustainability",
    63: "Technology – Communication and Networking Equipment",
    52: "Technology – Computers and Electronics",
    138: "Technology – Internet and Social Commerce",
    103: "Technology – IT Services",
    19: "Technology – Other Technology",
    98: "Technology – Semiconductors",
    13: "Technology – Software / SaaS / Apps",
    81: "Telecommunications – Cable Communications Services",
    106: "Telecommunications – Integrated Communications Providers",
    129: "Telecommunications – Internet Service Providers",
    99: "Telecommunications – Mobile Wireless Communications Services",
    50: "Telecommunications – Other Communications",
    44: "Telecommunications – Satellite Communications Services"
};

export const rnhQuickFilterLabel = [{
        id: rnhQuickFilter.all,
        label: "הצג הכול"
    },
    {
        id: rnhQuickFilter.assigned,
        filterType: rnhFilterTypeQuery.assignedTo,
        label: "מוקצות לי"
    },
    {
        id: rnhQuickFilter.authored,
        filterType: rnhFilterTypeQuery.authoredBy,
        label: "נכתב על ידי"
    }
];

export const relatedItemStatus = [{
        id: 1,
        label: "טיוטה"
    },
    {
        id: 2,
        label: "אין איש קשר ללקוח"
    },
    {
        id: 3,
        label: "נשלח"
    },
    {
        id: 4,
        label: "שגיאת מערכת"
    },
    {
        id: 5,
        label: "איש קשר לא חוקי ללקוח"
    },
    {
        id: 6,
        label: "מענה ממתין"
    },
    {
        id: 7,
        label: "התקבל"
    },
    {
        id: 8,
        label: "התקבל"
    },
    {
        id: 9,
        label: "הוחזר"
    },
    {
        id: 10,
        label: "נדחה"
    },
    {
        id: 11,
        label: "השליחה מתבצעת"
    },
    {
        id: 12,
        label: "קבלה בתהליך"
    },
    {
        id: 13,
        label: "דחייה בתהליך"
    },
    {
        id: 14,
        label: "מחיקה בתהליך"
    },
    {
        id: 15,
        label: "החזרה בתהליך"
    },
    {
        id: 16,
        label: "מתן מענה בתהליך"
    },
    {
        id: 17,
        label: "נמחק"
    },
    {
        id: 18,
        label: "הוחזר איש קשר לא חוקי ללקוח"
    },
    {
        id: 19,
        label: "איחזור בתהליך"
    },
    {
        id: 20,
        label: "אוחזר"
    },
    {
        id: 21,
        label: "השלמה בתהליך"
    },
    {
        id: 22,
        label: "איחזור בתהליך"
    }
];

export const GroupDocuments = [{
        id: 33,
        label: "הנחיות לביקורת הקבוצה נשלחו על ידי הצוות הראשי"
    },
    {
        id: 37,
        label: "מסמכים שהוחזרו מהצוות הראשי"
    }
];

export const engagementUserStatus = {
    1: "פעיל",
    2: "ממתין",
    3: "נדחה",
    4: "בוטל",
    5: "בקשה לגישה לארכיב",
    6: "דחה גישה לארכיב",
    7: "העתקת תיק ביקורת - לא פעיל",
    8: "לא מקושר-לא פעיל",
    9: "תבנית - לא פעילה",
    10: "גלגול קדימה (roll-forward) - לא פעיל",
    11: "התאמה מקומית כדי להבדיל מהארכיב האוניבסלי",
    12: "הזמנה בתהליך",
    13: "מתוזמן - לא פעיל"
};
export const CGTTaskSendStatus = [{
        id: 1,
        label: "לא נשלח"
    },
    {
        id: 2,
        label: "מסמך במעבר"
    },
    {
        id: 3,
        label: "גרסת טיוטת נשלחה"
    },
    {
        id: 4,
        label: "הוחזר"
    },
    {
        id: 5,
        label: "בסקירה"
    },
    {
        id: 6,
        label: "המשימות למענה  בביקורת הושלמו"
    },
    {
        id: 7,
        label: "משוחרר"
    },
    {
        id: 8,
        label: "דחה במעבר"
    },
    {
        id: 9,
        label: "הגרסה הסופית נשלחה"
    },
    {
        id: 999,
        label: "השליחה נכשלה"
    }
];

export const ServiceRequestStatus = [{
        id: 11,
        cssClass: 'accepted-text',
        statusLabel: "התקבל"
    },
    {
        id: 12,
        cssClass: 'pending-text',
        statusLabel: "נשלח"
    },
    {
        id: 13,
        cssClass: 'rejected-text',
        statusLabel: "מבוטל"
    },
    {
        id: 14,
        statusLabel: "טיוטה"
    },
    {
        id: 15,
        cssClass: 'completed-text',
        statusLabel: "הושלם"
    },
    {
        id: 16,
        statusLabel: "סקירה מפורטת"
    },
    {
        id: 17,
        statusLabel: "שגיאת הגשה"
    },
    {
        id: 22,
        statusLabel: "לא רלוונטי"
    },
    {
        id: 24,
        statusLabel: "פעולה נדרשת"
    }
];

export const assignmentsSectionLabels = [{
        id: bulkAssignment.assign,
        label: "משימות לביצוע"
    },
    {
        id: bulkAssignment.timephase,
        label: "שלבי זמן"
    },
    {
        id: bulkAssignment.tag,
        label: "תגים"
    }
];

export const assignmentsSectionLabelsNew = [{
        id: bulkAssignment.assign,
        label: "משימות לביצוע"
    },
    {
        id: bulkAssignment.timephase,
        label: "שלבי זמן"
    }
];

export const assignmentTypeLabels = [{
        id: assignmentTypes.preparer,
        label: "P"
    },
    {
        id: assignmentTypes.detailReviewer,
        label: "סוקר לסקירה מפורטת"
    },
    {
        id: assignmentTypes.generalReviewer,
        label: "סוקר כללי"
    },
    {
        id: assignmentTypes.partner,
        label: "שותף"
    },
    {
        id: assignmentTypes.eqr,
        label: "EQR"
    },
    {
        id: assignmentTypes.other,
        label: "אחרים"
    }
];

export const assignmentActionsLabels = [{
        id: bulkAssignmentConstants.actionIds.add,
        label: "הוסף"
    },
    {
        id: bulkAssignmentConstants.actionIds.remove,
        label: "הסר"
    },
    {
        id: bulkAssignmentConstants.actionIds.replace,
        label: "החלף"
    },
    {
        id: bulkAssignmentConstants.actionIds.updateDueDays,
        label: "יש לעדכן את מספר הימים (Days Due)"
    }
];

export const tagActionsLabels = [{
        id: bulkAssignmentConstants.actionIds.add,
        label: "הוסף"
    },
    {
        id: bulkAssignmentConstants.actionIds.remove,
        label: "הסר"
    }
];

export const manageAssigmentsActionTypeLabel = [{
        id: actionTypes.edit,
        label: "ערוך"
    },
    {
        id: actionTypes.delete,
        label: "מחק"
    }
];

export const confidentialityLevels = {
    [confidentialityTypes.DEFAULT]: "ברירת מחדל",
    [confidentialityTypes.LOW]: "Low",
    [confidentialityTypes.MODERATE]: "Moderate",
    [confidentialityTypes.HIGH]: "High"
};

export const milestoneTaskLabels = [{
        id: milestoneBuildTaskIds.accounts,
        label: "משימות הקשורות לתהליך קביעת סעיפים מהותיים"
    },
    {
        id: milestoneBuildTaskIds.scots,
        label: "משימות הקשורות לתהליך קביעת תתי התהליכים המהותיים SCOTs"
    },
    {
        id: milestoneBuildTaskIds.itso,
        label: "משימות הקשורות לתהליך קביעת יישומי IT / SO"
    },
    {
        id: milestoneBuildTaskIds.cra,
        label: "משימות הקשורות לתהליך הערכת הסיכון המשולב CRA"
    },
    {
        id: milestoneBuildTaskIds.auditPlan,
        label: "משימות הקשורות לתהליך קביעת תוכנית הביקורת"
    },
    {
        id: milestoneBuildTaskIds.groupStructure,
        label: "משימות הקשורות לתהליך מבנה הקבוצה"
    },
    {
        id: milestoneBuildTaskIds.groupInstructions,
        label: "משימות הקשורות לתהליך הנחיות הקבוצה"
    },
    {
        id: milestoneBuildTaskIds.review,
        label: "משימות הקשורות לתהליך הסקירה"
    }
];

//Filters for RegionComponentEvidence
export const gaDocFilters = {
    scope: "היקף",
    teamName: "שם קבוצה",
    groupStructure: "מבנה הקבוצה",
    region: "אזור (region)",
    component: "ישות מוחזקת (component)"
};

export const filterSourceOfForm = [{
        value: '1',
        label: "מותאם אישית"
    },
    {
        value: '2',
        label: "ידע"
    },
    {
        value: '3',
        label: "אי תלות"
    }
];

export const independenceActions = [{
        id: independenceActionIds.createIndependenceForm,
        label: "צור טופס אי תלות"
    },
    {
        id: independenceActionIds.removeTeamMember,
        label: "הסר את חבר הצוות"
    },
    {
        id: independenceActionIds.removeOverride,
        label: "הסר עקיפה (override)"
    }
];


export const reviewNoteModalLabels = {
    /*Review Notes*/
    commentThread: "שרשור הערה",
    singleNoteInstructionalText: "הצג והשב להערה שנבחרה למטה.",
    emptyNoteDetailsMessage: "בחר הערה כדי להציג פרטים. כדי להפעיל בקרות בכמות גדולה, השתמש במקש ה-control או Shift ובחר מספר הערות ביקורת. אם תרצה לעבוד על תגובה בודדת, בחר את ההערה מהרשימה.",
    documentReviewNotesLabel: "הערות במסמך",
    addNewReviewNoteButtonText: "הערה חדשה",
    noNotesAssociatedWithDocumentLabel: "השאר הערה באמצעות הקלטים למטה. הקצה את ההערה למשתמש וציין את העדיפות ואת תאריך היעד.",
    noNotesFound: "לא נמצאו הערות",
    noNotesAssociatedWithTaskLabel: "אין הערות {0} המשויכות למשימה.",
    allNotesLabel: "כל ההערות",
    charactersLabel: "תווים",
    myNotesLabel: "ההערות שלי",
    showClearedLabel: "הצג  שנוקו (cleared)",
    showClosedLabel: "הצג סגורים (closed)",
    assignedToLabel: "הוקצה ל",

    ofLabel: "של",
    enterNoteText: "הזן הערה",
    addNewNoteModalClose: "Close",
    addNewNoteModalTitleLabel: "הוסף הערה חדשה",
    editNoteModalTitleLabel: "ערוך הערה",
    deleteIconHoverText: "מחק",
    deleteIconModalAcceptText: "מחק",
    deleteIconModalConfirmMessage: "האם אתה בטוח שברצונך למחוק את תשובתך לתגובה זו?",
    deleteIconModalConfirmMessageParent: "האם אתה בטוח שברצונך למחוק את התגובה שנבחרה?",
    deleteIconModalTitleLabel: "מחק הערה",
    deleteReplyIconModalTitle: "מחק תשובה",
    emptyRepliesMessage: "עדיין אין תגובות",
    replyInputPlaceholder: "השב להערה זו",
    replyInputPlaceholderEdit: "ערוך תשובה להערת סקירה",
    noteInputPlaceholderEdit: "ערוך הערת סקירה",
    replyText: "טקסט תגובה",
    editReplyModelTitle: "ערוך תשובה",
    editReplyPlaceholder: "הזן מענה",
    noteDueDateLabel: "היעד בעוד",

    priorityLabel: "עדיפות",
    dueDateLabel: "תאריך יעד",
    dueLabel: "היעד בעוד",
    status: "סטטוס",
    noteModifiedDateLabel: "מותאם",
    cancelLabel: "בטל",
    saveLabel: "שמור",
    clearedBy: "נסגר על ידי",
    closedBy: "נסגר על ידי",
    reopenedBy: "נפתח מחדש על ידי",
    reply: "ענה",
    editIconHoverTextLabel: "ערוך",
    required: "נדרש",
    closeTitle: "Close",
    otherEngagementNotes: "הערות אחרות בהתקשרות",
    closeLabel: "Close",
    showMore: "הצג עוד",
    showLess: "הצג פחות",
    showMoreEllipsis: "הצג עוד ...",
    showLessEllipsis: "הצג פחות ...",
    noResultFound: "לא נמצאו תוצאות",
    engagementNameLabel: "שם ההתקשרות:",
    taskReviewNotesLabel: "הערות משימה",
    fromUserLabel: labels.fromUserLabel,
    toUserLabel: labels.toUserLabel
};

//Copyhub create package
export const createPackageLabels = {
    packageType: "סוג חבילה",
    categories: "קטגוריות",
    itemsToCopy: "פריטים להעתקה",
    createPackage: "צור חבילה",
    selectPackageType: "בחר סוג חבילה",
    selectPackageTypeTitle: "בחר סוג חבילה",
    selectCategoriesTitle: "בחר קטגוריות",
    selectEntitiesTitle: "בחר ישויות",
    relateCanvasFormsTitle: "שייך מסמכים",
    relateAnObjectTitle: "קשר אובייקט",
    step1InstructionalText: "בחר סוג חבילה, תן לה שם ובחר נמען. יש לוודא עמידה בכל החוקים, התקנות והמדיניות של EY בנוגע לפרטיות נתונים, העברת נתונים בין תחומי שיפוט (jurisdictions) והגנה על מידע סודי לפני יצירת או שליחת חבילת העתקה (Copy Package).",
    packageTypes: [{
        value: 21,
        text: "תיק ביקורת"
    }, {
        value: 20,
        text: "ראיות"
    }, {
        value: 24,
        text: "גלגול קדימה (Roll forward) מהקיים"
    }, {
        value: 22,
        text: "סעיפים"
    }, {
        value: 23,
        text: "SCOTs"
    }, {
        value: 26,
        text: "ייצוא בכמות גדולה"
    }, {
        value: 25,
        text: "תבנית"
    }, {
        value: 27,
        text: "מסמכים חיצוניים"
    }, {
        value: 28,
        text: "Guided Workflows"
    }, {
        value: 29,
        text: "התקשרות לפי ישות"
    }],

    packageName: "שם חבילה",
    packageDetailsText: "פרטי החבילה",
    required: "נדרש",
    sendTo: "שלח אל",
	nameOrEmail: 'שם או דוא"ל',
    sendToName: "שם",
    sendToEmail: "דואל",
    clearAllValues: "נקה את כל הערכים",
    engagementIdErrorMessage: "מזהה תיק הביקורת לא צויין",
    emptyCategoriesStep2Text: '...',
    insufficientPermissionsMessage: "אין הרשאות מספיקות כדי ליצור העתק  (copy package). פנה למנהל תיק הביקורת שלך ובקש הרשאה ליצור העתק (copy package).",
    CopyHubCanvasFormTooltip: "לטפסי EY Canvas בלבד",
    CopyEngagementInProgress: "ניתן לעבד רק עותק אחד של תיק ביקורת בכל פעם.",

    //Step 3 labels
    step3Header: "בחר {0} בכדי להעתיק",
    selectAllText: "בחר הכל",
    delectAllText: "בטל את כל הסינונים",
    documentsSelectedText: "מסמכים שנבחרו",
    scotsSelectedText: "SCOTs שנבחרו",
    accountsSelectedText: "סעיפים שנבחרו",
    entitiesSelectedText: "ישויות שנבחרו",
    step3InstructionText: "יש לוודא עמידה בכל החוקים, התקנות ומדיניות EY הרלוונטית בנוגע לפרטיות נתונים, העברת נתונים בין תחומי שיפוט והגנה על מידע סודי לפני יצירת או שליחת חבילת נתונים.",
    step3InstructionTextEvidence: "ודא ציות לכל החוקים, התקנות ומדיניות EY הנוגעים לעניין פרטיות הנתונים, העברת נתונים בין תחומי שיפוט והגנה על מידע סודי לפני שליחת נתונים של תיק הביקורת.",
    step3InstructionTextWarning: "EY Canvas Forms לא יכללו אובייקטים קשורים (למשל בקרות, תתי תהליכים מהותיים (SCOTs)). ",
    step3InstructionTextWarningFIT: "העותק של תהליך עבודה (workflow) המודרך עשוי לכלול אירועים ותנאים רלוונטיים שזוהו ואת התיאורים הקשורים אליהם. הוא לא יכלול אובייקטים קשורים אחרים (למשל חשבונות, סיכונים).",
    availableCanvasFormsColumnName: "מסמכים זמינים",
    availableFITDocuments: "Available Guided Workflows",
    availableAccountsColumnName: "סעיפים זמינים",
    availableSCOTsColumnName: "SCOTs זמינים",
    availableExternalDocumentsColumnName: "מסמכים חיצוניים זמינים",
    step3NoItemeSelectedError: "בחר פריט אחד לפחות כדי להמשיך",
    searchPackagePlaceholder: "חפש",
    searchPackageClearHoverText: "Clear",

    //step2:
    step2Header: "בחירת קטגוריות עבור חבילת {0}",
    step2AccountsHdr: "בחר קטגוריות שייכללו בחבילת ההעתקה. חבילת הליבה כוללת את כל מצגי ההנהלה, ה- PSPs וה- OSPs הקשורים.",
    step2scotshdr: "בחר קטגוריות שייכללו בחבילת ההעתקה. חבילת הליבה כוללת את כל ה- WCGWs הקשורים, בקרות ומשימות",
    step2canformhdr: "בחר קטגוריות שייכללו בחבילת העתקה",
    step2InstructionTextEngagementByEntity: "בחר ישויות שייכללו בחבילת העתקה",
    availableEntitiesColumnName: "ישויות זמינות",
    step2HeaderEntities: "בחר {0} עבור חבילת הדיווח של ההתקשרות (Engagement Package)",
    entitiesLabel: "ישויות",

    scots: "SCOTs",
    itso: "מבנה IT  application/ SO",
    evidence: "ראיות",
    realtedevidence: "ראיות קשורות",
    signoffs: "Sign-offs",
    tempfiles: "קבצים זמניים",
    priorperiodevidence: "ראיית ביקורת מתקופה קודמת",
    recentlydeletedfiles: "קבצים שנמחקו לאחרונה",
    historyfiles: "קבצים היסטוריים",
    extgrp: "קבוצות חיצוניות וחברי צוות חיצוניים",
    eydocument: "מסמכי EY",
    extdoc: "מסמכים חיצוניים",
    totalfilesize: "גודל הקובץ הכולל של כל הבחירות הוא",
    requestandexernaltasks: "בקשות ומשימות חיצוניות",
    rollForwardFromExisting: "גלגול קדימה (Roll forward) מהקיים",
    template: "תבנית",
    bulkExport: "ייצוא בכמות גדולה",

    fileSizeWaring: "הקטגוריות שנבחרו כוללות קבצים ש- {0}. EY Canvas אינו תומך בחבילות העתקה החורגות ממגבלה זו.",
    fileSizeWarningline2: "שקול להסיר קטגוריות מסמכים כדי להקטין את גודל הקובץ הכולל של חבילת ההעתקה.",
    coloredExceedLable: "חריגה מ- GB {0} ",
    step2EngHdr: "בחר קטגוריות שיש לכלול העתק של חבילת הדיווח. חבילת הבסיס כוללת את פרופיל ההתקשרות, כל מסמכי הידע, משימות חובה סטנדרטיות, משימות סטנדרטיות אחרות, שלבי זמן; חשבונות/גילויים, מצגי הנהלה ומשימות הקשורות אליהם; SCOTs, WCGWs, Controls ומשימות הקשורות אליהם; יישומי IT/ לשכות שירות, סיכונים, ITGCs/ ITSPs ומשימות נלוות. אם זו התקשרות לביקורת קבוצה, החבילה תכלול גם נתוני ביקורת קבוצה.",
    step2EngByEntityHdr: "בחר קטגוריות שיכללו בחבילת ההעתקה. חבילת הבסיס כוללת פרופיל תיק הביקורת, כל מסמכי הידע (knowledge documents), משימות חובה סטנדרטיות PSTs, משימות סטנדרטיות אחרות OSTs, time phases; סעיפים/ גילויים, מצגי הנהלה ומשימות רלוונטיות; SCOTs, WCGWs, בקרות ומשימות  רלוונטיות; יישומי IT/ לשכות שירות, סיכונים, ITGCs / ITSPs ומשימות קשורות. אם תיק הביקורת הוא ביקורת קבוצה, החבילה תכלול גם את נתוני ביקורת הקבוצה.",
    step2BulkExpHdr: "בחר קטגוריות מסמכים לייצוא.",
    gb: "GB",
    step2And: "ו-",
    step2Files: "מסמכ(ים)",
    lessThanMinGB: "פחות מ-0.01 GB",
    CategoryFileSizeCount: "{0} GB ו-{0} מסמכים",

    cancelLabel: "בטל",
    showSelected: "הצג את הפריטים שנבחרו",
    showSelectedDocuments: "הצג {0} מסמכים נבחרים",
    showSelectedEntities: "הצג {0} ישויות/ישויות שנבחרו",
    showSelectedGuidedWorflows: "הצג {0} זרימות עבודה מודרכות (guided workflow(s)) שנבחרו",
    showSelectedAccounts: "הצג {0} חשבונות נבחרים",
    showSelectedSCOTs: "הצג {0} תתי תהליכים מהותייפ SCOT(ים) שנבחרו",
    noDataFoundLabel: "לא נמצאו נתונים",
    copyPackageSuccessMessage: "ייצוא {0} נתונים החל.",
    copyPackageWarningLabel: "אזהרה : לא היתה אפשרות לשלוח את החבילה לחברי הצוות להלן עקב מידע לא חוקי :- {0}",
    noResultFound: "לא נמצאו תוצאות",
    canvasForms: "EY Canvas Forms",
    canvasFormsInformationText: "ניתן לייצא EY Canvas Forms רק כראיות ו/או כקבצים זמניים.<br/>אנא בחר אחת מהאפשרויות אלה כדי לאפשר הורדה של  EY Canvas Forms .",
    coEditSelectAllWarningMessage: "מסמכים מסוימים נמצאים כעת במצב עריכה פעיל של משתמשים מרובים ולא ניתן לכלול אותם בחבילת ההעתקה",
    coEditDocumentTooltip: "המסמך נמצא במצב עריכה פעיל מרובה משתמשים ולא ניתן להעתיקו. אנא בצעו צ'ק-אין למסמך כדי להעתיק אותו כחלק מחבילה זו",
    coEditCopyWarningMessage: "{0} מסמכים נמצאים במצב עריכה פעיל מרובה משתמשים בתוך הקטגוריה/קטגוריות {1}. אנא בצע צ'ק-אין בכל המסמכים בכל קטגוריה כדי לכלול אותם כחלק מחבילה זו"
};

export const documentTypes = [{
        id: 1,
        label: "ראיות"
    },
    {
        id: 2,
        label: "זמני"
    },
    {
        id: 3,
        label: "ראיות משנה קודמת"
    },
    {
        id: 4,
        label: "קבצי לקוח"
    },
    {
        id: 5,
        label: "תמונת מצב"
    },
    {
        id: 6,
        label: "טופס חכם (Smartform)"
    },
    {
        id: 29,
        label: "Paper profile"
    },
    {
        id: 47,
        label: "ייצוא מסמכים בכמות גדולה"
    },
    {
        id: 48,
        label: "Canvas form"
    },
    {
        id: 51,
        label: "Automation Hub"
    },
    {
        id: 59,
        label: "חבילות דיווח"
    },
    {
        id: 72,
        label: "נייר עבודה חכם (Smart Working Paper)"
    }
];

export const activityTypes = [{
        id: activityType.primaryLinkAccept,
        label: "בקשת הקישור התקבלה על-ידי {0}"
    },
    {
        id: activityType.primaryLinkReject,
        label: "בקשת הקישור נדחתה על-ידי {0}"
    },
    {
        id: activityType.primaryUnlink,
        label: "תיק הביקורת לא קושר לקבוצה על-ידי {0}"
    },
    {
        id: activityType.primaryComponentUnlink,
        label: "תיק הביקורת לא קושר לקבוצה על-ידי {0}"
    },
    {
        id: activityType.componentPrimaryUnlink,
        label: "תיק הביקורת לא קושר לקבוצה על-ידי {0}"
    },
    {
        id: activityType.primarySendLink,
        label: "בקשת הקישור נשלחה על-ידי {0} {1}"
    },
    {
        id: activityType.documentsReceived,
        label: "המסמכים התקבלו על-ידי {0}"
    },
    {
        id: activityType.primarySendInstruction,
        label: "הוראות נשלחו מ- {0} אל {1}"
    },
    {
        id: activityType.primaryRejectInstruction,
        label: "ההנחיות הוחזרו על-ידי {0}"
    },
    {
        id: activityType.primaryAcceptInstruction,
        label: "ההנחיות התקבלו על ידי {0}"
    },
    {
        id: activityType.componentReceivedInstruction,
        label: "ההנחיות התקבלו"
    },
    {
        id: activityType.componentAcceptInstruction,
        label: "ההנחיות התקבלו על ידי {0}"
    },
    {
        id: activityType.componentRejectInstruction,
        label: "ההנחיות הוחזרו על-ידי {0}"
    },
    {
        id: activityType.componentAcceptUpdatetInstruction,
        label: "ההנחיות התקבלו על ידי {0}"
    },
    {
        id: activityType.componentRejectUpdateInstruction,
        label: "ההנחיות הוחזרו על-ידי {0}"
    },
    {
        id: activityType.primaryEvidenceReceived,
        label: "הגירסה התקבלה על-ידי {0}"
    },
    {
        id: activityType.documentVersionConflictResolved,
        label: "ההתנגשות נפתרה על-ידי {0}"
    },
    {
        id: activityType.documentOverwrite,
        label: "תוכן המסמך הוחלף על ידי {0}"
    },

    {
        id: activityType.primaryAssignComponent,
        label: "המסמך הוקצה ל- {0}"
    },
    {
        id: activityType.componentUnassigned,
        label: "המסמך לא הוקצה מאת {0}"
    },
    {
        id: activityType.clearDocumentReturnedtoComponent,
        label: "הגירסה הושלמה על-ידי {0}"
    },
    {
        id: activityType.componentClearReturnedDocument,
        label: "הגירסה נפתרה על-ידי {0}"
    },
    {
        id: activityType.primaryReturnEvidence,
        label: "הגירסה הוחזרה על-ידי {0}"
    },
    {
        id: activityType.componentEvidenceSent,
        label: "הגירסה נשלחה על-ידי {0}"
    },
    {
        id: activityType.componentReturnEvidence,
        label: "הגירסה הוחזרה על-ידי {0}"
    },
    {
        id: activityType.createReviewNote,
        label: "ההערה נפתחה על-ידי {0}"
    },
    {
        id: activityType.openReviewNote,
        label: "ההערה נפתחה על-ידי {0}"
    },
    {
        id: activityType.clearReviewNote,
        label: "ההערה נוקתה על-ידי {0}"
    },
    {
        id: activityType.closeReviewNote,
        label: "ההערה נסגרה על-ידי {0}"
    },
    {
        id: activityType.reviewerSignOff,
        label: "חתום על ידי {0}"
    },
    {
        id: activityType.preparerSignOff,
        label: "חתום על ידי {0}"
    },
    {
        id: activityType.canvasSendClientRequest,
        label: labels.sent
    },
    {
        id: activityType.clientRespondToClientRequest,
        label: "הגיב"
    },
    {
        id: activityType.canvasRejectClientRequest,
        label: labels.rejected
    },
    {
        id: activityType.canvasWithdrawClientRequest,
        label: labels.WithdrawLabel
    },
    {
        id: activityType.canvasDeleteClientRequest,
        label: "נמחק"
    },
    {
        id: activityType.canvasAcceptClientRequest,
        label: labels.accepted
    },
    {
        id: activityType.CEARecallClientRequest,
        label: "אוחזר"
    },
    {
        id: activityType.canvasCompleteClientRequest,
        label: labels.completed
    }
];


export const gaLinkStatus = [{
        id: GALinkStatus.Undefined,
        label: "לא מוגדר"
    },
    {
        id: GALinkStatus.NoPointOfContact,
        label: "אין נקודת מגע"
    },
    {
        id: GALinkStatus.Pending,
        label: "ממתין"
    },
    {
        id: GALinkStatus.Accepted,
        label: "התקבל"
    },
    {
        id: GALinkStatus.Rejected,
        label: "נדחה"
    },
    {
        id: GALinkStatus.Expired,
        label: "לא בתוקף"
    },
    {
        id: GALinkStatus.Unlinked,
        label: "לא מקושר"
    },
    {
        id: GALinkStatus.Delegated,
        label: "הוקצה"
    },
    {
        id: GALinkStatus.SystemError,
        label: "שגיאת מערכת"
    },
    {
        id: GALinkStatus.Sent,
        label: "נשלח"
    },
    {
        id: GALinkStatus.InvalidPointOfContact,
        label: "נקודת מגע לא חוקית"
    },
    {
        id: GALinkStatus.ComponentNotUsingCanvas,
        label: "היחידה המדווחת לא משתמשת ב Canvas"
    }
];

export const gaInstructionStatus = [{
        id: 0,
        label: labels.notApplicable
    },
    {
        id: instructionStatus.notSent,
        label: "לא נשלח"
    },
    {
        id: instructionStatus.pending,
        label: "ממתין"
    },
    {
        id: instructionStatus.accepted,
        label: "התקבל"
    },
    {
        id: instructionStatus.rejected,
        label: "הוחזר"
    },
    {
        id: instructionStatus.systemError,
        label: "שגיאת מערכת"
    },
    {
        id: instructionStatus.expired,
        label: "לא בתוקף"
    },
    {
        id: instructionStatus.sent,
        label: "נשלח"
    },
    {
        id: instructionStatus.unlinked,
        label: "לא מקושר"
    },
    {
        id: instructionStatus.queued,
        label: "שבתור"
    }
];

export const gsSnapshotComparisonStatus = [{
        id: snapshotComparisonIds.noChange,
        value: "ריק"
    },
    {
        id: snapshotComparisonIds.new,
        value: "חדש"
    },
    {
        id: snapshotComparisonIds.added,
        value: "נוסף"
    },
    {
        id: snapshotComparisonIds.modified,
        value: "עבר שינוי"
    },
    {
        id: snapshotComparisonIds.updated,
        value: "מעודכן"
    },
    {
        id: snapshotComparisonIds.removed,
        value: "הוסר"
    },
    {
        id: snapshotComparisonIds.itemsRemoved,
        value: "הפריטים הוסרו"
    },
]

export const gaRoleType = [{
        id: GARoleTypeId.Primary,
        label: "צוות ראשי"
    },
    {
        id: GARoleTypeId.Region,
        label: "אזור (region)"
    },
    {
        id: GARoleTypeId.Component,
        label: "ישות מוחזקת (component)"
    }
];

export const linkRequestTypes = [{
        id: linkType.sent,
        label: "נשלח"
    },
    {
        id: linkType.unlinked,
        label: "לא מקושר"
    },
    {
        id: linkType.accepted,
        label: "התקבל"
    }
];

export const instructionTypes = [{
        id: instructionType.sent,
        label: "נשלח"
    },
    {
        id: instructionType.rejected,
        label: "הוחזר"
    },
    {
        id: instructionType.received,
        label: "התקבל"
    },
    {
        id: instructionType.accepted,
        label: "התקבל"
    }
];

export const syncStatusLabels = [{
        id: syncStatus.notSynchronized,
        label: "לא מסונכרן"
    },
    {
        id: syncStatus.syncInTransit,
        label: "סינכרון במעבר"
    },
    {
        id: syncStatus.syncInProcess,
        label: "בתהליך סינכרון"
    },
    {
        id: syncStatus.synchronized,
        label: "מסונכרן"
    },
    {
        id: syncStatus.deleteInTransit,
        label: "מחיקה במעבר"
    },
    {
        id: syncStatus.deleteInProcess,
        label: "מחיקה בתהליך"
    },
    {
        id: syncStatus.deleted,
        label: "נמחק"
    },
    {
        id: syncStatus.noHostEngagement,
        label: "אין סביבת עבודה מארחת (host engagement)'"
    },
    {
        id: syncStatus.syncError,
        label: "שגיאת סנכרון"
    }
];

export const colorOptionsLabels = {
    Red: "אָדוֹם",
    Orange: "כתום",
    Teal: "ירוק כחלחל",
    Blue: "כחול",
    Purple: "סגול",
    Green: "ירוק",
    Yellow: "צהוב",
    Gray: "אפור"
};

export const todoListTimeFrameLabels = [{
        id: todoListTimeframeOptions.byDay,
        label: "לפי יום"
    },
    {
        id: todoListTimeframeOptions.byWeek,
        label: "לפי שבוע"
    },
    {
        id: todoListTimeframeOptions.byMonth,
        label: "לפי חודש"
    },
    {
        id: todoListTimeframeOptions.all,
        label: "הכול"
    },
    {
        id: todoListTimeframeOptions.overdue,
        label: "תאריך היעד חלף"
    }
];

export const clientRequestsStatusFilter = [{
        value: 'Draft',
        label: "טיוטה"
    },
    {
        value: 'Pending',
        label: "ממתין למענה"
    },
    {
        value: 'Received',
        label: "התקבל"
    },
    {
        value: 'Accepted',
        label: "התקבל"
    }
];

export const clientRequestsTypeFilter = [{
        value: 'Required',
        label: "נדרשת חתימה"
    },
    {
        value: 'NotRequired',
        label: "אין צורך בחתימה (sign-off)"
    }
];

export const clientRequestsPriorityFilter = [{
        value: 'Normal',
        label: "נוֹרמָלִי"
    },
    {
        value: 'High',
        label: "High"
    },
    {
        value: 'Critical',
        label: "Critical"
    }
];

export const clientRequestsAttachmentsFilter = [{
        value: 'Analytics',
        label: "ניתוח"
    },
    {
        value: 'ExternalAttachments',
        label: "קבצים מצורפים חיצוניים"
    },
    {
        value: 'EyAttachments',
        label: "קבצים מצורפים של EY"
    },
    {
        value: 'None',
        label: "אף אחד"
    }
];

export const clientRequestsCreatedByFilter = [{
        value: 'Client',
        label: "לקוח"
    },
    {
        value: 'EY',
        label: "EY"
    }
];

export const filterTimePhase = [{
    value: -1,
    label: "אין time phase"
}];

export const clientRequestsBooleanFilters = [{
        value: 1,
        label: "כן"
    },
    {
        value: 0,
        label: "לא"
    }
]

export const bulkClientRequestsNoRelatedTaskFilter = [{
        value: false,
        label: "כן"
    },
    {
        value: true,
        label: "לא"
    }
]

export const controlsTestingFilters = [{
        value: 'true',
        label: "יָעִיל"
    },
    {
        value: 'false',
        label: "לֹא יָעִיל"
    },
    {
        value: 'null',
        label: "לא נבחר"
    }
];

export const controlsDesignEffectivenessFilters = [{
        value: '1',
        label: "יָעִיל"
    },
    {
        value: '2',
        label: "לֹא יָעִיל"
    },
    {
        value: '0',
        label: "לא נבחר"
    }
];

export const clientRequestAnnotationTabs = [{
        id: clientRequestNoteTab.comments,
        label: "הערות"
    },
    {
        id: clientRequestNoteTab.history,
        label: "היסטוריה"
    }
];

export const riskTypeOptions = [{
        id: 1,
        name: "סיכונים משמעותיים"
    },
    {
        id: 2,
        name: "סיכוני הונאה"
    },
    {
        id: 3,
        name: "סיכון להצגה מוטעית מהותית"
    }
];

export const months = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יול', 'אוגוסט', 'ספטמבר', 'אוקטוב', 'נובמבר', 'דצמב'];
export const longDays = ['ראשון', 'שני', 'שליש', 'רביעי', 'חמיש', 'שישי', 'שבת'];
export const shortDays = ['ראשון', 'שנ', 'שליש', 'רביעי', 'חמישי', 'שישי', 'שבת'];

// GA Scopes
export const gaScopesResource = [{
        id: gaScopes.full,
        label: "מלא"
    },
    {
        id: gaScopes.specific,
        label: "ספציפי"
    },
    {
        id: gaScopes.specificAuditProcedures,
        label: "נהלי ביקורת מוגדרים"
    },
    {
        id: gaScopes.review,
        label: "For My Review"
    }
]

// GA Instructions
export const gaRecommendationTypeResource = [{
        id: gaRecommendationType.required,
        label: "נדרש"
    },
    {
        id: gaRecommendationType.optional,
        label: "אופציונלי"
    },
    {
        id: gaRecommendationType.notApplicable,
        label: "לא ישים"
    }
]

// GS Group Summary
export const gsTabsResource = [{
        id: groupSummaryTabs.assignedTeams,
        label: "צוותים שהוקצו"
    },
    {
        id: groupSummaryTabs.instructions,
        label: "הוראות"
    },
    {
        id: groupSummaryTabs.tasks,
        label: "משימות"
    }
]

export const receiveInstructionsTypeResource = {
    true: {
        title: "חדש",
        instructional: "חדש"
    },
    false: {
        title: "מעודכן",
        instructional: "מעודכן"
    }
}

export const clientRequestSystemGeneratedMessages = {
    sent: "הבקשה נשלחה אל",
    accepted: "הבקשה התקבלה",
    received: "הבקשה התקבלה",
    returned: "הבקשה הוחזרה",
    withdrawn: "הבקשה בוטלה",
    complete: "הבקשה הושלמה על ידי EY",
    recalled: "הבקשה אוחזרה",
    notification_submit: "הבקשה הועברה לאוטומציה",
    notification_success: "הבקשה הועברה בהצלחה לאוטומציה",
    notification_error: "אירעה שגיאה בהגשה לאוטומציה. לחץ על שלח לאוטומציה כדי לנסות שוב.",
    restore_document: "המסמך שוחזר -",
    delete_document: "המסמך נמחק -",
	assignedto: "פריט הוקצה מחדש ל",
    editrequest: "הבקשה נערך",
    prioritychange: "בקש עדכון מתן עדיפות ל"
};

export const externalTaskSystemGeneratedMessages = {
    sent: "משימה חיצונית נשלחה אל",
    accepted: "התקבלה משימה חיצונית",
    received: "התקבלה תגובה",
    returned: "משימה חיצונית הוחזרה",
    withdrawn: "משימה חיצונית בוטלה",
    complete: "משימה חיצונית הושלמה דרך ה- EY Canvas",
    recalled: "משימה חיצונית אוחזרה",
    restore_document: "המסמך שוחזר -",
    delete_document: "המסמך נמחק -",
	assignedto: "פריט הוקצה מחדש ל",
    editrequest: "משימה חיצונית נערכה",
    prioritychange: "העדיפות של המשימה החיצונית עודכנה ל"
};

export const ipInputLabels = [{
        id: ipInputType.ipAddress,
        label: "כתובת ה - IP"
    },
    {
        id: ipInputType.ipRange,
        label: "טווח IP"
    },
    {
        id: ipInputType.cidrBlock,
        label: "חסום CIDR"
    }
];

export const ipFilterTypeLabels = {
    [ipFilterType.ipAddress]: "כתובת ה - IP",
    [ipFilterType.ipRange]: "טווח IP",
    [ipFilterType.cidrBlock]: "חסום CIDR"
};

export const gaLinkStatusObj = {
    [GALinkStatus.Undefined]: "לא מוגדר",
    [GALinkStatus.NoPointOfContact]: "אין איש קשר",
    [GALinkStatus.NotSent]: "לא נשלח",
    [GALinkStatus.Pending]: "בקשת קישור בהמתנה",
    [GALinkStatus.Accepted]: "בקשת הקישור התקבלה",
    [GALinkStatus.Rejected]: "נדחה",
    [GALinkStatus.Expired]: "לא בתוקף",
    [GALinkStatus.Unlinked]: "לא מקושר",
    [GALinkStatus.Delegated]: "הוקצה",
    [GALinkStatus.SystemError]: "שגיאת מערכת",
    [GALinkStatus.Sent]: "נשלח",
    [GALinkStatus.InvalidPointOfContact]: "נקודת מגע לא חוקית",
    [GALinkStatus.ComponentNotUsingCanvas]: "לא משתמש ב-EY Canvas",
    [GALinkStatus.ComponentReferenceOnly]: "לצרכי סימוכין בלבד"
};

export const epTasksObj = [{
        value: '3',
        label: "אין מסמכים חתומים"
    },
    {
        value: '2',
        label: "חלק מהמסמכים חתומים"
    },
    {
        value: '1',
        label: "כל המסמכים חתומים"
    }
];

export const eqrTasksObj = [{
        value: '6',
        label: "אין מסמכים חתומים"
    },
    {
        value: '5',
        label: "חלק מהמסמכים חתומים"
    },
    {
        value: '4',
        label: "כל המסמכים חתומים"
    }
];

export const groupsFilterEntity = [{
        id: 1,
        label: "משימות"
    },
    {
        id: 2,
        label: "מסמכים"
    }
];

export const scopesFilterEntity = [{
        id: 1,
        label: "מלא"
    },
    {
        id: 2,
        label: "ספציפי"
    },
    {
        id: 3,
        label: "נהלי ביקורת מוגדרים"
    },
    {
        id: 4,
        label: " For My Review"
    }
];

export const notesFilterLabels = [{
        id: notesFilter.allNotes,
        label: "כל ההערות"
    },
    {
        id: notesFilter.myNotes,
        label: "ההערות שלי"
    },
    {
        id: notesFilter.authoredByMeNotes,
        label: "מוקצות לי"
    }
];

//Client Request Advanvce Search
export const advancedSearchValues = [{
        id: 1,
        value: labels.advancedSearchTitleCheck
    },
    {
        id: 2,
        value: labels.advancedSearchRefereceNumberCheck
    },
    {
        id: 3,
        value: labels.advancedSearchDocumentsCheck
    },
    {
        id: 4,
        value: labels.advancedSearchCommentsCheck
    }
];


export const TaskTypeLabels = [{
        id: TaskListTypes.ScopeAndStrategy,
        label: taskNavigation[TaskListTypes.ScopeAndStrategy]
    },
    {
        id: TaskListTypes.SCOTs,
        label: taskNavigation[TaskListTypes.SCOTs]
    },
    {
        id: TaskListTypes.ITSOs,
        label: taskNavigation[TaskListTypes.ITSOs]
    },
    {
        id: TaskListTypes.Accounts,
        label: taskNavigation[TaskListTypes.Accounts]
    },
    {
        id: TaskListTypes.GeneralExecution,
        label: taskNavigation[TaskListTypes.GeneralExecution]
    },
    {
        id: TaskListTypes.Conclusion,
        label: taskNavigation[TaskListTypes.Conclusion]
    }
];

export const TaskCategoryLabels = [{
        id: TaskListTypes.ScopeAndStrategy,
        label: taskNavigation[TaskListTypes.ScopeAndStrategy],
        displayOrder: 1
    },
    {
        id: TaskListTypes.Risks,
        label: taskNavigation[TaskListTypes.Risks],
        displayOrder: 2
    },
    {
        id: TaskListTypes.SCOTs,
        label: taskNavigation[TaskListTypes.SCOTs],
        displayOrder: 3
    },
    {
        id: TaskListTypes.ITSOs,
        label: taskNavigation[TaskListTypes.ITSOs],
        displayOrder: 4
    },
    {
        id: TaskListTypes.Accounts,
        label: taskNavigation[TaskListTypes.Accounts],
        displayOrder: 5
    },
    {
        id: TaskListTypes.GeneralExecution,
        label: taskNavigation[TaskListTypes.GeneralExecution],
        displayOrder: 6
    },
    {
        id: TaskListTypes.Conclusion,
        label: taskNavigation[TaskListTypes.Conclusion],
        displayOrder: 7
    },
];

export const kendoLabels = {
    alignLeft: "הצדק שמאלה",
    alignRight: "הצדק ימינה",
    alignCenter: "הסבר מרכז",
    alignFull: "הסבר מלא",
    addComment: "הוסף תגובה",
    addColumnBefore: "הוסף עמודה משמאל",
    addColumnAfter: "הוסף עמודה מימין",
    addRowAbove: "הוסף שורה למעלה",
    addRowBelow: "הוסף שורה למטה",
    bulletList: "הוסף רשימה לא מסודרת",
    bold: "מודגש",
    backColor: "הדגשה",
    createLink: "הכנס היפר-קישור",
    createTable: "צור טבלה",
    cleanFormatting: "עיצוב נקי",
    deleteRow: "מחק שורה",
    deleteColumn: "מחק עמודה",
    deleteTable: "מחק טבלה",
    fontSizeInherit: "גודל גופן",
    foreColor: "צבע",
    format: "פורמט",
    fontSize: "גודל גופן",
    hyperlink: "הכנס קישור אינטרנט",
    italic: "נטוי",
    indent: "הזחה",
    insertTableHint: "צור טבלה של {0} על {1}",
    'hyperlink-dialog-content-address': "כתובת אתר אינטרנט",
    "hyperlink-dialog-title": "הכנס היפר-קישור",
    "hyperlink-dialog-content-title": "כותרת",
    "hyperlink-dialog-content-newwindow": "תפתח קישור בחלון חדש",
    "hyperlink-dialog-cancel": "בטל",
    "hyperlink-dialog-insert": "הכנס",
    outdent: "Outdent",
    orderedList: "הוסף רשימה מסודרת",
    print: "הדפס",
    pdf: "ייצוא ל-pdf",
    redo: "לבצע שוב",
    strikethrough: "חוצה",
    subscript: "מנוי",
    superscript: "כתב-על (Superscript)",
    underline: "קו תחתון להדגשה",
    undo: "לבטל"
};

export const kendoFormatOptions = [{
        text: "פסקה",
        value: "p"
    },
    {
        text: "כותרת 1",
        value: "h1"
    },
    {
        text: "כותרת 2",
        value: "h2"
    },
    {
        text: "כותרת 3",
        value: "h3"
    },
    {
        text: "כותרת 4",
        value: "h4"
    },
    {
        text: "כותרת 5",
        value: "h5"
    },
    {
        text: "כותרת 6",
        value: "h6"
    }
];

export const kendoFontSize = [{
        text: '8',
        value: '8px'
    },
    {
        text: '9',
        value: '9px'
    },
    {
        text: '10',
        value: '10px'
    },
    {
        text: '11',
        value: '11px'
    },
    {
        text: '12',
        value: '12px'
    },
    {
        text: '14',
        value: '14px'
    },
    {
        text: '16',
        value: '16px'
    },
    {
        text: '18',
        value: '18px'
    },
    {
        text: '20',
        value: '20px'
    },
    {
        text: '22',
        value: '22px'
    },
    {
        text: '24',
        value: '24px'
    },
    {
        text: '26',
        value: '26px'
    },
    {
        text: '28',
        value: '28px'
    },
    {
        text: '36',
        value: '36px'
    },
    {
        text: '48',
        value: '48px'
    },
    {
        text: '72',
        value: '72px'
    }
];

export const monthsList = [
	"ינואר",
	"פברואר",
	"מרץ",
	"אפריל",
	"מאי",
	"יוני",
	"יולי",
	"אוגוסט",
	"ספטמבר",
	"אוקטובר",
	"נובמבר",
	"דצמבר"
];

export const pspContentStatus = {
    1: "נדרש עדכון",
    2: "עדכון בתהליך",
    3: "העדכון הושלם",
    4: "שגיאה בעדכון"
}

export const handOffLabels = {
    handoff: "העבר",
    handOffTitleTip: "העברה לסקירה",
    markCompleteTitleTip: "סמן כהושלם",
    handoffModalTitle: "העברה לחבר הצוות הבא",
    handoffConfirmButtonText: "העבר",
    return: "החזר",
    handModalDescription: "כדי לחתום על קובץ הראיות, בחר מבין האפשרויות שלהלן.",
    markCompleteTextLine1: "העביר (hand-off) את המשימה הזו לחבר הצוות הבא.",
    markCompleteTextLine2: "כדי לחתום על קובץ ראיות, בחר מבין האפשרויות שלהלן. אם הוקצת למשימה זו והשלמת אותה, בחר <b>כן</b> כדי לסגור אותה. אם משימה זו דורשת אישור שותף אחראי על הביקורת PIC או שותף מלווה EQR, בחר מבין האפשרויות שלהלן.",
    closeLabel: "Close",
    handoffto: "מסירה (Hand-off) ל",
    missingToUserError: "נדרש",
    markCompleteConfirm: "סמן כהושלם",
    markCompleteModalHeaderTextPart1: "משימה זו תסומן כמשימה שהושלמה.",
    markCompleteModalHeaderTextPart2: "כדי לחתום על קובץ ראיות, בחר מבין האפשרויות שלהלן. אם הוקצת למשימה זו והשלמת אותה, בחר <b>כן</b> כדי לסגור אותה. אם משימה זו דורשת אישור שותף אחראי על הביקורת PIC או שותף מלווה EQR, בחר מבין האפשרויות שלהלן.",
    signOffOnAllAs: "חתום על הכל כ-",
    preparer: "P",
    reviewer: "R",
    none: "אף אחד",
    noSignOffsByMe: "אין חתימות שבוצעו על ידי",
    myPreparerSignOffs: "המכין שלי חותם",
    myReviewerSignOffs: "הסוקר שלי חותם",
    myPreparerAndReviewerSignOffs: "חתימה שלי כמכין וכסוקר",
    preparerTitle: "חתימות מכין",
    reviewerTitle: "חתימות הסוקר",
    autoAssignmentMessage: "לחבר צוות זה אין הקצאה. תיווצר הקצאה {0} עם תאריך יעד של {1}. כדי לערוך ה'קצאה זו {2}.",
    clickHere: "לחץ כאן",
    noTaskEvidencesHandoffModal: "אין קבצי ראיות הקשורים למשימה זו.",
    // Create Assignment
    createAssignment: "צור הקצאה",
    create: "צור",
    cancelLabel: "בטל",
    createassignmentheader1: "לחבר הצוות שנבחר אין הקצאה למשימה זו.",
    createassignmentheader2: "צור הקצאה כאן.",
    dueDate: "תאריך יעד",
    teamMemberAssigmentLabel: "חבר צוות",
    daysPriorToEndDate: "ימים לפני תאריך היעד",
    // Add Assignment
    addAssignmentTitle: "הוסף שם הקצאה",
    confirmButtonLabel: "הוסף",
    cancelButtonLabel: "בטל",
    assignmentTypeInstructionalText: "בחר סוג הקצאה והזן שם להלן. בסיום לחץ <b>הוסף</b>.",
    assignmentType: "סוג הקצאה",
    required: "נדרש",
    clearHoverText: "Clear",
    unmarkcomplete: "בטל סימון הושלם",
    markCompleteErrorMessage: "לא ניתן לסמן שהמשימה הושלמה. רענן את הדף ונסה שוב. אם הבעיה נמשכת פנה ללתמיכה הטכנית.",
    // Assignment Dropdown
    noResultFound: "לא נמצאו תוצאות",
    addTaskGroupLabel: "הוסף קבוצת משימות",
    addAssignmentName: "הוסף שם הקצאה",
    assignmentName: "שם חבר הצוות שהוקצה",
    additionalSignOff: "sign-offs נוספים נדרשים",
    signoffRequirementsModalPICLabel: "PIC",
    signoffRequirementsModalEQRLabel: "EQR",
    closeMyAssignment: "סגור את המשימה שלי",
    filterYes: "כן",
    filterNo: "לא",
    assignmentTypeLabels: [{
            id: assignmentTypes.preparer,
            label: "P"
        },
        {
            id: assignmentTypes.detailReviewer,
            label: "סוקר לסקירה מפורטת"
        },
        {
            id: assignmentTypes.generalReviewer,
            label: "סוקר כללי"
        },
        {
            id: assignmentTypes.partner,
            label: "שותף"
        },
        {
            id: assignmentTypes.eqr,
            label: "EQR"
        },
        {
            id: assignmentTypes.other,
            label: "אחרים"
        }
    ]
};

export const displayedOn = {
    "Account": "סעיף",
    "SCOT": "תת התהליך המהותי (SCOT)",
    "IT/SO": "IT/SO",
    "Scope & Strategy": "היקף ואסטרטגיה",
    "Execution": "ביצוע הביקורת",
    "Conclusion": "מסקנה"
}

export const auditPlanReportLabels = {
    adc: "אובייקט קשור",
    secondaryObject: "אובייקט קשור משני",
    taskTypeColumn: "סוג משימה",
    taskNamePrefix: "קידומת משימה",
    taskName: "כותרת המשימה",
    taskNameSuffix: "סיומת משימה",
    taskDescription: "תיאור המשימה",
    auditTaskStatus: "סטטוס המשימה",
    rationaleForRejection: "הסבר לדחיה",
    knowledgeTaskTitle: "כותרת משימת ידע",
    knowledgeTaskDescription: "תיאור משימת ידע",
    assignedTo: "הוקצה ל",
    engagementTagGroupName: "קבוצת תגים",
    engagementTagName: "תגים",
    prioritized: "סדר עדיפויות",
    viewDisplayedOn: "הצג תצוגה",
    engagementPhase: "שלב בתיק הביקורת",
    milestone: "אבן דרך",
    periodName: "Time Phase",
    riskTypeAbbr: "סוג סיכון קשור",
    riskName: "שם סיכון קשור",
    relatedMESTEntityName: "ישויות MEST קשורות",
    scheduledNextWaveservices: "שירותים מרכזיים (Centralized Services)",
    taskID: "מזהה משימה",
    timephaseID: "מזהה שלב זמן",
    taskTypeID: "מזהה סוג משימה",
    timephaseTypeID: "מזהה סוג שלב הזמן"
}

export const reportingTaskAll = {
    taskType: labels.taskType,
    taskStatus: labels.taskStatusLabel,
    taskAssignedTo: labels.taskassignedto,
    taskNamePrefix: labels.taskPrefix,
    task_Name: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    knowledge_Task_Title: "כותרת משימת ידע",
    knowledge_Task_Description: "תיאור משימת ידע",
    rejected: labels.rejected,
    rationale_for_Rejection: "הסבר לדחיה",
    audit_Phase: labels.auditPhasesLabel,
    milestonename: labels.filterMilestoneLabel,
    periodName: labels.timephase,
    timephasestartdateinutc: "תאריך תחילת שלב הזמן (ב-UTC)",
    timephaseduedateinutc: "תאריך יעד של שלב הזמן (ב-UTC)",
    taskSourceType: labels.repTaskSource,
    taskNatureType: labels.repTaskNature,
    lastTaskChangeDateInUTC: "תאריך שינוי סטטוס המשימה האחרון (ב-UTC)",
    engagementTagGroupName: labels.manageTagGroupName,
    engagementTagName: labels.tagsLabel,
    mesT_Entity_Name: "ישויות MEST קשורות",
    multiEntityType: "סוג ריבוי ישויות",
    taskID: "מזהה משימה",
    taskTypeID: "מזהה סוג משימה",
    taskStatusID: "מזהה סטטוס משימה",
    auditPhaseID: "מזהה שלב הביקורת",
    timephaseTypeID: "מזהה אבן דרך",
    taskSourceTypeID: "מזהה מקור המשימה",
    taskNatureTypeID: "מזהה אופי המשימה",
    cgTaskID: "מזהה משימת ידע",
    knowledgeContentID: "מזהה תוכן בידע"
}

export const reportTaskAssignments = {
    taskNamePrefix: labels.taskPrefix,
    taskName: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    taskTypeName: labels.taskType,
    taskSourceType: labels.repTaskSource,
    taskNatureType: labels.repTaskNature,
    auditPhaseName: labels.engagementPhase,
    milestones: labels.filterMilestoneLabel,
    periodName: labels.timephase,
    PICSignoffRequired: "נדרשת חתימת שותף אחראי על הביקורת (PIC) ",
    EQRSignoffRequired: "נדרש אישור שותף מלווה (EQR)",
    taskStatusName: labels.taskStatusLabel,
    taskDueDateInUTC: "תאריך יעד של משימה (ב-UTC)",
    engagementTagGroupName: labels.manageTagGroupName,
    engagementTagName: labels.tagsLabel,
    completedAssignment: labels.completedAssignments,
	totalAssignment: 'סה"כ הקצאות',
    closedTaskAssignmentPercent: "הקצאת משימה סגורה %",
    assignmentOrder: "סדר הקצאה",
    firstNameVal: "שם פרטי של חבר צוות לצורך הקצאת משימה",
    lastNameVal: "שם משפחה של חבר צוות לצורך הקצאת משימה",
    assignmentName: labels.assignmentName,
    assignmentTypeName: labels.filterAssignmentTypeLabel,
    roleName: "תפקיד משתמש בהתקשרות",
    assignmentStatusVal: "סטטוס משימה שהוקצתה",
    dueDays: "תאריך היעד",
    completedDateInUTC: "תאריך סיום (ב-UTC)",
    assignmentDueDateInUTC: "תאריך יעד להקצאה (ב-UTC)",
    daysCompleteBeforeDueDate: "ימים שנותרו לפני תאריך היעד של הקצאת המשימה",
    daysCompleteAfterDueDate: "הימים שעברו לאחר תאריך היעד של הקצאת המשימה",
    closedEarlyOrLate: "סגור מוקדם/מאוחר",
    closedDaysEarly: "סגור כמה ימים מוקדם יותר",
    closedDaysLate: "סגור באיחור של ימים",
    oldTaskName: "שם המשימה המקורי",
    oldTaskDetail: "תיאור המשימה המקורי",
    taskID: "מזהה משימה",
    assignmentID: "מזהה הקצאה",
    roleID: "מזהה תפקיד (Role ID)",
    userID: "מזהה משתמש"
}

export const reportingMultiEntityTask = {
    engagementID: "מזהה תיק הביקורת",
    taskID: "מזהה משימה",
    taskNamePrefix: labels.taskPrefix,
    task_Name: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    mesT_Entity_Name: "ישות קשורה",
    multiEntityType: "MultiEntityType",
    taskTypeID: "מספר מזהה לסוג המשימה",
    taskStatusID: "מזהה סטטוס משימה (TaskStatusID)"
}

export const reportingManageteamInternal = {
    firstName: labels.firstnameLabel,
    lastName: labels.lastnameLabel,
    userInitials: labels.initialsLabel,
    emailAddress: labels.editExternalEmailLabel,
    gui: "GUI",
    engagementRole: labels.engagementrole,
    hasOverallResponsability: "בעל אחריות כוללת",
    userStatus: "סטטוס",
    independenceStatus: "סטטוס אי תלות",
    grantedAccess: "ניתנה גישה לאחר ביצוע הארכיב",
    primaryOffice: "משרד ראשי",
    preferredContactPhone: "מספר טלפון",
    engagementUserStatusID: "מזהה סטטוס משתמש בהתקשרות",
    engagementRoleID: "מזהה תפקיד בתיק הביקורת",
    independenceStatusID: "מזהה סטטוס אי תלות"
}

export const reportingManageteamExternal = {
    clientGroupName: "שם הקבוצה",
    firstName: labels.firstnameLabel,
    lastName: labels.lastnameLabel,
    userInitials: labels.initialsLabel,
    emailAddress: labels.editExternalEmailLabel,
    domain: "דומיין משתמש",
    validDomainWithinGroup: "דומיין תקף בתוך הקבוצה",
    userStatus: "סטטוס משתמש",
    preferredContactPhone: "מספר טלפון מועדף"
};

export const controlDesignEffectivenessType = {
    1: "יעיל",
    2: "לא יעיל"
};

export const itAppSOSummaryReportLabels = {
    itApplicationName: "יישומי IT / לשכות שירות",
    strategyTypeName: "אסטרטגיית IT",
    typeName: "סוג",
    itProcessName: "תהליך IT",
    itRiskName: "סיכון IT",
    itControlName: "ITGCs/ITSPs",
    natureOfTest: "אופי הבדיקה",
    controlFrequencyTypeNameColumn: "תדירות",
    testing: "בודק",
    designEffectiveness: "Design Effectiveness",
    evaluation: "הערכת תהליכי IT"
};

export const ArchiveReportLabels = {
    engagementDescription: "תיאור תיק ביקורת",
    archiveReportQualifiedNameSection: "דוח מסוייג",
    archiveReportQualifiedTypeNameSection: "סוג דוח מסוייג",
    archiveFolderDescription: "תיאור תיקיית ארכיון",
    archiveFolderTypeNameSection: "סוג תיקיה",
    location: "Location",
    archiveComments: "הערות בארכיון",
    engagementID: "מזהה תיק הביקורת",
    archiveCountryOfficeRegionID: "מזהה ארכיון המשרד",
    archiveReportQualifiedID: "מזהה הדוח המסוייג בארכיון",
    archiveReportQualifiedTypeID: "מזהה סוג מוסמך לארכיון"
};

export const canvasFormRelatedCommentsLabels = {
    canvasFormName: "שם טופס Canvas",
    order1: "סדר כותרת",
    formHeaderName: "כותרת",
    order2: "סדר מקטעים",
    order3: " סBodyOrder",
    formBodyResponseValue: "מענה",
    commentNumber: "מספר תגובה",
    author: "יוצר",
    assignedTo: "הוקצה ל",
    createDateSection: "צור תאריך",
    commentStatusSection: "סטטוס",
    commentText: "הערה",
    commentVoiceNote: "יש הערה קולית",
    reply: "ענה",
    replyVoiceNote: "יש הערה קולית"
};

export const canvasFormRelatedObjectsLabels = {
    canvasFormName: "שם טופס Canvas",
    order1: "סדר כותרת",
    formHeaderName: "כותרת",
    formHeaderID: "מזהה FormHeader ",
    order2: "סדר מקטעים",
    formSectionID: "מזהה FormSection",
    formSectionName: "מקטע",
    firstLevelEntityColumn: "ישות ברמה ראשונה",
    firstLevelRelatedObject: "אובייקט קשור ברמה הראשונה",
    secondLevelEntityColumn: "ישות ברמה השנייה",
    secondLevelRelatedObject: "אובייקט קשור ברמה השנייה"
};

export const canvasFormResponseLabels = {
    canvasFormName: "שם טופס Canvas",
    order1: "סדר כותרת",
    formHeaderName: "כותרת",
    knowledgeFormHeaderID: "כותרת מזהה ידע",
    headerKnowledgeContentID: "כותרת מזהה תוכן ידע",
    order2: "סדר מקטעים",
    formSectionName: "מקטע",
    knowledgeFormSectionID: "מקטע מזהה ידע",
    sectionKnowledgeContentID: "מקטע מזהה תוכן ידע",
    order3: " סBodyOrder",
    formBody: "גוּף",
    knowledgeFormBodyID: "גוף מזהה ידע",
    bodyKnowledgeContentID: "גוף מזהה תוכן ידע",
    formBodyResponse_Value: "מענה"
};

export const CanvasFormsIncompleteLabels = {
    canvasFormName: "שם טופס Canvas",
    header: "כותרת",
    headerOrder: "סדר כותרת",
    sectionOrder: "סדר מקטעים",
    bodyOrder: " סBodyOrder",
    body: "גוּף",
    formHeaderID: "מזהה FormHeader ",
    formSectionID: "מזהה FormSection",
    formBodyID: "מזהה FormBody"
};

export const controlFormResponseLabels = {
    controlName: "בקרה",
    documentName: "Document",
    engagementDescription: "תיאור תיק ביקורת",
    formHeader: "כותרת",
    headerKnowledgeDisplayOrder: "HeaderKnowledgeDisplayOrder",
    formSection: "מקטע",
    sectionKnowledgeDisplayOrder: "SectionKnowledgeDisplayOrder",
    formBodyVal: "גוּף",
    bodyKnowledgeDisplayOrder: "BodyKnowledgeDisplayOrder",
    ControlTesting: "קיימות בדיקות בקרה",
    controlFrequencyType: "תדירות בקרה",
    Effective: "יעיל",
    formBodyOptionVal: "הערך האפשרי לפריט בטופס",
    controlType: "סוג בקרה",
    controlDesignEffectivenessType: "סוג אפקטיביות תכנון הבקרה (design effectiveness)"
};

export const itProcessSummaryLabels = {
    itProcessName: "תהליך IT",
    itProcessEvaluation: "הערכת תהליכי IT",
    itProcesSupportingRationale: "הסבר תומך",
    itRiskName: "סיכון IT",
    itControlName: "ITGCs/ITSPs",
    natureOfTest: "אופי הבדיקה",
    controlFrequencyTypeId: "תדירות",
    testing: "בודק",
    designEffectiveness: "Design Effectiveness",
    operatingEffectiveness: "אפקטיביות תפעולית"
}

export const itProcessScotControlsLabels = {
    itProcessName: "תהליך IT",
    scotName: "תת התהליך המהותי (SCOT)",
    controlName: "בקרה",
    controlDesignEffectivenessTypeName: "Design Effectiveness",
    testing: "בודק",
    operatingEffectiveness: "אפקטיביות תפעולית",
    controlTypeName: "סוג בקרה",
    isIPEManuallyTestedName: "IS IPE נבדק ידנית",
    itApplicationName: "יישום IT",
    aggregateITEvaluationTypeName: "הערכת IT מצטברת"
};

export const scotsControlsReportLabels = {
    scotName: "תת התהליך המהותי (SCOT)",
    controlName: "בקרה",
    operatingEffectiveness: "אפקטיביות תפעולית",
    itApplicationName: "אפליקציית IT",
    aggregateITEvaluation: "הערכת IT מצטברת",
    supportingRationaleControlLabel: "הסבר תומך"
}

export const sCOTSummaryReportHeaderLabels = {
    scotName: "תת התהליך המהותי (SCOT)",
    scotTypeName: "סוג טרנזקציה",
    strategyTypeName: "Scot Strategy",
    itApplicationName: "יישומי IT / SO של תת התהליך המהותי SCOT ",
    wcgwName: labels.wcgw,
    controlName: labels.control,
    controlFrequencyTypeName: labels.frequencyLabel,
    controlTypeName: "סוג בקרה",
    testing: "בודק",
    operatingEffectiveness: "אפקטיביות תפעולית",
    controlITApplication: "יישומי IT / SO של בקרה",
    aggregateITEvaluationTypeName: "הערכת IT מצטברת",
    supportingRationale: "הסבר תומך",
    scotId: "מזהה תת תהליך מהותי (SCOT)",
    strategyTypeID: "מזהה סוג אסטרטגיה",
    scotTypeID: "מזהה סוג תת תהליך מהותי (SCOT)",
    wcgwid: "מזהה WCGW",
    controlID: "מזהה בקרה",
    controlFrequencyTypeID: "מזהה סוג תדירות בקרה",
    controlTypeID: "מזהה סוג בקרה",
    aggregateITEvaluationTypeID: "מזהה סוג הערכת IT מצטבר"
};

export const findingsDeficiencyHeaderLabels = {
    description: "תיאור ליקוי",
    controls: "בקרות",
    controlsIsEffective: "יעילות תפעול של בקרות",
    type: "סוג הליקוי",
    magnitude: "חשיבות (Magnitude)",
    responseText: "טקסט תגובה",
    remediatedAtYearEnd: "תוקן בסוף שנה",
    mitigatingControls: "בקרה מפצה",
    mitigatingControlsIsEffective: "יעילות תפעול של בקרה מפצה",
    mitigatingTasks: "משימות מקלות",
    foundIn: "נמצא במסמך",
    accountsAndAssertions: "סעיפים ומצגי הנהלה (Assertions)",
    scoTs: "SCOTs",
    deficiencyID: "מזהה ליקוי",
    controlID: "מזהה בקרה",
    mitigatedControlID: "מזהה בקרה מפצה",
    mitigatedTaskID: "מזהה משימה מפצה",
    documentID: "מזהה מסמך",
    accountID: "מזהה סעיף",
    scotID: "מזהה תת תהליך מהותי (SCOT)"
};

export const findingsMisstatementHeaderLabels = {
    description: "תיאור הצגה מוטעית",
    type: "סוג ההצגה המוטעית",
    trialBalance: "מאזן בוחן",
    period: "תקופה",
    accountNumber: "מספר סעיף",
    accountName: "שם סעיף",
    accountType: "סוג סעיף (Account Type)",
    debit: "חובה",
    credit: "זכות",
    responseText: "טקסט תגובה",
    correctedUncorrected: "נכון/לא מתוקן",
    mitigatingTasks: "משימות מקלות",
    foundInDocument: "נמצא במסמך",
    accountsAndAssertions: "סעיפים ומצגי הנהלה (Assertions)",
    misstatementID: "מזהה הצגה מוטעית",
    trialBalanceID: "מזהה מאזן בוחן",
    misstatementAdjustmentID: "מזהה התאמת הצגה מוטעית"
};

export const findingsDeficiencyITHeaderLabels = {
    itApplicationName: "שם יישום ה- IT",
    itProcessName: "שם תהליך ה- IT",
    itControlName: "שם בקרת ה- IT",
    itApproachTypeName: "סוג גישת ה- IT",
    isEffective: "יעילות הבקרה",
    referenceNumber: "מספר סימוכין",
    description: "תיאור ליקוי",
    deficiencyMagnitudeName: "השפעת הליקוי",
    deficiencyTypeName: "סוג הליקוי"
};

export const auditPlanRelatedEvidenceReportHeaderLabels = {
    adc: "אובייקט קשור",
    secondaryObject: "בקרה קשורה / נוהל מבסס",
    taskName: "כותרת המשימה",
    taskDescription: "תיאור המשימה",
    taskTypeColumn: "סוג משימה",
    taskStatusValue: "סטטוס המשימה",
    rationaleForRejection: "הסבר לדחיה",
    engagementPhase: "שלב בתיק הביקורת",
    milestone: "אבן דרך",
    periodName: "Time Phase",
    assignedTo: "הוקצה ל",
    engagementTagGroupName: "קבוצת תגים",
    engagementTagName: "תגים",
    displayedOn: "הצג תצוגה",
    documentName: "שם המסמך",
    preparersValue: "מכינים (תאריך ב-UTC)",
    reviewersValue: "סוקרים (תאריך ב-UTC)",
    openReviewNotes: "פתחו הערות סקירה (review notes)",
    closedReviewNotes: "הערות סקירה שנוקו",
    trackChangesValue: "עקוב אחר שינויים",
    lastModifiedBy: "שונה לאחרונה על ידי",
    lastModifiedDateValue: "תאריכי עדכון אחרונים (ב-UTC)",
    taskID: "מזהה משימה",
    timephaseID: "מזהה שלב זמן",
    taskTypeID: "מזהה סוג משימה",
    documentTypeID: "מזהה סוג מסמך",
    parentDocumentTypeID: "מזהה סוג מסמך של חברת האם ",
    timePhaseTypeID: "מזהה סוג שלב זמן"
};

// group instruction summary
export const groupInstructionSummaryReportHeaderLabels = {
    sectionName: "מקטע",
    gaInstructionName: "כותרת ההנחיה",
    gaInstructionDescription: "תיאור הנחיות",
    documents: "שם המסמך",
    knowledgeInstructionName: "כותרת הוראת הידע",
    knowledgeInstructionDescription: "תיאור הוראת ידע",
    gaScopeName: "היקפים / תתי היקפים קשורים",
    componentOnly: "היקף / הנחיה פרטנית",
    shortName: "שם אזור / ישות מוחזקת (component)",
    cSection: "מקטע מותאם אישית",
    customInstruction: "הנחיה מותאמת אישית",
    gAinstructionID: "מזהה הנחיות GA"
};

// GIS last publish and send
export const gIsLastPublishAndSendReportHeaderLabels = {
    primaryEngagementID: "מזהה תיק הביקורת",
    gaScopeID: "מזהה היקף GA",
    gaScopeName: "היקף",
    gaComponentID: "מזהה רכיב GA",
    shortName: "שם ישות מוחזקת (component)",
    lastPublishedDateInUTC: "תאריך פרסום אחרון",
    lastSentDateInUTC: "תאריך שליחה אחרון",
    gaLinkStatusId: "סטטוס קישור",
    gaInstructionStatusId: "סטטוס ההנחייה"
};

// Group Activity
export const groupActivityReportHeaderLabels = {
    engagementID: "מזהה תיק הביקורת",
    gaScopeID: "מזהה היקף GA",
    gaScopeName: "היקף",
    gaComponentID: "מזהה רכיב GA",
    shortName: "שם ישות מוחזקת (component)",
    gaLinkStatusId: "סטטוס קישור",
    accountID: "מזהה סעיף",
    accountName: "שם סעיף",
    accountType: "ייעוד הסעיף",
    activityTypeID: "מזהה סוג פעילות",
    activityTypeText: "סוג הפעילות",
    modifyDateInUTC: "שנה תאריך",
    modifyUser: "שנה משתמש",
};

export const AccountDisclosuresReportHeadeLabels = {
    engagementID: "מזהה תיק הביקורת",
    accountID: "מזהה סעיף",
    accountName: "שם סעיף",
    accountTypeID: "מזהה סוג חשבון",
    accountTypeId: "ייעוד הסעיף",
    knowledgeAssertionId: "ראשי תיבות של מצגי ההנהלה ",
    inherentRiskTypeId: "הערכת הסיכון שבמהות (IR)",
    controlRiskTypeId: "הערכת הסיכון המשולב (CRA)",
    craValue: "CRA",
    riskID: "מזהה סיכון",
    riskTypeID: "מזהה סוג סיכון",
    riskType: "סוג הסיכון",
    riskName: "שם הסיכון",
    isHigherRiskValue: "יש סיכון גבוה יותר",
};

// CRA summary
export const craSummaryReportHeaderLabels = {
    accountName: "סעיף",
    accountTypeName: "סוג סעיף (Account Type)",
    rationale: "הסבר לאפיון הסעיף",
    pspIndex: "אינדקס PSP",
    conclusionStatement: "מסקנה לסעיף",
    scotName: "SCOTs",
    transactionType: "סוג טרנזקציה",
    strategyTypeName: "Scot Strategy",
    wcgwName: "WCGW",
    controlName: "בקרה",
    controlFrequencyTypeName: "תדירות",
    controlTypeName: "סוג בקרה",
    testing: "בודק",
    operatingEffectiveness: "אפקטיביות תפעולית",
    itApplicationName: "יישומי IT / SO של תת התהליך המהותי SCOT ",
    controlITApplication: "יישומי IT / SO של בקרה"
};

export const craSummaryAssertionReportHeaderLabels = {
    accountName: "סעיף",
    accountTypeName: "סוג סעיף (Account Type)",
    rationale: "הסבר לאפיון הסעיף",
    pspIndex: "אינדקס PSP",
    assertionAbbreviation: "יעד הנהלה",
    riskName: "סיכון",
    inherentRiskTypeName: "הערכת הסיכון שבמהות (IR)",
    controlRiskTypeName: "הערכת הסיכון המשולב (CRA)",
    craValue: "CRA",
    wcgwName: "WCGW",
    controlName: "בקרה",
    controLFrequencyTypeName: "תדירות",
    controlTypeName: "סוג בקרה",
    testing: "בודק",
    isLowerR: "סיכון נמוך יותר",
    operatingEffectiveness: "אפקטיביות תפעולית",
    itApplicationName: "יישום IT/SO"
};

export const craSummaryDataReportHeaderLabels = {
    wcgwName: "WCGW",
    controlName: "בקרה",
    controLFrequencyTypeName: "תדירות בקרה",
    controlTypeName: "סוג בקרה",
    itApplicationName: "אפליקציית IT",
    assertionName: "יעד הנהלה",
    statementTypeName: "סוג דוח",
    accountTypeName: "סוג סעיף (Account Type)",
    assertionAbbreviation: "ראשי תיבות של מצגי ההנהלה ",
    inherentRiskTypeName: "סיכון שבמהות (Inherent Risk)",
    controlRiskTypeName: "בקרת סיכון",
    craValue: "CRA",
    riskTypeAbbreviation: "ראשי תיבות לסיכון",
    frequency: "תדירות",
    accountName: "סעיף",
    riskName: "סיכון",
    pspIndex: "אינדקס PSP",
    testing: "בודק",
    operatingEffectiveness: "אפקטיביות תפעולית",
    isLowerRiskColumn: "יש סיכון נמוך יותר",
    scotName: "תת התהליך המהותי (SCOT)",
    controlitApplicationName: "בקרה אפליקטיבית ",
    rationale: "הסבר לאפיון הסעיף",
    accountID: "מזהה סעיף",
    riskID: "מזהה סיכון",
    scotid: "מזהה תת תהליך מהותי (SCOT)",
    wcgwid: "מזהה WCGW",
    controlID: "מזהה בקרה",
    itApplicationID: "מזהה יישום IT",
    knowledgeAssertionID: "מזהה מצג הנהלה ממאגר הידע ",
    controlTypeID: "מזהה סוג בקרה",
    controlFrequencyTypeID: "מזהה סוג תדירות בקרה",
    accountTypeID: "מזהה סוג חשבון",
    riskTypeID: "מזהה סוג סיכון",
    inherentRiskTypeID: "מזהה סוג סיכון שבמהות (IR)",
    controlRiskTypeID: "מזהה סוג סיכון בקרה (CR)",
    statementTypeID: "מזהה סוג הצהרה",
    conclusionStatement: "מסקנה לסעיף"
};

export const reportingRequestsAndTasks = {
    requestTitle: "כותרת לבקשה / למשימה",
    request_Description: "תיאור בקשה / משימה",
    type: "סוג",
    tasks: "כותרת המשימה",
    engagementTagName: "תגים",
    eyAssigned: "משתמש EY שהוקצה",
    clientGroupName: "קבוצה חיצונית",
    externalAssignedUser: "משתמש חיצוני שהוקצה",
    periodName: "Time Phase",
    dueDateInUTC: "תאריך יעד (ב-UTC)",
    requestStatus: "סטטוס בקשה/משימה",
    documentType: "סוג מסמך",
    documentName: "שם המסמך של השנה הנוכחית",
    priorYearDocumentName: "שם מסמך שנה קודמת",
    externalDocumentSignOffInUTC: "חתימות על מסמכים חיצוניים (ב-UTC)",
    clientRequestReferenceNumber: "מספר סימוכין של בקשת הלקוח"
};

export const reportingRequestComment = {
    requestTitle: "כותרת לבקשה / למשימה",
    request_Description: "תיאור בקשה / משימה",
    type: "סוג",
    tasks: "כותרת המשימה",
    engagementTagName: "תגים",
    eyAssigned: "משתמש EY שהוקצה",
    clientGroupName: "קבוצה חיצונית",
    externalAssignedUser: "משתמש חיצוני שהוקצה",
    periodName: "Time Phase",
    dueDateInUTC: "תאריך יעד (ב-UTC)",
    requestStatus: "סטטוס בקשה/משימה",
    externalDocumentSignOffInUTC: "חתימות על מסמכים חיצוניים (ב-UTC)",
    annotationTextData: "הערות",
    createDateInUTC: "תאריך הערות (ב-UTC)",
    annotationUserInitials: "הגיב על ידי"
};

export const reportingAllDocuments = {
    documentName: "שם המסמך",
    fileExt: "סיומת קובץ",
    canvasFormType: "סוג טופס קנבס",
    docType: "סוג מסמך",
    confidentiality: "סודיות",
    docFileSize: "גודל קובץ (KB)",
    preparers: "מכינים (ב-UTC)",
    reviewers: "סוקרים (ב-UTC)",
    relatedTask: "משימות קשורות",
    openReviewNote: "פתחו הערות סקירה (review notes)",
    clearedReviewNote: "הערות סקירה שנוקו",
    trackChanges: "עקוב אחר שינויים",
    hiddenSheets: "גיליונות מוסתרים",
    comments: "הערות",
    highlighted: "עיקרי הדברים",
    conflicted: "קונפליקטים בסינכרון",
    docModifyUser: "שונה לאחרונה על ידי",
    docModifyDateInUTC: "תאריך השינוי האחרון (ב-UTC)",
    documentID: "מזהה מסמך"
};

export const signOffDocuments = {
    documentName: "שם המסמך",
    fileExt: "סיומת קובץ",
    canvasFormType: "סוג טופס קנבס",
    docType: "סוג מסמך",
    confidentiality: "סודיות",
    docFileSize: "גודל קובץ (KB)",
    docModifyUser: "שונה לאחרונה על ידי",
    docModifyDateInUTC: "תאריך השינוי האחרון (ב-UTC)",
    signOffDate: "תאריך חתימה (ב-UTC)",
    signedOffBy: "חתום על ידי",
    role: "Role",
    preparerReviewer: "מכין/סוקר"
};

export const reportingDocumentsModified = {
    documentName: "שם המסמך",
    lastModifiedDateInUTC: "תאריך השינוי האחרון (ב-UTC)",
    lastModifiedUser: "משתמש שהתשנה לאחרונה",
    reason: "סיבה",
    documentChangeComment: "הסבר לאפיון הסעיף",
    preparersInUTC: "מכינים (ב-UTC)",
    reviewersInUTC: "סוקרים (ב-UTC)",
    approver: "מאשרים (ב-UTC)"
};

export const reportingDeletedTaskReport = {
    taskNamePrefix: labels.taskPrefix,
    taskName: "כותרת המשימה",
    taskNameSuffix: labels.taskSuffix,
    taskDescription: "תיאור המשימה",
    taskTypeAbbreviation: "סוג משימה",
    taskSourceType: "מקור המשימה",
    taskNatureType: "אופי המשימה",
    last_Modified_By: "שונה לאחרונה על ידי",
    modifyDateInUTC: "תאריך השינוי האחרון (ב-UTC)",
    oldTaskName: "שם המשימה המקורי",
    oldTaskDetail: "תיאור המשימה המקורי"
};

export const SEMReportHeaderLabel = {
    accountAssertion: "סעיף / יעד ביקורת",
    craValue: "CRA",
    riskOfMaterialMisstatements: labels.riskOfMaterialMisstatement,
    relatedRisks: "סיכונים קשורים",
    taskType: "סוג משימה",
    taskTitle: "כותרת המשימה",
    taskSource: labels.source,
    taskNature: labels.nature,
    taskTypeID: "מזהה סוג משימה",
    taskSourceTypeID: "מזהה סוג מקור משימה",
    taskNatureTypeID: "מזהה סוג אופי משימה"
}

export const MilestonesReportHeaderLabels = {
    taskName: labels.repTaskTitle,
    taskType: labels.taskType,
    taskStatus: labels.taskStatusLabel,
    auditPhase: labels.auditPhasesLabel,
    periodName: labels.timephase,
    timephase: "אבן דרך נוכחית",
    correctTimephase: "אבן הדרך המתוקנת"
}

export const MilestonesReportHeader = {
    milestone: "אבן דרך",
    status: "סטטוס אבן דרך (milestone)",
    taskStatus: "סטטוס המשימה",
    taskTitle: "כותרת המשימה",
    taskTypeAbbreviationColumn: "ראשי תיבות סוג משימה",
    taskType: "סוג משימה",
    timePhase: "Time Phase",
    assignedTo: "הוקצה ל",
    taskName: "שם משימה",
    task_Detail: "פירוט המשימה",
    due_Date: "תאריך יעד",
    documentName: "שם המסמך",
    preparers: "מכינים (Preparers)",
    reviewers: "סוקרים",
    tagGroup: "קבוצת תגים",
    tags: "תגים",
    engagementID: "מזהה תיק הביקורת",
    taskID: "מזהה משימה",
    taskTypeID: "מזהה סוג משימה",
    taskStatusID: "מזהה סטטוס משימה",
    timephaseID: "מזהה שלב זמן (Time phase)",
    timephaseTypeID: "מזהה סוג שלב זמן",
    documentID: "מזהה מסמך"
}

export const groupStructureSummaryReportHeaderLabels = {
    gaScopeName: "תיאור היקף",
    gaScopeDescription: "שם היקף / תת-היקף",
    shortName: "שם אזור / ישות מוחזקת (component)",
    legalName: "שם חוקי",
    gaRoleTypeName: "תפקיד בקבוצה",
    relatedRegion: "אזור קשור",
    pocText: "נקודת מגע",
    gaLinkStatusName: "סטטוס קישור",
    gaInstructionStatusName: "סטטוס ההנחייה",
    engagementID: "מזהה תיק הביקורת",
    gaRoleTypeID: "מזהה סוג תפקיד ב- GA",
    gaLinkStatusID: "מזהה סטטוס קישור ב- GA",
    gaInstructionStatusID: "מזהה סטטוס הוראות ב- GA"
}

export const collaborationSummary = {
    clientRequestID: "מספר בקשה",
    requestTitle: "כותרת",
    requestType: "סוג",
    engagementTagName: "תגים",
    clientUser: "הוקצה ל",
    clientEmail: "מייל לקוח",
    clientStatusName: "סטטוס",
    isOverDue: "תאריך היעד חלף",
    dueDateInUTC: "תאריך יעד (ב-UTC)",
    eySentDateInUTC: "תאריך שליחה על ידי EY (ב-UTC)",
    eyReceivedDateInUTC: "תאריך קבלה (ב-UTC)",
    deliveredLate: "נמסר באיחור",
    daysLate: "באיחור של ימים",
    timesReturned: "זמנים שהוחזרו"
}

export const collaborationActivity = {
    clientRequestID: "מספר בקשה",
    requestTitle: "כותרת",
    requestType: "סוג",
    engagementTagName: "תגים",
    clientUser: "הוקצה ל",
    clientEmail: "מייל לקוח",
    clientStatusName: "סטטוס",
    isOverDue: "תאריך היעד חלף",
    dueDateInUTC: "תאריך יעד (ב-UTC)",
    eySentDateInUTC: "תאריך שליחה על ידי EY (ב-UTC)",
    eyReceivedDateInUTC: "תאריך קבלה (ב-UTC)",
    deliveredLate: "נמסר באיחור",
    daysLate: "באיחור של ימים",
    timesReturned: "זמנים שהוחזרו",
    activity: "פעילות",
    activityDateInUTC: "תאריך פעילות (ב-UTC)",
    historicalDueDateInUTC: "תאריך יעד היסטורי (ב-UTC)"
}

export const groupReportHeaderLabels = {
    gaInstructionName: "שם הנחיה",
    gascopeTypeIDName: labels.scope,
    componentName: "שם ישות מוחזקת (component)",
    pointOfContact: labels.pointOfContact,
    dueDateValue: "תאריך יעד (ב-UTC)",
    overdueValue: labels.overdueLabel,
    gaStatusIdName: labels.status,
    documentName: labels.documents,
    createDateValue: "תאריך חתימה (ב-UTC)",
    signoffBy: labels.signedOffBy,
    engagementRoleIDName: labels.role,
    isPreparerText: "מכין/סוקר",
    documentID: "מזהה מסמך",
    gaStatusID: "מזהה סטטוס GA",
    engagementRoleID: "מזהה תפקיד בתיק הביקורת"
}

export const wcgwSummaryHeaders = {
    wcgwName: "WCGW",
    scotName: "תת התהליך המהותי (SCOT)",
    controlName: "בקרות קשורות",
    itApplications: "אפליקציית IT / SO קשורה",
    testing: "בחירת בדיקה",
    isLowerR: "סיכון נמוך יותר",
    controlFrequencyTypeName: "תדירות בקרה",
    controlTypeName: "סוג בקרה",
    wcgwCount: "ספירה של WCGWs קשורים אחרים"
}

export const allControlsHeaders = {
    engagementID: "מזהה תיק הביקורת",
    scotid: "SCOTID",
    controlID: "מזהה בקרה",
    scotName: "שם תת התהליך המהותי SCOT",
    controlName: "תיאור הבקרה",
    hasControlTesting: "בחירת בדיקה",
    isLowerRisk: "סיכון נמוך יותר",
    controlTypeID: "סוג בקרה",
    relatedITApplicationNames: "אפליקציית IT/SO קשורה",
    responsiveToSR: "מענה לסיכון משמעותי SR",
    IPE: "IPE"
}


export const qualityChecksHeaders = {
    itemID: "מזהה פריט",
    itemName: "שם הפריט",
    qualityChecks: "בדיקת איכות",
    validationDescription: "תיאור אימות",
    buildGroup: "צור קבוצה",
    impactedItem: "פריט מושפע",
    type: "סוג"
}

export const statisticsHeaders = {
    scotname: "תת התהליך המהותי (SCOT)",
    strategyTypeId: "אסטרטגיית תת-תהליך מהותי (SCOT)",
    wcgwName: "WCGW",
    controlName: "בקרה",
    operatingEvaluation: "הערכת תפעול",
    itApplicationName: "יישום IT /SO קשור",
    assertions: "יעדי ביקורת",
    controlTypeId: "סוג בקרה",
    testingSelection: "בחירת מדגם ",
    controlFrequencyTypeId: "תדירות",
    itApplications: "מערכות IT",
    scotTypeId: "סוג SCOT",
    itType: "סוג מערכת IT",
    isLowerR: "סיכון נמוך יותר",
    engagementID: "מזהה התקשרות",
    workspaceID: "מזהה סביבת עבודה",
    scotID: "SCOT מזהה",
    scotTypeID: "מזהה סוג תת תהליך מהותי (SCOT)",
    wcgwid: "WCGW מזהה",
    controlID: "מזהה בקרה"
}

export const CRTAssertionCountSummaryHeaders = {
    accountName: "סעיף",
    assertion: "יעד הנהלה",
    controlName: "בקרה",
    ControlTypeName: "סוג בקרה",
    ControlFrequencyTypeName: "תדירות",
    Testing: "בודק",
    OperatingEvaluation: "הערכת תפעול",
    assertionControlCount: "כמות מצגי ההנהלה המקושרים לבקרה",
    assertionAbbreviation: "ראשי תיבות מצגי ההנהלה",
    wcgwName: "WCGW",
    engagementID: "מזהה התקשרות",
    workspaceID: "מזהה סביבת עבודה",
    assertionID: "מזהה מצג הנהלה",
    wcgwid: "WCGW מזהה",
    controlID: "מזהה בקרה"
}

export const crtlistcontrolTypeName = {
    'IT Application Control': "בקרה אפליקטיבית ",
    'IT Dependent Manual Control': "בקרת IT ידנית",
    'Manual Prevent': "מונעת ידנית",
    'Manual Detect': "זיהוי ידני"
}

export const controlFrequencyNameTypes = {
    'Many times per day': "פעמים רבות ביום",
    'Daily': "יומי",
    'Weekly': "שבועי",
    'Monthly': "חודשי",
    'Quarterly': "רבעוני",
    'Annually': "שנתי",
    'IT Application Control': "בקרה אפליקטיבית ",
    'Other': "אחרים"
};

// Folder types
export const archiveFolderTypeNameTypes = {
    'Working Papers': "ניירות עבודה",
    'Perm File Active': "קובץ קשיח פעיל ",
    'Perm File Superseded': "קובץ קשיח מוחלפ",
    'Working Papers - CD/DVD': "ניירות עבודה - CD/DVD",
    'Perm File Active - CD/DVD': "קובץ קשיח פעיל - CD/DVD",
    'Perm File Superseded - CD/DVD': "קובץ קשיח מוחלף - CD/DVD",
    'Data Storage Devices': "מכשירי אחסון נתונים"
};

export const operatingEvaluationType = {
    'Effective': "יעיל",
    'Ineffective': "לא יעיל",
    'Not Selected': "לא נבחר"
};

export const CRTSCOTCountSummaryHeaders = {
    scotname: "תת התהליך המהותי (SCOT)",
    strategyTypeName: "אסטרטגיית תת-תהליך מהותי (SCOT)",
    wcgwName: "WCGWs קשורים",
    controlName: "בקרות קשורות ",
    operatingEvaluation: "הערכת תפעול",
    itApplicationName: "יישום IT /SO קשור",
    assertions: "יעדי ביקורת",
    controlTypeName: "סוג בקרה",
    testing: "בחירת מדגם ",
    controlFrequencyTypeName: "תדירות",
    itApplications: "מערכות IT",
    itAppType: "סוג מערכת IT",
    scotTypeName: "סוג SCOT",
    soctisLowerRisk: "בקרת סיכון נמוך",
    engagementID: "מזהה התקשרות",
    workspaceID: "מזהה סביבת עבודה",
    scotID: "SCOT מזהה",
    scottypeid: "מזהה סוג SCOT",
    wcgwid: "WCGW מזהה",
    controlID: "מזהה בקרה"
};

export const projectInsightCanvasFormExportHeaders = {
    EngagementID: "מזהה תיק הביקורת",
    DocumentID: "מזהה מסמך",
    ControlID: "מזהה בקרה"
};

export const projectInsightSCOTToWCGWToControlHeaders = {
    engagementID: "מזהה תיק הביקורת",
    scotName: "תת התהליך המהותי (SCOT)",
    strategyTypeName: "StrategyTypeName",
    wcgwName: "הזן שם WCGW",
    controlID: "מזהה בקרה",
    controlName: "שם הבקרה",
    controlFrequencyTypeName: "ControlFrequencyTypeName",
    controlTypeName: "ControlTypeName",
    isLowerRiskHeader: "סיכון נמוך יותר",
    hasControlTestingHeader: "האם הבקרה נבדקה",
    operativeEffectiveness: "יעילות תפעולית"
};

export const ComponentTeamGroupAccountInfoControlHeaders = {
    engagementId: "מזהה תיק הביקורת",
    accountId: "מזהה סעיף",
    accountName: "שם סעיף",
    accountTypeId: "מזהה סוג חשבון",
    accountDesignation: "ייעוד הסעיף",
    pspIndexTitle: "אינדקס PSP",
    knowledgeAssertion: "ראשי תיבות של מצגי ההנהלה ",
    inherentRiskType: "הערכת הסיכון שבמהות (IR)",
    controlRiskType: "הערכת הסיכון המשולב (CRA)",
    craValue: "CRA",
    riskId: "מזהה סיכון",
    riskTypeId: "מזהה סוג סיכון",
    riskTypeEnum: "סוג הסיכון",
    riskName: "שם הסיכון",
    isHigherRiskText: "יש סיכון גבוה יותר",
    rejectedTaskId: "מזהה משימה",
    rejectedTaskName: "PSP נדחה",
    rejectedTaskRationale: "רציונל PSP נדחה"
};

export const projectInsightControlToITApplicationHeaders = {
    engagementID: "מזהה תיק הביקורת",
    controlID: "מזהה בקרה",
    itApplicationID: "ITApplicationID",
    controlITApplication: "ControlITApplication"
};

export const projectInsightControlToAssertionHeaders = {
    engagementID: "מזהה תיק הביקורת",
    controlID: "מזהה בקרה",
    Accountname: "AccountName",
    AssertionAbbreviation: "ראשי תיבות של מצגי ההנהלה "
};

export const projectInsightRisksToWCGWsHeaders = {
    engagementId: "מזהה תיק הביקורת",
    accountName: "AccountName",
    accountId: "מזהה חשבון",
    knowledgeAssertion: "יעד הנהלה",
    CRA: "CRA",
    RelatedRisk: "סיכון קשור",
    riskId: "RiskID",
    riskType: "RiskType",
    WCGW: "WCGW",
    wcgwId: "WCGWID",
    RelatedSCOT: "RelatedSCOT",
    scotId: "SCOTID"
};

export const ipeControlsHeaders = {
    EngagementID: "מזהה תיק הביקורת",
    DocumentID: "מזהה מסמך"
};

export const ipeSubstantiveHeaders = {
    EngagementID: "מזהה תיק הביקורת",
    DocumentID: "מזהה מסמך"
};

export const ipeITGCHeaders = {
    EngagementID: "מזהה תיק הביקורת",
    DocumentID: "מזהה מסמך"
};

export const iTAppSOReport = {
    relatedITSO: "מערכת IT/SO קשורה",
    iTAppType: "סוג מערכת IT",
    iTAppControl: "בקרת מערכתת IT",
    testingSelection: "בחירת מדגם ",
    relatedSCOTs: "SCOTs קשורים",
    relatedSCOTStrategy: "אסטרטגיית SCOT קשורה",
    itdm: "ITDM",
    manualPrevent: "מונעת ידנית",
    manualDetect: "זיהוי ידני",
    noRelatedControls: "אין בקרות קשורות",
    controlsStatistics: "בקרות לפי סוג",
    relatedSCOTType: "סוג SCOT קשור",
    controlType: "סוג בקרה",
    grandTotal: "סך הכול",
    yes: "כן",
    no: "לא",
    notSelected: "לא נבחר",
    controls: "בקרות",
    substantive: "ביקורת מבססת",
    routine: "Routine",
    nonRoutine: "לא שגרתי",
    estimation: "Estimation"
};

export const IndependenceSummaryReport = {
    id: "ID",
    userName: "שם משתמש",
    order: "להזמין",
    questionFormatted: "שְׁאֵלָה",
    answer: "תשובה",
    actionTypeID: "מזהה סוג פעולה",
    independenceStatusID: "מזהה סטטוס אי התלות",
    EngagementUserStatusName: "סטטוס משתמש בתיק הביקורת",
    engagementUserStatusID: "מזהה סטטוס משתמש בהתקשרות",
    IndependenceStatusName: "סטטוס אי תלות",
    requiresExecutiveClearance: "דורש אישור מנהלים"
};

export const additionalInfoBasedOnValidationTypeId = {
	1: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
    2: "הצוות לא משתמש בגרסה הכי עדכנית של טופס 109 - טופס אי תלות עבור חברי צוות",
    3: "חבר צוות שינה את תפקידו מתפקיד PPEDD לאחר שנתן גישה לחבר צוות אחר עם בעיית אי תלות",
    4: "חבר צוות שינהאת תפקידו מתפקיד PPEDD לאחר שעקף חבר אחר בצוות עם בעיית אי תלות ",
    5: "לחץ על קישור האימות, זהה את תת התהליך המהותי (ה-SCOT) שאין לידו תג מספר (number badge). קשר את ה-SCOT לסעיף",
	6: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
    7: "זהה את תת התהליך המהותי (ה-SCOT) שבו ספירת ה-WCGWs הקשורים ריקה. נווט אל המשימה המובנית המתאימה. הרחב את תת התהליך המהותי (ה-SCOT) והוסף WCGWs לפי הצורך",
    8: "זהה את תת התהליך המהותי (ה-SCOT) שבו ספירת הבקרות הקשורות ריקה. נווט אל המשימה המובנית המתאימה. הרחב את תת התהליך המהותי (ה-SCOT) והוסף בקרה ל-WCGWs",
    9: "זהה את תת התהליך המהותי (ה-SCOT) עם האימות, הרחב את פרטי ה-SCOT וודא שנבחרה לבדיקה לפחות בקרה אחת לכל WCGW",
    10: "זהה את תת התהליך המהותי (ה-SCOT) עם האימות, הרחב את פרטי ה-SCOT. ודא שנבחרה לבדיקה לפחות בקרה אחת לכל WCGW",
    11: "לחץ על קישור האימות, זהה את הסיכון שאין לידו תג מספר (number badge). קשר את מצג ההנהלה המתאים לסיכון",
    12: "זהה את מצג ההנהלה עבורו לא שויך סיכון מובנה ו/או סיכון בקרה. השלם את השדה החסר",
    13: "לחץ על קישור האימות ופתח את האפשרות הוסף WCGW. בחר תת תהליך מהותי SCOT אחד בכל פעם וזהה את ה- WCGWs שאין לידו תג מספר (number badge). קשר את ה-WCGW למצג ההנהלה המתאים",
    14: "זהה את הסעיף שאין לידו תג מספר (number badge). נווט אל תרשים הזרימה המובנה של תת התהליך המהותיSCOT וקשר את ה-SCOT לסעיף",
    15: "זהה את הסעיף/מצג ההנהלה עם האימות, לחץ על כפתור הוסף WCGWs וקשר את ה-WCGW למצג ההנהלה",
    16: "בדיקת אימות זו מוודאת שכל ה-WCGWs הקשורים למצג ההנהלה עם אסטרטגיית בקרה מכוסים על ידי בקרה שתיבדק. זהה את מצג ההנהלה עם האימות, לחץ על כפתור הוסף WCGWs וקשר את ה-WCGW למצג ההנהלה",
    17: "סקור כל WCGW המשויך למצג ההנהלה, וודא שהוא מכוסה על ידי בקרה אחת לפחות שיש לה אסטרטגיית בדיקה של בקרות (testing  - 'Yes')",
    18: "כל WCGWs עבור מצג הנהלה עם אסטרטגיית הסתמכות חייבים להיות מכוסים על ידי בקרה עם ערך בדיקה מוגדר כ-כן",
    19: "ל-IT/SO קיימת אסטרטגיית הסתמכות שלא נמחקת ולא קשורה לתהליך IT/SO",
    20: "נהלים מבססים של בקרת IT/SO/IT מהותי אינו קשור לסיכון IT/SO",
	21: 'שינוי באסטרטגיה מהסתמכות ל"לא להסתמך " לאחר יצירת תהליך IT/SO',
    22: "סיכון אינו קשור למצג ההנהלה",
    23: "נהלים מבססים של בקרת IT/SO/IT מהותי אינו קשור לסיכון IT/SO",
    24: "IT/SO בקרה או נוהל מבסס הקשור לסיכון IT/SO לא נבחר לבדיקה",
    25: "נהלים מבססים של בקרת IT/SO/IT מהותי אינו קשור לסיכון IT/SO",
    26: "זהה את הסעיף בסיכון מוגבל (LRA) שאין לו משימות כלשהן. הוסף נוהל ביקורת מבסס נוסף (OSP) אחד או יותר",
    27: "ודא שיש לך PSPs מיובאים. אם PSPs לא יובאו, לחץ על ייבוא PSPs. אם אין PSPs עבור הטענה, צור OSP",
    28: "נווט אל תרשים הזרימה המובנה של תת התהליך המהותי (ה-SCOT), פתח את האפשרות הוסף בדיקת בקרה (TOC), זהה את משימת ה-TOC שאין לצידה תג מספר (number badge). קשר את משימת ה-TOC לבקרה",
    29: "התקשרות מכילה לפחות מטלת walkthrough אחת שעדיין לא שויכת לתת-תהליך מהותי (SCOT). ",
    30: "לתת התהליך המהותי (SCOT) אין לפחות מטלת walkthrough אחת שקשורה אליו",
    31: "נווט אל תרשים הזרימה המובנה של תת התהליך המהותי (ה-SCOT), פתח את האפשרות הוסף בדיקת בקרה (TOC), זהה את משימת ה-TOC שאין לצידה תג מספר (number badge). קשר את משימת ה-TOC לבקרה",
    32: "IT/SO walkthrough לא קשורה לפחות לתהליך IT/SO אחד",
    33: "בדיקת IT/SO של שליטה אינה קשורה לפחות ל- IT/SO בקרת/נוהל מבססעם ערך בדיקה מוגדר כן",
    34: "נוהל מבססIT/SO אחר אינו מקושר ללפחות בקרה או נוהל מבסס של IT/SO עם ערך בדיקה מוגדר כ'כן'.",
    35: "לנוהל IT/SO אין לפחות walkthrough אחד המשויך אליו",
    36: "הבקרה עם ערך בדיקה מוגדר כ'כן' אינה מקושרת למשימת בדיקת בקרה",
    37: "נוהל מבססIT/SO אחר אינו מקושר ללפחות בקרה או נוהל מבסס של IT/SO עם ערך בדיקה מוגדר כ'כן'.",
    38: "לחץ על קישור האימות, מרשימת הראיות לחץ על סמל ההתנגשות (conflict icon) בכדי לפתור את ההתנגשות",
	39: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	40: "לחץ על קישור האימות, מתוך החתימה על רשימת הראיות על המסמכים שחסרים עבורם חתימות מכין או סוקר. חתום רק על אותם קבצים שהכנת או בדקת",
	41: "לחץ על קישור האימות, מרשימת המשימות המסוננת סקור כל משימה ושייך את קבצי ראיות הביקורת המתאימים",
	42: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	43: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
    44: "לחץ על קישור האימות, מרשימת הראיות שנה את שמות המסמכים שמופיעים בשמות כפולים",
    45: "הערכת תהליך ה-IT לא נבחרה או שאינה תואמת להערכת היעילות התפעולית של ITCG/ITSP",
	46: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
    47: "הערכת ה-IT המצטברת לא נבחרה עבור אחד או יותר מהבקרות האפליקטיביות או בקרות הITDM",
    48: "לטופס קנבס יש לפחות שדה אחד שלא הושלם",
    49: "לחץ על קישור האימות ולאחר מכן לחץ על הוסף מצג הנהלה בכדי לקשר את מצג ההנהלה או הסעיף בסיכון מוגבל (LRA)",
    50: "משימה שאין לה מצג הנהלה או חשבון בעל סיכון מוגבל משויך. לחץ על הוסף מצג הנהלה בכדי לשייך מצג הנהלה או חשבון בעל סיכון מוגבל ",
    51: "WCGW לא קשור למשימה מבססת",
    52: "למעורבות יש לפחות סיכון מובנה (IR), סיכון משמעותי (SR) או סיכון הונאה (FR) אחד שאינו משויך ל-WCGW אחד לפחות",
    53: "חשבון הכרוך באומדן עבורו חסר אינדקס אומדני חשבונאות EST. הוסף אותו מרשימת ה-PSP Index.",
    54: "זהה את הסעיפים הכרוכים באומדנים ופתח את החשבון כדי לראות אם יש משוייך אליו תת תהליך מהותי הכרוך באומדן. לאחר שתזהה את החשבונות שחסרים להם תת תהליך מהותי הכרוך באומדן, תצטרכו לקשר את אותו תת תהליך מהותי הכרוך באומדן לחשבונות הרלוונטיים.",
    55: "זהה את תת התהליך המהותי הכרוך באומדן (Estimate SCOT) שאינו קשור לסעיף הכרוך באומדנים. לאחר שתזהה את תת התהליך המהותי שכרוך באומדן שלא משויך אליו חשבון שכרוך באומדנים, תידרש לשייך את תת התהליך המהותי שכרוך באומדן לחשבון שכרוך באומדנים.",
    56: "לסיכון משמעותי (SR) או לסיכון הונאה (FR) חייבים להיות לפחות נוהל מבסס אחד, בקרה אחת ומשימה אחת של בדיקת בקרה (אם ישימה)",
    57: "לסיכון משמעותי (SR) או לסיכון הונאה (FR) חייבים להיות לפחות נוהל מבסס אחד, בקרה אחת ומשימה אחת של בדיקת בקרה (אם ישימה)",
    58: "לחץ על הסיכון עם האימות  והרחב את מצג ההנהלה. ודא שלפחות משימה אחת נבחרה.",
    59: "לחץ על הסיכון עם האימות והרחב את מצג ההנהלה. ודא שלפחות בקרה אחת נבחרה. יש להשלים את האפקטיביות בתכנון הבקרה (design effectiveness). ",
    60: "לחץ על קישור האימות לפתרון הערות בטופס ה Canvas. פתח כל טופס Canvas ובחר הצג הערות לא פתורות. יש לנקות או לסגור את כל ההערות",
    61: "לחץ על קישור האימות לסגירת תגובות לא מלאות בטופס ה- Canvas. פתח כל טופס Canvas ובחר הצג תגובות לא שלמות. יש למלא את כל השאלות בטופס קנבס",
    62: "לחץ על קישור האימות, סקור את ההערות הפתוחות ונקה או סגור את כל ההערות הפתוחות.",
	63: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
    64: "לחץ על קישור האימות, מרשימת המשימות המסוננת סקור כל משימה וסמן משימות פתוחות שהושלמו",
    65: "לחץ על לחצן ביטול הקישור להכל, בכדי לבטל את הקישור של כל ראיות הביקורת המשותפות",
    66: "לטופס 440 יש לפחות מסמך אחד שבו לא נבחרה סיבה לשינוי",
	67: 'לטופס 440 יש לפחות מסמך אחד עם סיבה "לא מנהלית" לשינוי שנבחר, שלא השולם עבורו הרציונל ',
	68: 'Form 440 has at least one document with a “non administrative” reason for change selected that has not been approved by a manager or above',
    69: "טופס 440 לא נחתם על ידי שותף ההתקשרות (EIC) או השותף האחראי על הביקורת (PIC)",
    70: "לחץ על לחצן ביטול הקישור מקבוצה ברשימת התיוג לצורך הארכיב",
    71: "לטופס קנבס אין כותרות או תוכן סטנדרטי",
	72: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	73: "לחץ על סמל בדיקת האימות בטופס הקנבס כדי לראות את מספר התגובות שלא הושלמו",
	74: "לחץ על הקישור ושלח את הגרסה המעודכנת של Engagement Profile.smt",
	75: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	76: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	77: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	78: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	79: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	80: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	81: "זהה תהליכי IT וקשר אותם ליישומי IT",
	82: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	83: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	84: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	85: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	86: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	87: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	88: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
    89: "הערכת תהליך ה-IT לא נבחרה או שאינה תואמת להערכת היעילות התפעולית של ITCG/ITSP",
    90: "לבקרה חסרה בחירת לבחינת האפקטיביות התכנונית (design effectiveness) שלה",
    91: "הצג תת-תהליכים מהותיים (SCOTs) ויישומי IT הרלוונטיים לביקורת",
	92: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	93: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	94: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
    95: "להתקשרות אין חבר צוות ספציפי שזוהה כאדם אחראי על ניהול הצוות",
    96: "גורם סיכון אינו קשור לסיכון או לא מסומן כ”לא ROMM”",
    97: "סיכון אינו קשור למצג ההנהלה",
    98: "יש להזין סכום לבסיס החזוי",
    99: "יש להזין רציונל לבסיס החזוי",
    100: "יש להזין סכום לבסיס המתואם",
    101: "לא נבחר סף מהותיות (PM)",
    102: "סף המהותיות (PM) נמצא מחוץ לטווח המותר",
    103: "יש להזין רציונל לסף המהותיות (PM) שנבחר",
    104: "סף הטעות הנסבלת (TE) לא הוזן",
    105: "סף הטעות הנסבלת (TE) הוא מחוץ לטווח המותר",
    106: "יש להזין את הרציונל לסף הטעות הנסבלת שנקבע (TE)",
    107: "אחוז SAD לא נבחר",
    108: "אחוז SAD נמצא מחוץ לטווח המותר",
    109: "יש להזין את הרציונל לאחוז הSAD שנבחר",
	110: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	111: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	112: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	113: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	114: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	115: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	116: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	117: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	118: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	119: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	120: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	121: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	122: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	123: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	124: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
    125: "אין לשמור מסמכים מוגנים בתיקי ביקורת, אלא אם יש צורך בכך",
    126: "מחק מסמך והעלה מחדש",
	127: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	128: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב - EY Canvas " כדי לבצע אימות זה ',
	129: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	130: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	132: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	133: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	134: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	135: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	136: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	137: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	138: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	139: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	140: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	141: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	142: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	143: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	144: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	145: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	146: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	147: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	148: 'השתמש בהנחיות על פי השלבים באפשרות "כיצד לבצע בדיקות אימות ב-EY Canvas" כדי לבצע אימות זה ',
	149: 'לחץ על קישור האימות השלמת תשובות לא מלאות בטופס ה- Canvas. פתחו כל טופס Canvas ווודאו שכל הממסמכי החובה המשויכים לדרישות אכן כוללים את חתימת ה- PIC/EQR. הבדיקה תתבצע רק על הקבצים שהכנתם או סקרתם.',
	150: 'לחץ על קישור האימות השלמת תשובות לא מלאות בטופס ה- Canvas. פתחו כל טופס Canvas ווודאו שכל מסמכי החובה המשויכים לדרישות אכן כוללים את חתימת ה- PIC/EQR.',
	151: 'אנא בדוק שלכל הסעיפיםוהגילויים המשמעותיים יש לפחות מצג הנהלה אחד.',
	152: 'פתחו כל טופס Canvas ווודאו שלכל מסמכי החובה המשויכים לדרישות יש חתימות מכין וסוקר.היכנסו רק לקבצים שהכנתם או סקרתם.',
	153: 'Navigate to the adjustment and use "Add evidence" option to associate appropriate evidence',
	154: 'Navigate to the estimate document and check there that Higher/Lower risk estimates have an Estimate account related. Very low risk estimates should have at least one account related.',
	155: 'Navigate to the estimate document and check there  accounts related. Based on the audit documentation either unrelate non-estimate account or modify it to an estimate account.',
	156: 'Navigate to the estimate document and check responses there.',
	157: 'Navigate to the estimate document and check there that Higher/Lower risk estimates have an Estimate SCOT related. Very low risk estimates should have at least one SCOT related.',
	158: 'Navigate to the account document and check there are at least one  Higher or Lower risk estimate related.',
	159: 'Navigate to the account document and check there are at least one  Higher or Lower risk estimate related.',
	160: 'Navigate to the estimate lead sheet to identify Estimate SCOTs that do not have any estimate related. Based on the audit documentation either modify those SCOTs to non-estimate or relate estimates to those SCOTs',
	161: 'Navigate to the adjustment and check sum of the debit entries equals to the sum of credit entries.',
	162: 'Navigate to the estimate document and c and check there are at least one significant or fraud risk related.',
	163: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	164: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	165: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
    166: "נווט אל תיעוד האומדן ובדוק שיש שם סיכונים קשורים. בהתבסס על תיעוד הביקורת, או לבטל את הקישור של הסיכון המשמעותי/סיכון ההונאה או לעדכן את קטגוריית האומדן לסיכון גבוה יותר."
};

export const validationChecksReportHeaderLabels = {
    validationType: "סוג אימות",
    validationDescription: "תיאור אימות",
    itemName: "שם הפריט",
    auditPhase: "שלב בביקורת",
    additionalInformation: "מידע נוסף",
    localization: "התאמה מקומית",
    itemType: "סוג פריט",
    location: labels.location,
    count: "ספירה",
    validationCount: "ספירת אימותים (Validations)",
    itemID: "מזהה פריט",
    validationTypeID: "מזהה סוג אימות",
    category: "קטגוריה",
    auditPhaseID: "מזהה שלב הביקורת",
    entity: labels.filterEntitiesLabel
};


export const ReviewNotesReportHeaderLabel = {
    annotationID: "מזהה הערה",
    assignToUserID: "הוקצה ל-User ID",
    assignedtoUser: labels.assignedTo,
    createUserID: "מזהה מחבר",
    createdBy: "יוצר",
    createdDate: "נוצר ב",
    dueDateLabel: "תאריך יעד",
    relatedEvidence: "ראיות קשורות",
    reviewNote: labels.reviewNotesLabel,
    lastModifiedBy: "שונה לאחרונה על ידי",
    modifyUserID: "שונה על ידי מזהה משתמש",
    lastModifiedOnLabel: "שונה לאחרונה בתאריך",
    priorityType: labels.priorityLabel,
    annotationParentID: "מזהה הערה ראשית (Parent Annotation)",
    referenceNumber: "הפנייה",
    relatedTasks: "משימה קשורה",
    replies: labels.reply,
    reviewNoteStatus: labels.status,
    statusChangedByUserID: "הסטטוס השתנה לפי זיהוי משתמש",
    statusChangedBy: "הסטטוס שונה על ידי",
    statusChangedDateLabel: "הסטטוס שונה על ידי",
    startDateLabel: "נוצר לראשונה (ב-UTC)",
    clearedDateLabel: "נוקה לאחרונה (ב-UTC)",
    closedDateLabel: "סגירה אחרונה (ב-UTC)",
    documentTypeID: "הסטטוס עודכן בתאריך",
    childAnnotationID: "מזהה סוג מסמך"
};

export const taskDueDateCategoryIdLabels = {
    0: "השבועות האחרונים",
    1: "השבוע הנוכחי",
    2: "שבוע הבא",
    3: "השבועות הבאים"
};

export const taskSummaryReportHeaderLabels = {
    engagementID: "מזהה התקשרות",
    taskID: "מזהה משימה",
    displayedTaskName: labels.TaskName,
    taskNamePrefix: "קידומת משימה",
    taskNameSuffix: "סיומת משימה",
    dueDateColumn: labels.taskDueDateHeader,
    dueDateWeek: labels.dueLabel,
    assignmentType: labels.assignmentType,
    assignmentTypeID: "מזהה סוג המשימה",
    assignmentName: labels.assignmentName,
    assignmentStatus: labels.taskAssigmentStatusHeader,
    reviewNoteAssignedOpen: "הערות סקירה פתוחות שהוקצו",
    reviewNoteAssignedCleared: "הערות סקירה שנמחקו אשר הוקצו",
    reviewNoteAuthoredOpen: "הערות סקירה פתוחות",
    reviewNoteAuthoredCleared: "הערות סקירה שנמחקו",
    taskStatus: labels.taskStatusLabel,
    taskStatusID: "מזהה סטטוס משימה",
    taskType: labels.taskType,
    taskTypeID: "מזהה סוג משימה",
    milestone: labels.filterMilestoneLabel,
    milestoneID: "מזהה אבן דרך (milestone)",
    isOverdueColumn: labels.Overdue,
    timephaseName: labels.timephase,
    relatedObjectName: "אובייקט קשור",
    relatedEntityID: "מזהה אובייקט קשור",
    openAssignmentsOverdue: "משימות פתוחות - באיחור",
    openAssignmentsThisWeek: "משימות פתוחות - השבוע",
    openAssignmentsNextWeek: "משימות פתוחות - שבוע הבא",
	openAssignmentsTotal: 'משימות פתוחות-סה"כ ',
    inProgressAssignmentsOverdue: "משימות בביצוע - באיחור",
    inProgressAssignmentsThisWeek: "משימות בביצוע -השבוע",
    inProgressAssignmentsNextWeek: "משימות בביצוע - שבוע הבא",
	inProgressAssignmentsTotal: 'משימות בביצוע - סה"כ ',
};

export const crtControlSummaryReportHeaderLabels = {
    scotID: "SCOT מזהה",
    scotName: "תת התהליך המהותי (SCOT)",
    strategyTypeName: "סוג אסטרטגיה",
    wcgwID: "WCGW מזהה",
    wcgwName: "WCGW",
    controlID: "מזהה בקרה",
    controlName: "בקרה",
    operatingEvaluation: "הערכת תפעול",
    assertions: "יעדי ביקורת",
    controlTypeName: "סוג בקרה",
    testingFormatted: "בחירת בדיקה",
    scotStrategy: "אסטרטגיית תת-תהליך מהותי (SCOT)",
    itApplicationName: "יישום IT /SO קשור",
    controlFrequencyTypeName: "תדירות",
    scotTypeID: "מזהה סוג SCOT",
    scotTypeName: "סוג SCOT",
    itAppType: "אפליקציית IT/SO",
    lowerRiskControl: "בקרת סיכון נמוך"
};

export const trialBalanceReportHeaderLabels = {
    engagementID: "מזהה תיק הביקורת",
    trialBalanceID: "מזהה מאזן בוחן",
    trialBalanceTypeID: "מזהה סוג מאזן בוחן",
    trialBalanceTypeName: "שם סוג מאזן בוחן",
    financialStatementID: "מזהה דוח כספי",
    financialStatementName: "שם הדוח הכספי",
    financialStatementTypeID: "מזהה סוג דוחות כספיים",
    financialStatementTypeName: "שם סוג הדוחות הכספיים",
    financialStatementSubTypeID: "מזהה תת סוג של דוחות כספיים",
    financialStatementSubTypeName: "שם משנה של דוחות כספיים",
    analysisPeriodBalance: "ניתוח תאריך המאזן",
    comparativePeriodBalance: "השוואת תאריך המאזן",
    analysisComparativeBalanceChange: "ניתוח שינוי מאזן השוואתי",
    analysisComparativeBalanceChangePercent: "ניתוח אחוז שינוי מאזן השוואתי",
    secondComparativePeriodBalance: "השוואה שנייה של תאריך המאזן",
    analysisSecondComparativeBalanceChange: "ניתוח שינוי מאזן השוואתי שני",
    analysisSecondComparativeBalanceChangePercent: "ניתוח אחוז שינוי מאזן השוואתי שני",
    parentFinancialStatementID: "מזהה הדוח הכספי של חברת האם",
    displayOrder: "סדר תצוגה",
    eyCanvasAccountName: "שם הסעיף ב EY Canvas",
    relatedEntities: "ישויות קשורות"
};

export const taskSourceTypes = {
    1: labels.internal,
    2: labels.external
};

export const taskNatureTypes = {
    1: labels.testOfDetail,
    2: labels.substantiveAnalyticalProcedure,
    3: labels.testOfControl
};

export const priorityTypesCollaboration = [{
        value: 1,
        label: "נוֹרמָלִי"
    },
    {
        value: 3,
        label: "High"
    },
    {
        value: 4,
        label: "Critical"
    }
];

export const StatementType = [{
    id: 1,
    value: "דוח רווח והפסד"
}, {
    id: 2,
    value: "מאזן"
}, {
    id: 3,
    value: "שני"
}];

export const AccountTypes = [{
        id: 1,
        accountTypeName: "משמעותי"
    },
    {
        id: 2,
        accountTypeName: "סיכון נמוך (מוגבל)"
    },
    {
        id: 3,
        accountTypeName: "לא משמעותי"
    },
    {
        id: 4,
        accountTypeName: "אחרים"
    },
    {
        id: 5,
        accountTypeName: "גילויים משמעותיים"
    }
];

export const ITAppSOAttributes = [{
    id: 1,
    value: "בחירת מדגם "
}, {
    id: 2,
    value: "מערכת IT/SO קשורה"
}, {
    id: 3,
    value: "SCOTs קשורים"
}, {
    id: 4,
    value: "אסטרטגיית SCOT קשורה"
}, {
    id: 5,
    value: "סוג SCOT קשור"
}];

export const notesEditorLabels = {
    addNoteButtonLabel: reviewNoteModalLabels?.addNewReviewNoteButtonText,
    saveNoteButtonLabel: labels.saveLabel,
    messagePlaceholder: labels.addNewNoteModalTitle,
    messagePlaceholderReply: reviewNoteModalLabels?.replyInputPlaceholder,
    messagePlaceholderEdit: reviewNoteModalLabels?.noteInputPlaceholderEdit,
    messagePlaceholderReplyEdit: reviewNoteModalLabels?.replyInputPlaceholderEdit,
    addReplyButtonLabel: reviewNoteModalLabels?.reply,
    characters: labels.characters,
    of: labels.of,
    formRequired: labels.required,
    formMaxLength: labels.formMaxLength,
    toFieldLabel: labels.assignedTo,
    priorityFieldLabel: labels.rnhPriority,
    dueDateFieldLabel: labels.dueDate,
    voiceNoteButtonLabel: labels.voiceNoteButtonLabel,
    stopRecordingButtonLabel: labels.stopRecordingButtonLabel,
    cancelButtonLabel: labels.cancelButtonLabel,
    noResultsFound: labels.noResultsFound,
    microphoneBlockedMessage: labels.microphoneBlockedMessage,
    microphoneBlockedOnVideoMessage: labels.microphoneBlockedOnVideoMessage,
    notInMainWindowVoice: labels.notInMainWindowVoice,
    notInMainWindowScreen: labels.notInMainWindowScreen,
    voiceNoteNotAvailable: "הערה קולית והקלטת מסך אינם זמינים בתצוגת  סל האפשרויות. עבור לתצוגת מסך מלא בכדי להשתמש בתכונות אלה.",
    deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
    playButtonTitle: labels.voiceNoteCommentPlayLabel,
    pauseButtonTitle: labels.voiceNoteCommentStopLabel,
    screenRecord: labels.screenRecord,
    playbackReview: labels.playbackReview,
    close: labels.reviewNotesModalClose
};


export const noteModalLabels = {
    ...notesEditorLabels,
    closeButton: labels.reviewNotesModalClose,
    closed: labels.closed,
    open: labels.open,
    cleared: labels.cleared,
    allNotes: labels.allNotes,
    myNotes: labels.myNotes,
    assignedToMe: labels.assignedToMe,
    noNotesFound: reviewNoteModalLabels?.noNotesFound,
    noNotesFoundInstructional: reviewNoteModalLabels?.noNotesAssociatedWithDocumentLabel,
    assignedTo: labels.assignedTo,
    dueDate: labels.dueDate,
    edit: labels.edit,
    delete: labels.delete,
    clear: labels.clear,
    reopen: labels.reopen,
    close: labels.closeTitle,
    reply: labels.reply,
    confirm: labels.confirm,
    cancel: labels.cancelButtonLabel,
    deleteModalHeaderNote: reviewNoteModalLabels?.deleteIconModalTitleLabel,
    deleteModalHeaderReply: reviewNoteModalLabels?.deleteReplyIconModalTitle,
    deleteModalTextNote: reviewNoteModalLabels?.deleteIconModalConfirmMessageParent,
    deleteModalTextReply: reviewNoteModalLabels?.deleteIconModalConfirmMessage,
    showMore: reviewNoteModalLabels?.showMore,
    showLess: reviewNoteModalLabels?.showLess,
    view: labels.view,
    notSelected: labels.notSelectedText,
    deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
    playButtonTitle: labels.voiceNoteCommentPlayLabel,
    pauseButtonTitle: labels.voiceNoteCommentStopLabel
};

export const EntitiesLabels = {
    close: "Close",
    cancel: "בטל",
    repNoRecordMessage: "לא נמצאו תוצאות",
    edit: "ערוך",
    delete: "מחק",
    actions: "פעולות",
	show: "הצג",
    first: "הדף הראשון",
    last: "הדף האחרון",
    prev: "הדף הקודם",
    next: "הדף הבא",

    [Entity.Account]: {
        manageEntity: "ניהול סעיפים וגילויים",
        searchEntity: "חפש סעיפים",
        createEntity: "סעיף חדש",
        entityName: "סעיף",
        entityNameCaps: "סעיף",
        entityNamePlural: "סעיפים",
        placeholderText: "צור סעיפים וגילויים חדשים או ערוך ומחק סעיפים וגילויים קיימים להלן.",
        deleteConfirmLabel: "האם אתה בטוח שברצונך למחוק חשבון זה? כל הקשרים הקיימים יוסרו. לא ניתן לבטל פעולה זו."
    },
    [Entity.Estimate]: {
        manageEntity: "נהל אומדנים",
        searchEntity: "חפש אומדן",
        createEntity: "אומדן חדש",
        entityName: "אומדן",
        entityNameCaps: "אומדן",
        entityNamePlural: "אומדנים",
        placeholderText: "צור אומדנים חדשים או ערוך ומחק אומדנים קיימים להלן.",
        deleteConfirmLabel: "האם אתה בטוח שברצונך למחוק אומדן זה? כל הקשרים הקיימים יוסרו. לא ניתן לבטל פעולה זו."
    },
    [Entity.Risk]: {
        manageEntity: "ניהול סיכונים",
        searchEntity: "חיפוש סיכונים",
        createEntity: "סיכון חדש",
        entityName: "סיכון",
        entityNameCaps: "סיכון",
        entityNamePlural: "סיכונים",
        placeholderText: "צור סיכונים חדשים או ערוך ומחק סיכונים קיימים להלן.",
        deleteConfirmLabel: "האם אתה בטוח שברצונך למחוק סיכון זה? כל הקשרים הקיימים יוסרו. לא ניתן לבטל פעולה זו."
    },
    [Entity.STEntity]: {
        manageEntity: "ניהול ישויות",
        searchEntity: "חפש ישויות",
        createEntity: "ישות חדשה",
        entityName: "ישות",
        entityNameCaps: "ישות",
        entityNamePlural: "ישויות",
        placeholderText: "צור ישויות חדשות או ערוך ומחק ישויות קיימות להלן.",
        deleteEntity: "מחק ישות",
        deleteConfirmLabel: "האם אתה בטוח שברצונך למחוק ישות זו? כל הקשרים הקיימים יוסרו. לא ניתן לבטל פעולה זו."
    },
    [Entity.Control]: {
        manageEntity: "נהל בקרות",
        searchEntity: "חפש בקרות",
        createEntity: "בקרה חדשה",
        entityName: "בקרה",
        entityNameCaps: "בקרה",
        entityNamePlural: "בקרות",
        placeholderText: "צור בקרות חדשות או ערוך ומחק בקרות קיימות להלן.",
        deleteEntity: "מחק בקרה",
        deleteConfirmLabel: "האם אתה בטוח שברצונך למחוק בקרה זו? כל הקשרים הקיימים יוסרו. לא ניתן לבטל פעולה זו."
    },
    [Entity.SCOT]: {
        manageEntity: "נהל תתי תהליכים מהותיים (SCOT)",
        searchEntity: "חפש תת תהליך מהותי SCOTs",
        createEntity: "SCOT חדש",
        entityName: "תת התהליך המהותי (SCOT)",
        entityNameCaps: "תת התהליך המהותי (SCOT)",
        entityNamePlural: "SCOTs",
        placeholderText: "צור תתי תהליכים מהותיים SCOTs חדשים או ערוך ומחק SCOTs קיימים להלן.",
        deleteEntity: "מחק תת תהליך מהותי (SCOT)",
        deleteConfirmLabel: "האם אתה בטוח שברצונך למחוק תת תהליך מהותי (SCOT) זה? כל הקשרים הקיימים יוסרו. לא ניתן לבטל פעולה זו."
    },
    [Entity.ITApplication]: {
        manageEntity: "ניהול יישומי IT",
        searchEntity: "חפש",
        createEntity: "יישום IT חדש",
        entityName: "אפליקציית IT",
        entityNameCaps: "אפליקציית IT",
        entityNamePlural: "יישומי IT",
        placeholderText: "צור יישומי IT חדשים או ערוך ומחק יישומי IT קיימים להלן.,",
        deleteEntity: "מחק יישום IT",
        deleteConfirmLabel: "האם אתה בטוח שברצונך למחוק יישום IT זה? כל הקשרים הקיימים יוסרו. לא ניתן לבטל פעולה זו."
    },
    [Entity.TaskSection]: {
        manageEntity: "ניהול קבוצות משימות",
        searchEntity: "חיפוש קבוצת משימות",
        createEntity: "קבוצת משימה חדשה",
        entityName: "קבוצת משימות",
        entityNameCaps: "קבוצת משימות",
        entityNamePlural: "קבוצות משימות",
        placeholderText: "צור קבוצת משימות חדשה או ערוך ומחק קבוצת משימות קיימת להלן.",
        deleteEntity: "מחק קבוצת משימות",
        deleteConfirmLabel: "האם אתה בטוח שברצונך למחוק את ההתאמה שנבחרה?לא ניתן לבטל פעולה הזו."
    },
    [Entity.WCGW]: {
        manageEntity: "נהל WCGWs",
        searchEntity: "חפש WCGWs",
        createEntity: "חדשים'WCGWs ",
        entityName: "WCGW",
        entityNameCaps: "WCGW",
        entityNamePlural: "WCGWs",
        placeholderText: "צור WCGW חדש או ערוך ומחק WCGW קיים להלן.",
        deleteEntity: "מחק את ה- WCGW",
        deleteConfirmLabel: "האם אתה בטוח שברצונך למחוק WCGW זה? כל הקשרים הקיימים יוסרו. לא ניתן לבטל פעולה זו."
    },
    [Entity.Misstatement]: {
        manageEntity: "נהל התאמות",
        searchEntity: "התאמות חיפוש",
        createEntity: "התאמה חדשה",
        entityName: "התאמה",
        entityNameCaps: "התאמה",
        entityNamePlural: "התאמות",
        placeholderText: "צור התאמות חדשות או ערוך ומחק התאמות קיימות להלן.",
        deleteConfirmLabel: "האם אתה בטוח שברצונך למחוק את ההתאמה שנבחרה?לא ניתן לבטל פעולה הזו."
    },
    [Entity.AdjustmentValidation]: {
        manageEntity: "ניהול התאמות באמצעות בדיקות אימות",
        searchEntity: "חפש",
        entityName: "התאמות",
        entityNameCaps: "התאמות",
        entityNamePlural: "התאמות",
		placeholderText: 'כל התאמה חייבת לכלול ראיה אחת לפחות ולכל התאמה סכום כניסות החיוב צריך להיות שווה לסכום כניסות הזיכוי. להתאמות הבאות יש בעיית אימות אחת או יותר. לחץ על <b>ערוך"</b> כדי לטפל בהם.',
        deleteConfirmLabel: "האם אתה בטוח שברצונך למחוק את ההתאמה שנבחרה?לא ניתן לבטל פעולה הזו.",
        adjustmentHeader: "התאמה",
        validationTyeHeader: "סוג אימות",
        validationTypeAmtMissmatch: "סכום כניסות החיוב אינו שווה לסכום כניסות הזיכוי",
        validationTypeNoEvidence: "אין ראיות קשורות"
    },
    [Entity.SampleItem]: {
        manageEntity: "נהל תגיות למדגם",
        searchEntity: "תגי חיפוש",
        createEntity: "תג חדש",
        createManageTagEntity: "נהל קבוצות תגים",
        entityName: "תָג",
        entityNamePlural: "תגים",
        entityNameForTagGroupPlural: "תייגו קבוצות",
        placeholderText: "צור תגים חדשים או ערוך ומחק תגים קיימים למטה."
    },
    [Entity.SampleTagGroups]: {
        manageEntity: "נהל קבוצות תגים לדוגמה",
        searchEntity: "חפש",
        createEntity: "קבוצת תגים חדשה",
        entityName: "קבוצת תגים",
        entityNameCaps: "קבוצת תגים",
        entityNamePlural: "תייגו קבוצות",
        placeholderText: "צור קבוצות תגים לדוגמה חדשות או ערוך ומחק קבוצות תגים לדוגמה קיימות להלן.",
    }
};

export const executionType = [{
        id: 1,
        label: '',
        toolTip: '',
        value: "בהתקשרות הזו"
    },
    {
        id: 2,
        label: 'CT',
        toolTip: "נהלים בהתקשרות(יות) אחרת(ות) [PT-בלבד]",
        value: "בהתקשרות(יות) אחרת(ות) [PT-בלבד]"
    },
    {
        id: 3,
        label: 'PT/CT',
        toolTip: "נהלים בהתקשרות(יות) זו(אלו) ואחרות [PT-בלבד]",
        value: "בהתקשרות(יות) זו(אלו) ואחרות [PT-בלבד]"
    }
];

export const AccountType = [{
        id: 1,
        accounttypename: "סעיף מהותי"
    },
    {
        id: 2,
        accounttypename: "סעיף בסיכון מוגבל (limited risk account)"
    },
    {
        id: 3,
        accounttypename: "סעיף לא מהותי (Insignificant account)"
    },
    {
        id: 4,
        accounttypename: "סעיף אחר"
    },
    {
        id: 5,
        accounttypename: "גילוי משמעותי"
    }
];

export const statementTypes = [{
        id: 1,
        name: "דוח רווח והפסד"
    },
    {
        id: 2,
        name: "מאזן"
    },
    {
        id: 3,
        name: "שני"
    }
];

export const CreateEditAccountLabels = {
    createModalDescription: "הזן את פרטי החשבון החדשים למטה ובחר '<b>{0}</b>' כדי לסיים. כדי ליצור חשבון נוסף, בחר '<b>{1}</b>'.",
    editModalDescription: "ערוך את פרטי הסעיף להלן ובחר '<b>{0}</b>' כדי לסיים.",
    close: "Close",
    cancel: "בטל",
    yes: "כן",
    no: "לא",
    createAccount: "סעיף חדש",
    editAccount: "ערוך סעיף",
    delete: "מחק",
    save: "שמור",
    saveAndCloseLabel: "שמור וסגור",
    saveAndCreateLabel: "שמור וצור אחד נוסף",
    accountNameLabel: "שם סעיף (חובה)",
    accountDesignationLabel: "ייעוד",
    accountExecutionTypeLabel: "באיזו התקשרות Canvas יבוצעו ויתועדו נהלים עבור חשבון זה?",
    accountEstimateLabel: "האם סעיף זה מושפע מאומדן?",
    accountStatementTypeLabel: "סוג דוח",
    pspIndexDropdownLabel: "אינדקס PSP (נדרש, בחר עד 5)",
    removePSPIndexLabel: "הסר אינדקס PSP",
    assertionsLabel: "בחר מצגי הנהלה רלוונטיים",
    assertionOptions: assertions,
    executionTypeOptions: executionType,
    accountTypeOptions: AccountType,
    statementTypeOptions: statementTypes,
    confirm: "אשר",
    pspIndexErrorMsg: "נדרש",
    assertionWarningMessage: "לא ניתן לבצע שינויים במצגי ההנהלה שמקושרים אליהם סיכון משמעותי (SR), או סיכון הונאה (FR), או סיכון להצגה מוטעית מהותית (ROMM) או אומדן קשור. אתה צריך להסיר את היחסים האלה קודם.",
    confirmChanges: "אשר שינויים",
    executionTypeWarningMessage: "השינויים שאתה עומד לשמור בחשבון זה ישפיעו על מצגי ההנהלה (assetions) הקיימים ונהלי הביקורת המבססים העיקריים (PSPs), הקישורים יבוטלו. האם אתה בטוח שאתה רוצה להמשיך? לא ניתן לבטל פעולה זו.",
    contentUpdateToastMessage: "עדכון תוכן זמין עבור {0}. אנא התחל את עדכון התוכן מדף עדכון התוכן.",
    assertionsRequired: "יש לבחור לפחות מצד הנהלה אחד",
    pspIndexDisabledLabel: "בחר עד חמישה אינדקסים של PSP. בטל את הבחירה באפשרות אחת או יותר כדי להמשיך.",
    newSignificantDisclosure: "גילוי משמעותי חדש",
    noOptionsMessage: "לא נמצאו תוצאות",
    accountNameErrorMsg: "נדרש"
};

export const CreateMestLabels = {
    createModalTitle: "ישות חדשה",
    createModalDescription: "הזן את הישות למטה ובחר '<b>{0}</b>' כדי לסיים. כדי ליצור ישות נוספת, בחר '<b>{1}</b>'. הישויות הן איך אנו מתכוונים לגשת לבדיקה ועשויות לא להיות ישויות משפטיות אלא יחידות עסקיות או קומבינציות אחרות.",
    close: "סגור",
    cancel: "בטל",
    save: "שמור",
    saveAndCloseLabel: "שמור וסגור",
    saveAndCreateLabel: "שמור וצור אחד נוסף",
    entityNameLabel: "שם הישות",
    entityStandardIndexLabel: "אינדקס סטנדרטי של ישות",
    entityDescriptionLabel: "תיאור ישות (אופציונלי)",
    entityNameErrorMsg: "נדרש",
    entityStandardIndexErrorMsg: "נדרש"
}

export const CreateEditSCOTLabels = {
    createModalTitle: "SCOT חדש",
    editModalTitle: "ערוך תת תהליך מהותי SCOT",
    createModalDescription: "הזן את פרטי ה-SCOT החדשים להלן ובחר '<b>{0}</b>' כדי לסיים. כדי ליצור SCOT נוסף, בחר '<b>{1}</b>'.",
    editModalDescription: "ערוך את פרטי ה-SCOT להלן ובחר '<b>{0}</b>' כדי לסיים.",
    close: "סגור",
    cancel: "בטל",
    save: "שמור",
    saveAndCloseLabel: "שמור וסגור",
    saveAndCreateLabel: "שמור וצור אחד נוסף",
    scotNameLabel: "שם תת התהליך המהותי SCOT (חובה)",
    scotStrategyLabel: "Scot Strategy",
    scotTypeLabel: "סוג תת התהליך המהותי  (SCOT)",
    scotTypeOptions: scotTypes,
    hasEstimateLabel: "האם תת תהליך מהותי SCOT זה מושפע מאומדן?",
    itAPPUsedLabel: "לא נעשה שימוש ביישומי IT",
    routine: "Routine",
    nonRoutine: "לא רוטיני",
    controls: "בקרות",
    substantive: "ביקורת מבססת",
    yes: "כן",
    scotNameErrorMsg: "נדרש",
    remove: "הסר",
    noOptionsMessage: "לא נמצאו תוצאות",
    wtDetailPrefix: "<p>עבור כל תת תהליך SCOT רוטיני , לא רוטיני ותהליכי גילוי משמעותיים, אנו מאשרים את ההבנה שלנו בכל תקופה על ידי ביצוע נהלי WT. בנוסף, בביקורת PCAOB, אנו מבצעים נהלי WT לתתי תהליכים הכרוכים באומדנים <br/> עבור כל תתי התהליכים המהותיים (SCOTs) כאשר אנו נוקטים אסטרטגיית הסתמכות על בקרות, ועבור בקרות אשר נותנות מענה לסיכונים משמעותיים, אנו מאשרים שהבקרות הרלוונטיות תוכננו ויושמו כראוי. אנו מאשרים שההחלטה שלנו לנקוט באסטרטגיית הסתמכות בקרה עדיין מתאימה.<br/><br/>אנו מסיקים שהתיעוד שלנו מתאר במדויק את פעולת ה-SCOT וזיהינו את כל ה-WCGW המתאימים, כולל סיכונים הנובעים משימוש ב-IT , ובקרות רלוונטיות (כאשר רלוונטי).<br/><br/> עבור אומדן SCOTs כאשר אנו משתמשים באסטרטגיה מבססת בלבד, אנו מעריכים האם ההבנה שלנו של תת תהליך מהותי הכרוך באומדן מתאימה בהתבסס על הנהלים המבססים שלנו.</p>",
	disabledTabTooltipMessage: 'בטל את הבחירה באפשרות "לא נעשה שימוש ביישומי IT" כדי לקשר יישומי IT',
    itAppLabels: {
        tabLabel: "אפליקציות IT",
        dropdownLabel: "קשר יישומי IT",
        noRelatedItems: "אין יישומי IT קשורים",
        itApplications: "יישומי IT"
    },
    soLabels: {
        tabLabel: "לשכות שירות Sos",
        dropdownLabel: "קשר לשכות שירות SO",
        noRelatedItems: "אין לשכות שירות SO קשורות",
        serviceOrganizations: "לשכות שירות"
    }
};

export const CreateEditWCGWLabels = {
    wcgwName: "שם WCGW (נדרש)",
    editWCGW: "עריכת WCGW",
    editTheWCGW: "ערוך את פרטי WCGW להלן ובחר '<b>{0}</b>' כדי לסיים.",
    createNewWCGW: "הזן את פרטי WCGW החדשים להלן ובחר '<b>{0}</b>' כדי לסיים. כדי ליצור WCGW נוסף, בחר '<b>{1}</b>'.",
    createEditWCGWModelScot: "תת התהליך המהותי (SCOT)",
    newWCGWTitel: "New WCGW",
    editWCGWSave: "שמור",
    editWCGWClose: "לְבַטֵל",
    closeTitle: "סגור",
    wcgwNameIsRequired: "נדרש",
    saveAndCloseLabel: "שמור וסגור",
    saveAndCreateLabel: "שמור וצור אחד נוסף"
};

export const controlFrequencyTypes = [{
        value: 1,
        label: "הרבה פעמים ביום"
    },
    {
        value: 2,
        label: "יומי"
    },
    {
        value: 3,
        label: "שבועי"
    },
    {
        value: 4,
        label: "חודשי"
    },
    {
        value: 5,
        label: "רבעוני"
    },
    {
        value: 6,
        label: "שנתי"
    },
    {
        value: 8,
        label: "אחרים"
    }
];

export const controlTypes = [{
        value: 1,
        label: " בקרת אפליקציית IT"
    },
    {
        value: 2,
        label: "IT Dependent Manual Control"
    },
    {
        value: 3,
        label: "מונעת ידנית"
    },
    {
        value: 4,
        label: "בקרה ידנית מגלה"
    }
];

export const CreateEditControlLabels = {
    createModalTitle: "בקרה חדשה",
    editModalTitle: "ערוך בקרה",
    close: "סגור",
    cancel: "בטל",
    save: "שמור",
    saveAndCloseLabel: "שמור וסגור",
    saveAndCreateLabel: "שמור וצור אחד נוסף",
    controlNameLabel: "שם בקרה (חובה)",
    frequency: "תדירות",
    controlType: "סוג בקרה",
    frequencyTypeOptions: controlFrequencyTypes,
    controlTypeOptions: controlTypes,
    designEffectiveness: "Design Effectiveness",
    operatingEffectiveness: "אפקטיביות תפעולית",
    testingLabel: "בודק",
    lowerRiskLabel: "האם הבקרה בסיכון נמוך יותר?",
    ITDMControlSubstantiveTestingOptionLabel: "החלק האוטומטי של בקרת ה-ITDM זו הוא רק השימוש בדוחות שנוצרו על ידי המערכת שנבדקים באופן מבסס",
    effective: "יעיל",
    ineffective: "לא יעיל",
    yes: "כן",
    no: "לא",
    required: "נדרש",
    remove: "הסר",
    noOptionsMessage: "לא נמצאו תוצאות",
	disabledTabTooltipMessage: 'בחר "סוג בקרה" כ"בקרת יישומי IT" או "בקרה ידנית תלוית IT" כדי לקשר בין יישומי IT',
    itAppLabels: {
        tabLabel: "אפליקציות IT",
        dropdownLabel: "קשר יישומי IT",
        noRelatedItems: "אין יישומי IT קשורים",
        itApplications: "יישומי IT"
    },
    soLabels: {
        tabLabel: "לשכות שירות Sos",
        dropdownLabel: "קשר לשכות שירות SO",
        noRelatedItems: "אין לשכות שירות SO קשורות",
        serviceOrganizations: "לשכות שירות"
    },
    controlNameErrorMsg: "נדרש",
    createModalDescriptionLabel: "הזן את פרטי הבקרה החדשים למטה ובחר '<b>{0}</b>' כדי לסיים. כדי ליצור בקרה נוספת, בחר '<b>{1}</b>'.",
    editModalDescriptionLabel: "ערוך את פרטי הבקרה להלן ובחר '<b>{0}</b>' כדי לסיים.",
    wcgwLabel: "WCGW"
};

export const CreateEditITApplicationLabels = {
    close: "סגור",
    cancel: "בטל",
    yes: "כן",
    no: "לא",
    delete: "מחק",
    save: "שמור",
    closeTitle: "סגור",
    saveAndCloseLabel: "שמור וסגור",
    saveAndCreateLabel: "שמור וצור אחד נוסף",
    iTApplicationNameLabel: "שם יישום IT (חובה)",
    iTSOApplicationNameLabel: "שם לשכת השירות",
    newITApplicationLabel: "יישום IT חדש",
    newITSOApplicationLabel: "לשכת שירות חדשה",
    editITApplicationLabel: "ערוך יישום IT",
    confirm: "אשר",
    confirmChanges: "אשר שינויים",
    noOptionsMessage: "לא נמצאו תוצאות",
    iTAppNameErrorMsg: "נדרש",
    iTSOAppNameErrorMsg: "נדרש",
    controls: "בקרות",
    substantive: "ביקורת מבססת",
    remove: "הסר",
    iTApplicationStrategyLabel: "אסטרטגיית יישומי IT",
    SCOTsLabel: "שמות תתי תהליכים מהותיים SCOT",
    StrategyLabel: "אסטרטגיית תת התהליך המהותי (SCOT)",
    ControlsLabel: "שמות הבקרה",
    ControlTypeLabel: "סוג",
    addDescriptionLabel: "הזן את פרטי יישום ה- IT החדש להלן ובחר '<b>{0}</b>' כדי לסיים. כדי ליצור יישום IT אחר, בחר '<b>{1}</b>'.",

    editDescriptionLabel: "ערוך את פרטי יישום ה- IT להלן ובחר '<b>{0}</b>' כדי לסיים.",

    addSODescriptionLabel: "הזן את פרטי לשכת השירות החדשה למטלהלןה ובחר '<b>שמור וסגור</b>' כדי לסיים. כדי ליצור לשכת שירות נוספת, בחר '<b>שמור וצור אחרת</b>'.",

    scotErrorMessage: "ייתכן שתת תהליך מהותי SCOT אינו קשור ליישום ה-IT, מכיוון שיש בקרות הקשורות.",
    SCOTsLabels: {
        tabLabel: "SCOTs",
        dropdownLabel: "קשר תתי תהליכים מהותיים SCOTs",
        noRelatedItems: "אין תתי תהליכים מהותיים (SCOTs) קשורים"
    },
    ControlsLabels: {
        tabLabel: "בקרות",
        dropdownLabel: "קשר בקרות",
        noRelatedItems: "אין בקרות קשורות"
    },
    strategyType: {
        1: "בקרות",
        2: "ביקורת מבססת",
        3: "הסתמכות על בקרות",
        4: "לא להסתמך"
    },
    controlType: {
        1: "אפליקציית IT",
        2: "בקרה ידנית תלויית מחשב (ITDM)",
        3: "מונעת ידנית",
        4: "בקרה ידנית מגלה"
    }
};

export const groupComponentAccountReportHeaderLabels = {
    primaryEngagementId: "מזהה תיק הביקורת",
    gaScopeName: "היקף",
    gaComponentId: "GAComponentID",
    shortName: "שם ישות מוחזקת (component)",
    pocText: "נקודת מגע",
    accountId: "מזהה חשבון",
    accountName: "שם סעיף",
    accountType: "ייעוד הסעיף",
    knowledgeAssertion: "יעד הנהלה",
    inherentRiskType: "סיכון שבמהות (Inherent Risk)",
    riskId: "RiskID",
    riskType: "סוג הסיכון",
    riskName: "שם הסיכון",
    isHigherRiskText: "יש סיכון גבוה יותר"
};

export const AccountTypeIDs = {
    1: "סעיף מהותי",
    2: "סעיף בסיכון מוגבל (limited risk account)",
    3: "סעיף לא מהותי (Insignificant account)",
    4: "חשבון - אחר",
    5: "גילוי משמעותי"
};

export const InherentRiskTypeIDs = {
    1: "גבוה יותר",
    2: "נמוך יותר",
    3: "מאוד נמוך"
};

export const riskTypeIDs = {
    1: "סיכונים משמעותיים",
    2: "סיכוני הונאה",
    3: "סיכונים להצגה מוטעית מהותית (ROMM)"
};

export const riskTypeIDsShortForm = {
    1: "SR",
    2: "FR",
    3: "ROMM"
};

export const ControlRiskTypeIDs = {
    1: "הסתמכות על בקרות",
    2: "לא להסתמך",
    3: "בדיקת MP"
};

export const knowledgeAssertions = {
    1: "שלמות",
    2: "קיום",
    3: "ערך",
    4: "זכויות ובעלות",
    5: "הצגה וגילוי",
    6: "שלמות",
    7: "התרחשות",
    8: "מדידה",
    9: "הצגה וגילוי",
    10: "שלמות",
    11: "קיום/התרחשות",
    12: "מדידה/ערך",
    13: "זכויות ובעלות",
    14: "הצגה וגילוי"
};

export const gaInstructionStatuslabels = {
    0: "לא מוגדר",
    [instructionStatus.notSent]: "לא נשלח",
    [instructionStatus.pending]: "ממתין",
    [instructionStatus.accepted]: "התקבל",
    [instructionStatus.rejected]: "הוחזר",
    [instructionStatus.systemError]: "שגיאת מערכת",
    [instructionStatus.expired]: "לא בתוקף",
    [instructionStatus.sent]: "נשלח",
    [instructionStatus.unlinked]: "לא מקושר",
    [instructionStatus.queued]: "שבתור"
};

export const financialStatementTypeLabels = {
    [financialStatementType.Asset]: "נכס",
    [financialStatementType.CurrentAsset]: "נכס שוטף",
    [financialStatementType.NonCurrentAsset]: "נכס לא שוטף",
    [financialStatementType.Liability]: "התחייבות",
    [financialStatementType.CurrentLiability]: "התחייבות שוטפת",
    [financialStatementType.NonCurrentLiability]: "התחייבות לא שוטפת",
    [financialStatementType.Equity]: "הון ",
    [financialStatementType.Revenue]: "הַכנָסָה",
    [financialStatementType.Expense]: "הוצאה",
    [financialStatementType.NonOperatingIncome]: "רווח / (הפסד) לא תפעולי",
    [financialStatementType.OtherComprehensiveIncome]: "הכנסה כוללת אחרת",
    [financialStatementType.Other]: "אחרים",
    [financialStatementType.AccountType]: "סוג סעיף (Account Type)",
    [financialStatementType.AccountSubType]: "סוג משנה של הסעיף",
    [financialStatementType.AccountClass]: "סוג סעיף (Account class)",
    [financialStatementType.AccountSubClass]: "קבוצת משנה של הסעיף ",
    [financialStatementType.NetIncomeExpense]: "(הכנסה) / הוצאה נטו",
    18: "חשבון GL"
};

export const trialBalanceTypeLabels = {
    [trialBalanceType.Planning]: "תִכנוּן"
};

export const createEditRiskModalLabels = {
    createModalDescription: "הזן את פרטי הסיכון החדשים למטה ובחר '<b>{0}</b>' כדי לסיים. כדי ליצור סיכון נוסף, בחר '<b>{1}</b>'.",
    editModalDescription: "ערוך את פרטי הסיכון למטה ובחר <b>{0}</b> בכדי לסיים.",
    close: "סגור",
    cancel: "בטל",
    createRisk: "סיכון חדש",
    editRisk: "ערוך סיכון",
    riskType: "סוג סיכון (חובה)",

    riskTypeOptions: [{
            value: 1,
            label: "סיכון משמעותי (Significant Risk)"
        },
        {
            value: 2,
            label: "סיכון תרמית"
        },
        {
            value: 3,
            label: "סיכון להצגה מוטעית מהותית"
        }
    ],
    save: "שמור",
    saveAndCloseLabel: "שמור וסגור",
    saveAndCreateLabel: "שמור וצור אחד נוסף",
    riskNameLabel: "שם סיכון (חובה)",
    relatedAccountsAssertionsLabel: "סעיפים ומצגי הנהלה (assertions) קשורים (אופציונלי)",
    relateAccounts: "קשר סעיפים ומצגי הנהלה (assertions) (אופציונלי)",
    assertionsLabel: "בחר מצגי הנהלה רלוונטיים",
    riskNameErrorMsg: "נדרש",
    riskTypeErrorMsg: "נדרש",
    assertionOptions: assertions,
    removeAccountLabel: "הסר סעיף",
    required: "נדרש",
    assertionsRequired: "יש לבחור לפחות מצד הנהלה אחד"
};

export const activityTypeLabels = {
    104: "נוסף",
    105: "הוסר"
};

export const superModalNavigationLabels = {
    identifyAccountsAndDisclosures: "זיהוי סעיפים וגילויים",
    identifySCOTs: "זהה תתי תהליכים מהותיים (SCOTs)  וקשר אותם לסעיפים",
    determineSCOTStrategy: "קבע את אסטרטגיית תת התהליך המהותי (SCOT)",
    identifyWCGWAndControls: "זיהוי WCGWs ובקרות",
    selectControlToTest: "בחר בקרות לבדיקה",
    identifyRisks: "זיהוי סיכונים",
    relateWCGWsToAssertions: "קשר WCGWs למצגי ההנהלה",
    relateRisksToWCGWs: "קשר סיכונים ל-WCGWs",
    determineCRA: "הערכת הסיכון המשולב (CRA)",
    timephase: "שלב בלוח הזמנים",
    SCOTWT: "צור WT",
    controlTOC: "צור TOC",
    ITProcessUDP: "צור UDP",
    ITGC_ITSP_TOC_OSP: "צור IT TOC/OSP",
    accountPSP: "צור PSP",
    accountOSP: "צור OSP",
    relateWCGWTo: "קשר את ה- WCGW ל",
    relatedWCGWToTask: "קישור ה- WCGW למשימה",
    respondToSignificant_fraudRisks: "מענה לסיכונים משמעותיים SR/לסיכוני הונאה FR",
    OST: "OST",
    accountSummary: "סיכום הסעיפים",
    SCOTSummary: "סיכום תתי התהליכים המהותיים (SCOTs)",
    ITSummary: "סיכום IT",
    understandITProcesses: "הבנת תהליכי IT",
    evaluateIT: "הערכת IT",
    CRASummary: "סיכום הערכת הסיכון המשולב (CRA)",
    auditPlan: "תוכנית ביקורת",
    workplanSummary: "סיכום תוכנית עבודה",
    buildSteps: "בניית שלבים",
    ITApplicationsAndITProcesses: "יישומי IT ותהליכי IT",
    workPlan: "תוכנית עבודה",
    accounts: "סעיפים",
    scots: "תתי תהליכים מהותיים (SCOTs)",
    cra: "CRA",
    openInNewTab: "פתח בלשונית חדשה"
}

export const auditPlanITProcessLabels = {
    itProcess: "תהליך IT",
    itProcesses: "תהליכי IT",
    tasks: "משימות",
    sectionHeading: "תהליך ה-IT והמשימות להבנת התהליך (UDP) הקשורות",
    subHeader: "הבן את תהליך ה-IT",
    visualDistinctMessage: "לכל תהליך IT חייב להיות לפחות UDP אחד קשור. צור {0} או {1}.",
    addUdp: "UDP חדש",
    relatedUdp: "קשר UDPs",
    toggleFilter: "הצג רק תהליכי IT ללא כל UDP קשור",
    noResultsFound: "לא נמצאו תוצאות",
    taskTitle: "הבן ותעד את תהליך ה-IT: {0}",
    taskDescription: "תעד את ההבנה שלנו לגבי תהליך ה-IT. צרף את הטופס הרלוונטי כראיה לתמיכה בהבנתנו את תהליך ה-IT. כאשר ITGCs מופיעים במקטע מאפייני המשימה (Task Attributes), בצע נהלי WT בכדי לאשר את ההבנה שלנו של ה- ITGCs ולהעריך את התכנון והיישום שלהם. צרף ראיות לביצוע הנהלים שלנו.",
    noRecordsAvailable: "אין תהליכי IT זמינים",
    unrelatedLabel: "הצג UDPs שאינם מקושרים",
    unrelatedModalHeader: "משימות UDP שאינן מקושרות",
    noUnrelatedTaskPlaceholder: "אין משימות UDP זמינות שאינן מקושרות",
    noTaskselectedLabel: "יש לבחור לפחות משימה אחת למחיקה",
    relateITProcessTaskTitle: "קשר UDPs לתהליך IT",
    understandITProcesses: "הבנת תהליכי IT",
    unrelatedTasksMustBeAssociated: "משימות לא קשורות חייבות להיות משויכות לתהליך IT או למחוק אותן."
}

export const noEvidenceReferencedReasonsLabels = {
    immaterialReason: "לא מהותי (immaterial): מאזני/תוצאתי לא עומדים בהיקף הבדיקה - תחקור נוסף בוטל",
    strikethroughMText: "M",
    waivedReason: "Waived: סכום מתחת ל-SAD - ללא חקירה נוספת",
    strikethroughWText: "w"
}

export const auditPlanScotListLabels = {
    scot: "תת התהליך המהותי (SCOT)",
    scots: "תתי תהליכים מהותיים (SCOTs)",
    tasks: "משימות",
    sectionHeading: "תתי תהליכים מהותיים SCOTs ומשימות WT מקושרות",
    subHeader: "משימות WT",
    visualDistinctMessage: "לכל תת תהליך מהותי (SCOT)  חייב להיות לפחות WT אחד שמקושר. צור {0} או {1}.",
    newWT: "WT חדש",
    relatedWT: "קשר WTs",
    toggleFilter: "הצג רק תתי תהליכים מהותיים SCOTs ללא שום WT קשור",
    noResultsFound: "לא נמצאו תוצאות",
    noRecordsAvailable: "אין תתי תהליכים מהותחחם SCOTs זמינים",
    relateScotTaskTitle: "קשר WTs לתת תהליך מהותי SCOT",
    taskTitle: "WT: {0}",
    taskDescription: "<p>עבור כל תת תהליך SCOT רוטיני , לא רוטיני ותהליכי גילוי משמעותיים, אנו מאשרים את ההבנה שלנו בכל תקופה על ידי ביצוע נהלי WT. בנוסף, בביקורת PCAOB, אנו מבצעים נהלי WT לתתי תהליכים הכרוכים באומדנים <br/> עבור כל תתי התהליכים המהותיים (SCOTs) כאשר אנו נוקטים אסטרטגיית הסתמכות על בקרות, ועבור בקרות אשר נותנות מענה לסיכונים משמעותיים, אנו מאשרים שהבקרות הרלוונטיות תוכננו ויושמו כראוי. אנו מאשרים שההחלטה שלנו לנקוט באסטרטגיית הסתמכות בקרה עדיין מתאימה.<br/><br/>אנו מסיקים שהתיעוד שלנו מתאר במדויק את פעולת ה-SCOT וזיהינו את כל ה-WCGW המתאימים, כולל סיכונים הנובעים משימוש ב-IT , ובקרות רלוונטיות (כאשר רלוונטי).<br/><br/> עבור אומדן SCOTs כאשר אנו משתמשים באסטרטגיה מבססת בלבד, אנו מעריכים האם ההבנה שלנו של תת תהליך מהותי הכרוך באומדן מתאימה בהתבסס על הנהלים המבססים שלנו.</p>",
    unrelatedLabel: "הצג WTs לא קשורים",
    unrelatedModalHeader: "משימות WT לא קשורות",
    noUnrelatedTaskPlaceholder: "אין משימות WT לא קשורות זמינות",
    noTaskselectedLabel: "יש לבחור לפחות משימה אחת למחיקה.",
    manageScots: "נהל תתי תהליכים מהותיים (SCOT)",
    unrelatedTasksMustBeAssociated: "יש לשייך משימות שאינן מקושרות לתת התהליך המהותי (SCOT) או למחוק אותן."
}

export const auditPlanControlsLabels = {
    control: "בקרה",
    controls: "בקרות שנבחרו לבדיקה",
    tasks: "משימות",
    sectionHeading: "בקרות ובדיקה של בקרות TOC קשורה",
    subHeader: "משימה של בדיקת בקרה TOC",
    visualDistinctMessage: "לכל בקרה חייבת להיות לפחות בדיקת בקרה (TOC) אחת קשורה. צור {0} או {1}.",
    addToc: "בדיקת בקרה TOC חדשה",
    relatedToc: "קשר TOCs",
    toggleFilter: "הצג רק בקרות ללא כל בדיקת בקרה TOC קשורה",
    noResultsFound: "לא נמצאו תוצאות",
    noRecordsAvailable: "לא נבחרו בקרות לבדיקה",
    unrelatedLabel: "הצג תוכן עניינים לא קשור",
    unrelatedModalHeader: "משימות בדיקת בקרות TOC לא קשורות",
    noUnrelatedTaskPlaceholder: "אין משימות TOC לא קשורות זמינות",
    noTaskselectedLabel: "יש לבחור לפחות משימה אחת למחיקה.",
    relateControlTaskTitle: "קשר בדיקות בקרה TOCs לבקרה",
    manageControl: "נהל בקרות",
    taskTitleTOC: "בדיקת בקרה: {0}",
    taskDescriptionTOC: "תכנן את האופי, העיתוי וההיקף של בדיקות הבקרות (TOCs) שלנו בכדי להשיג ראיות ביקורת מתאימות ומספיקות לכך שהבקרה פועלת באפקטיביות כפי שתוכננה לאורך כל תקופת ההסתמכות על מנת למנוע או לזהות ולתקן הצגות מוטעות מהותיות ברמת מצג ההנהלה.<br/> המסקנה בדבר האפקטיביות התפעולית של הבקרות, על ידי הערכת תוצאות בדיקות הבקרות שלנו, לרבות כאשר הרחבנו את גודל המדגם שלנו וביצענו בדיקות של בקרות מפצות.'",
    manageControls: "נהל בקרות",
    unrelatedTasksMustBeAssociated: "משימות לא מקושרות חייבות להיות משויכות לבקרה או שיש למחוק אותן."
}

export const industrySelectionGroupLabels = {
    1: "תעשיות נבחרות",
    2: "תעשיות אחרות"
}

export const knowledgeDataLabels = {
    industry: "תעשייה",
    showSelected: "הצג רק את מה שנבחר",
    noContent: "אין תוכן זמין מ- Knowledge עבור התעשייה שנבחרה",
    importFromKnowledge: "ייבוא ​​מתוך ידע",
    importAccounts: "ייבוא ​​חשבונות",
    importAccountsAndDisclosures: "ייבוא ​​סעיפים וגילויים",
    accountBuild1: "בניית חשבון שלב 1",
    import: "ייבוא",
    close: "סגור",
    cancel: "בטל",
    selected: "המשתמש שנבחר",
    scotTitle: "SCOT build 1",
    importScots: "ייבוא ​​SCOTs",
    noKnowledgeDataResult: "אין תוכן זמין לבחירה",
    showOnlySelectedLabel: "הצג רק את מה שנבחר",
    scot: "תת התהליך המהותי (SCOT)",
    scotDropdownLabel: "תת תהליך מהותי (SCOT) עבור תעשייה נבחרה",
    importWcgw: "ייבוא ​​WCGWs",
    importFailedLabel: "הייבוא ​​נכשל. נסה לייבא שוב.",
    wtDetailPrefix: "<p>עבור כל תת תהליך SCOT רוטיני , לא רוטיני ותהליכי גילוי משמעותיים, אנו מאשרים את ההבנה שלנו בכל תקופה על ידי ביצוע נהלי WT. בנוסף, בביקורת PCAOB, אנו מבצעים נהלי WT לתתי תהליכים הכרוכים באומדנים <br/> עבור כל תתי התהליכים המהותיים (SCOTs) כאשר אנו נוקטים אסטרטגיית הסתמכות על בקרות, ועבור בקרות אשר נותנות מענה לסיכונים משמעותיים, אנו מאשרים שהבקרות הרלוונטיות תוכננו ויושמו כראוי. אנו מאשרים שההחלטה שלנו לנקוט באסטרטגיית הסתמכות בקרה עדיין מתאימה.<br/><br/>אנו מסיקים שהתיעוד שלנו מתאר במדויק את פעולת ה-SCOT וזיהינו את כל ה-WCGW המתאימים, כולל סיכונים הנובעים משימוש ב-IT , ובקרות רלוונטיות (כאשר רלוונטי).<br/><br/> עבור אומדן SCOTs כאשר אנו משתמשים באסטרטגיה מבססת בלבד, אנו מעריכים האם ההבנה שלנו של תת תהליך מהותי הכרוך באומדן מתאימה בהתבסס על הנהלים המבססים שלנו.</p>",
    importOSP: "ייבוא ​​OSPs",
    auditPlanBuild7: "תוכנית ביקורת Build 7",
    account: "חֶשְׁבּוֹן",
    accountName: "אינדקסים של PSP",
    wcgwName: "WCGWs",
    selectScot: "בחר תת תהליך מהותי SCOT",
    wcgwTitle: "SCOT build 3",
    noResultFound: "לא נמצאו תוצאות",
    importValidationMessage: "נדרשת בחירה",
    searchIconHoverLabel: "חפש",
    scotsHeader: "SCOTs",
    controlsHeader: "בקרות",
    ospsHeader: "OSPs",
    wcgw: "WCGW",
    importControls: "ייבא בקרות",
    accountAssertionsValidationMessage: "חסרים מצגי הנהלה למשימה",
    accountsAndDisclosures: "סעיפים וגילויים",
}

export const auditPlanITControlsLabels = {
    itcontrol: "בקרת IT",
    itcontrols: "בקרות IT שנבחרו לבדיקה",
    tasks: "משימות",
    type: "סוג",
    sectionHeading: "ITSPs של ITGC ובדיקה קשורה של משימות בקרה ומבססות",
    subHeader: "משימות TOC/OSP",
    visualTOCDistinctMessage: "לכל ITGC חייבת להיות לפחות בדיקת בקרה קשורה אחת. צור {0} או {2}.",
    visualOSPDistinctMessage: "לכל ITSP חייב להיות לפחות נוהל מבסס אחד קשור. צור {1} או {3}.",
    addTOC: "TOC חדש",
    addOSP: "OSP חדש",
    relatedTOCOSP: "קשר TOCs/OSPs",
    relatedTOC: "קשר TOCs",
    relatedOSP: "קשר ל-OSP",
    toggleFilter: "הצג רק בקרות IT ללא כל TOC/OSP קשורים",
    noResultsFound: "לא נמצאו תוצאות",
    noRecordsAvailable: "לא נבחרו ITGCs לבדיקה",
    taskTitleTOC: "בדיקת בקרה: {0}",
    taskDescriptionTOC: "בצע את הבדיקות המתוכננות שלנו על הבקרות הכלליות במערכות המידע (ITGCs) בכדי לקבל ראיות ביקורת נאותות מספיקות בקשר לאפקטיביות התפעולית של הבקרות כאמור לאורך כל תקופת ההסתמכות.",
    taskTitleOSP: "נוהל מבסס אחר: {0}",
    taskDescriptionOSP: "התאם אישית את תיאור המשימות הזה בכדי לתכנן את האופי, העיתוי וההיקף של נהלי הביקורת המבססים בקשר ל- IT על מנת להשיג ראיות ביקורת נאותות מספיקות בקשר למענה אפקטיבי לסיכוני ה- IT כפי שזוהו בתקופת ההסתמכות.<br>כאשר נהלי הביקורת המבססים בקשר ל- IT מתבצעים בתקופת ביניים, יש לעצב ולבצע נהלים בכדי להשיג ראיות נוספות לכך שניתן מענה לסיכוני ה- IT, מהתקופה שכוסתה על יד נהלי הביניים ועד סוף התקופה.<br>יש לתעד את המסקנה שלנו בקשר לביצוע נהלים מבססים מספיקים בקשר ל IT.",
    relateITControlTaskTitle: "קשר TOCs/OSPs לבקרת IT",
    relateITControlTOCTaskTitle: "קשר TOCs ל-ITGC",
    relateITControlOSPTaskTitle: "קשר OSPs ל-ITSP",
    unrelatedModalHeader: "משימות TOC/OSP לא קשורות",
    noUnrelatedTaskPlaceholder: "אין משימות TOC/OSP לא קשורות זמינות",
    noTaskselectedLabel: "יש לבחור לפחות משימה אחת למחיקה.",
    unrelatedLabel: "הצג TOCs/OSPs שאינם קשורים",
    understandITProcesses: "הבנת תהליכי IT",
    unrelatedTasksMustBeAssociated: "משימות לא מקושרות חייבות להיות משויכות לבקרת IT או שיש למחוק אותן."
}

export const generalLabelsForMobile = {
    noRecordsFound: "לא נמצאו תוצאות בקטגוריית המשימות הזו",
    taskListTitle: "המשימות שלי",
    taskEvidenceTitle: "ראיות",
    cameraPagesTitle: "דפים",
    cameraTitle: "מַצלֵמָה",
    taskDetailsTitle: "פרטי המשימה",
    invalidPage: "לא נמצא דף",
    combinedTaskLabel: "PIC/EQR",
    picTaskLabel: "PIC",
    eqrTaskLabel: "EQR",
    pageLabel: "עמוד",
    ofLabel: "שֶׁל",
    noTasksAvailable: "אין משימות זמינות",
    searchLabel: "חיפוש ...",
    noDescriptionAvailable: 'No description available.',
    knowledge: 'Knowledge',
    description: 'Description',
    knowledgeDescription: 'Knowledge description',
    customized: 'Customized',
    taskDetailsTitle: "פרטי המשימה",
    unassigned: "Unassigned",
    assignTo: "שהוקצה ל",
    signOffLabel: "Sign-offs",
    evidenceNoteLabel: "Evidence Notes",
    attributeLabel: "מאפיינים",
    addNoteLabel: "הערה חדשה",
    addCommentLabel: "הוסף תגובה",
    editCommentLabel: "עדכן תגובה",
    addReplyNoteLabel: "השב להערה זו",
    replyNoteLabel: "ענה",
    replyEditNoteLabel: "ערוך תשובה",
    enterReplyPlaceholder: "הזן מענה",
    editNoteLabel: "ערוך",
    deleteNoteLabel: "מחק",
    reopenNoteLabel: "פתח שוב",
    closeNoteLabel: "סגור",
    clearNoteLabel: "Clear",
    preparerAbbrv: "P",
    reviewerAbbrv: "R",
    uploadPhoto: "העלה תמונה",
    noEvidenceFound: "לא קושרו ראיות למשימה",
    noRegionComponentFound: "לא התקבלו מסמכים מצוות אזורי או מישות מדווחת",
    noEvidenceMessage: "לחץ על העלה תמונה בכדי להעלות ראיות",
    noNotesFound: "לא נמצאו הערות",
    noNotesStatement: "השאר הערה באמצעות הקלטים למטה. הקצה את ההערה למשתמש וציין את העדיפות ואת תאריך היעד.",
    regionComponentEvidence: "ראיות מצוות הביקורת של הישות המוחזקת והחברה המחזיקה",
    documentWarning: "המסמך שהורד יהיה לקריאה בלבד. אנא מחק את הקובץ בסיום.",
    preparerTitle: "חתימות מכין",
    reviewerTitle: "חתימות הסוקר",
    teamLabel: "צוות",
    saveEvidenceTitle: "שמור ראיות",
    saveButton: "שמור",
    cancelButton: "בטל",
    confirmButtonLabel: "אשר",
    previewButton: "מסמך לצפייה",
    evidenceLable: "שם הראיות",
    mergingTitleLable: "תמונות מוזגו ל-PDF.",
    showErrFileExistMsg: "שם הקובץ כבר קיים. אנא שנה את שם הקובץ.",
    showErrForNoImgExist: "אין תמונות זמינות ליצירת PDF.",
    showErrBlankFileNameMsg: "שם הקובץ לא יכול להיות ריק.",
    showIsCompletedMessage: "הקובץ הועלה בהצלחה.",
    uploadingTitle: "Processing",
    showErrImgContext: "יש להשתמש ב'השתמש בתמונות' (useImages) בתוך ספק Images (ImagesProvider)",
    PagePreviewTitle: "עמוד",
    regionComponentEvidenceLabel: "ראיות מצוות הביקורת של הישות המוחזקת והחברה המחזיקה",
    downloadProcessLabel: "הורדת...",
    downloadCompleteLabel: "ההורדה הושלמה",
    taskNotes: "הערות משימה",
    documentNotes: "הערות במסמך",
    dueDateLabel: "תאריך יעד",
    view: "הצג:",
    documentNotes: "הערות במסמך",
    newNote: "הוסף הערה",
    editNote: "ערוך הערה",
    assignedTo: "הוקצה ל",
    priority: "עדיפות",
    select: "בחר",
    dueDate: "תאריך יעד",
    addNewNote: "הוסף הערה חדשה",
    addNote: "הוסף הערה",
    updateNote: "עדכון הערה",
    enterDescription: "הזן תיאור...",
    allnotes: "כל ההערות",
    mynotes: "ההערות שלי",
    assignedToMe: "מוקצות לי",
    hashValue: "#",
    showLessToggle: "הצג פחות",
    showMoreToggle: "הצג עוד",
    delete: "מחק",
    deleteNoteModalTitle: "מחק הודעה",
    deleteReplyModalTitle: "מחק את התשובה",
    confirmDeleteNoteLabel: "האם הינך בטוח שברצונך למחוק את ההערה שנבחרה?",
    confirmDeleteReplyLabel: "האם הינך בטוח שברצונך למחוק את תשובתך להערה זו?",
    downloadInfo: "הורדת קובץ המכיל תו # אסורה",
	evidenceFileValidationInfo: 'שם הקובץ אינו יכול לכלול את התווים */ : <>\?| "',
    previewPageTitle: "מסמך לצפייה",
    redirecting: "מפנה לדף נחיתה תוך מספר שניות...",
    redirectingToTask: "מפנה לדף \'המשימות שלי\' תוך מספר שניות...",
    errorApplyingConstraints: "שגיאה בהחלת אילוצים:",
    zoomIsNotSupported: "זום אינו נתמך במכשיר זה.",
    errorCheckingCameraCapability: "שגיאה בבדיקת יכולות המצלמה:",
    previous: "הקודם",
    next: "הבא",
    after: "אחרי",
    redirectingToTaskDetails: "ניתוב מחדש לפרטי המשימה תוך מספר שניות",
    mobileURL: '/mobile'
};

export const RNHNoteMobileStatusOptions = [{
        value: 1,
        label: "פתח"
    },
    {
        value: 2,
        label: "Cleared"
    },
    {
        value: 3,
        label: "סגור"
    }
];

export const auditPhaseTypes = [{
        value: 1,
        label: "היקף ואסטרטגיה"
    },
    {
        value: 2,
        label: "ביצוע הביקורת"
    },
    {
        value: 3,
        label: "מסקנה"
    },
];

export const CreateEditTaskSectionLabels = {
    createModalTitle: "קבוצת משימה חדשה",
    editModalTitle: "ערוך קבוצת משימות",
    createModalDescription: "הזן את פרטי קבוצת המשימות למטה ובחר '<b>{0}</b>' כדי לסיים. כדי ליצור קבוצת משימות נוספת, בחר '<b>{1}</b>'.",
    editModalDescription: "ערוך את פרטי קבוצת המשימות למטה ובחר '<b>{0}</b>' כדי לסיים.",
    close: "סגור",
    cancel: "בטל",
    save: "שמור",
    saveAndCloseLabel: "שמור וסגור",
    saveAndCreateLabel: "שמור וצור אחד נוסף",
    taskSectionNameLabel: "שם קבוצת המשימות (חובה)",
    taskSectionNameErrorMsg: "נדרש",
    engagementPhaseOptions: auditPhaseTypes,
    engagementPhaseLabel: "שלב בתיק הביקורת (חובה)",
    engagementPhaseErrorMsg: "נדרש",
};

export const auditPhaseLabels = {
    1: "היקף ואסטרטגיה",
    2: "ביצוע הביקורת",
    3: "מסקנה",
    4: "בצע פעילויות מקדימות בתיק הביקורת",
    5: "זיהוי והערכת סיכונים",
    6: "מענה לסיכונים",
    7: "סיכום ודיווח"
};

export const ITApproachType = {
    1: "בקרות כלליות במערכות המידע (ITGC)",
    2: "נוהל מבסס ל- IT  (IT-substantive testing procedures (ITSP)) "
};

// taskbuildmilestoneid labels
export const taskBuildMilestoneId = [{
        id: 1,
        label: superModalNavigationLabels.identifyAccountsAndDisclosures
    },
    {
        id: 31,
        label: superModalNavigationLabels.identifyAccountsAndDisclosures
    },
    {
        id: 5,
        label: superModalNavigationLabels.identifySCOTs
    },
    {
        id: 32,
        label: superModalNavigationLabels.identifySCOTs
    },
    {
        id: 6,
        label: superModalNavigationLabels.determineSCOTStrategy
    },
    {
        id: 7,
        label: superModalNavigationLabels.identifyWCGWAndControls
    },
    {
        id: 38,
        label: superModalNavigationLabels.identifyWCGWAndControls
    },
    {
        id: 8,
        label: superModalNavigationLabels.selectControlToTest
    },
    {
        id: 2,
        label: superModalNavigationLabels.identifyRisks
    },
    {
        id: 15,
        label: superModalNavigationLabels.relateWCGWsToAssertions
    },
    {
        id: 30,
        label: superModalNavigationLabels.relateRisksToWCGWs
    },
    {
        id: 3,
        label: superModalNavigationLabels.determineCRA
    },
    {
        id: 18,
        label: superModalNavigationLabels.SCOTWT
    },
    {
        id: 19,
        label: superModalNavigationLabels.controlTOC
    },
    {
        id: 20,
        label: superModalNavigationLabels.ITProcessUDP
    },
    {
        id: 21,
        label: superModalNavigationLabels.ITGC_ITSP_TOC_OSP
    },
    {
        id: 25,
        label: superModalNavigationLabels.accountPSP
    },
    {
        id: 26,
        label: superModalNavigationLabels.accountOSP,
    },
    {
        id: 27,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 56,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 29,
        label: superModalNavigationLabels.relatedWCGWToTask
    },
    {
        id: 39,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 50,
        label: superModalNavigationLabels.OST
    }
];

export const noEvidenceReferencedReasons = [{
        id: 1,
        reason: noEvidenceReferencedReasonsLabels.immaterialReason,
        glAccountTypeId: 12,
        strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughMText
    },
    {
        id: 2,
        reason: noEvidenceReferencedReasonsLabels.waivedReason,
        glAccountTypeId: 13,
        strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughWText
    }
];


export const createEditAdjustmentLabels = {
    createModalTitle: "עדכון חדש ",
    editModalTitle: "ערוך התאמה",
    createModalDescription: "הזן את פרטי פקודת העדכון למטה ובחר '<b>{0}</b>' כדי לסיים. כדי ליצור עדכון נוסף, בחר '<b>{1}</b>'.",
    editModalDescription: "ערוך את פרטי ההתאמה למטה ובחר '<b>{0}</b>' כדי לסיים. כדי למחוק את ההתאמה לחץ על '<b>{1}</b>'.",
    close: "סגור",
    cancel: "בטל",
    save: "שמור",
    saveAndCloseLabel: "שמור וסגור",
    saveAndCreateLabel: "שמור וצור אחד נוסף",
    delete: "מחק",
    adjustmentNameLabel: "אינדקס התאמה (חובה)",
    adjustmentDescriptionLabel: "תיאור העדכון (חובה)",
    adjustmentDescriptionPlaceholder: "תיאור העדכון (חובה)",
    required: "נדרש",
    editDescriptionModal: "ערוך את תיאור ההתאמה",
    descriptionRequired: "נדרש תיאור לעדכון ",
    uploadDocumentPlaceholder: "יש לשמור התאמה לפני שאפשר לקשר אותה לראיות.",
    generalLedgerAccount: "חשבונות GL (חובה)",
    documentHeader: "מסמכים (חובה)",
    addDocumentButton: "הוסף ראיות",
    glAccountPlaceholder: 'GL account is not available. To add the account click {0}.',
    adjustmentIndex: "אינדקס התאמה",
    addglaccountbutton: "הוסף חשבון GL",
    descriptionMaxLengthError: "התגובה חורגת מהמקסימום המותר.",
	glaccountTotalError: 'סה"כ רישומי החובה צריך להיות שווה לסך רישומי הזכות',
    glaccountIdDuplicate: "יש להשתמש בכל חשבון GL פעם אחת בלבד בהתאמה",
    placeholderText: 'No related documents. To relate a document click <a>Add evidence<a>',
    editAdjustmentDescriptionHeader: "ערוך את תיאור ההתאמה",
    editAdjustmentDescriptionSubHead: "ערוך את פרטי תיאור ההתאמה למטה ובחר \'<b>שמור</b>\' כדי לסיים."
};

export const addUpdateGlAccountLabels = {
    addGLaccountTitle: "הוסף חשבון GL",
    glaccountDescription: "הזן את פרטי חשבון ה- GL להלן ובחר '<b>{0}</b>' כדי לסיים. בכדי להוסיף חשבון GL נוסף, בחר '<b>{1}</b>'.",
    addAndClose: "הוסף וסגור",
    addAnother: "הוסף עוד אחד",
    accountSubClassPlaceholder: "תת-סוג חשבון",
    glAccountsPlaceholder: "בחר תת-סוג חשבון כדי לראות חשבונות GL זמינים.",
    glAccountListHeaderColumn: "חשבון GL",
    amountLabel: "סכום (חובה)",
    debitCreditOptions: [{
            id: 1,
            label: "חובה"
        },
        {
            id: 2,
            label: "זכות"
        }
    ],
    searchPlaceholder: "חפש",
    newGlAccount: "חשבון התאמה (reconciling account) חדש",
    noResultsFound: "לא נמצאו תוצאות",
    noRecordsPlaceholder: "לא נמצאו חשבונות התאמה (reconciling accounts) עבור תת-סוג חשבון שנבחר. בחר תת-סוג חשבון אחר או לחץ על {0} כדי להוסיף חשבון התאמה (reconciling account) לתת-סוג החשבון שנבחר.",
    editTitleTip: "ערוך חשבון התאמה (reconciling account)",
    removeTitleTip: "מחק חשבון התאמה (reconciling account)",
    custom: "מותאם אישית",
    duplicateGLAccount: "יש להשתמש בכל חשבון GL פעם אחת בלבד בהתאמה",
    updateModalTitle: "עדכן חשבון התאמה (reconciling account)",
    updateModalDescription: `Update GL account amount and debit/credit details below and select '<b>{0}</b>' to finish.`,
    accountClassLabel: "Account class",
    glAccountLabel: "GL account",
    updateLabel: "עידכון",
    updateGlAccountModalTitle: "עדכן חשבון GL",
}

export const deleteGLAccountLabels = {
    deleteConfirmationModallHeader: "מחק חשבון התאמה (reconciling account)",
    deleteConfirmationModalBodyHeader: "האם אתה בטוח שברצונך למחוק את  חשבון ההתאמה (reconciling account) שנבחר?לא ניתן לבטל פעולה זו.",
    deleteConfirmationModalAccountSubClass: "תת-סוג חשבון:",
    deleteConfirmationModalAccountName: "שם חשבון:",
    deleteConfirmationModalGLAccountName: "שם חשבון התאמה (reconciling account):",
    closeButtonTitle: "בטל",
    confirmBtnTitle: "מחק"
}

export const glAccountListLabel = {
    accountClass: "סוג חשבון",
    accountSubClass: "תת-סוג חשבון",
    glAccount: "חשבון GL",
    debit: "חובה",
    credit: "זכות",
    actions: "פעולות",
    editTitleTip: "ערוך חשבון GL",
    removeTitleTip: "הסר חשבון GL"
}

export const EngagementMapLabels = {
    objectivePreviewMessage: 'Hover over a map item to preview',
    noMapAvailableMessage: "אין מיפוי זמין.",
    takeContentUpdateMessage: "בצע עדכון תוכן כדי לקבל את המיפוי העדכני ביותר.",
    noRecordsLabel: "לא נמצאו רשומות.",
    auditTopic: "נושא ביקורת",
    auditTopicPlaceholder: "בחר נושא לצפייה",
    numberSelected: "{0} נושאים נבחרו",
    refreshMapTitletip: "לחצו כאן להתחלת עדכון מפת ההתקשרות",
    mapUpdateInProgress: "העדכון מתבצע. ייתכן שיחלפו עד עשר דקות עד להשלמת העדכון.",
    refreshMapsLabel: "Refresh maps"
}

export const createEditGLAccountLabels = {
    createModalTitle: "חשבון התאמה (reconciling account) חדש",
    editModalTitle: "ערוך חשבון התאמה (reconciling account)",
    createModalDescription: "הזן את פרטי חשבון התאמה (reconciling account) למטה ובחר '<b>{0}</b>' כדי לסיים. כדי להוסיף חשבון התאמה נוסף, בחר '<b>{1}</b>'.",
    editModalDescription: "ערוך את פרטי חשבון ההתאמה (reconciling account) למטה ובחר '<b>{0}</b>' כדי לסיים.",
    accountSubClass: "תת-סוג חשבון",
    accountName: "שם חשבון (חובה)",
    glAccountName: "שם חשבון התאמה (reconciling account) (חובה)",
    cancelbtn: "בטל",
    saveAndAddbtn: "שמור והוסף עוד",
    saveAndClosebtn: "שמור וסגור",
    save: "שמור",
    required: "נדרש",
}

//Receive instructions switcher
export const receiveInstructionSwitcherLabels = {

    [receiveInstructionSwitcherIds.groupInstructions]: "הנחיות לקבוצה",
    [receiveInstructionSwitcherIds.groupRiskAssessment]: "הערכת סיכונים קבוצתית",
    [receiveInstructionSwitcherIds.documents]: "מסמכים"
};

export const misstatementEvidenceLabels = {
    placeholderText: "אין ראיות קשורות. יש לקשר לפחות ראיה תומכת אחת. כדי לקשר ראיה, לחץ על {0}.",
    addEvidenceBtn: "הוסף ראיות",
};

export const misstatementTempLabels = {
    placeholderText: "אין מסמכים זמניים קשורים. כדי לקשר מסמך זמני, לחץ על {0}.",
    addEvidenceBtn: "הוסף קובץ זמני",
};

export const inherentRiskFactorTypes = [{
        id: 1,
        label: "מורכבות",
        displayOrder: 1
    },
    {
        id: 2,
        label: "סובייקטיביות אי-וודאות",
        displayOrder: 2
    },
    {
        id: 3,
        label: "הונאה או טעות",
        displayOrder: 3
    },
    {
        id: 4,
        label: "שינוי",
        displayOrder: 4
    },
    {
        id: 5,
        label: "אופי החשבון",
        displayOrder: 5
    },
    {
        id: 6,
        label: "צדדים קשורים",
        displayOrder: 6
    }
];

export const helixSettingsStepLabels = {
    title: "הגדר הגדרות חיבור",
    subTitle: "בחר את ההגדרות עבור חיבור כלי הניתוח (Analyzer) שלך.",
    connectionNameLabel: "שם החיבור",
    connectionNamePlaceholder: "שם החיבור (חובה)",
    connetionTypesLabel: "סוגי חיבורים",
    connectionTypeScopeAndStrategy: "היקף ואסטרטגיה",
    connectionTypeFinancionStatement: "דוחות כספיים",
    includeAllBusinessUnitsField: "האם אתה רוצה לכלול את כל היחידות העסקיות?",
    yes: "כן",
    no: "לא",
    businessUnitsLabel: "יחידות עסקיות",
    businessUnitsPlaceholder: "יחידות עסקיות",
    analysisPeriodLabel: "תאריך Analysis",
    analysisPeriodPlaceholder: "תאריך Analysis",
    comparativePeriod1Label: "תאריך השוואה 1",
    comparativePeriod1Placeholder: "תאריך השוואתי 1 (אופציונלי)",
    comparativePeriod2Label: "תאריך השוואה 2",
    comparativePeriod2Placeholder: "תאריך השוואתי 2 (אופציונלי)",
    currencyTypeField: "סוג המטבע",
    reporting: "דוחות",
    functional: "פוּנקצִיוֹנָלִי",
    currencyCodeField: "קוד מטבע",
    currencyCodePlaceholder: "קוד מטבע (חובה)",
    scopeAndStrategyLabel: "היקף ואסטרטגיה",
    financialStatementLabel: "דוחות כספיים",

    required: "נדרש",
    comparativePeriodError: "תאריך לא חוקי. בחר תאריך לפני תאריך הניתוח.",

    dataConnectionLink: 'How to manage data connections',
    helixfiscalDropDownLabel: "תאריך {0} - {1}",

    helixError: 'Could not connect to the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    businessUnitsSelectedCount: "נבחרו {0}",
    allBusinessUnitsLabel: "כל היחידות העסקיות"
};

export const importDataModalLabels = ({
    title,
    description,
    buttonLabel
}) => {
    return {
        title: title,
        description: description,
        entity: "ישות",
        trialBalanceName: "שם מאזן בוחן",
        reporting: "דוחות",
        functional: "פוּנקצִיוֹנָלִי",
        analysisPeriod: "תאריך Analysis",
        comparativePeriod: "תאריך השוואתי",
        secondComparativePeriod: "תאריך השוואתי שני (אופציונלי)",
        includeFinancialStatements: "כלול דוחות כספיים",
        carryForwardReferencesAndAdjustments: "האם להעביר הפניות והתאמות לייבוא ​​החדש?",
        import: buttonLabel,
        businessUnitSelectedCount: "יחידה עסקית {0}",
        businessUnitsSelectedCount: "{0} יחידות עסקיות",
        allBusinessUnitsLabel: "כל היחידות העסקיות",
        businessUnitsPlaceholder: "יחידות עסקיות",
        required: "נדרש",
        comparativePeriodError: "תאריך לא חוקי. בחר תאריך לפני תאריך הניתוח.",
        secondComparativePeriodError: "תאריך השוואה שני גדול או שווה מתאריך ההשוואה.",
        equalComparativePeriodError: "התאריכים לא יכולים להיות זהים.",
        analysisDateMustBeLaterError: 'Analysis date must be later than both comparative dates.'
    };
};

export const AnalyzerHelixErrors = {
    400: "פרויקט EY Helix עבור החיבור שנבחר אינו זמין עוד. פנה למנהל מערכת של EY Helix לקבלת פרטים נוספים. כדי להסיר את החיבור לצמיתות, הסר תחילה את כל הייבוא ​​המשויך לחיבור. לאחר מכן, לחץ על 'נתק כלי ניתוח (analyzer)' בתפריט עוד. אנא שקול אם יש לחבר כלי ניתוח (analyzer) אחר.",
    403: "אינך חבר צוות מורשה של הכלי ניתוח (analyzer) המחובר. צור קשר עם מנהל הפרויקט של EY Helix כדי לקבל גישה.",
    405: "ניתוחים אינם זמינים בחיבור המקושר. עבור אל EY Helix והשלם את שלבי עיבוד הנתונים והניתוחים כדי להמשיך.",
    406: "כלי ניתוח (analyzer) EY Helix עבור החיבור שנבחר אינו זמין עוד. פנה למנהל מערכת של EY Helix לקבלת פרטים נוספים. כדי להסיר את החיבור לצמיתות, הסר תחילה את כל הייבוא ​​המשויך לחיבור. לאחר מכן, לחץ על 'נתק כלי ניתוח (analyzer)' בתפריט עוד. אנא שקול אם יש לחבר כלי ניתוח (analyzer) אחר.",
    408: "פרויקט EY Helix עבור החיבור שנבחר אינו זמין עוד. פנה למנהל מערכת של EY Helix לקבלת פרטים נוספים. כדי להסיר את החיבור לצמיתות, הסר תחילה את כל הייבוא ​​המשויך לחיבור. לאחר מכן, לחץ על 'נתק כלי ניתוח (analyzer)' בתפריט עוד. אנא שקול אם יש לחבר כלי ניתוח (analyzer) אחר.",
    411: "לכלי הניתוח (analyzer) שנבחר אין את כל הפרמטרים הנדרשים. צור קשר עם מנהל מערכת של EY Helix לקבלת פרטים נוספים.",
    430: "לכלי הניתוח (Analyzer) שנבחר אין את כל הפרמטרים הנדרשים. צור קשר עם מנהל מערכת של EY Helix לקבלת פרטים נוספים. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    800: "נראה שלא ניגשת ל-EY helix לפני כן.עבור אל EY Helix, התחבר ופעל לפניההנחיות בכדי להגדיר את חשבונך.",
    801: "אינך חבר צוות מורשה של הפרויקט המקושר.צור קשר עם מנהל פרויקט EY helix כדי לקבל גישה.",
    901: "פרויקט EY helix עבור הקישור שנבחר אינו זמין עוד. צור קשר עם מנהל EY helix לקבלת פרטים נוספים. בכדי למחוק לצמיתות את הקישור, לחץ על 'מחק' למטה בתפריט 'עוד'. שקול אם צריך לקשר כלי ניתוח (analyzer) אחר.",
    902: "פרויקט EY helix עבור הקישור שנבחר מסומן למחיקה. צור קשר עם מנהל EY helix לקבלת פרטים נוספים. בכדי למחוק לצמיתות את הקישור, לחץ על 'מחק' למטה בתפריט 'עוד'. שקול אם צריך לקשר כלי ניתוח (analyzer) אחר.",
    903: "פרויקט EY helix עבור הקישור שנבחר מסומן לאחסון. צור קשר עם מנהל EY helix לקבלת פרטים נוספים. בכדי למחוק לצמיתות את הקישור, לחץ על 'מחק' למטה בתפריט 'עוד'. שקול אם צריך לקשר כלי ניתוח (analyzer) אחר.",
    926: "כלי הניתוח (analyzer)שנבחר אינו זמין ב-EY Helix. רענן  את הדף ונסה שוב. אם הבעיה נמשכת צור קשר עם התמיכה הטכנית.",
    927: "ניתוחים אינם זמינים בפרויקט המקושר. עבור אל EY Helix והשלם את שלבי עיבוד הנתונים והניתוחים כדי להמשיך.",
    928: "כלי ניתוח (analyzer) לא חוקי או חסר ב-EY Helix. רענן את הדף ונסה שוב. אם הבעיה נמשכת צור קשר עם התמיכה הטכנית.",
    929: "אירעה שגיאה הקשורה לפרוייקט EY Helix המקושר. לא ניתן לייבא נתונים."
};

export const validationLabels = {
    viewAdjustmentWithValidations: "הצגת התאמות עם אימותים {0}",
    validationTypeAmtMissmatch: "סכום כניסות החיוב אינו שווה לסכום כניסות הזיכוי",
    validationTypeNoEvidence: "אין ראיות קשורות",
};

export const canavsImportErrors = {
    400: "הייבוא ​​נכשל. פרויקט EY Helix עבור החיבור שנבחר אינו זמין עוד. פנה למנהל מערכת של EY Helix לקבלת פרטים נוספים. כדי להסיר את החיבור לצמיתות, הסר תחילה את כל הייבוא ​​המשויך לחיבור. לאחר מכן, לחץ על 'נתק כלי ניתוח (analyzer)' בתפריט הנוסף. אנא שקול אם יש לחבר כלי ניתוח (analyzer) אחר.",
    403: "הייבוא נכשל. אינך חבר צוות מורשה של כלי הניתוח (Analyzer) המקושר. צור קשר עם מנהל פרויקט EY Helix כדי לקבל גישה, ולאחר מכן רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    405: "הייבוא נכשל. הניתוחים אינם זמינים בחיבור המקושר. עבור אל EY Helix והשלם את שלבי עיבוד הנתונים והניתוחים כדי להמשיך. לאחר מכן רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    406: "הייבוא ​​נכשל. כלי ניתוח (analyzer) EY Helix עבור החיבור שנבחר אינו זמין עוד. פנה למנהל מערכת של EY Helix לקבלת פרטים נוספים. כדי להסיר את החיבור לצמיתות, הסר תחילה את כל הייבוא ​​המשויך לחיבור. לאחר מכן, לחץ על 'נתק כלי ניתוח (analyzer)' בתפריט הנוסף. אנא שקול אם יש לחבר כלי ניתוח (analyzer) אחר.",
    408: "הייבוא ​​נכשל. פרויקט EY Helix עבור החיבור שנבחר אינו זמין עוד. פנה למנהל מערכת של EY Helix לקבלת פרטים נוספים. כדי להסיר את החיבור לצמיתות, הסר תחילה את כל הייבוא ​​המשויך לחיבור. לאחר מכן, לחץ על 'נתק כלי ניתוח (analyzer)' בתפריט הנוסף. אנא שקול אם יש לחבר כלי ניתוח (analyzer) אחר.",
    411: "הייבוא נכשל. לכלי הניתוח (Analyzer) שנבחר אין את כל הפרמטרים הנדרשים. פנה למנהל מערכת של EY Helix לקבלת פרטים נוספים ולאחר מכן רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    430: "הייבוא נכשל. לכלי הניתוח (Analyzer) שנבחר אין את כל הפרמטרים הנדרשים. צור קשר עם מנהל מערכת של EY Helix לקבלת פרטים נוספים. רענן את הדף ונסה שוב. אם הבעיה נמשכת, פנה לתמיכה הטכנית.",
    113082: "תקופת הניתוח לא יכולה להיות ריקה."
};
